"use strict";

let KDNoCaptureTypes = ["skeleton", "construct", "nobrain", "nocapture"];

let KinkyDungeonEnemies: enemy[] = [
	// Prisoners
	{name: "PrisonerBandit", tags: KDMapInit(["prisoner", "bandit", "human", "peaceful", "noshop"]), faction: "Prisoner", immobile: true, lowpriority: true, evasion: -100, armor: 0, followRange: 100, AI: "wander", regen: 0.1,
		visionRadius: 0, maxhp: 12, minLevel:0, weight:-1000, movePoints: 1000, attackPoints: 0, attack: "", attackRange: 0, specialdialogue: "PrisonerBandit",
		Behavior: {noPlay: true},
		terrainTags: {}, floors:KDMapInit([])},
	{name: "MummyElevator", tags: KDMapInit(["prisoner", "mummy", "peaceful", "noshop", "nofidget"]),
		faction: "Prisoner", immobile: true, lowpriority: true, evasion: -100, armor: 0, followRange: 100, AI: "wander", regen: 100,
		visionRadius: 0, maxhp: 1000, minLevel:0, weight:-1000, movePoints: 1000, attackPoints: 0, attack: "", attackRange: 0,
		specialdialogue: "MummyElevator",
		Behavior: {noPlay: true},
		terrainTags: {}, floors:KDMapInit([])},
	{name: "FactoryDoll", bound: "FactoryDoll", playLine: "Gagged", tags: KDMapInit(["prisoner",
		"nocapture", "dollmakerconvert", "doll", "human", "minor", "peaceful", "nohelp", "noshop"]),
		rescueTo: {
			Remove: "FreeDoll",
			Unlock: "FreeDoll",
		},
		faction: "Prisoner", lowpriority: true, evasion: -100, armor: 1, followRange: 100, AI: "wander", regen: 0.1,
		stunWhenSwap: true,
		visionRadius: 0, maxhp: 12, minLevel:0, weight:-10, movePoints: 4, attackPoints: 0, attack: "", attackRange: 0, events: [
			{trigger: "tick", type: "secretToy"},
		],
		Behavior: {noPlay: true},
		terrainTags: {"bellowsDoll": 20}, allFloors: true},
	{name: "FreeDoll", bound: "FactoryDoll", tags: KDMapInit(["formerprisoner", "nocapture", "doll", "human", "minor", "peaceful", "noshop"]),
		faction: "Prisoner", lowpriority: true, evasion: -100, armor: 1, followRange: 100, AI: "wander", regen: 0.1,
		visionRadius: 0, maxhp: 12, minLevel:0, weight:-1000, movePoints: 4, attackPoints: 0, attack: "", attackRange: 0,
		Behavior: {noPlay: true},
		terrainTags: {}, allFloors: true},
	{name: "DollmakerTarget", nameList: "cyborg", outfit: "DollsmithDoll", style: "Water", bound: "FactoryDoll", playLine: "Gagged", tags: KDMapInit(["prisoner", "silenceimmune", "blindimmune", "escapeddoll", "doll", "human", "minor", "peaceful", "noshop"]),
		faction: "Prisoner", lowpriority: true, evasion: -100, armor: 0, followRange: 100, AI: "wander", regen: 0.01, events: [
			{trigger: "tick", type: "secretToy"},
		],
		visionRadius: 0, maxhp: 8, minLevel:0, weight:-10, movePoints: 4, attackPoints: 0, attack: "", attackRange: 0,
		Behavior: {noPlay: true},
		ondeath: [{type: "dollID"}],
		terrainTags: {}, allFloors: true},



	// Easy mode rescuer
	{name: "ShopkeeperRescue", tags: KDMapInit(["human", "peaceful", "alwayshelp", "noshop", "opendoors"]), faction: "Prisoner", lowpriority: true, armor: 2, followRange: 100, AI: "guard",
		visionRadius: 0, maxhp: 120, regen: 10, minLevel:0, weight:-1000, movePoints: 2, attackPoints: 0, attack: "", attackRange: 0, specialdialogue: "ShopkeeperRescueChatter",
		Behavior: {noPlay: true},
		noDisplace: false, keys: true,
		events: [
			{type: "ShopkeeperRescueAI", trigger: "afterEnemyTick"},
		],
		terrainTags: {}, floors:KDMapInit([])},

	// Easy mode NPC
	{name: "ShopkeeperStart", tags: KDMapInit(["human", "peaceful", "alwayshelp", "noshop", "opendoors"]), faction: "Prisoner", lowpriority: true, armor: 2, followRange: 100, AI: "guard",
		visionRadius: 0, maxhp: 120, regen: 10, minLevel:0, weight:-1000, movePoints: 2, attackPoints: 0, attack: "", attackRange: 0, specialdialogue: "ShopkeeperStart",
		Behavior: {noPlay: true},
		spawnAISetting: "None",
		noDisplace: false, keys: true,
		terrainTags: {}, floors:KDMapInit([])},

	// Quest NPC
	{name: "DressmakerQuest", tags: KDMapInit(["dressmaker", "human", "peaceful", "noshop"]), faction: "Prisoner", lowpriority: true, armor: 0, followRange: 100, AI: "hunt", regen: 0.1,
		visionRadius: 0, maxhp: 12, minLevel:0, weight:-1000, movePoints: 4, attackPoints: 0, attack: "", attackRange: 0, specialdialogue: "DressmakerQuest",
		Behavior: {noPlay: true},
		terrainTags: {}, floors:KDMapInit([])},
	{name: "ApprenticeQuest", tags: KDMapInit(["apprentice", "human", "peaceful", "noshop"]), faction: "Prisoner", lowpriority: true, armor: 0, followRange: 100, AI: "hunt", regen: 0.1,
		visionRadius: 0, maxhp: 12, minLevel:0, weight:-1000, movePoints: 4, attackPoints: 0, attack: "", attackRange: 0, specialdialogue: "ApprenticeQuest",
		Behavior: {noPlay: true},
		terrainTags: {}, floors:KDMapInit([])},
	{name: "BlacksmithQuest", tags: KDMapInit(["human", "peaceful", "alwayshelp", "noshop"]), faction: "Prisoner", lowpriority: true, armor: 0, followRange: 100, AI: "hunt", regen: 0.1,
		visionRadius: 0, maxhp: 12, minLevel:0, weight:-1000, movePoints: 4, attackPoints: 0, attack: "", attackRange: 0, specialdialogue: "BlacksmithShop", data: {"shop": "BlacksmithShop"},
		Behavior: {noPlay: true},
		ondeath: [{type: "murder", count: 1}],
		terrainTags: {}, floors:KDMapInit([])},
	{name: "AdaLovelock", tags: KDMapInit(["human", "peaceful", "alwayshelp", "noshop"]), faction: "Prisoner", lowpriority: true, armor: 0, followRange: 100, AI: "hunt", regen: 0.1,
		visionRadius: 0, maxhp: 25, minLevel:0, weight:-1000, movePoints: 4, attackPoints: 0, attack: "", attackRange: 0, specialdialogue: "AdaMasterwork",
		Behavior: {noPlay: true},
		terrainTags: {}, floors:KDMapInit([])},
	{name: "AntiqueQuest", tags: KDMapInit(["skeleton", "peaceful", "alwayshelp", "noshop"]), faction: "Prisoner", lowpriority: true, armor: 0, followRange: 100, AI: "hunt", regen: 1,
		visionRadius: 0, maxhp: 12, minLevel:0, weight:-1000, movePoints: 4, attackPoints: 0, attack: "", attackRange: 0, specialdialogue: "AntiqueShop", data: {"shop": "AntiqueShop"},
		Behavior: {noPlay: true},
		ondeath: [{type: "murder", count: 1}],
		terrainTags: {}, floors:KDMapInit([])},
	{name: "BowyerQuest", tags: KDMapInit(["human", "peaceful", "alwayshelp", "noshop"]), faction: "Prisoner", lowpriority: true, armor: 0, followRange: 100, AI: "hunt", regen: 0.1,
		visionRadius: 0, maxhp: 12, minLevel:0, weight:-1000, movePoints: 4, attackPoints: 0, attack: "", attackRange: 0, specialdialogue: "BowyerShop", data: {"shop": "BowyerShop"},
		Behavior: {noPlay: true},
		ondeath: [{type: "murder", count: 1}],
		terrainTags: {}, floors:KDMapInit([])},
	{name: "ShadyQuest", tags: KDMapInit(["human", "peaceful", "alwayshelp", "noshop"]),
		faction: "Prisoner", lowpriority: true, armor: 0, followRange: 100, AI: "hunt", regen: 0.1,
		visionRadius: 0, maxhp: 12, minLevel:0, weight:-1000, movePoints: 4, attackPoints: 0, attack: "",
		attackRange: 0, specialdialogue: "ShadyShop", data: {"shop": "ShadyShop"},
		Behavior: {noPlay: true},
		ondeath: [{type: "murder", count: 1}],
		terrainTags: {}, floors:KDMapInit([])},
	{name: "ArmorerQuest", tags: KDMapInit(["human", "peaceful", "alwayshelp", "noshop"]), faction: "Prisoner", lowpriority: true, armor: 0, followRange: 100, AI: "hunt", regen: 0.1,
		visionRadius: 0, maxhp: 12, minLevel:0, weight:-1000, movePoints: 4, attackPoints: 0, attack: "", attackRange: 0, specialdialogue: "ArmorerShop", data: {"shop": "ArmorerShop"},
		Behavior: {noPlay: true},
		ondeath: [{type: "murder", count: 1}],
		terrainTags: {}, floors:KDMapInit([])},
	{name: "DragonheartQuest", tags: KDMapInit(["dragon", "peaceful", "alwayshelp", "noshop"]), faction: "Prisoner", lowpriority: true, armor: 0, followRange: 100, AI: "hunt", regen: 0.1,
		visionRadius: 0, maxhp: 12, minLevel:0, weight:-1000, movePoints: 4, attackPoints: 0, attack: "", attackRange: 0, specialdialogue: "DragonheartQuest",
		Behavior: {noPlay: true},
		terrainTags: {}, floors:KDMapInit([])},
	{name: "MaidforceQuest", tags: KDMapInit(["maid", "peaceful", "alwayshelp", "noshop"]), faction: "Prisoner", lowpriority: true, armor: 0, followRange: 100, AI: "hunt", regen: 0.1,
		visionRadius: 0, maxhp: 12, minLevel:0, weight:-1000, movePoints: 4, attackPoints: 0, attack: "", attackRange: 0, specialdialogue: "MaidforceQuest",
		Behavior: {noPlay: true},
		terrainTags: {}, floors:KDMapInit([])},
	{name: "DragonLeaderDuelist", nameList: "demon", outfit: "RebelScum", style: "Earth", faction: "Enemy", bound: "DragonLeader", color: "#F92900",
		tags: KDMapInit(["opendoors", "fire", "leashing", "noshop", "dragon", "melee", "elite",
			"dragonRestraints", "unflinching", "handcuffer", "leatherRestraints", "leatherRestraintsHeavy", "fireimmune"]),
		stamina: 7,
		sprintspeed: 1.25,
		ignorechance: 0, armor: 0, followRange: 1, AI: "hunt", focusPlayer: true,
		specialCD: 3, specialAttack: "Dash", specialRemove: "BindLockWill", specialCDonAttack: true, specialAttackPoints: 1, specialRange: 3, specialMinRange: 1.5, dashThrough: true, specialsfx: "Miss",
		visionRadius: 7, maxhp: 28, minLevel:0, weight:-1000, movePoints: 2, attackPoints: 2, attack: "MeleeBindLockWill", attackWidth: 1, attackRange: 1, power: 4, dmgType: "crush", fullBoundBonus: 2,
		terrainTags: {}, shrines: ["Leather"], allFloors: true,
		dropTable: [], factionrep: {"Dragon": 0.015}, ondeath: [{type: "removeQuest", quest: "DragonheartQuest"}]},
	{name: "BanditQuest", style: "Bandit", tags: KDMapInit(["bandit", "peaceful", "alwayshelp", "noshop"]), faction: "Prisoner", lowpriority: true, armor: 0, followRange: 100, AI: "hunt", regen: 0.1,
		visionRadius: 0, maxhp: 12, minLevel:0, weight:-1000, movePoints: 4, attackPoints: 0, attack: "", attackRange: 0, specialdialogue: "BanditQuest",
		Behavior: {noPlay: true},
		terrainTags: {}, floors:KDMapInit([])},


	{name: "PinkLabAssistant", faction: "Latex", clusterWith: "alchemist", playLine: "Gagged",
		bound: "LabAssistant", color: KDBasePink,
		tags: KDMapInit(["opendoors", "pink", "nocapture", "leashing", "latexRestraints", "latexpetsuit", "human", "alchemist", "ranged", "silenceimmune", "blindimmune", "minor", "latexGag"]),
		ignorechance: 0, followRange: 4.5, AI: "hunt",
		difficulty: 0.3,
		spells: ["AmpuleBlue", "LatexBubble"], spellCooldownMult: 1, spellCooldownMod: 1, kite: 2.5, projectileAttack: true, noKiteWhenHarmless: true,
		attackLock: "White",
		stamina: 3,
		Resistance: {
			profile: ["alchemist"],
		},
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "LatexThin", aoe: 1.5, power: 3, chance: 1.0, duration: 20},
		],
		visionRadius: 6, maxhp: 6, minLevel:0, weight:-1000, movePoints: 2.5, attackPoints: 3, attack: "SpellMeleeBlindLock", attackWidth: 1, attackRange: 1, power: 1, dmgType: "glue", fullBoundBonus: 1, blindTime: 3,
		terrainTags: {pink: 1100}, shrines: ["Latex"], allFloors: true,
		dropTable: [{name: "Gold", amountMin: 5, amountMax: 10, weight: 10}, {name: "SlimeRaw", amount: 3, weight: 10}]},

	{name: "PinkAlchemist", faction: "Latex", clusterWith: "alchemist", playLine: "Gagged", bound: "Alchemist", color: KDBasePink,
		tags: KDMapInit(["opendoors", "pink", "nocapture", "leashing", "imprisonable", "latexpetsuit", "human", "alchemist", "silenceimmune", "blindimmune", "ranged", "latexRestraints", "handcuffer",
			"leatherRestraintsHeavy", "latexGag"]),
		ignorechance: 0, armor: 0, followRange: 2, AI: "hunt",
		spells: ["AmpuleBlue", "AmpuleGreen", "AmpuleYellow"], spellCooldownMult: 1, spellCooldownMod: 4, kite: 1.5, projectileAttack: true,
		attackLock: "White",
		Resistance: {
			profile: ["alchemist"],
		},
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "LatexThin", aoe: 1.5, power: 3, chance: 1.0, duration: 20},
		],
		stamina: 4,
		visionRadius: 6, maxhp: 8, minLevel:0, weight:-1000, movePoints: 2, attackPoints: 3, attack: "SpellMeleeBindLock", attackWidth: 1, attackRange: 1, power: 1, dmgType: "grope", fullBoundBonus: 2,
		terrainTags: {pink: 1100}, shrines: [], allFloors: true,
		dropTable: [{name: "Gold", amountMin: 5, amountMax: 10, weight: 10}, {name: "SlimeRaw", amount: 3, weight: 10}]},
	{name: "PinkAlkahestor", faction: "Latex", clusterWith: "alchemist", playLine: "Gagged", bound: "Alkahestor", color: KDBasePink,
		tags: KDMapInit(["pink", "opendoors", "nocapture", "antiMagic", "leashing", "latexpetsuit", "human", "alchemist", "silenceimmune", "blindimmune", "ranged", "miniboss",
			"expRestraints", "steelCuffs", "latexCollar", "latexRestraints", "handcuffer", "latexGag"]),
		ignorechance: 0, armor: 1, followRange: 2, AI: "hunt",
		spells: ["AmpuleBlue", "BubbleBurstSlime"], spellCooldownMult: 1, spellCooldownMod: 4, kite: 1.5, projectileAttack: true,
		attackLock: "Red",
		stamina: 4,
		Resistance: {
			profile: ["alchemist"],
		},
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "LatexThin", aoe: 1.5, power: 3, chance: 1.0, duration: 20},
		],
		visionRadius: 6, maxhp: 16, minLevel:4, weight:-1000, movePoints: 2, attackPoints: 3, attack: "SpellMeleeBindLock", attackWidth: 1, attackRange: 1, power: 1.5, dmgType: "grope", fullBoundBonus: 2.5,
		terrainTags: {pink: 1025}, shrines: ["Latex"], allFloors: true,
		dropTable: [{name: "Gold", amountMin: 15, amountMax: 20, weight: 10}, {name: "SlimeRaw", amount: 10, weight: 10}, {name: "HardSlimeRaw", amount: 7, weight: 10}]},
	{name: "PinkGlueTechnician", faction: "Latex", clusterWith: "alchemist", playLine: "Gagged", bound: "GlueTechnician", color: KDBasePink,
		tags: KDMapInit(["opendoors", "pink", "nocapture", "leashing", "human", "latexpetsuit", "alchemist", "ranged", "silenceimmune", "blindimmune", "unflinching", "elite",
			"expRestraints", "steelCuffs", "latexRestraints", "latexRestraintsHeavy", "latexGag", "handcuffer",]),
		ignorechance: 0, armor: 1.5, followRange: 2, AI: "hunt",
		spells: ["AmpuleYellow", "GlueBomb"], spellCooldownMult: 0.7, spellCooldownMod: 0, projectileAttack: true,
		attackLock: "White",
		stamina: 4,
		Resistance: {
			profile: ["alchemist"],
		},
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "LatexThin", aoe: 1.5, power: 3, chance: 1.0, duration: 20},
		],
		visionRadius: 7.5, maxhp: 12, minLevel:2, weight:-1000, movePoints: 2, attackPoints: 3, attack: "SpellMeleeBindLockSlow", attackWidth: 2.5, attackRange: 1, power: 2, dmgType: "tickle", fullBoundBonus: 2,
		terrainTags: {pink: 1050}, shrines: ["Latex"], allFloors: true,
		dropTable: [{name: "Gold", amountMin: 10, amountMax: 15, weight: 10}, {name: "SlimeRaw", amount: 5, weight: 10}]},

	{name: "DroneNode", faction: "AncientRobot", clusterWith: "robot", color: "#00EFAB", playLine: "Robot",
		SFX: {death: "SciFiExplode"},
		tags: KDMapInit(["ignoreharmless",
			"stunweakness", "disarmimmune", "doortrap", "robot", "flying", "drone", "server", "robotServer",
			"acidweakness", "soapweakness", "soulresist", "miniboss", "melee", "electricsevereweakness", "coldresist", "iceresist",
			"slashresist", "crushsevereweakness", "pierceweakness"]),
		followRange: 4.9, kite: 3.5, difficulty: 0.2,
		evasion: -0.2,
		maxblock: 1,
		maxdodge: 0,
		Sound: {
			baseAmount: 4.5,
			moveAmount: 4.5,
			alertAmount: 12,
			idleSoundName: "NodeHum",
		},
		shield: 5,
		AI: "hunt",  visionRadius: 9, maxhp: 4, minLevel:0, weight:-100, movePoints: 2.5, cohesion: 1.0, armor: 0, spellResist: 1.5,
		attackPoints: 3, attack: "", attackWidth: 1, attackRange: 1, tilesMinRange: 1, power: 1, dmgType: "grope",
		terrainTags: {"robotServer": 200}, floors:KDMapInit([]), shrines: ["Metal"],
		events: [
			{trigger: "afterEnemyTick", type: "DroneNodeAura", power: 10, mult: 0.04, dist: 4.5},
		],
	},
	{name: "OldDroneNode", faction: "Enemy", clusterWith: "oldrobot", color: KDBaseRed, playLine: "Robot",
		SFX: {death: "SciFiExplode"},
		tags: KDMapInit(["ignoreharmless",
			"stunweakness", "disarmimmune", "doortrap", "robot", "oldrobot", "flying", "drone", "server", "robotServer",
			"acidweakness", "soapweakness", "soulresist", "miniboss", "melee", "electricsevereweakness", "coldresist", "iceresist",
			"slashresist", "crushsevereweakness", "pierceweakness"]),
		followRange: 4.9, kite: 3.5, difficulty: 0.2,
		evasion: -0.2,
		maxblock: 1,
		maxdodge: 0,
		Sound: {
			baseAmount: 6,
			moveAmount: 7,
			alertAmount: 12,
			idleSoundName: "NodeHum",
		},
		AI: "hunt",  visionRadius: 9, maxhp: 16, minLevel:0, weight:-100, movePoints: 2.5, cohesion: 1.0, armor: 0, spellResist: 0,
		attackPoints: 3, attack: "", attackWidth: 1, attackRange: 1, tilesMinRange: 1, power: 1, dmgType: "grope",
		terrainTags: {"robotServer": 200}, floors:KDMapInit([]), shrines: ["Metal"],

	},
	{name: "WolfServer", tags: KDMapInit(["poisonmmune",
			"soulimmune",
			"server", "immobile", "wolfServer",
			"noknockback", "melee",
			"nofidget", "notalk",
			"stunweakness",
			"nonvulnerable", "nobrain",
			"passivesignal",
			"acidweakness", "soapsevereweakness"]),
		SFX: {death: "SciFiExplode"},
		faction: "Nevermere", lowpriority: true, evasion: -100, armor: -1, followRange: 100, AI: "wander",
		visionRadius: 0, maxhp: 20, minLevel:0, weight:-100, movePoints: 1000, attackPoints: 0, attack: "", attackRange: 0,
		ondeath: [
			{type: "WolfServer"}
		],
		Sound: {
			baseAmount: 5,
			moveAmount: 0,
			idleSoundName: "ServerHum",
		},
		terrainTags: {"wolfServer": 200}, floors:KDMapInit([])},


	// End Quest NPC

	{name: "DirtPile", tags: KDMapInit(["poisonmmune", "soulimmune", "dirt", "immobile", "noknockback", "melee", "nofidget", "notalk", "nonvulnerable", "nobrain", "nosignal", "acidweakness", "soapsevereweakness"]),
		faction: "Door", spellResist: -3, lowpriority: true, evasion: -100, armor: -1, followRange: 100, AI: "wander",
		visionRadius: 0, maxhp: 4, minLevel:0, weight:-1000, movePoints: 1000, attackPoints: 0, attack: "", attackRange: 0,
		ondeath: [
			{type: "DirtPile"}
		],
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
		},
		terrainTags: {}, floors:KDMapInit([])},

	{name: "ExplosiveBarrel", tags: KDMapInit(["poisonmmune", "soulimmune", "noknockback", "melee", "minor", "scenery", "explosiveBarrel", "notalk", "nonvulnerable", "nobrain", "nosignal", "immobile", "fireweakness", "stunweakness"]),
		faction: "Barrel", immobile: true, lowpriority: true, evasion: -100, armor: 1, followRange: 100, AI: "wander",
		difficulty: 0.01,
		pathcondition: "barrel",
		visionRadius: 0, maxhp: 6, minLevel:0, weight:-10, movePoints: 1000, attackPoints: 0, attack: "", attackRange: 0,
		dropTable: [{name: "Gunpowder", amount: 3, weight: 10, noSummon: true}],
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
		},
		events: [
			{trigger: "afterDamageEnemy", type: "ExplosiveBarrel", chance: 0.5, power: 3.0, spell: "ExplosiveBarrel"},
			{trigger: "afterEnemyTick", type: "createEffectTile", kind: "Gunpowder", time: 4, power: 2, chance: 0.5, aoe: 0.5},
		],
		terrainTags: {"explosiveBarrel": 40, open: -16, passage: -30}, allFloors: true},

	{name: "ChainWall",
		tags: KDMapInit(["construct", "flying", "poisonmmune", "soulimmune", "noknockback", "melee", "temporary", "notalk", "nonvulnerable", "nobrain", "nosignal",
			"bulwark", "immobile"]),
		faction: "Witch", immobile: true, spellResist: 0, lowpriority: true, evasion: -100, armor: 3, followRange: 100, AI: "wander", regen: -0.25,
		visionRadius: 0, maxhp: 5, minLevel:0, weight:-1000, movePoints: 1000, attackPoints: 0, attack: "", attackRange: 0,
		cueSfx: {
			Block: "Clang",
			Resist: "Clang",
			Damage: "ArmorHit",
		},
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
		},
		terrainTags: {}, floors:KDMapInit([])},

	{name: "IceWall",
		tags: KDMapInit(["construct", "poisonmmune", "soulimmune", "noknockback", "melee", "temporary", "notalk", "nonvulnerable", "nobrain", "nosignal", "immobile", "fireweakness",
			"bulwark", "iceimmune"]),
		faction: "Natural", immobile: true, spellResist: 0, lowpriority: true, evasion: -100, armor: 1, followRange: 100, AI: "wander", regen: -0.5,
		visionRadius: 0, maxhp: 12, minLevel:0, weight:-1000, movePoints: 1000, attackPoints: 0, attack: "", attackRange: 0,
		cueSfx: {
			Block: "Clang",
			Resist: "Clang",
			Damage: "ArmorHit",
		},
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
		},
		terrainTags: {}, floors:KDMapInit([])},

	{name: "OneBar", tags: KDMapInit(["construct", "poisonmmune", "soulimmune", "noknockback", "melee", "temporary", "notalk", "nonvulnerable", "nobrain", "nosignal", "immobile"]),
		immobile: true, spellResist: 0, lowpriority: true, evasion: -100, armor: 3, followRange: 100, AI: "wander",
		visionRadius: 0, maxhp: 4, minLevel:0, weight:-1000, movePoints: 1000, attackPoints: 0, attack: "", attackRange: 0,
		faction: "Warden",
		cueSfx: {
			Block: "Clang",
			Resist: "Clang",
			Damage: "ArmorHit",
		},
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
		},
		events: [
			{trigger: "afterEnemyTick", type: "breakDownForHumanoid", power: 2, dist: 1.5},
		],
		terrainTags: {}, floors:KDMapInit([])},

	{name: "ForceField",
		tags: KDMapInit(["construct", "flying", "poisonmmune", "soulimmune",
			"bulwark", "noknockback", "melee", "temporary", "notalk", "nonvulnerable", "nobrain", "nosignal", "immobile"]),
		faction: "Enemy", immobile: true, spellResist: 3, lowpriority: true, evasion: -100, armor: 0, followRange: 100, AI: "wander", regen: -0.6,
		visionRadius: 0, maxhp: 12, minLevel:0, weight:-1000, movePoints: 1000, attackPoints: 0, attack: "", attackRange: 0,

		terrainTags: {}, floors:KDMapInit([])},


	// Door lock, trap
	{name: "DoorLock",
		tags: KDMapInit(["construct", "soulimmune", "melee", "noknockback", "unstoppable", "temporary",
			"bulwark", "nonvulnerable", "nobrain", "nosignal", "immobile", "poisonimmune",
			"soulimmune",
		]), faction: "KinkyConstruct", immobile: true, lowpriority: true, spellResist: 1.5, evasion: -100, armor: 3, followRange: 100, AI: "wander", regen: -1.0,
		visionRadius: 0, maxhp: 30, minLevel:0, weight:-1000, movePoints: 1000, attackPoints: 0, attack: "", attackRange: 0,
		terrainTags: {}, floors:KDMapInit([]),
		events: [
			{trigger: "duringDamageEnemy", type: "damageThreshold", power: 1, chance: 1.0},
		],
	},

	{name: "EarthenMonolith", tags: KDMapInit(["construct", "poisonimmune", "soulimmune", "player", "playerinstakill", "noknockback", "melee", "temporary", "notalk", "immobile", "summonedRock", "fireresist", "nonvulnerable", "nobrain", "nosignal"]), immobile: true, spellResist: 1.0, faction: "Rock", lowpriority: true, evasion: -100, armor: 2.5, followRange: 100, AI: "wander", regen: -0.25,
		visionRadius: 0, maxhp: 5, minLevel:0, weight:-1000, movePoints: 1000, attackPoints: 0, attack: "", attackRange: 0,
		terrainTags: {}, floors:KDMapInit([])},

	{name: "Wall",
		tags: KDMapInit(["construct", "player", "playerinstakill", "noknockback", "melee", "temporary", "notalk", "nonvulnerable", "immobile",
			"bulwark", "nobrain", "nosignal"]),
		immobile: true, spellResist: 4, allied: true, lowpriority: true, evasion: -100, armor: 1, followRange: 100, AI: "wander", regen: -1.0,
		Resistance: {
			profile: ["construct"],
		},
		visionRadius: 0, maxhp: 15, minLevel:0, weight:-1000, movePoints: 1000, attackPoints: 0, attack: "", attackRange: 0,
		terrainTags: {}, floors:KDMapInit([])},
	{name: "WallDoor",
		tags: KDMapInit(["construct", "player", "playerinstakill", "noknockback", "melee", "temporary", "notalk",
			"bulwark", "nonvulnerable", "immobile", "nobrain", "nosignal"]),
		immobile: true, spellResist: 4, allied: true, lowpriority: true, evasion: -100, armor: 2.5, followRange: 100, AI: "wander", regen: -0.8,
		Resistance: {
			profile: ["construct"],
		},
		visionRadius: 0, maxhp: 25, minLevel:0, weight:-1000, movePoints: 1000, attackPoints: 0, attack: "", attackRange: 0,
		terrainTags: {}, floors:KDMapInit([])},
	{name: "StaticSphere", tags: KDMapInit(["construct", "flying", "poisonimmune", "silenceimmune", "blindimmune", "soulimmune", "player", "playerinstakill", "noknockback", "melee", "electricImmune", "nowet", "immobile", "temporary", "notalk", "nonvulnerable", "nobrain", "nosignal"]), immobile: true, spellResist: 4, allied: true, lowpriority: true, evasion: -100, armor: 1, followRange: 100, AI: "wander",
		visionRadius: 0, maxhp: 20, minLevel:0, weight:-1000, movePoints: 1000, attackPoints: 0, attack: "", attackRange: 0,
		terrainTags: {}, floors:KDMapInit([]),
		events: [
			{type: "CastSpellNearbyEnemy", trigger: "afterEnemyTick", spell: "StaticSphereStrike", aoe: 1.5, player: false},
			{type: "ApplyConductionAoE", trigger: "afterEnemyTick", aoe: 1.5},
			{trigger: "getLights", type: "enemyTorch", power: 5, color: KDBaseWhite},
		],
	},
	{name: "Decoy", tags: KDMapInit(["construct", "nosignal", "poisonimmune", "soulimmune", "player", "temporary", "notalk", "deaf"]), noblockplayer: true, allied: true, evasion: 3, armor: 0,
		followRange: 100, AI: "wander", triggersTraps: true,
		visionRadius: 0, maxhp: 12, minLevel:0, weight:-1000, movePoints: 2, attackPoints: 0, attack: "", attackRange: 0,
		maxblock: 0,
		maxdodge: 3,
		terrainTags: {}, floors:KDMapInit([])},
	{name: "Ally", tags: KDMapInit(["ghost", "flying", "silenceimmune", "blindimmune", "player", "melee"]), keepLevel: true, allied: true, armor: 0, followRange: 1, AI: "hunt", evasion: 0.33, accuracy: 1.5,
		visionRadius: 20, playerBlindSight: 100, maxhp: 8, minLevel:0, weight:-1000, movePoints: 1, attackPoints: 1, attack: "MeleeWill", attackRange: 1, attackWidth: 3, power: 1, dmgType: "slash", CountLimit: true,
		stamina: 4,
		maxblock: 0,
		maxdodge: 2,
		nonDirectional: true,
		terrainTags: {}, floors:KDMapInit([])},
	{name: "AllyDoll", bound: "AllyDoll", color: "#9c2a70", tags: KDMapInit(["human", "nocapture", "player", "blindweakness", "gagged", "blindfold", "melee", "glueimmune", "tickleweakness", "nohelp"]), allied: true, armor: 0, followRange: 1, AI: "hunt",
		visionRadius: 20, playerBlindSight: 100, maxhp: 8, regen: -0.1, minLevel:0, weight:-1000, movePoints: 2, attackPoints: 2, attack: "MeleeWill", attackRange: 1, attackWidth: 1, power: 1.5, dmgType: "glue", events: [
			{trigger: "tick", type: "secretToy"},
		],
		stamina: 2,
		maxblock: 0,
		maxdodge: 0,
		nonDirectional: true,
		terrainTags: {}, floors:KDMapInit([])},
	{name: "PetChastity", bound: "AllyDoll", color: KDBaseLightBlue, tags: KDMapInit(["human", "nocapture", "player", "gagged", "blindfold", "melee", "charmresist", "soulweakness", "tickleweakness", "nohelp"]), armor: 1.0, followRange: 1, AI: "hunt",
		visionRadius: 6, maxhp: 8, minLevel:0, weight:-1000, movePoints: 3, attackPoints: 2, attack: "MeleeWill", attackRange: 1, attackWidth: 1, power: 2, dmgType: "charm", events: [
			{trigger: "tick", type: "secretToy"},
		],
		stamina: 10,
		maxblock: 0,
		maxdodge: 0,
		sprintspeed: 3.0,
		nonDirectional: true,
		terrainTags: {}, floors:KDMapInit([])},
	{name: "Pet", color: KDBaseLightBlue, tags: KDMapInit(["human", "nocapture", "player", "gagged", "melee", "tickleweakness", "nohelp"]), allied: true, armor: 0, followRange: 4, AI: "hunt",
		events: [
			{trigger: "calcManaPool", type: "PetManaRegen", power: 0.01, dist: 1.5},
			{trigger: "tick", type: "secretToy"},
		],
		stamina: 4,
		maxblock: 0,
		maxdodge: 0,
		nonDirectional: true,
		visionRadius: 20, playerBlindSight: 100, maxhp: 10, minLevel:0, weight:-1000, movePoints: 1, attackPoints: 2, attack: "", attackRange: 0, power: 1.5, dmgType: "tickle", focusPlayer: true,
		terrainTags: {}, floors:KDMapInit([])},
	{name: "PetDisplay", color: KDBaseLightBlue, tags: KDMapInit(["human", "nocapture", "player", "gagged", "melee", "meleeresist", "nohelp"]), immobile: true, allied: true, armor: 1.5, followRange: 4, AI: "hunt",
		events: [
			{trigger: "calcManaPool", type: "PetManaRegen", power: 0.04, dist: 3.99},
			{trigger: "tick", type: "DisplayAura", power: 0.5, dist: 3.99},
			{trigger: "tick", type: "secretToy"},
		],
		nonDirectional: true,
		evasion: -9,
		maxblock: 0,
		maxdodge: 0,
		visionRadius: 0, playerBlindSight: 100, maxhp: 15, minLevel:0, weight:-1000, movePoints: 9999, attackPoints: 2, attack: "", attackRange: 0, power: 1.5, dmgType: "tickle", focusPlayer: true,
		terrainTags: {}, floors:KDMapInit([])},
	{name: "PlayerGag", tags: KDMapInit(["construct", "nosignal", "poisonresist", "silenceimmune", "blindimmune", "soulimmune", "player", "melee", "temporary", "notalk"]), noblockplayer: true, allied: true, armor: 0, followRange: 1, AI: "guard", accuracy: 1.5, noTargetSilenced: true,
		visionRadius: 20, playerBlindSight: 100, maxhp: 4, minLevel:0, weight:-1000, movePoints: 1, attackPoints: 1, attack: "MeleeWillSilenceSuicideStun",
		nonDirectional: true,
		maxblock: 0,
		maxdodge: 0,
		silenceTime: 9, stunTime: 1, attackRange: 1, attackWidth: 1, power: 3.5, dmgType: "grope",
		terrainTags: {}, floors:KDMapInit([])},
	{name: "ShadowWarrior", tags: KDMapInit(["ghost", "player", "shadow", "flying", "melee", "silenceimmune", "blindimmune", "tickleimmune", "glueimmune", "temporary", "notalk"]),
		allied: true, armor: 0, followRange: 1, AI: "hunt", evasion: 1,
		spells: ["AllyShadowStrike"], spellCooldownMult: 1, spellCooldownMod: 0,
		visionRadius: 5.99, playerBlindSight: 100, maxhp: 11, minLevel:0, weight:-1000, movePoints: 1, attackPoints: 1, attack: "Spell", attackRange: 0, power: 1,
		stamina: 4,
		maxblock: 0,
		maxdodge: 0,
		nonDirectional: true,
		dmgType: "holy",
		terrainTags: {}, floors:KDMapInit([])},

	{name: "FireElemental", color: "#FF6200", tags: KDMapInit(["elemental", "flying", "silenceimmune", "blindimmune", "fire", "player", "ranged", "charmimmune", "fireimmune", "coldweakness", "soapweakness", "icesevereweakness", "stunweakness", "nohelp"]),
		keepLevel: true, allied: true, armor: 0, kite: 1.5, followRange: 3, playerFollowRange: 1, AI: "hunt",
		spells: ["AllyFirebolt"], spellCooldownMult: 1, spellCooldownMod: 0,  castWhileMoving: true, spellRdy: true, evasion: 0.5, CountLimit: true,
		visionRadius: 20, playerBlindSight: 100, maxhp: 8, minLevel:0, weight:-1000, movePoints: 1, attackPoints: 1, attack: "Spell", attackRange: 0, power: 1,
		terrainTags: {}, floors:KDMapInit([]),
		stamina: 3,
		maxblock: 0,
		maxdodge: 1,
		nonDirectional: true,
		events: [
			{trigger: "afterEnemyTick", type: "createEffectTile", kind: "Ember", time: 3, power: 2, chance: 0.2, aoe: 1.5},
			{trigger: "getLights", type: "enemyTorch", power: 5.5, color: "#ff8933"},
		],
	},
	{name: "NatureSpirit", color: KDBaseMint, tags: KDMapInit(["elemental", "flying", "silenceimmune", "blindimmune", "defensive", "nature", "player", "ranged", "groperesist", "crushresist", "chainresist", "glueresist", "charmimmune", "fireweakness", "soapimmune", "acidweakness", "slashweakness", "holyresist", "nohelp"]),
		keepLevel: true, allied: true, armor: 0, followRange: 1.5, playerFollowRange: 1, AI: "hunt",
		spells: ["NatureMoteBolt"], spellCooldownMult: 1, spellCooldownMod: 0,  castWhileMoving: true, spellRdy: true, evasion: -0.2, CountLimit: true,
		spellResist: 1, kite: 2.5,
		visionRadius: 20, playerBlindSight: 100, maxhp: 12, minLevel:0, weight:-1000, movePoints: 1, attackPoints: 1, attack: "Spell", attackRange: 0, power: 2,
		terrainTags: {}, floors:KDMapInit([]),
		stamina: 0,
		maxblock: 0,
		maxdodge: 0,
		nonDirectional: true,
		events: [
			{trigger: "afterEnemyTick", type: "createEffectTile", kind: "Vines", time: 3, power: 2, chance: 0.2, aoe: 1.5},
			{trigger: "getLights", type: "enemyTorch", power: 2.5, color: KDBaseLightGreen},
			{trigger: "afterEnemyTick", type: "NatureSpiritAura", power: 0.2, mult: 1.5, dist: 4.5},
		],
	},
	{name: "HolyOrb", immobile: true, color: "#FFFF88", tags: KDMapInit(["holy", "ghost", "flying", "silenceimmune", "blindimmune", "player", "ranged", "soulresist", "unstoppable", "coldsevereweakness", "flying", "holyresist", "nohelp"]),
		allied: true, armor: 0, followRange: 1.5, playerFollowRange: 1, AI: "hunt",
		spells: ["AllyHolyBolt"], spellCooldownMult: 1, spellCooldownMod: 0,  castWhileMoving: true, evasion: -10,
		spellResist: 3,
		visionRadius: 20, playerBlindSight: 100, maxhp: 16, minLevel:0, weight:-1000, movePoints: 1000, attackPoints: 1, attack: "Spell", attackRange: 0, power: 3,
		terrainTags: {}, floors:KDMapInit([]),
		stamina: 0,
		maxblock: 0,
		maxdodge: 0,
		nonDirectional: true,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 7.99, color: "#ffff88"},
			{trigger: "afterEnemyTick", type: "HolyOrbAura", power: 0.2, mult: 1.5, dist: 7.99},
			{trigger: "orgasm", type: "HolyOrbPunish", dist: 7.99},
		],
	},
	{name: "WaterMote", color: "#73efe8", tags: KDMapInit(["elemental", "flying", "silenceimmune", "blindimmune", "water", "player", "melee", "charmimmune", "fireresist", "iceweakness", "soapimmune", "acidresist", "electricsevereweakness", "nohelp"]),
		keepLevel: true, allied: true, armor: 0, followRange: 1, playerFollowRange: 1, AI: "hunt",
		evasion: 1.0, CountLimit: true, specialAttack: "Stun", specialCD: 6,
		stamina: 4,
		maxblock: 0,
		maxdodge: 2,
		nonDirectional: true,
		visionRadius: 20, playerBlindSight: 100, maxhp: 14, minLevel:0, weight:-1000, movePoints: 1, attackPoints: 2, attack: "MeleeWill", attackRange: 1, attackWidth: 1, power: 2, stunTime: 2, dmgType: "soap",
		terrainTags: {}, floors:KDMapInit([]),
		events: [{trigger: "afterEnemyTick", type: "createWater", power: 1, chance: 0.5, aoe: 0.5}],},
	{name: "EarthMote", color: KDBaseRed, tags: KDMapInit(["elemental", "flying", "silenceimmune", "blindimmune", "earth", "player", "melee", "charmimmune", "fireresist", "electricresist", "tickleresist", "nohelp"]), keepLevel: true, allied: true, followRange: 1, playerFollowRange: 1, AI: "hunt",
		evasion: -0.4, armor: 2.0, spellResist: 0.5, CountLimit: true,
		stamina: 4,
		maxblock: 2,
		maxdodge: 0,
		nonDirectional: true,
		visionRadius: 20, playerBlindSight: 100, maxhp: 12, minLevel:0, weight:-1000, movePoints: 1, attackPoints: 4, attack: "MeleeWillSlow", attackRange: 1, attackWidth: 1, power: 6, dmgType: "crush",
		terrainTags: {}, floors:KDMapInit([]),
		events: [{trigger: "death", type: "createEffectTile", kind: "Cracked", power: 1, chance: 1, aoe: 0.5, time: 40, variance: 10}],},
	{name: "AirMote", color: KDBaseWhite, tags: KDMapInit(["elemental", "flying", "air", "silenceimmune", "defensive", "blindimmune", "nowet", "player", "ranged", "charmimmune", "fireweakness", "electricresist", "stunimmune", "painresist", "tickleweakness", "groperesist", "nohelp"]), keepLevel: true, allied: true, followRange: 3, kite: 1.5, playerFollowRange: 1, AI: "hunt",
		spells: ["AllyWindBlast"], spellCooldownMult: 1, spellCooldownMod: 0, spellRdy: true, evasion: 1.0, CountLimit: true, castWhileMoving: true,
		stamina: 4,
		maxblock: 0,
		maxdodge: 2,
		nonDirectional: true,
		visionRadius: 20, playerBlindSight: 100, maxhp: 8, minLevel:0, weight:-1000, movePoints: 1, attackPoints: 1, attack: "Spell", attackRange: 0, power: 1,
		terrainTags: {}, floors:KDMapInit([])},

	{name: "Golem",
		tags: KDMapInit(["construct", "nosignal", "poisonimmune", "disarmresist", "blindresist", "soulimmune",
			"bulwark", "player", "melee", "fireresist", "unstoppable", "tickleresist", "groperesist", "electricresist", "notalk"]),
		keepLevel: true, allied: true, armor: 2.0, spellResist: 0.4, followRange: 1, AI: "hunt",
		visionRadius: 20, playerBlindSight: 100, maxhp: 18, minLevel:0, weight:-1000, movePoints: 2, attackPoints: 3, attack: "MeleeWill", attackRange: 1, attackWidth: 1, power: 4.5, accuracy: 0.7, CountLimit: true,
		stamina: 4,
		nonDirectional: true, dmgType: "crush",
		terrainTags: {}, floors:KDMapInit([])},
	{name: "StormCrystal", tags: KDMapInit(["construct", "nosignal", "flying", "silenceimmune", "blindimmune", "poisonimmune", "soulimmune", "player", "ranged", "unstoppable", "meleeresist", "tickleimmune", "electricimmune", "soulimmune", "temporary", "notalk", "nonvulnerable", "immobile", "nobrain", "nosignal"]), immobile: true, noblockplayer: true, allied: true, armor: 1.5, followRange: 1, AI: "wander", evasion: -10,
		spells: ["AllyCrackle"], spellCooldownMult: 1, spellCooldownMod: 0, castWhileMoving: true, movePoints: 1000,
		nonDirectional: true, noFlip: true,
		visionRadius: 6, maxhp: 30, regen: -1, minLevel:0, weight:-1000, attackPoints: 1, attack: "Spell", attackRange: 0, power: 1,
		terrainTags: {}, floors:KDMapInit([]),
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 8, color: KDBaseLightBlue},
		],
	},


	{name: "HolyConstruct", nonHumanoid: true, faction: "Angel", clusterWith: "angel", color: "#ffffaa", tags: KDMapInit(["opendoors", "minor", "holy", "holyresist", "construct", "nosignal", "ranged", "soulimmune", "meleeresist", "unstoppable", "celestialRopes", "coldsevereweakness", "flying"]),
		cohesion: 0.7, cohesionRange: 10,
		spellResist: 3,
		nonDirectional: true,
		maxblock: 0,
		maxdodge: 1,
		followLeashedOnly: true, ignorechance: 0, armor: 0.5, followRange: 3, AI: "hunt", buffallies: true,
		spells: ["OrbHeal", "CelestialBolt"], spellCooldownMult: 2, spellCooldownMod: 0, tilesMinRange: 1, stopToCast: true, kite: 1.5, kiteChance: 0.9,
		visionRadius: 10, maxhp: 7, minLevel: 0, weight: -1, movePoints: 3, attackPoints: 4, attack: "SpellMeleeBlindBind", blindTime: 3, attackWidth: 8, attackRange: 1, power: 4, dmgType: "fire",
		terrainTags: {"goddessRage":7, "willPleased":2, "willFriendly":2, "angel": 6}, shrines: ["Will"], allFloors: true, dropTable: [{name: "Ectoplasm", weight: 9}, {name: "ElfCrystal", weight: 3}],
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 3, color: "#ffff44"}
		],
	},

	{name: "Angel", bound: "Angel", outfit: "Angel", style: "Angel", faction: "Angel", color:"#ffffaa", tags: KDMapInit(["angel", "flying", "ranged", "holyimmune", "divineRestraints", "coldweakness", "meleeresist", "unflinching"]),
		followRange: 0, AI: "hunt", evasion: 0.25, attackWhileMoving: true,
		Behavior: {
			noPlay: true,
		},
		maxblock: 2,
		maxdodge: 2,
		armor: 2.5, spellResist: 2.5,
		spells: ["HeatBolt", "WitchElectrify", "EnemyCorona"], spellCooldownMult: 0, spellCooldownMod: 4, castWhileMoving: true, noSpellsLowSP: true, spellRdy: true,
		visionRadius: 10, maxhp: 25, minLevel: 4, movePoints: 1.7, attackPoints: 3, attack: "SpellMeleeBindLock", attackRange: 1, attackWidth: 3, power: 2, fullBoundBonus: 4, dmgType: "tickle",
		attackLock: "Blue",
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 6, color: "#ffff44"},
		],
		terrainTags: {"goddessRage": 0.4, "increasingWeight": 0.2, "goddessAnger": 0.6, "angel": 3,}, allFloors: true, weight: -0.5,
		dropTable: [{name: "MagicSword", weight: 1, ignoreInInventory: true}, {name: "MagicSpear", weight: 1, ignoreInInventory: true}, {name: "MagicAxe", weight: 1, ignoreInInventory: true}, {name: "MagicFlail", weight: 1, ignoreInInventory: true}, {name: "MagicHammer", weight: 1, ignoreInInventory: true}],
		rep: {"Will": -1, "Elements": -1, "Conjure": -1, "Illusion": -1}},

	{name: "BlindZombie", bound: "Zombie", style: "Zombie", outfit: "Zombie", playLine: "Zombie", clusterWith: "zombie", tags: KDMapInit(["ignoretiedup", "nocapture", "minor", "zombie", "melee", "fireweakness", "ribbonRestraints", "meleeweakness"]),
		evasion: -1, ignorechance: 0.33, armor: 0, followRange: 1, AI: "wander",
		visionRadius: 2.5, maxhp: 8, minLevel:0, weight:14, movePoints: 3, attackPoints: 4, attack: "MeleeBind", attackWidth: 1, attackRange: 1, power: 1, dmgType: "grope", fullBoundBonus: 1,
		terrainTags: {"increasingWeight":-1.5}, floors:KDMapInit(["grv"]), dropTable: [], difficulty: 0.9},
	{name: "FastZombie", bound: "Zombie", style: "Zombie", outfit: "Zombie", playLine: "Zombie", clusterWith: "zombie", tags: KDMapInit(["ignoretiedup", "nocapture", "zombie", "melee", "fireweakness", "ribbonRestraints", "meleeweakness"]),
		evasion: -1, ignorechance: 0.33, armor: 1, followRange: 1, AI: "hunt",
		stamina: 3,
		visionRadius: 5, maxhp: 10, minLevel:0, weight:9, movePoints: 3, attackPoints: 4, attack: "MeleeBind", attackWidth: 1, attackRange: 1, power: 1, dmgType: "grope", fullBoundBonus: 1,
		terrainTags: {"secondhalf":10, "lastthird":14}, floors:KDMapInit(["grv"]), dropTable: [{name: "Gold", amountMin: 5, amountMax: 10, weight: 10}]},
	{name: "SummonedZombie", bound: "Zombie", style: "Zombie", outfit: "Zombie", playLine: "Zombie", clusterWith: "zombie", tags: KDMapInit(["ignoretiedup", "nocapture", "zombieTrap", "zombie", "melee", "fireweakness", "ribbonRestraints", "meleeweakness", "temporary", "nocapture"]),
		evasion: -1, ignorechance: 0.33, armor: 1.5, followRange: 1, AI: "hunt", regen: -0.1,
		Behavior: {
			leashCondition: "fuukaLeash",
		},
		visionRadius: 5, maxhp: 12, minLevel:0, weight:-1000, movePoints: 3, attackPoints: 3, attack: "MeleeBind", attackWidth: 1, attackRange: 1, power: 1, dmgType: "grope", fullBoundBonus: 1,
		terrainTags: {"secondhalf":10, "zombieTrap": 50, "lastthird":14}, floors:KDMapInit([])},
	{name: "MageZombie", bound: "MageZombie", style: "Zombie", outfit: "Zombie", playLine: "Zombie", clusterWith: "zombie", tags: KDMapInit(["leashing", "zombie", "ranged", "zombieTrap", "fireweakness", "ribbonRestraints", "meleeweakness", "hunter"]),
		spellResist: 0.5, evasion: -1, armor: 1, followRange: 2, AI: "hunt",
		spells: ["ZombieOrb", "ZombieOrbIce"], spellCooldownMult: 1, spellCooldownMod: 0, castWhileMoving: true, projectileAttack: true,
		visionRadius: 6, maxhp: 11, minLevel:2, weight:14, movePoints: 3, attackPoints: 4, attack: "SpellMeleeBindLock", attackWidth: 1, attackRange: 1, power: 1, dmgType: "grope", fullBoundBonus: 2,
		attackLock: "Purple",
		terrainTags: {"zombieTrap": 25}, floors:KDMapInit(["grv", "tmb"]), dropTable: [{name: "Gold", amountMin: 10, amountMax: 20, weight: 10}]},
	{name: "TalismanZombie", bound: "TalismanZombie", style: "Zombie", outfit: "Zombie", playLine: "Zombie", clusterWith: "zombie", tags: KDMapInit(["leashing", "zombie", "zombieTrap", "ranged", "fireweakness", "ribbonRestraints", "meleeweakness", "hunter"]),
		spellResist: 0.5, evasion: -1, armor: 1, followRange: 3, AI: "hunt",
		spells: ["ZombieOrb", "ZombieBuff", "OrbHeal", "EnemyCM1"], unlockCommandLevel: 1, unlockCommandCD: 90, spellCooldownMult: 1, spellCooldownMod: 0, castWhileMoving: true, buffallies: true, kite: 1.5, projectileAttack: true,
		visionRadius: 6, maxhp: 20, minLevel:3, weight:14, movePoints: 3, attackPoints: 4, attack: "SpellMeleeBindLock", attackWidth: 1, attackRange: 1, power: 1, dmgType: "grope", fullBoundBonus: 2,
		attackLock: "Purple",
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 3, color: "#ffff44"},
		],
		terrainTags: {"mummy": 3, "zombieTrap": 10}, floors:KDMapInit(["grv", "tmb"]), dropTable: [{name: "Gold", amountMin: 10, amountMax: 20, weight: 10}]},
	{name: "SamuraiZombie", bound: "SamuraiZombie", style: "Zombie", outfit: "Zombie", playLine: "Zombie", clusterWith: "zombie",
		tags: KDMapInit(["leashing", "zombie",
			"bulwark", "zombieTrap", "melee", "elite", "fireweakness", "unflinching", "ropeRestraints", "ropeRestraints2", "meleeweakness", "hunter"]),
		evasion: -1, armor: 1, followRange: 1, AI: "hunt",
		stunTime: 2, specialCD: 6, specialAttack: "Stun", specialRemove: "BindLock", specialPower: 5, specialDamage: "pain",
		attackLock: "White",
		Resistance: {
			block_phys: 2,
		},
		stamina: 2,
		specialCDonAttack: false, visionRadius: 6, maxhp: 20, minLevel:4, weight:9, movePoints: 3, attackPoints: 3, attack: "MeleeBindLock",
		attackWidth: 1, attackRange: 1, power: 2, dmgType: "grope", fullBoundBonus: 3, specialWidth: 5, specialRange: 1,
		terrainTags: {"secondhalf":5, "zombieTrap": 20, "lastthird":5}, shrines: ["Will"], floors:KDMapInit(["grv", "tmb"]), dropTable: [{name: "Gold", amountMin: 15, amountMax: 20, weight: 10}, {name: "Sword", weight: 3.5, ignoreInInventory: true},]},
	{name: "NawashiZombie", bound: "NawashiZombie", style: "Zombie", outfit: "Zombie", playLine: "Zombie", clusterWith: "zombie", tags: KDMapInit(["leashing", "zombie", "zombieTrap", "melee", "elite", "fireweakness", "unflinching", "ropeRestraints", "ropeRestraints2", "meleeweakness", "hunter"]),
		evasion: -1, armor: 0, followRange: 1, AI: "hunt",
		visionRadius: 8, maxhp: 11, minLevel:2, weight:2, movePoints: 2, attackPoints: 2, attack: "MeleeBind", attackWidth: 1, attackRange: 1, power: 1, dmgType: "grope", fullBoundBonus: 2, difficulty: 1.4,
		terrainTags: {"secondhalf":1, "lastthird":2}, shrines: [], floors:KDMapInit(["grv", "tmb"]), dropTable: [{name: "Gold", amountMin: 5, amountMax: 15, weight: 10}, {name: "Rope", weight: 3.5, ignoreInInventory: true}, {name: "Scissors", weight: 0.5, ignoreInInventory: true},]},

	{name: "Ninja", nameList: "japanese", playLine: "Hunter", outfit: "Ninja", style: "Fire", faction: "Bountyhunter", bound: "Ninja", clusterWith: "human", color: "#814BB7", tags: KDMapInit(["leashing", "shadowclan", "antiMagic", "opendoors", "human", "guardCall", "imprisonable", "bountyhunter", "ninja", "melee", "ropeRestraints", "ropeRestraints2", "jailer", "unarmedresist", "pierceresist", "slashresist", "glueweakness", "chainweakness", "search"]), followLeashedOnly: true, blindSight: 5, followRange: 1, AI: "hunt", projectileAttack: true,
		stunTime: 4, specialCD: 6, specialCharges: 6, specialAttack: "Stun", specialRemove: "BindLock", specialCDonAttack: true, strictAttackLOS: true, focusPlayer: true,
		projectileTargeting: true,
		Sound: {
			baseAmount: 0.5,
			moveAmount: 4,
			decay: 1.5,
		},
		Resistance: {
			block_phys: 3,
		},
		armor: -1,
		preferDodge: true,
		maxblock: 2,
		maxdodge: 2,
		stamina: 8,
		attackLock: "White",
		visionRadius: 7, maxhp: 9, minLevel:4, weight:5, movePoints: 1, attackPoints: 3, attack: "MeleeBindLock", attackWidth: 1, attackRange: 1, power: 1.5, dmgType: "crush", fullBoundBonus: 1.5, specialWidth: 1, specialAttackPoints: 3, specialRange: 4, specialMinRange: 1.5, //specialFollow: 3,
		terrainTags: {"secondhalf":3, "lastthird":7, "ropeAnger": 2, "bountyhunter": 8, "rope": 5}, shrines: ["Illusion", "Rope"], floors:KDMapInit(["cat", "tmb", "tmp", "cry"]),
		dropTable: [{name: "Gold", amountMin: 5, amountMax: 10, weight: 10}]},
	{name: "Deputy", playLine: "Officer", color: "#1451f1", faction: "Bountyhunter", bound: "Deputy", outfit: "Bountyhunter", style: "Water", clusterWith: "human", tags: KDMapInit(["leashing", "antiMagic", "opendoors", "imprisonable", "human", "police", "guardCall", "bountyhunter", "handcuffer", "steelCuffs", "police", "melee", "search", "jail", "jailer"]),
		followLeashedOnly: true, blindSight: 5, followRange: 1, AI: "hunt", projectileAttack: true,
		projectileTargeting: true,
		armor: 0.8,
		stamina: 1,
		maxblock: 2,
		maxdodge: 1, evasion: -0.3,
		stunTime: 5, specialCD: 11, specialCharges: 4, specialAttack: "Stun", specialRemove: "BindLock", specialCDonAttack: true, strictAttackLOS: true, specialWidth: 2, specialAttackPoints: 4, specialRange: 5, specialMinRange: 1.5, //specialFollow: 3,
		visionRadius: 8, maxhp: 12, minLevel:2, weight:1, movePoints: 1.5, attackPoints: 3, attack: "MeleeBindLock", attackWidth: 1, attackRange: 1, power: 1, dmgType: "grope", fullBoundBonus: 3,
		attackLock: "White",
		terrainTags: {"secondhalf":2, "lastthird":4, "leatherAnger": 2, "metalAnger": 2, "bountyhunter": 8, "metal": 2, "NoPolice": -10000}, shrines: ["Leather", "Metal"], floors:KDMapInit(["grv", "jng", "lib", "cry"]),
		dropTable: [{name: "Donut", weight: 1}]},
	{name: "NinjaStalker", nameList: "japanese", playLine: "Hunter", faction: "Bountyhunter", bound: "NinjaStalker", outfit: "Ninja", style: "Ice", clusterWith: "human", color: "#814BB7", tags: KDMapInit(["leashing", "shadowclan", "antiMagic", "opendoors", "ninja", "human", "bountyhunter", "melee", "ropeRestraints", "ropeRestraints2", "unarmedresist", "pierceresist", "slashresist", "glueweakness", "chainweakness", "search"]), blindSight: 5, followRange: 1, AI: "ambush", stealth: 1, noReveal: true,
		ambushRadius: 1.9, wanderTillSees: true, visionRadius: 7, maxhp: 9, minLevel:4, weight:4, movePoints: 1, attackPoints: 3, focusPlayer: true,
		Sound: {
			baseAmount: 0.25,
			moveAmount: 3,
			decay: 1.5,
		},
		preferDodge: true,
		maxblock: 1,
		maxdodge: 2,
		stamina: 8,
		Resistance: {
			block_phys: 2,
		},
		armor: -1,
		attackLock: "White",
		attack: "MeleeBindLock", attackWidth: 1, attackRange: 1, power: 3, dmgType: "crush", fullBoundBonus: 2, specialWidth: 1, specialAttackPoints: 3, specialRange: 4, specialMinRange: 1.5, //specialFollow: 3,
		terrainTags: {"secondhalf":3, "lastthird":7, "ropeAnger": 2, "bountyhunter": 8, "rope": 5}, shrines: ["Illusion", "Rope"], floors:KDMapInit(["cat", "tmb", "tmp", "cry"]),
		dropTable: [{name: "Gold", amountMin: 5, amountMax: 10, weight: 10}]},
	{name: "Nawashi", nameList: "japanese", playLine: "Hunter", outfit: "Sailor", style: "Earth",
		faction: "Bountyhunter", bound: "Nawashi", clusterWith: "construct", color: "#5261ff",
		tags: KDMapInit(["leashing", "antiMagic", "opendoors", "guardCall", "human", "bountyhunter", "elite", "melee", "ropeRestraints", "ropeRestraints2", "ropeRestraintsWrist", "ropeAuxiliary", "jail", "jailer", "ropeRestraintsHogtie"]),
		spells: ["RopeAttack"], spellCooldownMult: 1, spellCooldownMod: 0, castWhileMoving: true, stealth: 2, noReveal: true, focusPlayer: true,
		followLeashedOnly: true, blindSight: 10, followRange: 1, kite: 3, AI: "hunt", evasion: 0.5, dontKiteWhenDisabled: true,
		stamina: 6,
		preferDodge: true,
		maxblock: 1,
		maxdodge: 3,
		visionRadius: 7, maxhp: 22, minLevel:8, weight:1, movePoints: 1.5, attackPoints: 2, attack: "SpellMeleeBind", attackWidth: 1, attackRange: 1, power: 2, dmgType: "crush", fullBoundBonus: 1, specialWidth: 1, specialAttackPoints: 3, specialRange: 4, specialMinRange: 1.5, //specialFollow: 3,
		terrainTags: {"secondhalf":1, "lastthird":2, "ropeAnger": 1, "ropeRage": 1, "bountyhunter": 4, "rope": 5}, shrines: ["Rope"], allFloors: true,
		dropTable: [{name: "Gold", amountMin: 20, amountMax: 30, weight: 10}, {name: "Scissors", ignoreInInventory: true, weight: 10}, {name: "EnchKnife", ignoreInInventory: true, weight: 1}, {name: "Rope", weight: 100, ignoreInInventory: true},]},

	{name: "Maidforce", nameList: "maid", faction: "Maidforce", bound: "Maid", outfit: "Maidforce", style: "Maid", clusterWith: "maid", playLine: "SubMaid", color: "#814BB7", tags: KDMapInit(["leashing", "submissive", "tickleweakness", "imprisonable", "opendoors", "human", "minor", "maid", "melee", "ropeRestraints", "ropeRestraints2", "handcuffer", "maidVibeRestraintsLimited", "maidRestraintsLight", "jail", "jailer", "search"]), blindSight: 3, followRange: 1, AI: "hunt",
		stealth: 3.5, noReveal: true, bindOnDisableSpecial: true, bindOnDisable: true,  events: [
			{trigger: "tick", type: "secretToy"},
		],
		Sound: {
			baseAmount: 1,
			moveAmount: 5,
			decay: 1.5,
		},
		preferDodge: true,
		stamina: 4,
		maxblock: 0,
		maxdodge: 1,
		smartBind: true,
		attackLock: "White",
		specialCD: 3, specialAttack: "BindLock", specialCDonAttack: true,
		visionRadius: 6, maxhp: 8, minLevel:0, weight:-2, movePoints: 2, attackPoints: 2, attack: "MeleeWill", attackWidth: 1, attackRange: 1, power: 2, dmgType: "tickle", fullBoundBonus: 2,
		terrainTags: {"secondhalf":1, "lastthird":1, "illusionAnger": 22, "illusionRage": 12, "increasingWeight":-1, "maid": 25}, shrines: ["Illusion"], allFloors: true,
		dropTable: [{name: "Duster", weight: 10, ignoreInInventory: true}, {name: "Gold", amountMin: 5, amountMax: 10, weight: 10}]},
	{name: "MaidforcePara", nameList: "maid", faction: "Maidforce", bound: "MaidforcePara", outfit: "MaidforcePara", style: "Maid", clusterWith: "maid", playLine: "DomMaid", color: "#814BB7", tags: KDMapInit(["leashing", "antiMagic", "ballGagRestraints", "opendoors", "imprisonable", "tickleweakness", "guardCall", "human", "miniboss", "maid", "ranged", "ropeRestraints", "ropeRestraints2", "handcuffer", "maidVibeRestraintsLimited", "maidRestraintsLight", "jail", "jailer", "hunter"]), followLeashedOnly: true, blindSight: 5, followRange: 4, AI: "hunt", guardChance: 0.6, projectileAttack: true,
		spells: ["ParasolBuff", "Hairpin", "EnemyCM1"],
		unlockCommandLevel: 1, unlockCommandCD: 90, spellCooldownMult: 1, spellCooldownMod: 0,
		buffallies: true, kite: 2.5, events: [
			{trigger: "tick", type: "secretToy"},
		],
		preferDodge: true,
		Sound: {
			baseAmount: 0.5,
			moveAmount: 4,
			decay: 1.5,
		},
		maxblock: 1,
		maxdodge: 1,
		stamina: 4,
		stealth: 2.5, disarm: 0.5, spellRdy: true, armor: 0.4,
		attackLock: "White",
		visionRadius: 8, maxhp: 10, minLevel:0, weight:-2, movePoints: 2, attackPoints: 3, attack: "SpellMeleeBindLock", attackWidth: 1, attackRange: 1, power: 2, dmgType: "grope",
		terrainTags: {"secondhalf":1, "lastthird":1, "illusionAnger": 17, "illusionRage": 11, "maid": 16}, shrines: ["Illusion"], allFloors: true,
		dropTable: [{name: "Gold", amountMin: 15, amountMax: 20, weight: 10}, ]},
	{name: "MaidforceStalker", nameList: "maid", faction: "Maidforce", bound: "MaidforceStalker", outfit: "MaidforceNinja", style: "Maid", clusterWith: "maid", playLine: "DomMaid", color: "#814BB7",
		tags: KDMapInit(["leashing", "opendoors", "human", "maid", "melee", "maidRestraints", "handcuffer", "maidRestraintsHeavy", "maidVibeRestraintsLimited", "shadowclan", "unarmedresist", "pierceresist", "antiMagic", "tickleweakness", "slashresist", "glueweakness", "chainweakness", "jail", "jailer", "hunter"]),
		followLeashedOnly: true, blindSight: 5, followRange: 1, AI: "hunt", guardChance: 0.6, projectileAttack: true, evasion: 0.33, events: [
			{trigger: "tick", type: "secretToy"},
		],
		preferDodge: true,
		maxblock: 2,
		maxdodge: 3,
		stamina: 8,
		Sound: {
			baseAmount: 0.5,
			moveAmount: 3,
			decay: 1.5,
		},
		spells: ["EnemyFlashBomb", "MirrorImage"], spellCooldownMult: 1, spellCooldownMod: 0, kite: 2, dontKiteWhenDisabled: true, castWhileMoving: true,
		stealth: 1.5,
		attackLock: "White",
		visionRadius: 7, maxhp: 12, minLevel:4, weight:-2, movePoints: 1, attackPoints: 3, attack: "SpellMeleeBindLock", attackWidth: 1, attackRange: 1, tilesMinRange: 1, power: 2, dmgType: "grope", fullBoundBonus: 1,
		terrainTags: {"secondhalf":1, "lastthird":1, "illusionAnger": 15, "illusionRage": 10, "increasingWeight":0.5, "maid": 15}, shrines: ["Illusion"], allFloors: true,
		dropTable: [{name: "Gold", amountMin: 15, amountMax: 20, weight: 10}, {name: "PotionInvisibility", weight: 3}]},
	{name: "MaidforceStalkerImage", faction: "Maidforce", color: "#814BB7", tags: KDMapInit(["ghost", "maid", "melee"]), followLeashedOnly: true, blindSight: 12, followRange: 2, AI: "hunt", guardChance: 0.6, projectileAttack: true, evasion: -10,
		kite: 2, dontKiteWhenDisabled: true,
		stealth: 1.5,
		stamina: 4,
		preferDodge: true,
		maxblock: 0,
		maxdodge: 3,
		visionRadius: 7, maxhp: 1, minLevel:0, weight:-10, movePoints: 1.25, attackPoints: 2, attack: "MeleeWill", attackWidth: 1, attackRange: 1, tilesMinRange: 1, power: 1, dmgType: "grope",
		terrainTags: {}, shrines: ["Illusion"], floors:KDMapInit([]),},
	{name: "MaidforceMafia", nameList: "italian", faction: "Maidforce", bound: "MaidforceMafia", outfit: "MaidforceMafia", style: "Maid", clusterWith: "maid", color: "#814BB7", playLine: "GunnerMaid", tags: KDMapInit(["leashing", "gun", "opendoors", "imprisonable", "tickleweakness", "human", "elite", "maid", "ranged", "maidRestraints", "handcuffer", "maidVibeRestraintsLimited", "jail", "jailer", "hunter"]), followLeashedOnly: true, followRange: 4, AI: "hunt", guardChance: 0.6, projectileAttack: true, evasion: -0.25,
		spells: ["RubberBullets"],  spellCooldownMult: 1, spellCooldownMod: 0, kite: 3, noKiteWhenHarmless: true, noSpellsWhenHarmless: true, armor: 0.8,
		events: [
			{trigger: "tick", type: "secretToy"},
			// It's supposed to be the light of the cigar
			{trigger: "getLights", type: "enemyTorch", power: 1, color: "#ffaa00"},
		],
		preferBlock: true,
		maxblock: 2,
		maxdodge: 1,
		specialAttack: "Stun", specialRemove: "BindLock", specialCD: 10,
		visionRadius: 7.5, maxhp: 14, minLevel:4, weight:-7, movePoints: 2.5, attackPoints: 3, attack: "SpellMeleeBindLock", attackWidth: 1, attackRange: 1, tilesMinRange: 1, power: 1, dmgType: "pain", fullBoundBonus: 3,
		stamina: 5, sprintspeed: 2.0,
		terrainTags: {"secondhalf":1, "lastthird":1, "open": 2, "illusionAnger": 12, "illusionRage": 5, "latexAnger": 4, "maid": 15}, shrines: ["Illusion"], allFloors: true,
		attackLock: "White",
		dropTable: [{name: "Gold", amountMin: 15, amountMax: 20, weight: 10}]},
	{name: "MaidforceMini", nameList: "russian", faction: "Maidforce", bound: "MaidforceMini", outfit: "MaidforceHeavy", style: "Maid", clusterWith: "maid", color: "#814BB7", playLine: "GunnerMaid",
		tags: KDMapInit(["leashing", "opendoors", "imprisonable", "tickleweakness", "human", "elite", "maid", "ranged", "maidRestraintsLight",
			"bulwark", "handcuffer", "gun", "jail", "jailer", "hunter"]),
		followLeashedOnly: true, followRange: 12, AI: "hunt", guardChance: 0.7, projectileAttack: true, evasion: -1.0,
		spells: ["Minigun", "MinigunWindup"],  spellCooldownMult: 1, spellCooldownMod: 0, noKiteWhenHarmless: true, noSpellsWhenHarmless: true, armor: 1.0, stopToCast: true,
		events: [
			{trigger: "tick", type: "secretToy"},
		],
		preferBlock: true,
		maxblock: 1,
		maxdodge: 0,
		sneakThreshold: 3, kite: 3.5, kiteChance: 0.75,
		visionRadius: 8, maxhp: 10, minLevel:3, weight:-6, movePoints: 3.2, attackPoints: 4, attack: "SpellMeleeBindLock", attackWidth: 1, attackRange: 1, tilesMinRange: 1, power: 1, dmgType: "pain", fullBoundBonus: 4,
		terrainTags: {"secondhalf":2, "lastthird":-1, "open": 8, "illusionAnger": 9, "illusionPleased": 9, "illusionFriendly": 5, "illusionRage": 3, "latexAnger": 3, "maid": 10}, shrines: ["Illusion"], allFloors: true,
		weightMult: 0.5,
		attackLock: "White",
		dropTable: [{name: "Gold", amountMin: 15, amountMax: 20, weight: 10}]},
	{name: "MaidforceHead", nameList: "bountyhunter", faction: "Maidforce", bound: "MaidforceHead", outfit: "MaidforceHead", style: "Maid", clusterWith: "maid", color: "#814BB7", playLine: "HeadMaid", tags: KDMapInit(["leashing", "antiMagic", "guardCall", "tickleweakness", "opendoors", "human", "maid", "unflinching", "boss", "ranged", "maidRestraintsHeavy", "maidRestraintsNonChastity", "maidVibeRestraints", "handcuffer", "jailer", "hunter"]), followLeashedOnly: true, followRange: 3.5, AI: "hunt", guardChance: 0.6, projectileAttack: true,
		spells: ["AmpuleGreen", "Hairpin", "RestrainingDevice"], spellCooldownMult: 1, spellCooldownMod: 0,  disarm: 1, ignoreStaminaForBinds: true, sneakThreshold: 1, focusPlayer: true,
		useLock: "Red", kite: 2.5, armor: 1.5,
		RestraintFilter: {
			ignoreInitialTag: ["maidVibeRestraints"],
		},
		stamina: 4,
		maxblock: 3,
		maxdodge: 3,
		preferBlock: true,
		Sound: {
			baseAmount: 0.5,
			moveAmount: 4,
			decay: 1.5,
		},
		RemoteControl: {
			remote: 5, remoteAmount: 4,
		}, bypass: true, noLeashUnlessExhausted: true, evasion: 0.15, //-15 weight
		events: [
			{trigger: "afterEnemyTick", type: "maidforceHeadAura", dist: 1.5},
		],
		visionRadius: 8, maxhp: 28, minLevel:6, weight:-14, movePoints: 2, attackPoints: 2, attack: "SpellMeleeBindLockAllVibe", attackWidth: 3, attackRange: 1, tilesMinRange: 1, power: 1.5, dmgType: "tickle", fullBoundBonus: 1,
		terrainTags: {"secondhalf":1, "lastthird":1, "open": 4, "illusionAnger": 10, "illusionRage": 4, "maid": 10}, shrines: ["Illusion"], allFloors: true, attackLock: "Red",
		dropTable: [{name: "Gold", amountMin: 30, amountMax: 40, weight: 20}, {name: "KeyCard", weight: 10}, {name: "EnchKnife", ignoreInInventory: true, weight: 1}]},

	{name: "Skeleton", nonHumanoid: true, bound: "Skeleton", playLine: "Skeleton", clusterWith: "skeleton", tags: KDMapInit(["nosub", "skeletonTrap", "leashing", "skeleton", "gagged", "melee", "ropeRestraints", "leatherRestraints", "clothRestraints", "coldresist", "crushweakness", "search"]), ignorechance: 0, armor: 0, followRange: 1, AI: "hunt",
		visionRadius: 4, maxhp: 5, minLevel:0, weight:8, movePoints: 2, attackPoints: 3, attack: "MeleeBind", attackWidth: 1, attackRange: 1, power: 1, dmgType: "grope", fullBoundBonus: 1.0,
		evasion: -0.1,
		summon: [{enemy: "LesserSkeleton", range: 2.5, count: 2, strict: true}],
		master: {type: "Necromancer", range: 4.5},
		stamina: 3,
		maxblock: 1,
		maxdodge: 1,
		preferBlock: true,
		terrainTags: {"secondhalf":4, "skeletonTrap": 50, "increasingWeight":-0.5, "skeleton": 14}, shrines: ["Leather"], floors:KDMapInit(["cat", "tmb"]), dropTable: [{name: "Gold", amountMin: 5, amountMax: 10, weight: 10}]},
	{name: "SkeletonArcher", nonHumanoid: true, bound: "Skeleton", playLine: "Skeleton", clusterWith: "skeleton", tags: KDMapInit(["nosub", "skeletonTrap", "leashing", "skeleton", "gagged", "ranged", "ropeRestraints", "leatherRestraints", "clothRestraints", "coldresist", "crushweakness", "search"]), ignorechance: 0, armor: 0, followRange: 1, AI: "hunt",
		visionRadius: 6, maxhp: 5, minLevel:0, weight:6, movePoints: 2.5, attackPoints: 3, attack: "SpellMeleeBind", attackWidth: 1, attackRange: 1, power: 1, dmgType: "grope", fullBoundBonus: 1.0,
		master: {type: "Necromancer", range: 3.5},
		summon: [{enemy: "LesserSkeleton", range: 2.5, count: 2, strict: true}],
		dontKiteWhenDisabled: true, kite: 3.5, followLeashedOnly: true,
		spells: ["CursedArrow"], miscastmsg: "KDBanditMiscast", miscastsfx: "Miss", spellCooldownMult: 1, spellCooldownMod: 0, stopToCast: true, castWhileMoving: true, projectileAttack: true,
		evasion: -0.1,
		stamina: 3,
		maxblock: 0,
		maxdodge: 1,
		terrainTags: {"secondhalf":4.5, "skeletonTrap": 30, "skeleton": 10}, shrines: ["Leather"], floors:KDMapInit(["cat", "tmb"]), dropTable: [{name: "Gold", amountMin: 5, amountMax: 15, weight: 10}, {name: "Bow", ignoreInInventory: true, weight: 100}]},
	{name: "SummonedSkeleton", nonHumanoid: true, bound: "Skeleton", playLine: "Skeleton", clusterWith: "skeleton", tags: KDMapInit(["nosub", "leashing", "skeleton", "gagged", "minor", "melee", "coldresist", "ropeRestraints", "leatherRestraints", "clothRestraints", "crushweakness"]), ignorechance: 0, armor: 0, followRange: 1, AI: "guard",
		visionRadius: 5, maxhp: 5, minLevel:0, weight:8, movePoints: 2, attackPoints: 3, attack: "MeleeBind", attackWidth: 1, attackRange: 1, power: 0.5, dmgType: "grope", fullBoundBonus: 0.5,
		evasion: -0.1,
		stamina: 3,
		maxblock: 0,
		maxdodge: 0,
		preferBlock: true,
		terrainTags: {"lastthird":-8}, shrines: [], floors:KDMapInit([])},
	{name: "LesserSkeleton", nonHumanoid: true, bound: "Skeleton", playLine: "Skeleton", noChaseUnrestrained: true, clusterWith: "skeleton", tags: KDMapInit(["nosub", "skeletonTrap", "minor", "leashing", "skeleton", "gagged", "melee", "coldresist", "crushweakness"]), ignorechance: 0, armor: 0, followRange: 1, AI: "wander", evasion: -2,
		visionRadius: 1, maxhp: 2.5, minLevel:0, weight:10, movePoints: 2, attackPoints: 3, attack: "MeleeWillSlow", attackWidth: 1, attackRange: 1, power: 0.5, dmgType: "grope", fullBoundBonus: 0.5,
		stamina: 3,
		master: {type: "Necromancer", range: 4.5},
		preferBlock: true,
		maxblock: 0,
		maxdodge: 1,
		terrainTags: {"secondhalf":-8, "skeletonTrap": 100, "lastthird":-8, "increasingWeight":-1}, floors:KDMapInit(["cat", "tmb"])},
	{name: "GreaterSkeleton", nonHumanoid: true, bound: "GreaterSkeleton", playLine: "Skeleton", clusterWith: "skeleton",
		tags: KDMapInit(["nosub", "leashing", "skeletonTrap",
			"bulwark", "skeleton", "gagged", "melee", "unflinching", "elite", "coldresist", "crushweakness", "hunter"]),
		stamina: 4,
		master: {type: "Necromancer", range: 5.5},
		maxblock: 4,
		maxdodge: 1,
		preferBlock: true,
		ignorechance: 0, armor: 2, followRange: 1.5, AI: "hunt", guardChance: 0.6, disarm: 0.5,
		visionRadius: 4, maxhp: 10, minLevel:9, weight:5, movePoints: 3, attackPoints: 3, attack: "MeleeWillSlow", attackWidth: 3, attackRange: 1, power: 5, dmgType: "crush", fullBoundBonus: 0,
		evasion: -0.4,
		terrainTags: {"secondhalf":4, "lastthird":6, "skeletonTrap": 25, "increasingWeight":0.5}, floors:KDMapInit(["cat", "tmb", "tmp"]), dropTable: [{name: "PotionStamina", weight: 3}, {name: "Gold", amountMin: 15, amountMax: 20, weight: 10}, {name: "Hammer", weight: 50, ignoreInInventory: true}]},
	{name: "HeavySkeleton", nonHumanoid: true, bound: "HeavySkeleton", playLine: "Skeleton", clusterWith: "skeleton", color: "#aaaaaa",
		tags: KDMapInit(["nosub", "leashing",
			"bulwark", "skeletonTrap", "skeleton", "gagged", "melee", "unflinching", "elite", "coldresist", "crushweakness", "hunter", "fiddle", "obsidianRestraints"]),
		stamina: 4,
		preferBlock: true,
		master: {type: "Necromancer", range: 5.5},
		maxblock: 4,
		maxdodge: 1,
		ignorechance: 0, armor: 3, followRange: 1.5, AI: "hunt", guardChance: 0.6, disarm: 0.5,
		visionRadius: 6, maxhp: 16, minLevel:15, weight:4, movePoints: 3, attackPoints: 3, attack: "MeleeWillSlowBind", attackWidth: 3.6, attackRange: 1, power: 5, dmgType: "crush", fullBoundBonus: 3,
		evasion: -0.4,
		terrainTags: {"secondhalf":1, "lastthird":4, "skeletonTrap": 10, "increasingWeight":1}, floors:KDMapInit(["cat", "tmb", "tmp"]),
		dropTable: [{name: "Gold", amountMin: 15, amountMax: 20, weight: 10}, {name: "Axe", weight: 50, ignoreInInventory: true}]},

	{name: "Ghost", color: KDBaseWhite, faction: "Ghost", clusterWith: "ghost", tags: KDMapInit(["illusionTrap", "ghost", "flying", "spooky", "melee", "minor", "glueimmune", "chainimmune", "magicweakness"]),
		ethereal: true, ignorechance: 0, armor: 0, followRange: 1, AI: "hunt", guardChance: 0.6, 
		visionRadius: 6, blindSight: 3, evasion: 9.0, alwaysEvade: true, maxhp: 1, minLevel:0, weight:1, movePoints: 1.5,
		attackPoints: 2, attack: "MeleeSuicideEffectWill", attackWidth: 1, attackRange: 1, power: 1, dmgType: "tickle", suicideOnEffect: true, fullBoundBonus: 1,
		effect: {
			effect: {name: "GhostHaunt", count: 1},
		},
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 1, color: KDBaseWhite},
		],
		Sound: {
			baseAmount: 0,
			moveAmount: 0.5,
			attackAmount: 0,
			decay: 5,
		},
		maxblock: 0,
		maxdodge: 0,
		terrainTags: {"ghost" : 4.9}, shrines: ["Illusion"], allFloors: true,
		dropTable: [{name: "Ectoplasm", weight: 1}]},
	{name: "TickleTerror", faction: "Ghost", color: KDBaseWhite, tags: KDMapInit(["illusionTrap", "chestTrap", "ignorenoSP", "comfyRestraints", "spooky", "ghost", "flying", "melee", "glueimmune", "chainimmune", "meleeresist", "magicweakness"]), ethereal: true, ignorechance: 0, armor: 0, followRange: 1, AI: "hunt",  noAlert: true, 
		visionRadius: 8, blindSight: 8, evasion: 0.5, maxhp: 12, minLevel:4, weight:0.1, movePoints: 2, attackPoints: 2, attack: "MeleeWillBind", attackWidth: 3, attackRange: 1, power: 3, dmgType: "tickle", fullBoundBonus: 3,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 1, color: KDBaseWhite},
		],
		RestraintFilter: {
			unlimitedRestraints: true,
		},
		Sound: {
			baseAmount: 0,
			moveAmount: 1.5,
			attackAmount: 0,
			decay: 5,
		},
		maxblock: 0,
		maxdodge: 0,
		terrainTags: {"ghost" : 1.9, "increasingWeight": 0.2, "chestTrap": 50, revenge: 50, "goddessRage": 4}, shrines: ["Illusion"], allFloors: true,
		dropTable: [{name: "Ectoplasm", weight: 1}]},
	{name: "HugHorror", faction: "Ghost", color: KDBaseWhite, tags: KDMapInit(["illusionTrap", "chestTrap", "ignorenoSP", "ghostRestraints", "spooky", "ghost", "flying", "melee", "glueimmune", "chainimmune", "meleeresist", "magicweakness"]), ethereal: true, ignorechance: 0, armor: 0, followRange: 1, AI: "hunt",  noAlert: true,
		spells: ["GhostAttack", "GagGeistAttack"], spellCooldownMult: 1, spellCooldownMod: 0, castWhileMoving: true,
		stunTime: 4, specialCD: 20, specialAttack: "Stun", specialPower: 4,
		visionRadius: 8, blindSight: 8, evasion: 0.2, maxhp: 20, minLevel:4, weight:0.1, movePoints: 3, attackPoints: 2, attack: "MeleeWillSpell", attackWidth: 3, attackRange: 1, power: 1, dmgType: "crush", fullBoundBonus: 2,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 1, color: KDBaseWhite},
		],
		RestraintFilter: {
			unlimitedRestraints: true,
		},
		Sound: {
			baseAmount: 0,
			moveAmount: 2.5,
			attackAmount: 0,
			decay: 3,
		},
		maxblock: 0,
		maxdodge: 0,
		terrainTags: {"ghost" : 1.9, "increasingWeight": 0.2, "chestTrap": 50, revenge: 50, "goddessRage": 4}, shrines: ["Illusion"], allFloors: true,
		dropTable: [{name: "Ectoplasm", weight: 1}]},
	{name: "GagGeist", faction: "Ghost", color: KDBaseWhite, tags: KDMapInit(["illusionTrap", "chestTrap", "ignoregagged", "invisGag", "spooky", "ghost", "flying", "melee", "glueimmune", "chainimmune", "meleeresist", "magicweakness"]), ethereal: true, ignorechance: 0, armor: 0, followRange: 1, AI: "hunt",  noAlert: true,
		stealth: 1.5,
		RestraintFilter: {
			unlimitedRestraints: true,
		},
		visionRadius: 8, blindSight: 8, evasion: 0.3, maxhp: 9, minLevel:0, weight:0.3, movePoints: 1.4, attackPoints: 2, attack: "MeleeBindWill", attackWidth: 3, attackRange: 1, power: 1, dmgType: "grope", fullBoundBonus: 2,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 1, color: KDBaseWhite},
		],
		ignoreflag: ["gaggeistatk"], failAttackflag: ["gaggeistatk"], failAttackflagDuration: 12, failAttackflagChance: 0.4,
		Sound: {
			baseAmount: 0,
			moveAmount: 0.5,
			attackAmount: 0,
			decay: 5,
		},
		maxblock: 0,
		maxdodge: 0,
		terrainTags: {"ghost" : 3.9, "increasingWeight": 0.15, "chestTrap": 80, revenge: 60, "goddessRage": 5}, shrines: ["Illusion"], allFloors: true,
		dropTable: [{name: "Ectoplasm", weight: 1}]},
	{name: "TimeGhost", faction: "Ghost", color: KDBaseWhite, tags: KDMapInit(["timeghost", "timestealth", "ignoreharmless", "invisRestraints", "timeimmune", "spooky", "ghost", "flying", "melee", "glueimmune", "chainimmune", "meleeresist"]),
		ethereal: true, ignorechance: 0, armor: 0, followRange: 1, AI: "hunt",  noAlert: true,
		RestraintFilter: {
			unlimitedRestraints: true,
		},
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
		},
		stealth: 4.5,
		stunTime: 3,
		visionRadius: 14, blindSight: 14, evasion: 1.0, maxhp: 10, minLevel:0, weight:-1000, movePoints: 3, attackPoints: 2, attack: "MeleeBindWillStamina", attackWidth: 3, attackRange: 1, power: 4, dmgType: "grope", fullBoundBonus: 2,
		events: [
			{trigger: "tick", type: "TimeGhostDecay", power: 5},
		], regen: 4,
		maxblock: 0,
		maxdodge: 0,
		terrainTags: {"timeghost" : 1010}, shrines: ["Illusion"], allFloors: true,},

	{name: "Poltergeist", faction: "Ghost", color: KDBaseWhite, tags: KDMapInit(["illusionTrap", "chestTrap", "ignoreharmless", "invisRestraints", "spooky", "ghost", "flying", "melee", "glueimmune", "chainimmune", "meleeresist", "magicweakness"]),
		ethereal: true, ignorechance: 0, armor: 0, followRange: 1, AI: "hunt",  noAlert: true,
		RestraintFilter: {
			unlimitedRestraints: true,
		},
		stealth: 1.5,
		visionRadius: 8, blindSight: 8, evasion: 0.2, maxhp: 16, minLevel:4, weight:0.3, movePoints: 2, attackPoints: 2, attack: "MeleeBindWillStamina", attackWidth: 3, attackRange: 1, power: 2, dmgType: "grope", fullBoundBonus: 2,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 1, color: KDBaseWhite},
		],
		Sound: {
			baseAmount: 0,
			moveAmount: 0.5,
			attackAmount: 0,
			decay: 5,
		},
		maxblock: 0,
		maxdodge: 1,
		terrainTags: {"ghost" : 3, "increasingWeight": 0.1, "chestTrap": 50, revenge: 50, "goddessRage": 4}, shrines: ["Illusion"], allFloors: true,
		dropTable: [{name: "Ectoplasm", weight: 1}]},
	{name: "GreedyGhast", faction: "Ghost", color: KDBaseWhite, tags: KDMapInit(["illusionTrap", "chestTrap", "ignorenoSP", "ghost", "flying", "melee", "spooky", "glueimmune", "chainimmune", "meleeresist", "magicweakness"]), ethereal: true, ignorechance: 0, armor: 0, followRange: 1, AI: "hunt",  noAlert: true,
		visionRadius: 6, blindSight: 4, evasion: 0.5, maxhp: 7, minLevel:2, weight:0.1, movePoints: 2.2, attackPoints: 2, attack: "MeleeWill", attackWidth: 3, attackRange: 1, power: 2, dmgType: "grope", fullBoundBonus: 3,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 1, color: KDBaseWhite},
		],
		Sound: {
			baseAmount: 0,
			moveAmount: 1,
			attackAmount: 0,
			decay: 4,
		},
		maxblock: 0,
		maxdodge: 0,
		terrainTags: {"ghost" : 1.9, "increasingWeight": 0.05, "chestTrap": 100, revenge: 50, "goddessRage": 5}, shrines: ["Illusion"], allFloors: true,
		dropTable: [{name: "Ectoplasm", weight: 1}]},

	{name: "OrbGuardian", faction: "Ghost", alwaysHostile: true, clusterWith: "ghost", tags: KDMapInit(["divine", "melee", "flying", "glueimmune", "chainimmune"]), ethereal: true, ignorechance: 0, armor: 0, followRange: 1, AI: "hunt",
		spells: ["ShadowStrike"], spellCooldownMult: 1, spellCooldownMod: 0,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 5, color: "#440099"},
		],
		Sound: {
			baseAmount: 0,
			moveAmount: 0.5,
			attackAmount: 0,
			decay: 5,
		},
		maxblock: 0,
		maxdodge: 0,
		visionRadius: 100, blindSight: 100, evasion: 0.5, alwaysEvade: true, maxhp: 12, minLevel:0, weight:-10, movePoints: 2, attackPoints: 1, attack: "Spell", attackWidth: 3,
		attackRange: 1, power: 4, dmgType: "cold", fullBoundBonus: 0,
		terrainTags: {}, shrines: [], floors:KDMapInit([]),
		dropTable: [{name: "Ectoplasm", weight: 1}]},



	{name: "TickleHand", hidetimerbar: true, faction: "Witch", clusterWith: "ghost", color: KDBaseWhite, tags: KDMapInit(["ignorenoSP", "ghost", "flying", "melee", "glueimmune", "chainimmune", "magicweakness"]),
		ethereal: true, ignorechance: 0, armor: 0, followRange: 1, AI: "hunt",  regen: -0.1, noAlert: true, 
		visionRadius: 10, blindSight: 3, evasion: 9.0, alwaysEvade: true, maxhp: 1, minLevel:0, weight:-1000, movePoints: 2, attackPoints: 1, attack: "MeleeWill", attackWidth: 3, attackRange: 1, power: 3, dmgType: "tickle", fullBoundBonus: 0,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 1, color: KDBaseWhite},
		],
		Sound: {
			baseAmount: 0,
			moveAmount: 0.5,
			attackAmount: 0,
			decay: 5,
		},
		maxblock: 0,
		maxdodge: 0,
		terrainTags: {}, shrines: [], allFloors: true},
	{name: "TickleHandSlave", faction: "Witch", color: KDBaseWhite, tags: KDMapInit(["ignorenoSP", "ghost", "flying", "melee", "glueimmune", "chainimmune", "magicweakness"]),
		ethereal: true, ignorechance: 0, armor: 0, followRange: 1, AI: "hunt",
		master: {type: "ConjurerTickler", range: 3, dependent: true}, noAlert: true, 
		visionRadius: 10, blindSight: 3, evasion: 9.0, alwaysEvade: true, maxhp: 1, minLevel:0, weight:-1000, movePoints: 2, attackPoints: 1, attack: "MeleeWill", attackWidth: 3, attackRange: 1, power: 3, dmgType: "tickle", fullBoundBonus: 0,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 1, color: KDBaseWhite},
		],
		Sound: {
			baseAmount: 0,
			moveAmount: 0.5,
			attackAmount: 0,
			decay: 5,
		},
		maxblock: 0,
		maxdodge: 0,
		terrainTags: {}, shrines: [], allFloors: true,
		Reputation: {
			noRepLoss: true,
		},
		dropTable: [{name: "Ectoplasm", weight: 1}]},
	{name: "Frog", faction: "Witch", clusterWith: "beast", color: "#00FF44",
		tags: KDMapInit(["summoned", "beast", "ranged", "acidweakness", "electricsevereweakness", "soapresist"]),
		followLeashedOnly: true, armor: 1, followRange: 1, AI: "hunt",
		pullTowardSelf: true, pullDist: 3, master: {type: "Conjurer", range: 3}, projectileAttack: true, projectileTargeting: true,
		evasion: -0.4,
		stamina: 4,
		Sound: {
			baseAmount: 4,
			moveAmount: 8,
		},
		maxblock: 1,
		maxdodge: 0,
		visionRadius: 8, maxhp: 19, minLevel:0, weight:0, movePoints: 1.5, attackPoints: 2, attack: "MeleePullWill", attackRange: 4, attackWidth: 1, power: 4, strictAttackLOS: true, dmgType: "tickle",
		terrainTags: {}, floors:KDMapInit([])},
	{name: "Conjurer", nameList: "witch", faction: "Witch", clusterWith: "apprentice", bound: "Conjurer", outfit: "Conjurer", style: "Necromancer", playLine: "Witch",
		tags: KDMapInit(["leashing", "opendoors", "mage", "antiMagic", "conjurer", "leatherRestraintsMagic", "closedoors", "witch", "ranged", "boss", "unflinching", "dressRestraints", "latexRestraints", "handcuffer"]),
		followRange: 1,
		events: [
			{trigger: "death", type: "frogDies"},
		],
		stamina: 2,
		maxblock: 2,
		maxdodge: 2,
		summon: [{enemy: "Frog", range: 2.5, count: 1, strict: true}],
		spells: ["SummonTickleHand", "SummonEnemyGag2", "EnemyCM1"], unlockCommandLevel: 2, unlockCommandCD: 9, spellCooldownMult: 2, spellCooldownMod: 1, AI: "guard",
		visionRadius: 8, maxhp: 24, minLevel:7, weight:3, movePoints: 3, spellRdy: true,
		spellResist: 1.5, attackLock: "Purple",
		attackPoints: 4, attack: "MeleeLockAllWillSpellBind", attackWidth: 1, attackRange: 1, power: 3, dmgType: "tickle",
		terrainTags: {"secondhalf":16, "lastthird":5, "boss": -4, "open": 20, "passage": -20, "conjureAnger": 20, "conjureRage": 70, "increasingWeight":0.5, "witch": 30},
		allFloors: true, shrines: ["Conjure"],
		dropTable: [{name: "MagicSword", weight: 1, ignoreInInventory: true}, {name: "MagicSpear", weight: 1, ignoreInInventory: true}, {name: "MagicAxe", weight: 1, ignoreInInventory: true}, {name: "MagicFlail", weight: 1, ignoreInInventory: true}, {name: "MagicHammer", weight: 1, ignoreInInventory: true}, {name: "BlueKey", weight: 2}]},
	{name: "ConjurerTickler", nameList: "witch", faction: "Witch", clusterWith: "apprentice", bound: "ConjurerTickler", outfit: "Conjurer", style: "Necromancer", playLine: "Witch",
		tags: KDMapInit(["leashing", "opendoors", "mage", "antiMagic", "conjurer", "leatherRestraintsMagic", "closedoors", "witch", "ranged", "boss", "unflinching", "dressRestraints", "latexRestraints", "handcuffer"]),
		followRange: 1,
		summon: [{enemy: "TickleHandSlave", range: 2.5, count: 3, strict: true}],
		spells: ["SummonBookChain", "SummonBookBelt", "SummonBookRope", "EnemyCM1"], unlockCommandLevel: 2, unlockCommandCD: 9, spellCooldownMult: 2, spellCooldownMod: 1, AI: "guard",
		visionRadius: 8, maxhp: 24, minLevel:6, weight:-1, movePoints: 3, spellRdy: true,
		spellResist: 1.5, attackLock: "Purple",
		stamina: 2,
		maxblock: 3,
		maxdodge: 1,
		attackPoints: 4, attack: "MeleeLockAllWillSpellBind", attackWidth: 1, attackRange: 1, power: 3, dmgType: "tickle",
		terrainTags: {"secondhalf":16, "lastthird":5, "boss": -4, "open": 20, "passage": -20, "conjureAnger": 20, "conjureRage": 70, "increasingWeight":0.5, "witch": 30},
		allFloors: true, shrines: ["Conjure"],
		dropTable: [{name: "MagicSword", weight: 1, ignoreInInventory: true}, {name: "MagicSpear", weight: 1, ignoreInInventory: true}, {name: "MagicAxe", weight: 1, ignoreInInventory: true}, {name: "MagicFlail", weight: 1, ignoreInInventory: true}, {name: "MagicHammer", weight: 1, ignoreInInventory: true}, {name: "BlueKey", weight: 2}]},

	{name: "BookChain", hidetimerbar: true, clusterWith: "book", tags: KDMapInit(["fireweakness", "chainimmune", "blindimmune", "ignoreharmless", "book", "flying", "minor", "ranged", "slashsevereweakness", "acidweakness", "soapweakness", "piercesevereweakness"]), followLeashedOnly: true, armor: 0, followRange: 3, AI: "hunt", guardChance: 0.6, noAlert: true,
		spells: ["MagicChain"], spellCooldownMult: 1, spellCooldownMod: 1, sneakthreshold: 0.7, kite: 1.5, difficulty: 0.05, noSpellLeashing: true,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 1, color: "#aaaaaa"},
		],
		maxblock: 0,
		maxdodge: 0,
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			attackAmount: 0,
		},
		nonDirectional: true,
		projectileTargeting: true,
		spellResist: 2.0,
		dropTable: [{name: "BondageTome", weight: 0.5, ignoreInInventory: true}],
		visionRadius: 6, maxhp: 5, minLevel:0, weight:20, movePoints: 5, attackPoints: 2, attack: "Spell", attackRange: 1, attackWidth: 1, power: 6,
		terrainTags: {"open": 100, "passage": -7, "witch": 2}, floors:KDMapInit(["lib"])},
	{name: "BookRope", hidetimerbar: true, clusterWith: "book", tags: KDMapInit(["fireweakness", "chainimmune", "blindimmune", "ignoreharmless", "book", "flying", "minor", "ranged", "slashsevereweakness", "acidweakness", "soapweakness", "piercesevereweakness"]), followLeashedOnly: true, armor: 0, followRange: 3, AI: "hunt", guardChance: 0.6, noAlert: true,
		spells: ["MagicRope"], spellCooldownMult: 1, spellCooldownMod: 1, sneakthreshold: 0.7, kite: 1.5, difficulty: 0.05, noSpellLeashing: true,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 1, color: "#aaaaaa"},
		],
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			attackAmount: 0,
		},
		maxblock: 0,
		maxdodge: 0,
		nonDirectional: true,
		projectileTargeting: true,
		spellResist: 2.0,
		dropTable: [{name: "BondageTome", weight: 0.5, ignoreInInventory: true}],
		visionRadius: 6, maxhp: 5, minLevel:0, weight:20, movePoints: 5, attackPoints: 2, attack: "Spell", attackRange: 1, attackWidth: 1, power: 6,
		terrainTags: {"open": 100, "passage": -7, "witch": 2}, floors:KDMapInit(["lib"])},
	{name: "BookBelt", hidetimerbar: true, clusterWith: "book", tags: KDMapInit(["fireweakness", "chainimmune", "blindimmune", "ignoreharmless", "book", "flying", "minor", "ranged", "slashsevereweakness", "acidweakness", "soapweakness", "piercesevereweakness"]), followLeashedOnly: true, armor: 0, followRange: 3, AI: "hunt", guardChance: 0.6, noAlert: true,
		spells: ["MagicBelt"], spellCooldownMult: 1, spellCooldownMod: 1, sneakthreshold: 0.7, kite: 1.5, difficulty: 0.05, noSpellLeashing: true,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 1, color: "#aaaaaa"},
		],
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			attackAmount: 0,
		},
		maxblock: 0,
		maxdodge: 0,
		nonDirectional: true,
		projectileTargeting: true,
		spellResist: 2.0,
		dropTable: [{name: "BondageTome", weight: 0.5, ignoreInInventory: true}],
		visionRadius: 6, maxhp: 5, minLevel:0, weight:20, movePoints: 5, attackPoints: 2, attack: "Spell", attackRange: 1, attackWidth: 1, power: 6,
		terrainTags: {"open": 100, "passage": -7, "witch": 2}, floors:KDMapInit(["lib"])},
	{name: "BookBondage", hidetimerbar: true, clusterWith: "book", tags: KDMapInit(["fireweakness", "chainimmune", "blindimmune", "ignoreharmless", "book", "flying", "ranged", "slashsevereweakness", "acidweakness", "soapweakness", "piercesevereweakness"]), followLeashedOnly: true, armor: 0, followRange: 3, AI: "hunt", guardChance: 0.2, noAlert: true,
		spells: ["MagicChain", "MagicBelt", "MagicRope"], spellCooldownMult: 1, spellCooldownMod: -2, sneakthreshold: 0.7, kite: 1.5, noSpellLeashing: true,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 4, color: "#aaaaaa"},
		],
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			attackAmount: 0,
		},
		maxblock: 0,
		maxdodge: 0,
		nonDirectional: true,
		projectileTargeting: true,
		spellResist: 2.0,
		dropTable: [{name: "ManaOrb", weight: 0.5}, {name: "Nothing", weight: 3, ignoreInInventory: true}],
		visionRadius: 7, maxhp: 12, minLevel:0, weight:20, movePoints: 5, attackPoints: 2, attack: "Spell", attackRange: 1, attackWidth: 1, power: 6,
		terrainTags: {"open": 100, "passage": -7, "witch": 2}, floors:KDMapInit(["lib", "cat", "tmb"])},
	{name: "BookCelestial", hidetimerbar: true, clusterWith: "book", tags: KDMapInit(["fireresist", "holyimmune", "blindimmune", "ignoreharmless", "book", "flying", "minor", "ranged", "slashsevereweakness", "acidweakness", "soapweakness", "piercesevereweakness"]), followLeashedOnly: true, armor: 0, followRange: 3, AI: "hunt", guardChance: 0.6, noAlert: true,
		spells: ["EnemyCorona", "OrbHeal"], spellCooldownMult: 1, spellCooldownMod: 1, sneakthreshold: 0.7, difficulty: 0.05, noSpellLeashing: true,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 1, color: "#ffff44"},
		],
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			attackAmount: 0,
		},
		maxblock: 0,
		maxdodge: 0,
		nonDirectional: true,
		spellResist: 2.0,
		dropTable: [{name: "BondageTome", weight: 0.5, ignoreInInventory: true}],
		visionRadius: 6, maxhp: 5, minLevel:6, weight:18, movePoints: 5, attackPoints: 2, attack: "Spell", attackRange: 1, attackWidth: 1, power: 6,
		terrainTags: {"open": 100, "passage": -7, "elf": 2}, floors:KDMapInit(["lib"])},
	{name: "BookNature", hidetimerbar: true, clusterWith: "book", tags: KDMapInit(["unstoppable", "fireweakness", "blindimmune", "ignoreharmless", "book", "flying", "minor", "ranged", "slashsevereweakness", "acidweakness", "soapweakness", "piercesevereweakness"]), followLeashedOnly: true, armor: 0, followRange: 3, AI: "hunt", guardChance: 0.6, noAlert: true,
		spells: ["Entangle", "OrbHeal"], spellCooldownMult: 1, spellCooldownMod: 1, sneakthreshold: 0.7, difficulty: 0.05, noSpellLeashing: true,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 1, color: KDBaseMint},
		],
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			attackAmount: 0,
		},
		maxblock: 0,
		maxdodge: 0,
		nonDirectional: true,
		spellResist: 2.0,
		dropTable: [{name: "BondageTome", weight: 0.5, ignoreInInventory: true}],
		visionRadius: 6, maxhp: 5, minLevel:0, weight:18, movePoints: 5, attackPoints: 2, attack: "Spell", attackRange: 1, attackWidth: 1, power: 6,
		terrainTags: {"open": 100, "passage": -7, "elf": 2}, floors:KDMapInit(["lib"])},
	{name: "BookElectric", hidetimerbar: true, clusterWith: "book", tags: KDMapInit(["fireweakness", "electricimmune", "blindimmune", "ignoreharmless", "book", "flying", "minor", "ranged", "slashsevereweakness", "acidweakness", "soapweakness", "piercesevereweakness"]), followLeashedOnly: true, armor: 0, followRange: 3, AI: "hunt", guardChance: 0.6, noAlert: true,
		spells: ["AreaElectrify"], spellCooldownMult: 1, spellCooldownMod: 1, sneakthreshold: 0.7, difficulty: 0.05, noSpellLeashing: true,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 1, color: KDBaseLightBlue},
		],
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			attackAmount: 0,
		},
		maxblock: 0,
		maxdodge: 0,
		nonDirectional: true,
		spellResist: 2.0,
		dropTable: [{name: "ArcaneTome", weight: 0.5, ignoreInInventory: true}],
		visionRadius: 6, maxhp: 5, minLevel:3, weight:18, movePoints: 5, attackPoints: 2, attack: "Spell", attackRange: 1, attackWidth: 1, power: 6,
		terrainTags: {"open": 100, "passage": -7, "elemental": 2}, floors:KDMapInit(["lib"])},
	{name: "BookSlime", hidetimerbar: true, clusterWith: "book", tags: KDMapInit(["fireweakness", "glueimmune", "blindimmune", "ignoreharmless", "book", "flying", "minor", "ranged", "slashsevereweakness", "acidweakness", "soapweakness", "piercesevereweakness"]), followLeashedOnly: true, armor: 0, followRange: 3, AI: "hunt", guardChance: 0.6, noAlert: true,
		spells: ["WitchSlimeBall", "WitchSlimeBall", "WitchSlime"], spellCooldownMult: 1, spellCooldownMod: 0, sneakthreshold: 0.7, difficulty: 0.05, noSpellLeashing: true,
		spellResist: 2.0,
		visionRadius: 6, maxhp: 5, minLevel:2, weight:18, movePoints: 5, attackPoints: 2, attack: "Spell", attackRange: 1, attackWidth: 1, power: 6,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 1, color: "#ff00ff"},
		],
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			attackAmount: 0,
		},
		maxblock: 0,
		maxdodge: 0,
		nonDirectional: true,
		projectileTargeting: true,
		dropTable: [{name: "ArcaneTome", weight: 0.5, ignoreInInventory: true}],
		terrainTags: {"open": 100, "passage": -7, "alchemist": 2}, floors:KDMapInit(["lib"])},
	{name: "BookIce", hidetimerbar: true, clusterWith: "book", tags: KDMapInit(["fireweakness", "iceimmune", "blindimmune", "ignoreharmless", "book", "flying", "minor", "ranged", "slashsevereweakness", "acidweakness", "soapweakness", "piercesevereweakness"]), followLeashedOnly: true, armor: 0, followRange: 3, AI: "hunt", guardChance: 0.6, noAlert: true,
		spells: ["IceSlowPrepare", "IceDragonBreathPrepare"], spellCooldownMult: 1, spellCooldownMod: 4, sneakthreshold: 0.7, difficulty: 0.05, noSpellLeashing: true,
		spellResist: 2.0,
		visionRadius: 6, maxhp: 5, minLevel:4, weight:18, movePoints: 5, attackPoints: 2, attack: "Spell", attackRange: 1, attackWidth: 1, power: 6,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 1, color: "#44aaff"},
		],
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			attackAmount: 0,
		},
		maxblock: 0,
		maxdodge: 0,
		nonDirectional: true,
		dropTable: [{name: "ArcaneTome", weight: 0.5, ignoreInInventory: true}],
		terrainTags: {"open": 100, "passage": -7, "elemental": 2}, floors:KDMapInit(["lib"])},
	{name: "BookForbidden", hidetimerbar: true, clusterWith: "book", tags: KDMapInit(["fireweakness", "blindimmune", "coldimmune", "ignoreharmless", "book", "flying", "minor", "ranged", "slashsevereweakness", "acidweakness", "soapweakness", "piercesevereweakness"]), followLeashedOnly: true, armor: 0, followRange: 3, AI: "hunt", guardChance: 0.6, noAlert: true,
		spells: ["SoulCrystalBind"], spellCooldownMult: 1, spellCooldownMod: 3, sneakthreshold: 0.7, difficulty: 0.05, noSpellLeashing: true,
		spellResist: 2.0,
		visionRadius: 6, maxhp: 5, minLevel:5, weight:15, movePoints: 5, attackPoints: 2, attack: "Spell", attackRange: 1, attackWidth: 1, power: 6,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 1, color: "#ff5577"},
		],
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			attackAmount: 0,
		},
		maxblock: 0,
		maxdodge: 0,
		nonDirectional: true,
		dropTable: [{name: "BondageTome", weight: 0.5, ignoreInInventory: true}],
		terrainTags: {"open": 100, "passage": -8, "witch": 2}, floors:KDMapInit(["lib", "tmp"])},
	{name: "BookArcane", hidetimerbar: true, clusterWith: "book", tags: KDMapInit(["fireweakness", "blindimmune", "coldimmune", "ignoreharmless", "book", "flying", "minor", "ranged", "slashsevereweakness", "acidweakness", "soapweakness", "piercesevereweakness"]), followLeashedOnly: true, armor: 0, followRange: 3, AI: "hunt", guardChance: 0.6, noAlert: true,
		spells: ["MummyBolt"], spellCooldownMult: 1, spellCooldownMod: 3, sneakthreshold: 0.7, difficulty: 0.05, noSpellLeashing: true,
		spellResist: 2.0,
		visionRadius: 6, maxhp: 5, minLevel:0, weight:15, movePoints: 5, attackPoints: 2, attack: "Spell", attackRange: 1, attackWidth: 1, power: 6,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 1, color: "#4fd658"},
		],
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			attackAmount: 0,
		},
		maxblock: 0,
		maxdodge: 0,
		projectileTargeting: true,
		dropTable: [{name: "ArcaneTome", weight: 0.5, ignoreInInventory: true}],
		nonDirectional: true,
		terrainTags: {"open": 100, "passage": -8, "mummy": 2}, floors:KDMapInit(["lib", "tmp"])},

	{name: "AnimatedArmor", blockVisionWhileStationary: true,
		tags: KDMapInit(["mimicBlock", "removeDoorSpawn", "ignoreharmless", "leashing", "construct", "nosignal", "blindresist", "fiddle",
			"poisonimmune", "soulimmune", "minor", "melee", "acidweakness", "steelCuffs", "shackleRestraints", "shackleGag", "slashresist", "crushweakness"]),
		evasion: -0.5, ignorechance: 1.0, armor: 3, followRange: 1, AI: "ambush", difficulty: 0.05, guardChance: 0,
		cueSfx: {
			Block: "Clang",
			Resist: "Clang",
			Damage: "ArmorHit",
		},
		maxblock: 4,
		maxdodge: 0,
		GFX: {
			lighting: true,
		},
		Sound: {
			baseAmount: 0.0,
			moveAmount: 10,
		},
		Resistance: {
			profile: ["construct"],
		},
		useLock: "White",
		visionRadius: 100, ambushRadius: 1.9, blindSight: 100, maxhp: 20, minLevel:0, weight:0, movePoints: 2, attackPoints: 3, attack: "MeleeBind",
		attackWidth: 1, attackRange: 1, power: 4, dmgType: "crush", fullBoundBonus: 4,
		terrainTags: {"secondhalf":4, "lastthird":7, "passage": 70, "adjChest": 58, "door": 50, "rubble": 15}, floors:KDMapInit(["cat"]), shrines: ["Metal"],
		dropTable: [{name: "Gold", amountMin: 5, amountMax: 10, weight: 10}, {name: "Sword", weight: 1, ignoreInInventory: true}]},
	{name: "Mimic", blockVisionWhileStationary: true, tags: KDMapInit(["removeDoorSpawn", "ignoreharmless", "ignoreharmless", "blindresist", "construct", "nosignal", "poisonresist", "soulresist", "minor", "melee", "trap", "shackleGag", "crushweakness", "meleeresist", "fireweakness", "electricresist", "chainweakness"]),
		evasion: -0.5, ignorechance: 1.0, armor: 1, followRange: 1, AI: "ambush", bypass: true, difficulty: 0.15, guardChance: 0,
		nonDirectional: true,
		useLock: "White",
		GFX: {
			lighting: true,
		},
		maxblock: 1,
		maxdodge: 0,
		Sound: {
			baseAmount: 0,
			alertAmount: 0,
			moveAmount: 10,
		},
		stamina: 10,
		visionRadius: 100, ambushRadius: 1.9, blindSight: 100, maxhp: 20, minLevel:2, weight:-1, movePoints: 1.5, attackPoints: 2, attack: "MeleeBind", attackWidth: 1, attackRange: 1, power: 3, dmgType: "tickle", fullBoundBonus: 1,
		terrainTags: {"rubble": 100, "adjChest": 15, "passage": 14, "illusionRage": 2, "illusionAnger": 2}, allFloors: true, shrines: ["Illusion"],
		dropTable: [{name: "RedKey", weight: 1}, {name: "Gold", amountMin: 10, amountMax: 40, weight: 6}, {name: "ScrollArms", weight: 1}, {name: "ScrollVerbal", weight: 1}, {name: "ScrollLegs", weight: 1}]},

	{name: "VineSpitter", faction: "Plant", clusterWith: "plant", color: "#4fd658", blockVisionWhileStationary: true,
		tags: KDMapInit(["nature", "blindresist", "removeDoorSpawn", "nosignalothers", "ignoreharmless", "plant", "melee", "glueresist", "slashweakness", "coldweakness", "firesevereweakness", "unarmedresist", "crushresist", "vineRestraints"]),
		ignorechance: 1.0, armor: 0, followRange: 4, AI: "ambush", guardChance: 0,
		evasion: -0.5,
		GFX: {
			lighting: true,
			AmbushSprite: "VinePlant",
		},
		spells: ["VineSlimeBall"], castWhileMoving: true, spellRdy: false, spellCooldownMult: 1, spellCooldownMod: 3, projectileAttack: true,
		maxblock: 0,
		maxdodge: 0,
		kite: 1.5,
		stamina: 3,
		visionRadius: 5, ambushRadius: 2.5, blindSight: 5, maxhp: 10, minLevel:0, weight:25, movePoints: 1.8, attackPoints: 2, attack: "SpellMeleeBind", attackWidth: 1, attackRange: 1, power: 2, dmgType: "crush", fullBoundBonus: 3,
		terrainTags: {"passage": -50, "adjChest": 8, "door": 12, "elf": 5, "nature": 5}, floors:KDMapInit(["jngWild"]), shrines: ["Rope", "Will"]},
	{name: "DragonVinePlant", faction: "Plant", clusterWith: "plant", color: "#4fd658", blockVisionWhileStationary: true,
		tags: KDMapInit(["nature", "blindresist", "removeDoorSpawn", "ignoreharmless", "nosignalothers", "plant", "elite", "melee", "chainresist", "slashweakness", "coldweakness", "firesevereweakness", "unarmedresist", "crushresist", "vineRestraints"]),
		ignorechance: 1.0, armor: 0, followRange: 4, AI: "ambush", guardChance: 0,
		ondeath: [{type: "spellOnSelf", spell: "Entangle"}],
		evasion: -0.5,
		GFX: {
			lighting: true,
			AmbushSprite: "VinePlant",
		},
		spells: ["DragonVine"], castWhileMoving: true, spellRdy: false, spellCooldownMult: 1, spellCooldownMod: 3, projectileAttack: true,
		maxblock: 0,
		maxdodge: 0,
		stamina: 2,
		visionRadius: 5, ambushRadius: 2.5, blindSight: 5, maxhp: 13, minLevel: 5, weight:25, movePoints: 2.3, attackPoints: 3, attack: "SpellMeleeBind", multiBind: 2,
		attackWidth: 3, attackRange: 1, power: 3, dmgType: "crush", fullBoundBonus: 3,
		terrainTags: {"passage": -50, "adjChest": 8, "door": 12, "elf": 5, "nature": 5}, floors:KDMapInit(["jngWild"]), shrines: ["Rope", "Will"]},
	{name: "DragonFlower", faction: "Plant", clusterWith: "plant", color: "#4fd658",
		tags: KDMapInit(["nature", "blindresist", "removeDoorSpawn", "ignoreharmless", "nosignalothers", "plant", "melee", "minor", "scenery", "chainresist", "slashweakness", "coldweakness", "firesevereweakness", "unarmedresist", "crushresist", "vineRestraints"]),
		ignorechance: 1.0, armor: 0, followRange: 1.5, AI: "guard", guardChance: 1,
		ondeath: [{type: "spellOnSelf", spell: "DragonFlowerSpores"}],
		evasion: -2,
		spells: ["DragonFlowerSpores"], castWhileMoving: true, spellRdy: false, spellCooldownMult: 1, spellCooldownMod: 3, projectileAttack: true,
		maxblock: 0,
		maxdodge: 0,
		stamina: 2,
		visionRadius: 5, ambushRadius: 2.5, blindSight: 5, maxhp: 1, minLevel: 5, weight:25, movePoints: 4, attackPoints: 3, attack: "Spell", multiBind: 2,
		attackWidth: 3, attackRange: 1, power: 3, dmgType: "crush", fullBoundBonus: 3,
		terrainTags: {"passage": -50, "adjChest": 8, "door": 12, "elf": 5, "nature": 5}, floors:KDMapInit(["jngWild"]), shrines: ["Rope", "Will"]},



		
	{name: "Pumpkin", faction: "Natural", clusterWith: "plant", color: "#f46d24",
		tags: KDMapInit(["nature", "nofidget", "scenery", "nonvulnerable", "minor", "inactive", "harmless", "immobile", "unstoppable", "soulimmune", 
			"crushweakness", "unarmedresist", "pierceresist", "chainresist", "poisonimmune", "coldweakness"]), sneakthreshold: 0.6,
		lowpriority: true,
		nonDirectional: true,
		evasion: -9, ignorechance: 1.0, armor: 0, followRange: 1, AI: "ambush", ambushRadius: 0, difficulty: -0.05,
		visionRadius: 0, maxhp: 14, minLevel:0, weight:-4, movePoints: 99999, attackPoints: 4, attack: "", attackWidth: 8, attackRange: 3, power: 1, dmgType: "souldrain",
		terrainTags: {"passage": -50, "elf": 5, "nature": 5, "jungle": 10, "halloween": 50},
		floors:KDMapInit(["grv", "jngWild", "cat", "cav", "cry"]), shrines: ["Will"], 
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			alertAmount: 0,
		},
		GFX: {
			lighting: true,
		},
		},

	{name: "PumpkinAngry", faction: "Plant", clusterWith: "plant", color: "#f46d24", blockVisionWhileStationary: true,
		tags: KDMapInit(["nature", "blindresist", "removeDoorSpawn", "ignoreharmless", "nosignalothers", "plant", "minor", "melee",
			"chainresist",
			"crushweakness", "coldweakness", "unarmedresist", "pierceresist", "vineRestraints"]),
		ignorechance: 1.0, armor: 0, followRange: 1, AI: "ambush", specialCD: 99, specialAttack: "Stun", specialAttackPoints: 1, specialRemove: "Bind", difficulty: 0.05, guardChance: 0,
		evasion: -0.5,
		GFX: {
			lighting: true,
			AmbushSprite: "Pumpkin",
		},
		ignoreflag: ["vineplantatk"], failAttackflag: ["vineplantatk"], failAttackflagDuration: 9, failAttackflagChance: 0.4,
		spells: ["Entangle"], minSpellRange: 0, spellCooldownMult: 1, spellCooldownMod: 0, stopToCast: true, castWhileMoving: true, 
		
		maxblock: 1,
		maxdodge: 0,
		stamina: 1,
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			alertAmount: 0,
			attackAmount: 2,
		}, ondeath: [{type: "transform", inheritDamage: true, enemy: "Pumpkin"}],
		nonDirectional: true,
		visionRadius: 5.5, ambushRadius: 1.9, blindSight: 5, maxhp: 18, minLevel:0, weight:-4, movePoints: 3.0, attackPoints: 2,
		attack: "Spell", attackWidth: 1, attackRange: 1, power: 2, dmgType: "crush", fullBoundBonus: 3,
		terrainTags: {"passage": -50, "elf": 5, "nature": 5, "jungle": 10, "halloween": 30}, floors:KDMapInit(["grv", "jngWild", "jng", "cat", "cav", "cry"]), shrines: ["Illusion", "Will"]},
	
		
	{name: "VinePlant", faction: "Plant", clusterWith: "plant", color: "#4fd658", blockVisionWhileStationary: true,
		tags: KDMapInit(["nature", "blindresist", "removeDoorSpawn", "ignoreharmless", "nosignalothers", "plant", "minor", "melee", "chainresist", "slashweakness", "coldweakness", "firesevereweakness", "unarmedresist", "crushresist", "vineRestraints"]),
		ignorechance: 1.0, armor: 0, followRange: 1, AI: "ambush", specialCD: 99, specialAttack: "Stun", specialAttackPoints: 1, specialRemove: "Bind", difficulty: 0.05, guardChance: 0,
		evasion: -0.5,
		GFX: {
			lighting: true,
		},
		ignoreflag: ["vineplantatk"], failAttackflag: ["vineplantatk"], failAttackflagDuration: 9, failAttackflagChance: 0.4,
		maxblock: 1,
		maxdodge: 0,
		stamina: 3,
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			alertAmount: 0,
			attackAmount: 2,
		},
		nonDirectional: true,
		visionRadius: 3, ambushRadius: 1.9, blindSight: 5, maxhp: 10, minLevel:0, weight:25, movePoints: 1.5, attackPoints: 2, attack: "MeleeBind", attackWidth: 1, attackRange: 1, power: 2, dmgType: "crush", fullBoundBonus: 3,
		terrainTags: {"passage": -50, "adjChest": 8, "door": 12, "elf": 5, "nature": 5}, floors:KDMapInit(["jngWild", "jng"]), shrines: ["Rope", "Will"]},
	{name: "Bramble", faction: "Plant", clusterWith: "plant", color: "#4fd658", hitsfx: "DealDamage",
		sneakthreshold: 0.6,
		nonDirectional: true,
		GFX: {
			lighting: true,
		},
		maxblock: 0,
		maxdodge: 0,
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			alertAmount: 0,
			attackAmount: 1,
		},
		tags: KDMapInit(["removeDoorSpawn", "immobile", "blindresist", "nature", "nosignalothers", "plant", "minor", "melee", "glueresist", "slashweakness", "coldweakness", "firesevereweakness", "unarmedresist", "crushresist"]),
		evasion: -9, ignorechance: 1.0, armor: 1.5, followRange: 1, AI: "wander", specialCD: 2, specialAttack: "Slow", specialAttackPoints: 1,
		visionRadius: 1.5, blindSight: 1.5, maxhp: 16, minLevel:0, weight:-80, movePoints: 99999, attackPoints: 1, attack: "MeleeWill", attackWidth: 8, attackRange: 1, power: 1, dmgType: "pain",
		terrainTags: {"passage": -50, "adjChest": -50, "door": -50, "open": 140, "elf": 10}, floors:KDMapInit(["jngWild", "jng"]), shrines: ["Rope", "Will"]},

	{name: "Alchemist", outfit: "Alchemist", style: "GreenHair", faction: "Alchemist", clusterWith: "alchemist", playLine: "Alchemist", bound: "Alchemist", color: "#50a968",
		tags: KDMapInit(["opendoors", "leashing", "imprisonable", "guardCall", "human", "alchemist", "ranged", "latexRestraints", "handcuffer",
			"leatherRestraintsHeavy", "jail", "jailer", "latexGag", "search"]),
		ignorechance: 0, armor: 0, followRange: 2, AI: "hunt",
		spells: ["AmpuleBlue", "AmpuleGreen", "AmpuleYellow", "AmpuleRed"], spellCooldownMult: 1, spellCooldownMod: 4, kite: 1.5, projectileAttack: true,
		attackLock: "White",
		Resistance: {
			profile: ["alchemist"],
		},
		Sound: {
			idleSoundName: "Rubber",
		},
		maxblock: 0,
		maxdodge: 2,
		stamina: 4,
		visionRadius: 6, maxhp: 8, minLevel:0, weight:0.1, movePoints: 2, attackPoints: 3, attack: "SpellMeleeBindLock", attackWidth: 1, attackRange: 1, power: 1, dmgType: "grope", fullBoundBonus: 2,
		terrainTags: {"secondhalf":1, "thirdhalf":1, "latexAnger": 12, "latexRage": 5, "latexPleased": 12, "latexFriendly": 5, "alchemist": 15}, shrines: ["Latex"], allFloors: true,
		dropTable: [{name: "VinylTapeRaw", amount: 8, weight: 10}, {name: "Gunpowder", amount: 1, weight: 10}]},
	{name: "Alkahestor", outfit: "Alchemist", style: "Water", faction: "Alchemist", clusterWith: "alchemist", playLine: "Alchemist", bound: "Alkahestor", color: "#92b9e8",
		tags: KDMapInit(["opendoors", "antiMagic", "leashing", "guardCall", "human", "alchemist", "ranged", "miniboss",
			"expRestraints", "steelRestraints", "latexRestraints", "handcuffer", "jailer", "latexGag", "search"]),
		ignorechance: 0, armor: 1, followRange: 2, AI: "hunt",
		spells: ["AmpuleBlue", "SummonLatexElemental", "BubbleBurstLatex"], spellCooldownMult: 1, spellCooldownMod: 4, kite: 1.5, projectileAttack: true,
		attackLock: "Red",
		stamina: 4,
		Resistance: {
			profile: ["alchemist"],
		},
		Sound: {
			idleSoundName: "Rubber",
		},
		maxblock: 2,
		maxdodge: 3,
		visionRadius: 6, maxhp: 16, minLevel:4, weight:-1, movePoints: 2, attackPoints: 3, attack: "SpellMeleeBindLock", attackWidth: 1, attackRange: 1, power: 1.5, dmgType: "grope", fullBoundBonus: 2.5,
		terrainTags: {"secondhalf":1, "thirdhalf":1, "latexAnger": 4, "bubbleOptout": -2, "bubblePref": 4, "latexRage": 4, "latexPleased": 3, "latexFriendly": 5, "alchemist": 10}, shrines: ["Latex"], allFloors: true,
		dropTable: [{name: "HardSlimeRaw", amount: 25, weight: 3}, {name: "Gold", amountMin: 15, amountMax: 20, weight: 10}, {name: "Gunpowder", amount: 3, weight: 10}]},
	{name: "ElementalLatex", faction: "Elemental", hidetimerbar: true, playLine: "Elemental", clusterWith: "alchemist", outfit: "ElementalLatex", style: "ElementalLatex", bound: "ElementalLatex", squeeze: true,
		tags: KDMapInit(["opendoors", "latexTrap", "elemental", "latex", "elite", "slashweakness", "melee", "glueimmune", "coldweakness", "electricresist", "pierceweakness", "acidweakness", "latexRestraints", "latexRestraintsHeavy", "latexGag", "leashing", "search", "doortrap"]),
		armor: 0, followRange: 1, AI: "hunt", spellResist: 1.5,
		stamina: 6,
		maxblock: 2,
		maxdodge: 0,
		Sound: {
			idleSoundName: "Rubber",
		},
		events: [
			{trigger: "afterEnemyTick", type: "createEffectTile", kind: "LatexThinBlue", time: 4, power: 1, chance: 0.5, aoe: 0.5},
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "LatexThinBlue", aoe: 1.5, power: 1, chance: 1.0},
		],
		visionRadius: 7, maxhp: 20, minLevel:4, weight:-3, movePoints: 2, attackPoints: 2, attack: "MeleeWillBind", attackWidth: 3, attackRange: 1, tilesMinRange: 1, power: 2, dmgType: "grope", fullBoundBonus: 3,
		terrainTags: {"secondhalf":2, "thirdhalf":1, "latexAnger": 4, "latexRage": 4, "latexPleased": 2, "latexFriendly": 3, "temple": 4, "doortrap":2, revenge: 5, "alchemist": 5, "witch": 5}, allFloors: true, shrines: ["Latex", "Elements"],
		dropTable: [{name: "HardSlimeRaw", amount: 5, weight: 10}, {name: "RopeRune", weight: 1, noSummon: true}]},
	{name: "GlueTechnician", outfit: "Alchemist", style: "Earth", faction: "Alchemist", clusterWith: "alchemist", playLine: "Alchemist", bound: "GlueTechnician", color: "#ffee43",
		tags: KDMapInit(["opendoors", "leashing", "human", "alchemist", "ranged", "unflinching", "elite",
			"expRestraints", "steelCuffs", "latexRestraints", "latexRestraintsHeavy", "latexGag", "handcuffer", "jail", "jailer", "hunter"]),
		ignorechance: 0, armor: 1.5, followRange: 2, AI: "hunt",
		spells: ["AmpuleYellow", "GlueBomb"], spellCooldownMult: 0.7, spellCooldownMod: 0, projectileAttack: true,
		attackLock: "White",
		stamina: 4,
		maxblock: 2,
		maxdodge: 1,
		Resistance: {
			profile: ["alchemist"],
		},
		Sound: {
			idleSoundName: "Rubber",
		},
		visionRadius: 7.5, maxhp: 12, minLevel:2, weight:0, movePoints: 2, attackPoints: 3, attack: "SpellMeleeBindLockSlow", attackWidth: 2.5, attackRange: 1, power: 2, dmgType: "tickle", fullBoundBonus: 2,
		terrainTags: {"secondhalf":0.5, "thirdhalf":1, "latexAnger": 5, "latexRage": 5, "latexPleased": 2, "latexFriendly": 2, "alchemist": 10}, shrines: ["Latex"], allFloors: true,
		dropTable: [{name: "Gold", amountMin: 10, amountMax: 15, weight: 10}, {name: "Gunpowder", amount: 2, weight: 10}]},

	{name: "SlimeEnthusiast", outfit: "Alchemist", style: "RedHair", faction: "Alchemist", clusterWith: "alchemist", playLine: "Alchemist", bound: "SlimeEnthusiast",
		tags: KDMapInit(["opendoors", "leashing", "human", "alchemist",
			"ranged", "unflinching", "elite", "steelCuffs", "latexRestraints", "latexRestraintsHeavy", "latexGag", "handcuffer", "jail", "jailer", "hunter"]),
		ignorechance: 0, armor: 1.5, followRange: 2, AI: "hunt",
		spells: ["RedSlime"], spellCooldownMult: 1, spellCooldownMod: 1, projectileAttack: true,
		attackLock: "White",
		stamina: 4,
		maxblock: 1,
		maxdodge: 2,
		Resistance: {
			profile: ["alchemist"],
		},
		visionRadius: 6, maxhp: 12, minLevel:2, weight:0, movePoints: 3, attackPoints: 3, attack: "SpellMeleeBindLock", attackWidth: 2.5, attackRange: 1, power: 2, dmgType: "grope", fullBoundBonus: 2,
		terrainTags: {"secondhalf":0.5, "thirdhalf":1, "latexAnger": 5, "latexRage": 5, "latexPleased": 2, "latexFriendly": 2, "alchemist": 10}, shrines: ["Latex"], allFloors: true,
		dropTable: [{name: "Gold", amountMin: 10, amountMax: 15, weight: 10}, {name: "Gunpowder", amount: 2, weight: 10}]},
	{name: "RedSlime", faction: "Alchemist", clusterWith: "alchemist", color: KDBaseRed, hidetimerbar: true, tags: KDMapInit(["ignoretiedup", "disarmimmune", "blindresist", "ignoregagged", "experiment", "slime", "melee", "minor", "ballGagRestraints", "meleeresist", "chainimmune", "electricresist", "iceweakness"]),
		squeeze: true, followRange: 1, AI: "hunt",  sneakThreshold: 1, hitsfx: "", armor: 0,
		spells: ["RedSlime"], spellCooldownMult: 1, spellCooldownMod: 1, evasion: 1,
		regen: 0.3,
		maxblock: 0,
		maxdodge: 0,
		Sound: {
			idleSoundName: "Slime",
		},
		nonDirectional: true,
		nopickpocket: true,
		Reputation: {
			noRepLoss: true,
		},
		stamina: 2,
		visionRadius: 4.5, maxhp: 3.2, minLevel: 5, weight:10, movePoints: 2, attackPoints: 3, attack: "SpellMeleeSlowBindSuicide", suicideOnSpell: true, suicideOnAdd: true, attackWidth: 1, attackRange: 1, power: 1, dmgType: "crush",
		terrainTags: {}, floors:KDMapInit(["tmp"]), shrines: ["Latex"]},
	{name: "LabAssistant", faction: "Alchemist", clusterWith: "alchemist", playLine: "Apprentice", outfit: "BlueSuit", bound: "LabAssistant", color: "#92b9e8",
		tags: KDMapInit(["opendoors", "leashing", "human", "alchemist", "latexRestraints", "ranged", "minor", "latexGag", "jail", "jailer", "hunter"]),
		ignorechance: 0, followRange: 4.5, AI: "hunt",
		difficulty: 0.3,
		spells: ["AmpuleBlue", "LatexBubble"], spellCooldownMult: 1, spellCooldownMod: 1, kite: 2.5, projectileAttack: true, noKiteWhenHarmless: true,
		attackLock: "White",
		stamina: 3,
		maxblock: 0,
		maxdodge: 2,
		Resistance: {
			profile: ["alchemist"],
		},
		Sound: {
			idleSoundName: "Rubber",
		},
		visionRadius: 6, maxhp: 6, minLevel:0, weight:1, movePoints: 2.5, attackPoints: 3, attack: "SpellMeleeBlindLock", attackWidth: 1, attackRange: 1, power: 1, dmgType: "grope", fullBoundBonus: 1, blindTime: 3,
		terrainTags: {"secondhalf":2, "thirdhalf":-4, "latexAnger": 4, "latexRage": 4, "latexPleased": 2, "latexFriendly": 2, "alchemist": 40}, shrines: ["Latex"], allFloors: true,
		dropTable: [{name: "Gold", amountMin: 5, amountMax: 10, weight: 10}, {name: "Gunpowder", amount: 1, weight: 7}]},

	{name: "SummonedDrone", playLine: "Robot",
		SFX: {death: "SciFiExplode"},
		tags: KDMapInit([ "drone","oldrobot", "disarmimmune", "ignoreharmless", "doortrap", "robot", "flying", "acidweakness", "soapweakness", "soulresist", "minor", "melee",
			"electricsevereweakness", "coldresist", "iceresist", "slashresist", "crushsevereweakness", "pierceweakness", "hitechCables", "cableGag", "temporary"]),
		evasion: 0.2, armor: 1.5, followRange: 3.5, AI: "hunt",
		spells: ["EncaseBoltDrone"], spellCooldownMult: 2, spellCooldownMod: 0, projectileTargeting: true,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 3, color: "#e7cf1a"},
		],
		Behavior: {
			leashCondition: "dollmakerLeash",
		},
		maxblock: 0,
		maxdodge: 0,
		stamina: 2,
		cueSfx: {
			Block: "Clang",
			Resist: "SoftShield",
			Damage: "RobotHit",
		},
		Security: {
			level_key: 1,
			level_tech: 1,
		},
		Sound: {
			baseAmount: 3.5,
			moveAmount: 3.5,
			alertAmount: 12,
		},
		visionRadius: 14, sneakthreshold: 0.85, maxhp: 14, minLevel:0, weight:-1000, kite: 1.5, movePoints: 1.5, attackPoints: 3, attack: "Spell", attackWidth: 1, attackRange: 1, power: 1, dmgType: "glue", fullBoundBonus: 1,
		terrainTags: {}, floors:KDMapInit([])},
	{name: "SummonedCaptureDrone", playLine: "Robot",
		SFX: {death: "SciFiExplode"},
		tags: KDMapInit([ "drone","leashing", "disarmimmune", "oldrobot", "ignoreharmless", "doortrap", "robot", "flying", "acidweakness", "soapweakness", "soulresist", "minor", "melee",
			"electricsevereweakness", "coldresist", "iceresist", "slashresist", "crushsevereweakness", "pierceweakness", "hitechCables", "cableGag", "temporary"]),
		evasion: 0.15, armor: 2.0, followRange: 1, AI: "hunt",
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 3, color: "#e7cf1a"},
		],
		Behavior: {
			leashCondition: "dollmakerLeash",
		},
		maxblock: 0,
		maxdodge: 0,
		stamina: 4,
		Sound: {
			baseAmount: 3.5,
			moveAmount: 3.5,
			alertAmount: 12,
		},
		Security: {
			level_key: 1,
			level_tech: 1,
		},
		cueSfx: {
			Block: "Clang",
			Resist: "SoftShield",
			Damage: "RobotHit",
		},
		visionRadius: 15, sneakthreshold: 0.85, maxhp: 16, minLevel:0, weight:-1000, movePoints: 1.35, attackPoints: 2, attack: "MeleeBind", attackWidth: 1.5, attackRange: 1, power: 1, dmgType: "chain", fullBoundBonus: 1.5,
		ondeath: [{type: "spellOnSelf", spell: "RubberSlime"}],
		terrainTags: {}, floors:KDMapInit([])},
	{name: "OldDrone", faction: "Enemy", clusterWith: "robot", playLine: "Robot", noChaseUnrestrained: true,
		SFX: {death: "SciFiExplode"},
		color: "#ff3367",
		tags: KDMapInit([ "drone","oldrobot", "disarmimmune", "ignoreharmless", "doortrap", "robot", "flying", "acidweakness", "soapweakness", "soulresist", "minor", "melee",
			"electricsevereweakness", "coldresist", "iceresist", "slashresist", "crushsevereweakness", "pierceweakness", "hitechCables", "cableGag", "jail", "search"]),
		AI: "hunt", difficulty: 0.05,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 3, color: "#e7cf1a"},
		],
		maxblock: 0,
		maxdodge: 1,
		stamina: 2,
		Sound: {
			baseAmount: 5,
			moveAmount: 5,
			alertAmount: 12,
		},
		cueSfx: {
			Block: "Clang",
			Resist: "SoftShield",
			Damage: "RobotHit",
		},
		Security: {
			level_key: 1,
			level_tech: 1,
		},
		RestraintFilter: {
			unlimitedRestraints: true,
		},
		armor: 1.5, maxhp: 5, movePoints: 1.1,
		visionRadius: 7, followRange: 1, projectileAttack: true, useLock: "White", followLeashedOnly: true,
		bindOnDisable: true, suicideOnAdd: true,
		attack: "MeleeBindSuicideWill", attackPoints: 2, attackWidth: 1, attackRange: 1, power: 2, dmgType: "electric", multiBind: 2, fullBoundBonus: 4,
		minLevel:0, weight:15, terrainTags: {"oldrobot": 10}, shrines: ["Metal"], floors:KDMapInit(["bel"]),
		dropTable: [{name: "Nothing", weight: 19}, {name: "AncientPowerSourceSpent", weight: 1, noSummon: true}]},
	{name: "OldTapeDrone", faction: "Enemy", clusterWith: "robot", playLine: "Robot", noChaseUnrestrained: true,
		SFX: {death: "SciFiExplode"},
		color: "#ff3367",
		tags: KDMapInit([ "drone","oldrobot", "leashing", "doortrap", "robot", "flying", "acidweakness", "soapweakness", "soulresist", "melee",
			"electricsevereweakness", "coldresist", "iceresist", "slashresist", "crushweakness", "autoTape", "jail", "search"]),
		AI: "patrol",
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 3, color: "#e7cf1a"},
		],
		stamina: 2,
		cueSfx: {
			Block: "Clang",
			Resist: "SoftShield",
			Damage: "RobotHit",
		},
		RestraintFilter: {
			unlimitedRestraints: true,
		},
		Security: {
			level_key: 1,
			level_tech: 1,
		},
		maxblock: 0,
		maxdodge: 1,
		Sound: {
			baseAmount: 6,
			moveAmount: 6,
			alertAmount: 12,
		},
		armor: 2.0, maxhp: 9, movePoints: 1.75,
		visionRadius: 7, followRange: 1,
		evasion: -0.1,
		attack: "MeleeBind", attackPoints: 2, attackWidth: 1, attackRange: 1, power: 2, dmgType: "glue", fullBoundBonus: 1,
		minLevel:2, weight:15, terrainTags: {"notapebot": -1000, "oldrobot": 10, "tapePref": 10, "tapeOptout": -15}, shrines: ["Metal"], floors:KDMapInit(["bel"]),
		dropTable: [{name: "Gold", amountMin: 7, amountMax: 15, weight: 10, noSummon: true}, {name: "AncientPowerSourceSpent", weight: 1, noSummon: true}]},

	{name: "RubberTurret", faction: "Enemy", clusterWith: "robot", playLine: "Robot", noChaseUnrestrained: true,
		SFX: {death: "SciFiExplodeLarge"},
		nonDirectional: true,
		color: "#ff3367",
		tags: KDMapInit(["oldrobot", "disarmimmune", "turret", "basicturret", "immobile", "ignoreharmless", "mimicBlock", "doortrap", "robot", "acidweakness", "soapweakness", "soulresist", "minor", "ranged",
			"electricsevereweakness", "coldresist", "iceresist", "slashresist", "crushsevereweakness", "pierceweakness"]),
		AI: "hunt", difficulty: 0.2,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 4.5, color: KDBaseRed},
		],
		spells: ["EncaseBolt"], spellCooldownMult: 1, spellCooldownMod: 0, projectileTargeting: true,
		cueSfx: {
			Block: "Clang",
			Resist: "SoftShield",
			Damage: "RobotHit",
		},
		maxblock: 0,
		maxdodge: 0,
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			alertAmount: 12,
		},
		RestraintFilter: {
			unlimitedRestraints: true,
		},
		armor: 2.0, maxhp: 20, movePoints: 9999, immobile: true,
		visionRadius: 6.5, followRange: 999,
		sneakThreshold: 1,
		evasion: -9,
		attack: "SpellMeleeWill", attackPoints: 2, attackWidth: 1, attackRange: 1, power: 2, dmgType: "electric",
		minLevel:0, weight:-50, terrainTags: {"oldrobot": 7, "oldrobotturret": 50, "oldrobotturretspawn": 150, open: 50, "latexOptout": -50}, shrines: ["Latex"], floors:KDMapInit(["bel"]),
		ondeath: [{type: "spellOnSelf", spell: "RubberSlime"}],
		dropTable: [{name: "AncientPowerSourceSpent", weight: 9, noSummon: true}, {name: "AncientPowerSource", weight: 1, noSummon: true}]},

	{name: "RubberSilo", faction: "Enemy", clusterWith: "robot", playLine: "Robot", noChaseUnrestrained: true,
		SFX: {death: "SciFiExplodeLarge"},
		color: "#ff3367",
		nonDirectional: true,
		tags: KDMapInit(["oldrobot", "disarmimmune", "turret", "immobile", "ignoreharmless", "mimicBlock", "doortrap", "robot", "acidweakness", "soapweakness", "soulresist", "minor", "ranged",
			"electricsevereweakness", "coldresist", "iceresist", "slashresist", "crushsevereweakness", "pierceweakness"]),
		AI: "hunt", difficulty: 0.2,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 4.5, color: KDBaseRed},
		],
		maxblock: 0,
		maxdodge: 0,
		spells: ["RubberMissile"], spellCooldownMult: 1, spellCooldownMod: 0, projectileTargeting: true,
		cueSfx: {
			Block: "Clang",
			Resist: "SoftShield",
			Damage: "RobotHit",
		},
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			alertAmount: 12,
		},
		RestraintFilter: {
			unlimitedRestraints: true,
		},
		armor: 2.0, maxhp: 20, movePoints: 9999, immobile: true,
		visionRadius: 8.5, followRange: 999,
		sneakThreshold: 1,
		evasion: -9,
		attack: "SpellMeleeWill", attackPoints: 2, attackWidth: 1, attackRange: 1, power: 2, dmgType: "electric",
		minLevel: 7, weight:-50, terrainTags: {"oldrobot": 7, "oldrobotturret": 30, oldrobotturretspawn: 100, open: 50, "latexOptout": -24}, shrines: ["Latex"], floors:KDMapInit(["bel"]),
		ondeath: [{type: "spellOnSelf", spell: "RubberSlime"}],
		dropTable: [{name: "Gunpowder", weight: 8, noSummon: true}, {name: "AncientPowerSource", weight: 2, noSummon: true}]},


	{name: "LatexSprayer", faction: "AncientRobot", clusterWith: "robot", playLine: "Robot", noChaseUnrestrained: true,
		SFX: {death: "SciFiExplodeLarge"},
		nonDirectional: true,
		color: "#2789cd",
		tags: KDMapInit(["disarmimmune", "turret", "basicturret", "immobile", "ignoreharmless", "mimicBlock", "doortrap", "robot", "acidweakness", "soapweakness", "soulresist", "minor", "ranged",
			"electricsevereweakness", "coldresist", "iceresist", "slashresist", "crushsevereweakness", "pierceweakness"]),
		AI: "hunt", difficulty: 0.25,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 4.5, color: KDBaseRed},
		],
		effect: {
			effect: {name: "LatexSpray", count: 1, time: 4, power: 2, mult: 2, damage: "glue"},
		},
		spells: ["LatexSpray"], spellCooldownMult: 1, spellCooldownMod: 0, projectileTargeting: true,
		cueSfx: {
			Block: "Clang",
			Resist: "SoftShield",
			Damage: "RobotHit",
		},
		maxblock: 0,
		maxdodge: 0,
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			alertAmount: 12,
		},
		RestraintFilter: {
			unlimitedRestraints: true,
		},
		armor: 2.0, maxhp: 20, movePoints: 9999, immobile: true,
		visionRadius: 7.5, followRange: 999,
		sneakThreshold: 1,
		evasion: -9,
		attack: "SpellMeleeEffect", attackPoints: 2, attackWidth: 2.5, attackRange: 1, power: 1, dmgType: "glue",
		minLevel:0, weight:-50, terrainTags: {"robot": 7, "oldrobot": -3, "oldrobotturret": -50, "oldrobotturretspawn": -150, "robotturret": 50, "robotturretspawn": 150, open: 50, "latexOptout": -50},
		shrines: ["Latex"], floors:KDMapInit(["bel"]),
		dropTable: [{name: "AncientPowerSource", weight: 9}, {name: "EnchantedGrinder", weight: 1, noSummon: true}]},

	{name: "Drone", faction: "AncientRobot", clusterWith: "robot", playLine: "Robot", noChaseUnrestrained: true, color: "#ff7755",
		SFX: {death: "SciFiExplode"},
		tags: KDMapInit([ "drone","ignoreharmless", "disarmimmune", "doortrap", "robot", "flying", "acidweakness", "soapweakness", "soulresist", "minor", "melee", "electricsevereweakness", "coldresist", "iceresist",
			"slashresist", "crushsevereweakness", "pierceweakness", "hitechCables", "cableGag", "jail", "search"]),
		AI: "patrol", difficulty: 0.3,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 3, color: KDBaseRed},
		],
		Security: {
			level_tech: 2,
		},
		maxblock: 0,
		maxdodge: 3,
		stamina: 8,
		sprintspeed: 1.8,
		cueSfx: {
			Block: "Clang",
			Resist: "SoftShield",
			Damage: "RobotHit",
		},
		Sound: {
			baseAmount: 4,
			moveAmount: 4,
			alertAmount: 12,
		},
		RestraintFilter: {
			unlimitedRestraints: true,
		},
		//summon: [
		//{enemy: "Drone", range: 2, count: 2, chance: 0.7, strict: true},],
		armor: 2, maxhp: 5, movePoints: 1.8,
		visionRadius: 6, followRange: 1, projectileAttack: true, useLock: "Red",
		bindOnDisable: true, suicideOnAdd: true,
		evasion: 0.15,
		specialCD: 30, specialAttack: "Stun", specialRemove: "Bind", specialCDonAttack: true, specialAttackPoints: 3, specialRange: 7, specialWidth: 1.5, specialMinRange: 3, specialsfx: "Laser", stunTime: 5,
		attack: "MeleeBindSuicideWill", attackPoints: 2, attackWidth: 1, attackRange: 1, power: 3, dmgType: "electric", multiBind: 2, fullBoundBonus: 6,
		minLevel:0, weight:-4, terrainTags: {"secondhalf":0.5, "thirdhalf":0.5, "increasingWeight":0.25, "metalAnger": 4, "metalRage": 2, "metalPleased": 4, "metalFriendly": 4, "robot": 40}, shrines: ["Metal"], allFloors: true,
		dropTable: [{name: "Nothing", weight: 19}, {name: "AncientPowerSourceSpent", weight: 1, noSummon: true}]},

	{name: "DroneGuardian", faction: "AncientRobot", clusterWith: "robot", playLine: "Robot", noChaseUnrestrained: true, color: "#ff7755",
		SFX: {death: "SciFiExplode"},
		tags: KDMapInit([ "drone","ignoreharmless", "disarmimmune", "doortrap", "robot", "flying", "acidweakness", "soapweakness", "soulresist", "guardian", "minor", "melee", "electricsevereweakness", "coldresist", "iceresist",
			"slashresist", "crushsevereweakness", "pierceweakness", "hitechCables", "cableGag", "jail", "search"]),
		AI: "patrol", difficulty: 0.3,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 3, color: "#e7cf1a"},
		],
		maxblock: 0,
		maxdodge: 3,
		stamina: 8,
		sprintspeed: 1.8,
		cueSfx: {
			Block: "Clang",
			Resist: "SoftShield",
			Damage: "RobotHit",
		},
		Sound: {
			baseAmount: 4,
			moveAmount: 4,
			alertAmount: 12,
		},
		RestraintFilter: {
			unlimitedRestraints: true,
		},
		Security: {
			level_tech: 2,
		},
		//summon: [
		//{enemy: "Drone", range: 2, count: 2, chance: 0.7, strict: true},],
		armor: 2, maxhp: 8, movePoints: 1.5,
		visionRadius: 6, followRange: 1, projectileAttack: true, useLock: "Red",
		bindOnDisable: true, suicideOnAdd: true,
		evasion: 0.15,
		specialCD: 30, specialAttack: "Stun", specialRemove: "Bind", specialCDonAttack: true, specialAttackPoints: 3, specialRange: 7, specialWidth: 1.5, specialMinRange: 3, specialsfx: "Laser", stunTime: 5,
		attack: "MeleeBindSuicideWill", attackPoints: 2, attackWidth: 1, attackRange: 1, power: 3, dmgType: "electric", multiBind: 2, fullBoundBonus: 6,
		minLevel:0, weight:-40, terrainTags: {guardian: 40, "secondhalf":0.5, "thirdhalf":0.5, "increasingWeight":0.25, "metalAnger": 4, "metalRage": 2, "metalPleased": 4, "metalFriendly": 4, "robot": 40}, shrines: ["Metal"], allFloors: true,
		dropTable: [{name: "Nothing", weight: 19}, {name: "AncientPowerSourceSpent", weight: 1, noSummon: true}]},

	// Miku
	{name: "Cyborg", faction: "AncientRobot",
		playLine: "Cyborg",
		outfit: "Cyborg",
		style: "GreenHair",
		bound: "Cyborg", color: "#95e892",
		tags: KDMapInit(["leashing", "opendoors", "closedoors", "jail", "jailer", "melee", "unflinching", "elite", "robot", "cyborg", "cyberdollrestraints", "cyberhogtie", "cyberdollheavy", "controlharness", "handcuffer",
			"electricweakness", "coldresist", "iceresist", "slashresist", "pierceresist", "guardian"]),
		noDisplace: false, disarm: 0.5,
		armor: 2,
		keys: true, followRange: 1, AI: "guard", visionRadius: 7, maxhp: 10, minLevel: 0, weight:-20, movePoints: 1.5, attackPoints: 2, evasion: -0.2, focusPlayer: true,
		attack: "MeleeBindLockWillStun", attackWidth: 3, attackRange: 1, power: 4, dmgType: "electric", stunTime: 1, attackLock: "Red",
		stamina: 4,
		maxblock: 1,
		maxdodge: 2,
		sprintspeed: 2.4,
		
		Security: {
			level_key: 3,
			level_tech: 3,
		},
		RemoteControl: {
			punishRemote: 4,
			punishRemoteChance: 0.2,
		},
		Sound: {
			baseAmount: 3.5,
			alertAmount: 8,
		},
		RestraintFilter: {
			requiredItems: ["CyberDollJacket"],
		},
		events: [
			{trigger: "defeat", type: "delete", chance: 1.0},
			{trigger: "tick", type: "secretToy"},
		],
		terrainTags: {"jailGuard": 50, "robot": 25, guardian: 26, "cyborg": 25}, allFloors: true, dropTable: [{name: "RedKey", weight: 1}, {name: "KeyCard", weight: 1}]},

	// Rin
	{name: "CyborgGuardian", faction: "AncientRobot",
		playLine: "Cyborg",
		outfit: "Cyborg",
		style: "Bandit",
		bound: "CyborgGuardian", color: "#f0b541",
		tags: KDMapInit(["leashing", "opendoors", "closedoors", "jail", "jailer", "melee", "unflinching", "miniboss", "robot", "cyborg", "guardian", "cyberhogtie", "cyberdollrestraints", "cyberdollheavy", "controlharness", "handcuffer",
			"electricweakness", "coldresist", "iceresist", "slashresist", "pierceresist"]),
		noDisplace: false, disarm: 0.5,
		spells: ["SummonForceFields", "RobotBolt"], spellCooldownMult: 1, spellCooldownMod: 0, castWhileMoving: true,
		projectileTargeting: true,
		armor: 2,
		keys: true, followRange: 1, AI: "guard", visionRadius: 7.5, maxhp: 16, minLevel: 0, weight:-30, movePoints: 1.8, attackPoints: 2, evasion: -0.3, focusPlayer: true,
		attack: "SpellMeleeBindLockWillStun", attackWidth: 3, attackRange: 1, power: 4, dmgType: "electric", stunTime: 1, attackLock: "Red",
		stamina: 3,
		maxblock: 2,
		maxdodge: 1,
		sprintspeed: 2.4,
		Security: {
			level_key: 3,
			level_tech: 3,
		},
		RemoteControl: {
			punishRemote: 4,
			punishRemoteChance: 0.2,
		},
		Sound: {
			baseAmount: 3.5,
			alertAmount: 8,
		},
		RestraintFilter: {
			requiredItems: ["CyberDollJacket"],
		},
		events: [
			{trigger: "defeat", type: "delete", chance: 1.0},
			{trigger: "tick", type: "secretToy"},
		],
		terrainTags: {"robot": 5, "cyborg": 25, guardian: 50}, allFloors: true, dropTable: [{name: "RedKey", weight: 1}, {name: "KeyCard", weight: 1}, {name: "BlueKey", weight: 0.1}]},



	{name: "CaptureBot", faction: "AncientRobot", clusterWith: "robot", playLine: "Robot", color: "#2a319c",
		SFX: {death: "SciFiExplode"},
		tags: KDMapInit(["leashing", "jailer", "doortrap", "robot", "acidweakness", "soapweakness", "melee", "electricsevereweakness", "coldresist", "cyberhogtie", "soulresist", "guardCall", "iceresist", "slashresist", "crushsevereweakness", "pierceweakness", "hitechCables", "cableGag", "controlHarness", "opendoors", "closedoors", "search"]),
		AI: "patrol",
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 4.5, color: KDBaseRed},
		],
		maxblock: 2,
		maxdodge: 0,
		cueSfx: {
			Block: "Clang",
			Resist: "SoftShield",
			Damage: "RobotHit",
		},
		stamina: 2,
		Sound: {
			baseAmount: 3,
			moveAmount: 8,
			alertAmount: 12,
		},
		Security: {
			level_key: 2,
			level_tech: 2,
		},
		armor: 2.5, maxhp: 10, movePoints: 2,
		evasion: -0.2,
		visionRadius: 6, followRange: 1, projectileAttack: true, useLock: "Red",
		RemoteControl: {
			punishRemote: 4,
			punishRemoteChance: 0.25,
		},
		attack: "MeleeBind", attackPoints: 4, attackWidth: 3, attackRange: 1, power: 3, dmgType: "crush", multiBind: 2, fullBoundBonus: 2,
		minLevel:3, weight:-6, terrainTags: {"nocablebot": -1000, "secondhalf":1, "thirdhalf":1, "increasingWeight":0.5, "metalAnger": 6, "metalRage": 4, "metalPleased": 6, "metalFriendly": 4, "robot": 20, "tapePref": -4, "tapeOptout": 3}, shrines: ["Metal"], allFloors: true,
		dropTable: [{name: "Gold", amountMin: 10, amountMax: 20, weight: 10, noSummon: true}, {name: "KeyCard", weight: 1}, {name: "AncientPowerSourceSpent", weight: 1, noSummon: true}]},
	{name: "ForcefieldBot", faction: "AncientRobot", clusterWith: "robot", playLine: "Robot", color: "#2a319c",
		SFX: {death: "SciFiExplode"},
		tags: KDMapInit(["leashing", "jailer", "doortrap", "robot", "acidweakness", "soapweakness", "melee", "elite", "electricsevereweakness",
			"bulwark", "coldresist", "soulresist", "guardCall", "iceresist", "slashresist", "crushsevereweakness", "pierceweakness", "hitechCables", "cableGag", "controlHarness", "opendoors", "closedoors", "search"]),
		AI: "patrol",
		spells: ["SummonForceFields"], spellCooldownMult: 1, spellCooldownMod: 0, castWhileMoving: true,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 4.5, color: KDBaseRed},
		],
		maxblock: 3,
		maxdodge: 0,
		stamina: 2,
		cueSfx: {
			Block: "Clang",
			Resist: "SoftShield",
			Damage: "RobotHit",
		},
		Sound: {
			baseAmount: 4,
			moveAmount: 8,
			alertAmount: 12,
		},
		Security: {
			level_key: 2,
			level_tech: 2,
		},
		armor: 2.5, maxhp: 14, movePoints: 3,
		evasion: -0.35,
		visionRadius: 6, followRange: 1, projectileAttack: true, useLock: "Red",
		RemoteControl: {
			punishRemote: 4,
			punishRemoteChance: 0.25,
		},
		attack: "SpellMeleeBind", attackPoints: 4, attackWidth: 1, attackRange: 1, power: 3, dmgType: "electric", multiBind: 1, fullBoundBonus: 4,
		minLevel:6, weight:-6,
		terrainTags: {"secondhalf":1, "thirdhalf":1, "increasingWeight":0.5, "metalAnger": 5, "metalRage": 3, "metalPleased": 5, "metalFriendly": 3, "robot": 17}, shrines: ["Metal"], allFloors: true,
		dropTable: [{name: "Gold", amountMin: 10, amountMax: 20, weight: 10, noSummon: true}, {name: "AncientPowerSourceSpent", weight: 1, noSummon: true}]},
	{name: "TapeBot", faction: "AncientRobot", clusterWith: "robot", playLine: "Robot", color: "#00eeee",
		SFX: {death: "SciFiExplode"},
		tags: KDMapInit(["leashing", "jailer", "doortrap", "robot", "acidweakness", "soapweakness", "melee", "electricsevereweakness", "coldresist", "soulresist", "guardCall", "iceresist", "slashresist", "crushsevereweakness", "pierceweakness", "autoTape", "opendoors", "closedoors", "search"]),
		AI: "patrol",
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 4, color: "#00eeee"},
		],
		maxblock: 1,
		maxdodge: 0,
		cueSfx: {
			Block: "Clang",
			Resist: "SoftShield",
			Damage: "RobotHit",
		},
		stamina: 2,
		Sound: {
			baseAmount: 3,
			moveAmount: 8,
			alertAmount: 12,
		},
		Security: {
			level_key: 1,
			level_tech: 2,
		},
		armor: 2.5, maxhp: 10, movePoints: 1.7,
		evasion: -0.2,
		visionRadius: 6, followRange: 3.5, projectileAttack: true, useLock: "Red",
		RemoteControl: {
			punishRemote: 4,
			punishRemoteChance: 0.25,
		},
		attack: "MeleeBind", attackPoints: 3, attackWidth: 1, attackRange: 3.5, power: 3, dmgType: "glue", multiBind: 1, fullBoundBonus: 2,
		minLevel:2, weight:-8, terrainTags: {"notapebot": -1000, "secondhalf":1, "thirdhalf":1, "increasingWeight":0.5, "metalAnger": 6, "metalRage": 4, "metalPleased": 6, "metalFriendly": 4, "robot": 20, "tape": 5, "tapePref": 6, "tapeOptout": -30}, shrines: ["Metal"], allFloors: true,
		dropTable: [{name: "Gold", amountMin: 10, amountMax: 20, weight: 10, noSummon: true}, {name: "KeyCard", weight: 1}, {name: "AncientPowerSourceSpent", weight: 1, noSummon: true}]},
	{name: "BotMissile", faction: "AncientRobot", clusterWith: "robot", playLine: "Robot", color: "#2a319c",
		SFX: {death: "SciFiExplodeLarge"},
		tags: KDMapInit(["leashing", "disarmresist", "robot", "ranged", "miniboss", "acidweakness", "soapweakness", "electricsevereweakness",
			"unflinching", "coldresist", "soulresist", "iceresist", "slashresist", "crushsevereweakness", "pierceweakness",
			"bulwark", "hitechCables", "cableGag", "controlHarness", "search", "dollRoomBoss"]),
		AI: "guard", spellRdy: true, bypass: true,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 5.5, color: KDBaseRed},
		],
		maxblock: 0,
		maxdodge: 0,
		spells: ["RubberMissile"], spellCooldownMult: 0.7, spellCooldownMod: 0, castWhileMoving: true, followLeashedOnly: true,
		cueSfx: {
			Block: "Clang",
			Resist: "SoftShield",
			Damage: "RobotHit",
		},
		Sound: {
			baseAmount: 5,
			moveAmount: 10,
			alertAmount: 12,
		},
		Security: {
			level_key: 2,
			level_tech: 2,
		},
		armor: 4, maxhp: 20, movePoints: 4,
		evasion: -0.5,
		visionRadius: 9, followRange: 3.5, projectileAttack: true, useLock: "Red",
		RemoteControl: {
			punishRemote: 6,
			punishRemoteChance: 0.5,
		},
		attack: "SpellMeleeBind", attackPoints: 2, attackWidth: 1, attackRange: 3.5, power: 1, dmgType: "crush", multiBind: 1, fullBoundBonus: 3,
		minLevel:7, weight:-106, terrainTags: {"nolatexbot": -1000,"thirdhalf":1, "increasingWeight":0.5, "open": 100, "metalAnger": 44, "metalRage": 13, "metalPleased": 44, "latex": 5, "metalFriendly": 13, "robot": 7}, shrines: ["Metal"], allFloors: true,
		dropTable: [{name: "Gunpowder", amountMin: 2, amountMax: 3, weight: 5, noSummon: true}, {name: "KeyCard", weight: 1}, {name: "AncientPowerSource", weight: 1, noSummon: true}]},
	{name: "EnforcerBot", faction: "AncientRobot", clusterWith: "robot", playLine: "Robot", color: "#2a319c",
		SFX: {death: "SciFiExplodeLarge"},
		tags: KDMapInit(["leashing", "disarmresist", "robot", "ranged", "miniboss", "acidweakness", "soapweakness",
			"bulwark", "electricsevereweakness", "unstoppable", "coldresist", "soulresist", "iceresist", "slashresist", "cyberhogtie", "crushsevereweakness", "pierceweakness", "hitechCables", "cableGag", "controlHarness", "search"]),
		AI: "guard", spellRdy: true, bypass: true,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 5.5, color: KDBaseRed},
		],
		maxblock: 0,
		maxdodge: 0,
		spells: ["RobotBolt"], spellCooldownMult: 1, spellCooldownMod: 0, castWhileMoving: true, followLeashedOnly: true,
		cueSfx: {
			Block: "Clang",
			Resist: "SoftShield",
			Damage: "RobotHit",
		},
		Security: {
			level_key: 2,
			level_tech: 2,
		},
		Sound: {
			baseAmount: 5,
			moveAmount: 10,
			alertAmount: 12,
		},
		summon: [
			{enemy: "Drone", range: 2, count: 2, chance: 0.25, strict: true},],
		armor: 5, maxhp: 28, movePoints: 4,
		evasion: -0.5,
		visionRadius: 9, followRange: 3.5, projectileAttack: true, useLock: "Red",
		RemoteControl: {
			punishRemote: 6,
			punishRemoteChance: 0.5,
		},
		attack: "SpellMeleeBind", attackPoints: 2, attackWidth: 1, attackRange: 3.5, power: 1, dmgType: "crush", multiBind: 1, fullBoundBonus: 3,
		minLevel:9, weight:-106, terrainTags: {"thirdhalf":1, "increasingWeight":0.5, guardian: 100, "robot": 7}, shrines: ["Metal"], allFloors: true,
		dropTable: [{name: "Gold", amountMin: 20, amountMax: 30, weight: 5, noSummon: true}, {name: "KeyCard", weight: 1}, {name: "AncientPowerSource", weight: 1, noSummon: true}]},

	{name: "EnforcerBotGuardian", faction: "AncientRobot", clusterWith: "robot", playLine: "Robot", color: "#2a319c",
		SFX: {death: "SciFiExplodeLarge"},
		tags: KDMapInit(["leashing", "disarmresist", "robot", "ranged", "miniboss", "acidweakness", "soapweakness",
			"bulwark", "electricsevereweakness", "guardian", "unstoppable", "coldresist", "soulresist", "iceresist", "cyberhogtie", "slashresist", "crushsevereweakness", "pierceweakness", "hitechCables", "cableGag", "controlHarness", "search"]),
		AI: "guard", spellRdy: true, bypass: true,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 5.5, color: "#e7cf1a"},
		],
		maxblock: 0,
		maxdodge: 0,
		spells: ["RobotBolt"], spellCooldownMult: 1, spellCooldownMod: 0, castWhileMoving: true, followLeashedOnly: true,
		cueSfx: {
			Block: "Clang",
			Resist: "SoftShield",
			Damage: "RobotHit",
		},
		Sound: {
			baseAmount: 5,
			moveAmount: 10,
			alertAmount: 12,
		},
		Security: {
			level_key: 2,
			level_tech: 2,
		},
		summon: [
			{enemy: "DroneGuardian", range: 2, count: 2, chance: 0.25, strict: true},],
		armor: 5, maxhp: 24, movePoints: 4,
		evasion: -0.5,
		visionRadius: 9, followRange: 3.5, projectileAttack: true, useLock: "Red",
		RemoteControl: {
			punishRemote: 6,
			punishRemoteChance: 0.5,
		},
		attack: "SpellMeleeBind", attackPoints: 2, attackWidth: 1, attackRange: 3.5, power: 1, dmgType: "crush", multiBind: 1, fullBoundBonus: 3,
		minLevel:9, weight:-106, terrainTags: {"nocablebot": -1000, "thirdhalf":1, "increasingWeight":0.5, "open": 100, "metalAnger": 44, "metalRage": 13, "metalPleased": 44, "metalFriendly": 13, "robot": 7}, shrines: ["Metal"], allFloors: true,
		dropTable: [{name: "KeyCard", weight: 5}, {name: "AncientPowerSource", weight: 1, noSummon: true}]},

	{name: "AlchemistPet", style: "Nevermere", outfit: "AlchemistPet", faction: "Alchemist", clusterWith: "alchemist", bound: "AlchemistPet", playLine: "Gagged", color: "#007C59", tags: KDMapInit(["opendoors", "disarmresist", "noarms", "submissive", "noshop", "gagged", "imprisonable", "ignoreharmless", "alchemist", "ranged", "glueweakness", "electricresist", "ticklesevereweakness", "iceresist", "charmweakness", "stunweakness", "search"]),
		ignorechance: 0, armor: 1, followRange: 1.5, AI: "hunt",
		master: {type: "Alchemist", range: 2, loose: true, aggressive: true}, sneakThreshold: 1, blindSight: 2, projectileAttack: true, strictAttackLOS: true, events: [
			{trigger: "tick", type: "secretToy"},
		],
		maxblock: 0,
		maxdodge: 2,
		stamina: 7,
		nopickpocket: true,
		specialCD: 11, specialAttack: "DashStun", specialRemove: "Will", specialCDonAttack: true, specialAttackPoints: 2, specialRange: 4, specialMinRange: 1.5, specialsfx: "HeavySwing", stunTime: 4, stunOnSpecialCD: 4,
		visionRadius: 6, maxhp: 10, minLevel:3, weight:0, movePoints: 1, attackPoints: 2, attack: "MeleeWill", attackWidth: 1, attackRange: 1, power: 1, dmgType: "grope", fullBoundBonus: 2,
		terrainTags: {"latexAnger": 2, "latexRage": 2, "alchemist": 7}, shrines: ["Latex"], allFloors: true,
		dropTable: []},
	{name: "WolfgirlPet", style: "Nevermere", outfit: "Wolfgirl", faction: "Nevermere", clusterWith: "nevermere", bound: "WolfgirlPet", playLine: "Gagged", color: "#009C79", tags: KDMapInit(["opendoors", "wolfSub", "disarmresist", "nevermere", "noarms", "submissive", "noshop", "gagged", "wolfPet", "alwaysAlert", "imprisonable", "wolfgirl", "minor", "ignoreharmless", "ranged", "glueweakness", "electricresist", "ticklesevereweakness", "iceresist", "charmweakness", "stunweakness", "search"]),
		ignorechance: 0, armor: 1, followRange: 2, AI: "hunt",  cohesion: 0.9,
		master: {type: "Wolfgirl", range: 2, loose: true, aggressive: true}, sneakThreshold: 1, blindSight: 2, projectileAttack: true, strictAttackLOS: true, difficulty: 0.5, events: [
			{trigger: "tick", type: "secretToy"},
		],
		maxblock: 0,
		maxdodge: 2,
		stamina: 7,
		nopickpocket: true,
		specialCD: 11, specialAttack: "DashStun", specialRemove: "Will", specialCDonAttack: true, specialAttackPoints: 2, specialRange: 4, specialMinRange: 1.5, specialsfx: "HeavySwing", stunTime: 4, stunOnSpecialCD: 4,
		visionRadius: 6, maxhp: 10, minLevel:0, weight:0.1, movePoints: 1, attackPoints: 2, attack: "MeleeWill", attackWidth: 1, attackRange: 1, power: 1, dmgType: "grope", fullBoundBonus: 2,
		terrainTags: {"metalAnger": 3, "metalRage": 3, "metalPleased": 2, "metalFriendly": 2, "nevermere": 2}, shrines: ["Metal"], allFloors: true,
		dropTable: []},
	{name: "WolfGuard", style: "Nevermere", outfit: "Wolfgirl", faction: "Nevermere", clusterWith: "nevermere", bound: "WolfGuard", color: "#00dCa9", playLine: "Gagged",
		tags: KDMapInit([
			"opendoors", "blindweakness", "disarmimmune", "wolfSub", "nevermere", "noarms", "submissive", "noshop", "gagged", "wolfPet", "autoTape", "alwaysAlert", "leashing", "wolfLeash", "imprisonable", "wolfgirl", "ranged", "glueweakness", "electricresist", "ticklesevereweakness", "iceresist", "charmweakness", "stunweakness", "search",
			"bulwark"]),
		ignorechance: 0, armor: 2.5, followRange: 2, AI: "hunt",  cohesion: 0.5, events: [
			{trigger: "tick", type: "secretToy"},
		],
		maxblock: 0,
		maxdodge: 3,
		nopickpocket: true,
		attackLock: "White",
		master: {type: "Wolfgirl", range: 2, loose: true, aggressive: true}, sneakThreshold: 1, blindSight: 2, projectileAttack: true, strictAttackLOS: true,
		specialCD: 9, specialAttack: "DashWill", specialRemove: "Bind", specialCDonAttack: true, specialAttackPoints: 2, specialRange: 4, specialMinRange: 1.5, specialsfx: "HeavySwing", stunTime: 4, stunOnSpecialCD: 4, specialDamage: "crush",
		visionRadius: 6, maxhp: 14, minLevel:6, weight:0, movePoints: 1, attackPoints: 3, attack: "MeleeBind", attackWidth: 1, attackRange: 3, projectileTargeting: true, power: 2, dmgType: "electric", fullBoundBonus: 2,
		terrainTags: {"metalAnger": 1.5, "metalRage": 8, "metalPleased": 4, "metalFriendly": 4, "nevermere": 1}, shrines: ["Metal"], allFloors: true,
		dropTable: [{name: "Nothing", weight: 10}, {name: "EscortDrone", weight: 0.5, ignoreInInventory: true}, {name: "VibeWand", weight: 100, ignoreInInventory: true},]},
	{name: "WolfInstructor", style: "Nevermere", outfit: "Wolfgirl", faction: "Nevermere", clusterWith: "nevermere", bound: "Wolfgirl", playLine: "Wolfgirl", color: "#00EFAB", tags: KDMapInit(["leashing", "nevermere", "wolfPetsuit", "antiMagic", "imprisonable", "trainer", "controlHarness", "wolfRestraintsHeavy","wolfgirl", "jailer", "opendoors", "unflinching", "closedoors", "wolfGear", "handcuffer", "melee", "unflinching", "iceresist", "electricresist", "charmweakness", "stunweakness", "ticklesevereweakness", "jail", "jailer", "hunter"]),
		followRange: 3, kite: 2.5,
		summon: [
			{enemy: "WolfgirlPet", range: 2, count: 1, chance: 1.0, strict: true},
			{enemy: "WolfgirlPet", range: 2, count: 1, chance: 0.5, strict: true},
		],
		maxblock: 1,
		maxdodge: 1,
		stamina: 5,
		spells: ["NevermereBoost"], spellCooldownMult: 1, spellCooldownMod: 5, buffallies: true,
		AI: "hunt",  visionRadius: 10, maxhp: 9, minLevel:6, weight:-2, movePoints: 2, evasion: 0.3,
		RemoteControl: {
			punishRemote: 4,
			punishRemoteChance: 0.25,
		},
		attackPoints: 3, attack: "MeleeBindLockWillSpell", attackWidth: 1, attackRange: 1, tilesMinRange: 1, power: 3, dmgType: "pain",
		attackLock: "White",
		terrainTags: {"secondhalf":4, "lastthird":4, "metalAnger": 4, "metalRage": 4, "metalPleased": 9, "metalFriendly": 4, "nevermere": 9}, allFloors: true, shrines: ["Metal"],
		dropTable: [{name: "Gold", amountMin: 15, amountMax: 20, weight: 10}, {name: "KeyCard", weight: 1}]
	},
	{name: "WolfExecutive", style: "Nevermere", outfit: "Wolfgirl", faction: "Nevermere", clusterWith: "nevermere", bound: "WolfExecutive", color: "#00EFAB", playLine: "Wolfgirl",
		tags: KDMapInit(["leashing", "wolfPetsuit", "nevermere", "trainer", "wolfgirl", "jailer", "opendoors", "unflinching", "closedoors", "antiMagic", "wolfGear", "controlHarness", "wolfRestraints", "wolfRestraintsHeavy", "melee",
			"boss", "unstoppable", "iceresist", "electricresist", "charmweakness", "stunweakness", "ticklesevereweakness", "jailer", "hunter"]),
		followRange: 4.5, kite: 2.5,
		summon: [
			{enemy: "WolfGuard", range: 2, count: 2, chance: 1.0, strict: true},
			{enemy: "WolfShieldDrone", range: 2, count: 1, chance: 0.5, strict: true},
		],
		maxblock: 2,
		maxdodge: 3,
		spells: ["NevermereBoost", "SummonWolfDrone", "SummonWolfTapeDrone", "EnemyBlast"], spellCooldownMult: 0.5, spellCooldownMod: 0, buffallies: true, projectileTargeting: true,
		stamina: 5,
		AI: "hunt",  visionRadius: 10, maxhp: 30, minLevel:5, weight:-30, movePoints: 1.2, evasion: 0.2, bindOnDisable: true,
		smartBind: true,
		RemoteControl: {
			punishRemote: 5,
			punishRemoteChance: 0.35,
		},
		attackPoints: 4, attack: "MeleeWillBindLockAllSpell", multiBind: 2, attackWidth: 3, attackRange: 1, tilesMinRange: 1, power: 3, fullBoundBonus: 3, dmgType: "charm", attackLock: "Blue",
		terrainTags: {"secondhalf":5, "lastthird":5, "boss": -30, "open": 10, "passage": -40, "metalAnger": 2, "metalRage": 2, "metalPleased": 5, "metalFriendly": 5, "increasingWeight":0.5, "nevermere": 30},
		allFloors: true, shrines: ["Metal"],
		dropTable: [{name: "KeyCard", weight: 10}, {name: "Blaster", weight: 100, ignoreInInventory: true},]
	},

	{name: "Wolfgirl", style: "Nevermere", outfit: "Wolfgirl", faction: "Nevermere", clusterWith: "nevermere", bound: "Wolfgirl", color: "#00EFAB", playLine: "Wolfgirl",
		tags: KDMapInit(["leashing", "wolfPetsuit", "nevermere", "imprisonable", "trainer", "wolfgirl", "jailer", "opendoors", "unflinching", "closedoors", "wolfRestraints", "melee", "miniboss", "unflinching", "glueweakness", "ticklesevereweakness", "iceresist", "electricresist", "charmweakness", "stunweakness", "unflinching", "jail", "jailer", "hunter"]), followRange: 1,
		summon: [
			{enemy: "WolfgirlPet", range: 2, count: 1, chance: 0.7, strict: true},],
		spells: ["RestrainingDevice"], spellCooldownMult: 1, spellCooldownMod: 1, AI: "hunt",  visionRadius: 10, maxhp: 20, minLevel:0, weight:-6, movePoints: 2, disarm: 0.5, armor: 1.5,
		RemoteControl: {
			punishRemote: 4,
			punishRemoteChance: 0.25,
		},
		events: [
			{trigger: "tick", type: "LeashWolfgirls", dist: 3.5, chance: 0.3},
		],
		maxblock: 3,
		maxdodge: 2,
		stamina: 6,
		attackPoints: 3, attack: "MeleeBindLockAllWillSpell", attackWidth: 3, attackRange: 1, tilesMinRange: 1, power: 4, dmgType: "grope", attackLock: "Red",
		terrainTags: {"secondhalf":3, "lastthird":5, "metalAnger": 7, "metalRage": 2, "metalPleased": 9, "metalFriendly": 6, "nevermere": 7}, allFloors: true, shrines: ["Metal"],
		dropTable: [{name: "Gold", amountMin: 15, amountMax: 20, weight: 10}, {name: "EscortDrone", weight: 1.0, ignoreInInventory: true}]
	},

	{name: "WolfOperative", style: "Nevermere", outfit: "Wolfgirl", faction: "Nevermere", clusterWith: "nevermere", bound: "WolfOperative", color: "#00EFAB", playLine: "Hunter",
		tags: KDMapInit(["leashing", "bountyhunter", "nevermere", "imprisonable", "trainer", "wolfgirl", "jailer", "antiMagic", "opendoors", "imprisonable", "unflinching", "closedoors", "wolfRestraints", "wolfRestraintsHeavy", "melee", "elite", "unflinching", "glueweakness", "ticklesevereweakness", "iceresist", "electricresist", "charmweakness", "stunweakness", "unflinching", "jail", "jailer", "hunter"]), followRange: 1,
		spells: ["EnemyBlast"], spellCooldownMult: 0.75, spellCooldownMod: 0, AI: "hunt",  visionRadius: 10, maxhp: 18, minLevel:5, weight:-3, movePoints: 1.7, disarm: 0.5, stealth: 3.5, armor: 0.5,
		RemoteControl: {
			punishRemote: 3,
			punishRemoteChance: 0.2,
		},
		maxblock: 2,
		maxdodge: 2,
		stamina: 7,
		Sound: {
			baseAmount: 1,
			moveAmount: 4,
		},
		bindOnDisable: true, projectileTargeting: true, cohesion: 0.1,
		smartBind: true,
		attackPoints: 2, attack: "MeleeBindLockAllWillSpell", attackWidth: 1, attackRange: 1, tilesMinRange: 1, power: 2, dmgType: "grope", fullBoundBonus: 2,
		attackLock: "White",
		terrainTags: {"secondhalf":1, "lastthird":2, "metalAnger": 5, "metalRage": 5, "metalPleased": 15, "metalFriendly": 10, "nevermere": 13, "bountyhunter": 3}, allFloors: true, shrines: ["Metal"],
		dropTable: [{name: "Gold", amountMin: 15, amountMax: 20, weight: 19}, {name: "Blaster", ignoreInInventory: true, weight: 0.5}]},

	{name: "WolfApprentice", style: "Nevermere", outfit: "Wolfgirl", faction: "Nevermere", clusterWith: "nevermere", bound: "Wolfgirl", color: "#00EFAB", playLine: "Wolfgirl",
		tags: KDMapInit(["leashing", "imprisonable", "nevermere", "trainer", "wolfgirl", "jailer", "opendoors", "unflinching", "closedoors", "wolfRestraints", "melee", "elite", "unflinching", "glueweakness", "ticklesevereweakness", "iceresist", "electricresist", "charmweakness", "stunweakness", "unflinching", "jail", "jailer", "hunter"]),
		spells: ["SummonWolfDrone"], spellCooldownMult: 1, spellCooldownMod: 0, AI: "hunt",  visionRadius: 10, maxhp: 9, minLevel:0, weight:1, movePoints: 2.5, events: [
			{trigger: "tick", type: "secretToy"},
		],
		maxblock: 1,
		maxdodge: 1,
		armor: 0.5,
		RemoteControl: {
			punishRemote: 3,
			punishRemoteChance: 0.15,
		},
		stamina: 2,
		attackLock: "White",
		followRange: 1, kite: 2.5, dontKiteWhenDisabled: true, castWhileMoving: true,
		attackPoints: 3, attack: "MeleeBindLockWillSpell", attackWidth: 1, attackRange: 1, tilesMinRange: 1, power: 2, dmgType: "grope", sneakThreshold: 2.5,
		terrainTags: {"secondhalf":1, "lastthird":2, "metalAnger": 12, "metalRage": 6, "metalPleased": 5, "metalFriendly": 10, "nevermere": 15}, allFloors: true, shrines: ["Metal"],
		dropTable: [{name: "Gold", amountMin: 15, amountMax: 20, weight: 10}, {name: "EscortDrone", weight: 0.25, ignoreInInventory: true}]},

	{name: "WolfDrone", faction: "Nevermere", clusterWith: "nevermere", color: "#00EFAB", playLine: "Robot",
		SFX: {death: "SciFiExplode"},
		tags: KDMapInit(["ignoreharmless", "quadcopter", "disarmimmune", "robot", "nevermere", "wolfdrone", "flying", "acidweakness", "soapweakness", "soulresist", "minor", "ranged", "electricsevereweakness", "wolfPet", "coldresist", "iceresist", "slashresist", "crushsevereweakness", "pierceweakness", "hitechCables", "cableGag", "search"]),
		followRange: 2.5, kite: 1.5,
		maxblock: 0,
		maxdodge: 0,
		Sound: {
			baseAmount: 5,
			moveAmount: 8,
			alertAmount: 12,
		},
		spells: ["WolfCrackle"], spellCooldownMult: 1, spellCooldownMod: 1, AI: "hunt",  visionRadius: 9, maxhp: 5, armor: 1, minLevel:0, weight:-1000, movePoints: 1,
		attackPoints: 3, attack: "Spell", attackWidth: 1, attackRange: 1, tilesMinRange: 1, power: 1, dmgType: "grope",
		terrainTags: {}, allFloors: true, shrines: ["Metal"],
	},
	{name: "WolfShieldDrone", faction: "Nevermere", clusterWith: "nevermere", color: "#00EFAB", playLine: "Robot",
		SFX: {death: "SciFiExplode"},
		tags: KDMapInit(["ignoreharmless", "quadcopter", "disarmimmune", "robot", "wolfdrone", "nevermere", "flying", "acidweakness",
			"bulwark", "soapweakness", "soulresist", "minor", "ranged", "electricsevereweakness", "wolfPet", "coldresist", "iceresist", "slashresist", "crushsevereweakness", "pierceweakness", "search"]),
		followRange: 3.9, kite: 2.5, difficulty: 0.2,
		evasion: -0.2,
		maxblock: 1,
		maxdodge: 0,
		Sound: {
			baseAmount: 4.5,
			moveAmount: 4.5,
			alertAmount: 12,
		},
		shield: 5,
		AI: "hunt",  visionRadius: 9, maxhp: 6, minLevel:0, weight:-4, movePoints: 1.5, cohesion: 1.0, armor: 1.5, spellResist: 1.5,
		attackPoints: 3, attack: "", attackWidth: 1, attackRange: 1, tilesMinRange: 1, power: 1, dmgType: "grope",
		terrainTags: {"metalAnger": 4, "metalRage": 4, "nevermere": 8}, allFloors: true, shrines: ["Metal"],
		events: [
			{trigger: "afterEnemyTick", type: "wolfShieldDroneAura", power: 10, mult: 0.04, dist: 4.5},
		],
	},
	{name: "WolfTapeDrones", faction: "Nevermere", clusterWith: "nevermere", color: "#00eeee", playLine: "Robot",
		SFX: {death: "SciFiExplode"},
		tags: KDMapInit(["ignoreharmless", "quadcopter", "disarmimmune", "robot", "wolfdrone", "leashing", "nevermere", "flying", "acidweakness", "soapweakness", "soulresist", "minor", "ranged", "fireweakness", "electricsevereweakness", "wolfPet", "coldresist", "iceresist", "slashresist", "crushsevereweakness", "pierceweakness", "autoTape", "search"]),
		followRange: 1, difficulty: 0.5,
		maxblock: 0,
		maxdodge: 0,
		Sound: {
			baseAmount: 4,
			moveAmount: 7,
			alertAmount: 12,
		},
		AI: "hunt",  visionRadius: 9, maxhp: 7, minLevel:0, weight:-3, movePoints: 1, cohesion: 1.0, armor: 1, spellResist: -0.5, evasion: 0.5,
		attackPoints: 2, attack: "MeleeBind", attackWidth: 2.5, attackRange: 1, tilesMinRange: 1, power: 1, dmgType: "glue", fullBoundBonus: 1,
		terrainTags: {"metalPleased": 4, "metalFriendly": 8, "nevermere": 13, "tapeOptout": -30, "tape": 5, "tapePref": 2}, allFloors: true, shrines: ["Metal"],
	},


	{name: "BanditGuard", outfit: "BanditGuard", style: "Earth", faction: "Bandit", clusterWith: "bandit", playLine: "Bandit", bound: "Bandit", tags: KDMapInit(["opendoors", "closedoors", "leashing", "cacheguard", "bandit", "minor", "melee", "leatherRestraints", "leatherRestraintsHeavy", "clothRestraints", "chainweakness", "glueweakness", "jail", "jailer", "search"]),
		cohesion: 0.9, armor: 1, followRange: 1, AI: "hunt",
		maxblock: 2,
		maxdodge: 1,
		master: {type: "BanditChief", range: 2, loose: true, aggressive: true},
		spells: ["BanditBola"], spellCooldownMult: 1, spellCooldownMod: 6, noSpellLeashing: true, difficulty: 0.9, miscastmsg: "KDBanditMiscast", miscastsfx: "Miss",
		visionRadius: 7, maxhp: 11, minLevel:9, weight:20, movePoints: 1.5, attackPoints: 3, attack: "SpellMeleeBindLock", attackWidth: 1, attackRange: 1, power: 2, dmgType: "grope", fullBoundBonus: 2,
		attackLock: "White",
		stamina: 4,
		terrainTags: {"BanditEnemy": 10, "increasingWeight":-1, "BanditWanted": 10, "BanditHated": 5}, shrines: ["Leather"], allFloors: true,
		dropTable: [{name: "Gold", amountMin: 5, amountMax: 20, weight: 24}, {name: "Rope", weight: 100.5, ignoreInInventory: true},]},
	{name: "Miner", outfit: "Bandit", style: "Earth", faction: "Bandit", clusterWith: "human", playLine: "Bandit", bound: "Miner", tags: KDMapInit(["opendoors", "closedoors", "leashing", "bandit", "human", "miner", "imprisonable", "melee", "leatherRestraints", "leatherRestraintsHeavy", "clothRestraints", "chainweakness", "glueweakness", "search"]),
		cohesion: 0.9, armor: 2.0, followRange: 1, AI: "hunt",
		maxblock: 1,
		maxdodge: 0,
		spells: ["MinerBomb"], spellCooldownMult: 1, spellCooldownMod: 3, noSpellLeashing: true, miscastmsg: "KDBanditMiscast", miscastsfx: "Miss",
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 5.5, color: "#ffdd00"},
		],
		attackLock: "White",
		stamina: 5,
		visionRadius: 5, maxhp: 10, minLevel:0, weight:12, movePoints: 2, attackPoints: 3, attack: "SpellMeleeBindLock", attackWidth: 1, attackRange: 1, power: 2, dmgType: "pain", fullBoundBonus: 2,
		terrainTags: {"increasingWeight": 1}, shrines: [], floors:KDMapInit(["cry"]), noOverrideFloor: true,
		dropTable: [{name: "Gold", amountMin: 10, amountMax: 20, weight: 21}, {name: "Pickaxe", ignoreInInventory: true, weight: 100}, {name: "Bomb", weight: 9}]},
	{name: "Bandit", style: "Earth", outfit: "Bandit", faction: "Bandit", clusterWith: "bandit", playLine: "Bandit", bound: "Bandit", tags: KDMapInit(["opendoors", "closedoors", "leashing", "cacheguard", "imprisonable", "bandit", "minor", "melee", "leatherRestraints", "leatherRestraintsHeavy", "clothRestraints", "chainweakness", "glueweakness", "jail", "jailer", "search"]),
		cohesion: 0.9, armor: 0, followRange: 1, AI: "hunt",
		spells: ["BanditBola"], spellCooldownMult: 1, spellCooldownMod: 8, noSpellLeashing: true, difficulty: 0.9, miscastmsg: "KDBanditMiscast", miscastsfx: "Miss",
		visionRadius: 6, maxhp: 9, minLevel:0, maxLevel: 9, weight:23, movePoints: 2, attackPoints: 3, attack: "SpellMeleeBindLock", attackWidth: 1, attackRange: 1, power: 1, dmgType: "grope", fullBoundBonus: 2,
		terrainTags: {"thirdhalf":-4, "increasingWeight":-1, "BanditEnemy": -7, "BanditWanted": -6, "BanditHated": -5}, shrines: ["Leather"], floors:KDMapInit(["jng", "cry"]),
		attackLock: "White",
		stamina: 3,
		maxblock: 1,
		maxdodge: 1,
		dropTable: [{name: "Gold", amountMin: 5, amountMax: 15, weight: 24}, {name: "Rope", weight: 3.5, ignoreInInventory: true},]},
	{name: "BanditChief", nameList: "italian", style: "Earth", outfit: "BanditChief", faction: "Bandit", clusterWith: "bandit", playLine: "Bandit", bound: "BanditChief",
		tags: KDMapInit(["opendoors",
			"bulwark", "cacheguard", "closedoors", "leashing", "bandit", "miniboss", "banditleader", "melee", "unflinching", "ballGagRestraints", "handcuffer", "leatherRestraints", "leatherRestraintsHeavy", "clothRestraints", "chainweakness", "glueweakness", "jail", "jailer", "hunter"]),
		cohesion: 0.9, armor: 0, followRange: 1, AI: "hunt",
		maxblock: 4,
		summon: [
			{enemy: "BanditPet", range: 3, count: 1, chance: 1.0, strict: true},],
		stamina: 4,
		spells: ["BanditBola"], spellCooldownMult: 1, spellCooldownMod: 4, noSpellLeashing: true, miscastmsg: "KDBanditMiscast", miscastsfx: "Miss",
		visionRadius: 8, maxhp: 18, minLevel:0, weight:-11, movePoints: 2, attackPoints: 3, attack: "SpellMeleeBindLock", attackWidth: 3.6, attackRange: 1, power: 4, dmgType: "grope", fullBoundBonus: 2,
		terrainTags: {"secondhalf":16, "lastthird":5, "open": 10, "passage": -10, "increasingWeight":1}, shrines: ["Leather"], floors:KDMapInit(["jng", "cry", "tmp"]),
		factionrep: {"Maidforce": 0.005},
		dropTable: [{name: "Gold", amountMin: 20, amountMax: 30, weight: 10}, {name: "Knife", ignoreInInventory: true, weight: 2}, {name: "Rope", weight: 100, ignoreInInventory: true},]},
	{name: "BanditPet", style: "Earth", outfit: "BanditPet", faction: "Bandit", clusterWith: "human", playLine: "Gagged", bound: "BanditPet", tags: KDMapInit(["opendoors", "silenceimmune", "submissive", "noshop", "gagged", "imprisonable", "cacheguard", "closedoors", "leashing", "bandit", "melee", "minor", "ballGagRestraints", "ropeRestraints", "tickleweakness", "chainweakness", "glueweakness", "jail", "search"]),
		cohesion: 0.9, armor: 0, followRange: 1, AI: "hunt",
		maxblock: 0,
		maxdodge: 2,
		master: {type: "BanditChief", range: 2, loose: true, aggressive: true}, difficulty: 0.7, events: [
			{trigger: "tick", type: "secretToy"},
		],
		stamina: 6,
		visionRadius: 6, maxhp: 6, minLevel:0, weight:13, movePoints: 1.5, attackPoints: 3, attack: "MeleeBindLockWill", attackWidth: 1, attackRange: 1, power: 2, dmgType: "grope", fullBoundBonus: 2,
		terrainTags: {"thirdhalf":-1, "increasingWeight":-1}, shrines: ["Leather"], floors:KDMapInit(["jng", "cry"]),
		dropTable: [{name: "Gold", amountMin: 1, amountMax: 5, weight: 10}, {name: "Feather", weight: 50, ignoreInInventory: true}]},
	{name: "BanditHunter", nameList: "japanese", style: "Earth", outfit: "BanditHunter", faction: "Bandit", bound: "BanditHunter", playLine: "Bandit", tags: KDMapInit(["opendoors", "closedoors", "leashing", "bandit", "imprisonable", "melee", "elite", "leatherRestraints", "leatherRestraintsHeavy", "clothRestraints", "chainweakness", "glueweakness", "jail", "jailer", "hunter"]),
		ignorechance: 0, armor: 0.5, followRange: 1.5, AI: "hunt", guardChance: 0.6, stealth: 1,
		spells: ["BanditBola"], spellCooldownMult: 1, spellCooldownMod: 3, noSpellLeashing: true, projectileTargeting: true, focusPlayer: true, miscastmsg: "KDBanditMiscast", miscastsfx: "Miss",
		visionRadius: 7, maxhp: 9, minLevel:0, weight:4 , movePoints: 2, attackPoints: 2, attack: "SpellMeleeBindLock", attackWidth: 1, attackRange: 1, power: 3, dmgType: "grope", fullBoundBonus: 2,
		attackLock: "White",
		maxblock: 1,
		maxdodge: 2,
		stamina: 5,
		terrainTags: {"secondhalf":7, "thirdhalf":5}, shrines: ["Leather"], floors:KDMapInit(["jng", "cry", "tmp"]),
		Sound: {
			baseAmount: 1,
		},
		dropTable: [{name: "Gold", amountMin: 15, amountMax: 20, weight: 10}, {name: "Rope", weight: 8, ignoreInInventory: true},]},
	{name: "BanditGrappler", nameList: "russian", style: "Earth", outfit: "BanditGuard", faction: "Bandit", clusterWith: "bandit", playLine: "Bandit", bound: "BanditGrappler", color: "#ddcaaa",
		tags: KDMapInit(["opendoors", "closedoors", "leashing", "bandit", "imprisonable", "melee", "cacheguard", "elite", "unflinching", "fiddle", "chainRestraints",
			"bulwark", "handcuffer","leatherRestraintsHeavy", "clothRestraints", "chainweakness", "glueweakness", "jail", "jailer", "hunter"]),
		ignorechance: 0, armor: 2.0, followRange: 1, AI: "hunt",
		specialCD: 10, specialAttack: "Pull", specialCDonAttack: true, specialAttackPoints: 2, specialRange: 4, specialsfx: "Chain", specialWidth: 1, specialRemove: "BindLock", pullDist: 3, pullTowardSelf: true,
		visionRadius: 7, maxhp: 10, minLevel:3, weight:4, movePoints: 3, attackPoints: 2, attack: "MeleeBindLock", attackWidth: 2, attackRange: 1, power: 3, dmgType: "grope", fullBoundBonus: 2,
		attackLock: "White",
		stamina: 3,
		maxblock: 3,
		maxdodge: 0,
		terrainTags: {"secondhalf":10, "thirdhalf":1}, shrines: ["Leather", "Metal"], floors:KDMapInit(["jng", "cry", "tmp"]),
		dropTable: [{name: "Gold", amountMin: 15, amountMax: 20, weight: 10}]},

	{name: "SlimeMold", clusterWith: "mold", faction: "Mold", color: "#FF00FF", tags: KDMapInit(["ignoretiedup", "disarmimmune", "doortrap", "mold", "minor", "melee", "moldRestraints", "fireweakness", "glueresist", "acidweakness"]),
		squeeze: true, ignorechance: 0.75, followRange: 1, AI: "hunt",  sneakThreshold: 1,
		nonDirectional: true,
		maxblock: 0,
		maxdodge: 0,
		Sound: {
			baseAmount: 0,
			idleSoundName: "Slime",
		},
		visionRadius: 5, maxhp: 1, minLevel: 0, weight:-15, movePoints: 1.5, attackPoints: 2, attack: "MeleeBindSuicide", suicideOnAdd: true, attackWidth: 1, attackRange: 1, power: 1, dmgType: "glue", fullBoundBonus: 1,
		terrainTags: {"increasingWeight":-2, "mold": 25}, allFloors: true, shrines: ["Latex"]},
	{name: "SlimeMoldLeaper", clusterWith: "mold", faction: "Mold", color: "#FF00FF", tags: KDMapInit(["ignoretiedup", "disarmimmune", "doortrap", "mold", "minor", "melee", "moldRestraints", "fireweakness", "glueresist", "acidweakness"]),
		squeeze: true, ignorechance: 0.75, followRange: 1, AI: "hunt",  sneakThreshold: 1,
		nonDirectional: true,
		maxblock: 0,
		maxdodge: 2,
		Sound: {
			baseAmount: 0,
			idleSoundName: "Slime",
		},
		specialCD: 5, specialAttack: "DashBonus", specialRemove: "Bind", specialCDonAttack: true, specialAttackPoints: 1, specialRange: 3, specialMinRange: 1.5, specialsfx: "Miss",
		visionRadius: 9, maxhp: 1, minLevel: 3, weight:-5, movePoints: 1, attackPoints: 2, attack: "MeleeBindSuicide", suicideOnAdd: true, attackWidth: 1, attackRange: 1, power: 1, dmgType: "glue", fullBoundBonus: 2,
		terrainTags: {"increasingWeight":-1, "mold": 25}, allFloors: true, shrines: ["Latex"]},

	{name: "SlimeMoldSpawner", clusterWith: "mold", faction: "Mold", color: "#FF00FF", tags: KDMapInit(["mold", "silenceimmune", "immobile", "spawner", "melee", "moldRestraints", "meleeresist", "fireweakness", "glueresist", "acidweakness"]),
		immobile: true, squeeze: true, followRange: 1, AI: "hunt",  sneakThreshold: 1, enemyCountSpellLimit: 40,
		evasion: -9,
		Sound: {
			baseAmount: 10,
			moveAmount: 10,
			idleSoundName: "SlimeLarge2",
		},
		spells: ["SummonSlimeMold"], spellCooldownMult: 1, spellCooldownMod: 0, castWhileMoving: true,
		visionRadius: 30, blindSight: 30, maxhp: 12, minLevel: 0, weight:-15, movePoints: 1000, attackPoints: 0, attack: "Spell", attackRange: 0, attackWidth: 1, power: 1, dmgType: "acid", fullBoundBonus: 5,
		terrainTags: {"increasingWeight":0, "mold": 25, "maid": 15.25}, allFloors: true, shrines: ["Latex"], ondeath: [{type: "summon", enemy: "SlimeMold", range: 2.5, count: 4, strict: true}],
		factionrep: {"Maidforce": 0.005},
	},



	{name: "SlimeAdv", faction: "Slime", clusterWith: "slime", bound: "SlimeAdv", playLine: "Gagged", color: "#FF00FF",
		tags: KDMapInit([
			"ignoretiedup", "nocapture", "latexTrap", "slime", "disarmresist", "blindimmune", "melee", "slimeRestraints", "electricresist", "acidresist", "iceweakness", "ticklesevereweakness", "charmweakness",
			"submissive", "noshop", "gagged", "imprisonable", "rescueslime", "nocapture", "noarms", "arcaneweakness"
		]),
		Sound: {
			baseAmount: 4,
			moveAmount: 4,
			idleSoundName: "Rubber",
		},
		nopickpocket: true,
		maxblock: 0,
		maxdodge: 0,
		nonDirectional: true,
		ignorechance: 0, armor: 1, followRange: 1.5, AI: "hunt",  cohesion: 0.45, sneakThreshold: 1,
		evasion: -0.25,
		master: {type: "WitchSlime", range: 2, loose: true, aggressive: true},
		visionRadius: 4.5, blindSight: 2.5, maxhp: 10, minLevel:2, weight:2, movePoints: 1.7,
		attackPoints: 3, attack: "MeleeBindSlow", attackWidth: 1, attackRange: 1, power: 1, dmgType: "glue", fullBoundBonus: 2,
		terrainTags: {"latexAnger": 3, "latexRage": 3, "alchemist": 2, "slimeBonus": 2, "slime": 5, "slimeOptOut": -2, "slimePref": 2, "jungle": 8, revenge: 10}, shrines: ["Latex"], allFloors: true,
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Slime", aoe: 1.5, power: 1, chance: 1.0, duration: 20},
		],},

		{name: "LatexKitty", faction: "Slime", clusterWith: "slime", bound: "LatexKitty", playLine: "Gagged", color: "#92dbe8",
			tags: KDMapInit([
				"nocapture", "latexTrap", "slime", "disarmresist", "blindimmune", "petsuit",
				"melee", "blueLatexEncase", "blueLatexEncaseRandom", "electricweakness", "acidresist", "iceweakness",
				"ticklesevereweakness", "charmweakness",
				"submissive", "noshop", "gagged", "imprisonable", "rescueslime", "nocapture", "noarms", "arcaneweakness",
				"latexKitty",
			]),
			effect: {
				effect: {name: "LatexKitty", damage: "glue", power: 4},
			},
			ignoreflag: ["LatexKittyatk"], failAttackflag: ["LatexKittyatk"], failAttackflagDuration: 4, failAttackflagChance: 0.4,
			Sound: {
				baseAmount: 4,
				moveAmount: 4,
				idleSoundName: "Rubber",
			},
			applyFaction: "Rubber",
			nopickpocket: true,
			maxblock: 0,
			maxdodge: 0,
			willBonus: 0.4,
			nonDirectional: true,
			ignorechance: 0, armor: 1, followRange: 1.5, AI: "hunt",  cohesion: 0.25, sneakThreshold: 1,
			evasion: -0.25,
			Attack: {
				mustBindorFail: true,
				noFailifHasWP: true,
			},
			master: {type: "ElementalRubber", range: 2, loose: true, aggressive: true},
			visionRadius: 4.5, blindSight: 2.5, maxhp: 9, minLevel:2, weight:2, movePoints: 2.4,
			maxLevel: 8,
			sprintspeed: 2.5, stamina: 5,
			attackPoints: 2, attack: "MeleeBindLockEffect", attackWidth: 1, attackRange: 1,
			power: 1, dmgType: "glue", fullBoundBonus: 2,
			terrainTags: {"latexAnger": 3, "latexRage": 3, "alchemist": 3, "slimeBonus": 2, "latex": 5, "slimeOptOut": -4,
				"petOptout": -15,
				"petPref": 4,
	
				"slimePref": 2, revenge: 10}, shrines: ["Latex"], allFloors: true,
			},
	{name: "LatexKittyCursed", faction: "Slime", clusterWith: "slime", bound: "LatexKitty", playLine: "Gagged", color: "#92dbe8",
		tags: KDMapInit([
			"nocapture", "latexTrap", "slime", "disarmresist", "blindimmune", "petsuit",
			"melee", "blueLatexEncase", "blueLatexEncaseRandom", "electricweakness", "acidresist", "iceweakness",
			"ticklesevereweakness", "charmweakness",
			"submissive", "noshop", "gagged", "imprisonable", "rescueslime", "nocapture", "noarms", "arcaneweakness",
			"latexKitty",
		]),
		effect: {
			effect: {name: "LatexKittyCursed", damage: "glue", power: 4, curse: "LatexKittyCurse"},
		},
		ignoreflag: ["LatexKittyatk"], failAttackflag: ["LatexKittyatk"], failAttackflagDuration: 4, failAttackflagChance: 0.4,
		Sound: {
			baseAmount: 4,
			moveAmount: 4,
			idleSoundName: "Rubber",
		},
		
		spells: ["ManyRubberPull"],  spellCooldownMult: 1, spellCooldownMod: 0,
		applyFaction: "Rubber",
		nopickpocket: true,
		maxblock: 0,
		maxdodge: 0,
		willBonus: 0.4,
		nonDirectional: true,
		ignorechance: 0, armor: 1, followRange: 1.5, AI: "hunt",  cohesion: 0.25, sneakThreshold: 1,
		evasion: -0.25,
		Attack: {
			mustBindorFail: true,
			noFailifHasWP: true,
		},
		master: {type: "ElementalRubber", range: 2, loose: true, aggressive: true},
		visionRadius: 4.5, blindSight: 2.5, maxhp: 18, minLevel:8, weight:2, movePoints: 2.4,
		sprintspeed: 2.5, stamina: 5,
		attackPoints: 2, attack: "SpellMeleeBindLockAllEffect", attackWidth: 1, attackRange: 1,
		power: 1, dmgType: "glue", fullBoundBonus: 2,
		terrainTags: {"latexAnger": 3, "latexRage": 3, "alchemist": 3, "slimeBonus": 2, "latex": 5, "slimeOptOut": -4,
			"petOptout": -15,
			"petPref": 4,

			"slimePref": 2, revenge: 10}, shrines: ["Latex"], allFloors: true,
		},
	{name: "AquaSlime", clusterWith: "water", faction: "Slime", color: "#2277ee",
		tags: KDMapInit(["ignoretiedup", "disarmimmune", "blindimmune", "elementsTrap", "minor", "water", "melee", "aquaRestraints", "pierceweakness", "electricweakness", "acidresist", "iceweakness"]), squeeze: true, ignorechance: 0.75, followRange: 1, AI: "hunt",  sneakThreshold: 1,
		visionRadius: 4.5, blindSight: 2.5, maxhp: 7, minLevel: 0, weight:8, movePoints: 1.5, attackPoints: 2, attack: "MeleeBindSuicideWill",
		suicideOnAdd: true, attackWidth: 1, attackRange: 1, power: 1, dmgType: "soap", fullBoundBonus: 2,
		Animations: ["squishy"],
		Sound: {
			baseAmount: 0,
			idleSoundName: "Slime",
		},
		nopickpocket: true,
		terrainTags: {"water": 4, "bubbleOptout": -300, "bubblePref": 6, "jungle": 20, "temple": 4, "elements": 4}, allFloors: true, shrines: ["Elements"],
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Water", aoe: 1.5, power: 1, chance: 1.0, duration: 20},
		],},

	{name: "SmallSlime", clusterWith: "slime", faction: "Slime", color: "#FF00FF", tags: KDMapInit(["ignoretiedup", "disarmimmune", "blindimmune", "latexTrap", "minor", "slime", "melee", "slimeRestraints", "meleeresist", "chainimmune", "electricweakness", "acidresist", "iceweakness"]), squeeze: true, ignorechance: 0.75, followRange: 1, AI: "hunt",  sneakThreshold: 1,
		visionRadius: 3, blindSight: 2.5, maxhp: 3, minLevel: 0, maxLevel: 5, weight:8, movePoints: 1.5, attackPoints: 2, attack: "MeleeBindSuicideWill", suicideOnAdd: true, attackWidth: 1, attackRange: 1, power: 1, dmgType: "glue", fullBoundBonus: 2,
		Animations: ["squishy"],
		Sound: {
			baseAmount: 0,
			idleSoundName: "Slime",
		},
		Resistance: {
			profile: ["slime"],
		},
		nopickpocket: true,
		dropTable: [{name: "SlimeRaw", amount: 1, weight: 10}],
		terrainTags: {"increasingWeight":-1, "slime": 4, "slimeOptOut": -2, "slimePref": 2, "jungle": 20, "alchemist": 4}, allFloors: true, shrines: ["Latex"],
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Slime", aoe: 1.5, power: 1, chance: 1.0, duration: 20},
		],},
	{name: "SmallSlimeLeaper", clusterWith: "slime", faction: "Slime", color: "#FF00FF", tags: KDMapInit(["ignoretiedup", "disarmimmune", "latexTrap", "minor", "slime", "melee", "slimeRestraints", "meleeresist", "chainimmune", "electricweakness", "acidresist", "iceweakness"]), squeeze: true, ignorechance: 0.75, followRange: 1, AI: "hunt",  sneakThreshold: 1,
		visionRadius: 4.5, blindSight: 2.5, maxhp: 3, minLevel: 5, weight:8, movePoints: 1.5, attackPoints: 2, attack: "MeleeBindSuicideWill", suicideOnAdd: true, attackWidth: 1, attackRange: 1, power: 1, dmgType: "glue", fullBoundBonus: 2,
		Animations: ["squishy"],
		Sound: {
			baseAmount: 0,
			moveAmount: 7,
			idleSoundName: "Slime",
		},
		Resistance: {
			profile: ["slime"],
		},
		nopickpocket: true,
		dropTable: [{name: "SlimeRaw", amount: 1, weight: 10}],
		specialCD: 5, specialAttack: "DashBonus", specialRemove: "BindSuicideWill", specialCDonAttack: true, specialAttackPoints: 1, specialRange: 4.99, specialMinRange: 1.5, specialsfx: "Miss",
		terrainTags: {"increasingWeight":-1, "slime": 4, "slimeOptOut": -2, "slimePref": 2, "jungle": 20, "alchemist": 4}, allFloors: true, shrines: ["Latex"],
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Slime", aoe: 1.5, power: 1, chance: 1.0, duration: 20},
		],},
	{name: "FastSlime", clusterWith: "slime", faction: "Slime", color: "#FF00FF", tags: KDMapInit(["ignoretiedup", "disarmimmune", "latexTrap", "slime", "melee", "slimeRestraints", "meleeresist", "chainimmune", "electricweakness", "acidresist", "iceweakness"]), squeeze: true, evasion: 0.3, followRange: 1, AI: "hunt",  sneakThreshold: 1,
		visionRadius: 4.5, blindSight: 2.5, maxhp: 3, minLevel: 9, weight:3, movePoints: 1, attackPoints: 3, attack: "MeleeBindSuicideWill", suicideOnAdd: true, attackWidth: 1, attackRange: 3, power: 2, dmgType: "glue", fullBoundBonus: 2,
		Animations: ["squishy"],
		Sound: {
			baseAmount: 0,
			idleSoundName: "Slime",
		},
		Resistance: {
			profile: ["slime"],
		},
		nopickpocket: true,
		maxblock: 0,
		maxdodge: 2,
		dropTable: [{name: "SlimeRaw", amount: 1, weight: 10}],
		terrainTags: {"increasingWeight":1, "slime": 2.5, "slimeOptOut": -1.2, "slimePref": 1.2, "jungle": 8, "alchemist": 4}, allFloors: true, shrines: ["Latex"],
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Slime", aoe: 1.5, power: 1, chance: 1.0, duration: 20},
		],},
	{name: "BigSlime", clusterWith: "slime", faction: "Slime", color: "#FF00FF", tags: KDMapInit(["ignoretiedup", "disarmimmune", "slime", "latexTrap", "elite", "melee", "slimeRestraints", "meleeresist", "chainimmune", "electricweakness", "acidresist", "iceweakness"]),
		squeeze: true, evasion: -0.3, followRange: 1, AI: "hunt",  sneakThreshold: 1,
		Animations: ["squishy"],
		Sound: {
			baseAmount: 0,
			idleSoundName: "SlimeLarge",
		},
		Resistance: {
			profile: ["slime"],
		},
		maxblock: 0,
		maxdodge: 0,
		nopickpocket: true,
		dropTable: [{name: "SlimeRaw", amount: 5, weight: 10}],
		visionRadius: 4.5, blindSight: 2.5, maxhp: 12, minLevel: 9, weight:2, movePoints: 3, attackPoints: 3, attack: "MeleeBind",
		attackWidth: 3, attackRange: 1, power: 4, dmgType: "glue", fullBoundBonus: 2, disarm: 0.5,
		terrainTags: {"slime": 1.5, "alchemist": 3, "slimeOptOut": -1, "slimePref": 1}, allFloors: true, shrines: ["Latex"],
		ondeath: [{type: "summon", enemy: "SmallSlime", range: 2.5, count: 4, strict: true, lifetime: 50}],
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Slime", aoe: 1.5, power: 3, chance: 1.0, duration: 20},
			{trigger: "afterEnemyTick", type: "createEffectTile", kind: "Slime", time: 25, power: 2, chance: 0.3, aoe: 0.5}
		],
	},
	{name: "LatexCube", faction: "Latex", color: "#aa00cc",
		tags: KDMapInit(["ignoretiedup", "unstoppable", "slime", "latex", "latexTrap", "elite", "slashweakness", "disarmimmune", "melee", "chainimmune", "glueresist", "coldweakness", "electricresist", "pierceweakness", "latexRestraints", "latexEncaseRandom"]),
		Animations: ["squishyAmbush"],
		GFX: {
			AmbushSprite: "LatexCubeHidden",
		},
		RestraintFilter: {
			unlimitedRestraints: true,
		},
		Sound: {
			baseAmount: 0,
			moveAmount: 3,
			idleSoundName: "SlimeLarge",
		},
		Resistance: {
			profile: ["slime"],
		},
		nopickpocket: true,
		maxblock: 0,
		maxdodge: 0,
		stamina: 3,
		nonDirectional: true,
		squeeze: true, evasion: -1, followRange: 1, AI: "ambush", sneakThreshold: 3, ambushRadius: 1.5,
		visionRadius: 7.0, blindSight: 2.5, maxhp: 18, minLevel: 6, weight:1, movePoints: 4, attackPoints: 3, attack: "MeleeBind", attackWidth: 3, attackRange: 1, power: 4, dmgType: "glue", fullBoundBonus: 2, disarm: 0.7,
		terrainTags: {"slime": 2.5, "plant": 2, "passage": 20, "open": -10, "slimeOptOut": -0.9, "slimePref": 1},
		allFloors: true, shrines: ["Latex"],
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "LatexThin", aoe: 1.5, power: 3, chance: 1.0, duration: 20},
			{trigger: "afterEnemyTick", type: "createEffectTile", kind: "LatexThin", time: 25, power: 2, chance: 0.5, aoe: 0.5},
		],
		dropTable: [{name: "Gold", amountMin: 20, amountMax: 30, weight: 1}, {name: "HardSlimeRaw", amount: 10, weight: 10}, {name: "StaffGlue", weight: 130, ignoreInInventory: true}],
	},
	{name: "LatexCubeSmall", faction: "Latex", color: "#aa00cc",
		tags: KDMapInit(["ignoretiedup", "unflinching", "slime", "latex", "latexTrap", "minor", "melee", "disarmimmune", "chainimmune", "glueresist", "coldweakness", "electricresist", "pierceweakness", "latexRestraints", "latexEncaseRandom"]),
		Animations: ["squishyAmbush"],
		GFX: {
			AmbushSprite: "LatexCubeSmallHidden",
		},
		stamina: 3,
		nonDirectional: true,
		RestraintFilter: {
			unlimitedRestraints: true,
		},
		Resistance: {
			profile: ["slime"],
		},
		nopickpocket: true,
		Sound: {
			baseAmount: 0,
			moveAmount: 2,
			idleSoundName: "SlimeLarge",
		},
		difficulty: 0.3,
		squeeze: true, evasion: -0.5, followRange: 1, AI: "ambush", sneakThreshold: 3, ambushRadius: 1.5,
		visionRadius: 7.0, blindSight: 2.5, maxhp: 7, minLevel: 0, weight:1, movePoints: 2, attackPoints: 3, attack: "MeleeBindSuicide", attackWidth: 1, attackRange: 1, power: 2, dmgType: "glue", fullBoundBonus: 1, disarm: 0.2,
		suicideOnAdd: true, focusPlayer: true, multiBind: 3,
		terrainTags: {"slime": 3.5, "plant": 3, "passage": 30, "open": -10, "slimeOptOut": -1, "slimePref": 1}, allFloors: true, shrines: ["Latex"],
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "LatexThin", aoe: 1.5, power: 3, chance: 1.0, duration: 20},
			{trigger: "afterEnemyTick", type: "createEffectTile", kind: "LatexThin", time: 25, power: 2, chance: 0.5, aoe: 0.5},
		],
		dropTable: [{name: "HardSlimeRaw", amount: 3, weight: 14}, {name: "StaffGlue", weight: 3, ignoreInInventory: true}],
	},
	{name: "LiquidMetalCube", faction: "Latex", color: "#aa00cc",
		tags: KDMapInit(["ignoretiedup", "unstoppable", "metal", "metalTrap", "minor", "melee", "disarmimmune", "construct", "nosignal", "poisonimmune", "soulimmune", "chainimmune", "glueresist", "acidweakness", "metallatexRestraints", "mithrilRestraints", "liquidMetalRestraintsRandom"]),
		Animations: ["squishyAmbush"],
		GFX: {
			AmbushSprite: "SteelDoor",
		},
		RestraintFilter: {
			unlimitedRestraints: true,
		},
		Sound: {
			baseAmount: 0,
			moveAmount: 5,
			idleSoundName: "SlimeLarge",
		},
		nopickpocket: true,
		maxblock: 3,
		maxdodge: 0,
		nonDirectional: true,
		squeeze: true, evasion: -10, followRange: 1, AI: "ambush", sneakThreshold: 3, ambushRadius: 1.5, armor: 3,
		visionRadius: 7.0, blindSight: 2.5, maxhp: 18, minLevel: 9, weight:0.1, movePoints: 4, attackPoints: 4, attack: "MeleeBind", attackWidth: 3, attackRange: 1, power: 5, dmgType: "crush", fullBoundBonus: 2, disarm: 0.7, multiBind: 2,
		terrainTags: {"metal": 2.5, "demon": 2, "magic": 2, "passage": 8, "open": -50, "slimeOptOut": -3, "slimePref": 0.1}, allFloors: true, shrines: ["Latex"],
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "LiquidMetal", aoe: 1.5, power: 3, chance: 1.0, duration: 6},
			{trigger: "afterEnemyTick", type: "createEffectTile", kind: "LiquidMetal", time: 25, power: 2, chance: 0.5, aoe: 0.5},
		],
		dropTable: [{name: "LiquidMetalRaw", amount: 2, weight: 14}, {name: "StaffBind", weight: 4, ignoreInInventory: true}],
	},
	{name: "LatexCubeMetal", faction: "Latex", color: "#aa00cc",
		tags: KDMapInit(["ignoretiedup", "unstoppable", "metal", "metalTrap", "minor", "melee", "disarmimmune", "construct", "nosignal",
			"bulwark", "poisonimmune", "soulimmune", "chainimmune", "glueresist", "acidweakness", "metallatexRestraints", "mithrilRestraints", "liquidMetalRestraintsRandom"]),
		Animations: ["squishyAmbush"],
		GFX: {
			AmbushSprite: "LatexCubeSmallHidden",
		},
		nonDirectional: true,
		RestraintFilter: {
			unlimitedRestraints: true,
		},
		Sound: {
			baseAmount: 0,
			moveAmount: 4,
			idleSoundName: "SlimeLarge",
		},
		nopickpocket: true,
		maxblock: 1,
		maxdodge: 0,
		difficulty: 0.4,
		squeeze: true, evasion: -0.5, followRange: 1, AI: "ambush", sneakThreshold: 3, ambushRadius: 1.5,
		visionRadius: 7.0, blindSight: 2.5, maxhp: 8, armor: 1.5, minLevel: 2, weight:0.1, movePoints: 2.4, attackPoints: 3, attack: "MeleeBindSuicide", attackWidth: 1, attackRange: 1, power: 2, dmgType: "crush", fullBoundBonus: 1, disarm: 0.35,
		suicideOnAdd: true, focusPlayer: true, multiBind: 3,
		terrainTags: {"metal": 3.5, "demon": 3, "magic": 3, "passage": 10, "open": -50, "slimeOptOut": -3, "slimePref": 0.1}, allFloors: true, shrines: ["Latex"],
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "LiquidMetal", aoe: 1.5, power: 3, chance: 1.0, duration: 6},
			{trigger: "afterEnemyTick", type: "createEffectTile", kind: "StarryTrail", time: 25, power: 2, chance: 0.5, aoe: 0.5},
		],
		dropTable: [{name: "Nothing", weight: 10}, {name: "LiquidMetalRaw", amount: 10, weight: 10}, {name: "StaffChain", weight: 3, ignoreInInventory: true}, {name: "StaffBind", weight: 0.5, ignoreInInventory: true}],
	},

	{name: "Barricade", faction: "Door",
		lowpriority: true,
		nonDirectional: true, noFlip: true,
		/*cueSfx: {
			Block: "Clang",
			Resist: "Clang",
			Damage: "ArmorHit",
		},*/
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			alertAmount: 0,
		},
		GFX: {
			lighting: true,
		},
		pathcondition: "barricade",
		tags: KDMapInit(["obstacledoor", "scenery", "barricade", "minor", "inactive", "nonvulnerable", "unstoppable", "immobile", "nobrain", "nosignal", "poisonimmune", "harmless", "temporary",
			"soulimmune", "pierceresist", "electricresist", "crushweakness", "unarmedresist", "glueresist", "tickleresist", "groperesist", "painresist", "charmimmune",
		]), spellResist: 0, sneakthreshold: 0.6,
		evasion: -9, ignorechance: 1.0, armor: 0, followRange: 1, AI: "ambush", ambushRadius: 0, difficulty: -0.05,
		visionRadius: 0, maxhp: 8, minLevel:0, weight:-1, movePoints: 99999, attackPoints: 4, attack: "", attackWidth: 8, attackRange: 3, power: 1, dmgType: "souldrain",
		terrainTags: {"obstacle": 2, "obstacletile": 5, "increasingWeight":-0.5,}, allFloors: true, shrines: [],
		events: [
			{trigger: "enemyMove", type: "damageOnMove", power: 1, mult: 0.25},
		],
	},

	{name: "BarricadeVine", faction: "Plant",
		lowpriority: true,
		nonDirectional: true, noFlip: true,
		/*cueSfx: {
			Block: "Clang",
			Resist: "Clang",
			Damage: "ArmorHit",
		},*/
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			alertAmount: 0,
		},
		GFX: {
			lighting: true,
		},
		tags: KDMapInit(["obstacledoor", "scenery", "barricade", "minor", "inactive", "nonvulnerable", "unstoppable", "immobile", "nobrain", "nosignal", "poisonimmune", "harmless", "plant", "vine", "temporary",
			"soulimmune", "slashweakness", "fireweakness", "crushresist", "tickleresist", "groperesist", "painresist", "charmimmune",
		]), spellResist: 0, sneakthreshold: 0.6,
		evasion: -9, ignorechance: 1.0, armor: 0, followRange: 1, AI: "ambush", ambushRadius: 0, difficulty: -0.05, regen: 0.05,
		visionRadius: 0, maxhp: 12, minLevel:0, weight:-1, movePoints: 99999, attackPoints: 4, attack: "", attackWidth: 8, attackRange: 3, power: 1, dmgType: "grope",
		terrainTags: {"obstacle": 2, "obstacletile": 5, "increasingWeight":-0.5,}, allFloors: true, shrines: [],
		events: [
			{trigger: "afterPlayerAttack", type: "spellReflect", spell: "Vineexp", time: 2},
			{trigger: "NPCHitNPC", type: "spellReflect", spell: "Vineexp", time: 2},
		],
	},

	{name: "BarricadeConcrete", faction: "Door",
		lowpriority: true,
		nonDirectional: true, noFlip: true,
		cueSfx: {
			Block: "Clang",
			Resist: "Clang",
			Damage: "ArmorHit",
		},
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			alertAmount: 0,
		},
		GFX: {
			lighting: true,
		},
		tags: KDMapInit(["obstacledoor", "scenery", "barricade", "minor", "inactive", "nonvulnerable", "unstoppable", "immobile", "nobrain", "nosignal", "poisonimmune", "harmless", "temporary",
			"soulimmune", "pierceresist", "electricresist", "crushweakness", "unarmedresist", "glueresist", "tickleresist", "groperesist", "painresist", "charmimmune",
		]), spellResist: 0, sneakthreshold: 0.6,
		evasion: -9, ignorechance: 1.0, armor: 1, followRange: 1, AI: "ambush", ambushRadius: 0, difficulty: -0.05,
		visionRadius: 0, maxhp: 10, minLevel:0, weight:-1, movePoints: 99999, attackPoints: 4, attack: "", attackWidth: 8, attackRange: 3, power: 1, dmgType: "souldrain",
		terrainTags: {"obstacle": 4, "obstacletile": 8, "increasingWeight":-1,}, allFloors: true, shrines: [],
		events: [
			{trigger: "enemyMove", type: "damageOnMove", power: 1, mult: 0.25},
		],
	},


	{name: "BarricadeBlastDoor", faction: "Door", color: "#ff9944",
		lowpriority: true,
		nonDirectional: true, noFlip: true,
		cueSfx: {
			Block: "Clang",
			Resist: "Clang",
			Damage: "ArmorHit",
		},
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			alertAmount: 0,
		},
		GFX: {
			lighting: true,
		},
		tags: KDMapInit(["obstacledoor", "scenery", "minor", "inactive", "nonvulnerable", "unstoppable", "immobile", "nobrain", "nosignal", "poisonimmune", "harmless", "temporary",
			"soulimmune", "slashresist", "pierceresist", "electricimmune", "unarmedresist", "chainimmune", "glueresist", "tickleresist", "groperesist", "painresist", "charmimmune",
			"bulwark",
		]), spellResist: 1.5, sneakthreshold: 0.6, immobile: true,
		pathcondition: "blastdoor",
		evasion: -9, ignorechance: 1.0, armor: 2, followRange: 1, AI: "ambush", ambushRadius: 0, difficulty: -0.05, blockVision: true,
		visionRadius: 0, maxhp: 11, minLevel:0, weight:-1, movePoints: 99999, attackPoints: 4, attack: "", attackWidth: 8, attackRange: 3, power: 1, dmgType: "souldrain",
		terrainTags: {"obstacle": 4, "obstacletile": 14, "increasingWeight":-1,}, floors:KDMapInit(["bel"]), shrines: [],
		events: [
			{trigger: "enemyMove", type: "removeIfRobot"},
			{trigger: "afterPlayerAttack", type: "tauntMsg", msg: "KDDoorAccessDenied", power: 3},
		],
	},

	{name: "BarricadeMetal", faction: "Door",
		lowpriority: true,
		nonDirectional: true, noFlip: true,
		cueSfx: {
			Block: "Clang",
			Resist: "Clang",
			Damage: "ArmorHit",
		},
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			alertAmount: 0,
		},
		GFX: {
			lighting: true,
		},
		Resistance: {
			profile: ["construct"],
		},
		tags: KDMapInit(["obstacledoor", "scenery", "barricade", "minor", "inactive", "nonvulnerable", "unstoppable", "immobile", "nobrain", "nosignal", "poisonimmune", "harmless", "temporary",
			"soulimmune", "electricimmune", "acidweakness", "meleeresist", "glueresist", "tickleresist", "groperesist", "painresist", "charmimmune",
		]), spellResist: 0, sneakthreshold: 0.6,
		evasion: -9, ignorechance: 1.0, armor: 2, followRange: 1, AI: "ambush", ambushRadius: 0, difficulty: -0.05,
		visionRadius: 0, maxhp: 8, minLevel:0, weight:-1, movePoints: 99999, attackPoints: 4, attack: "", attackWidth: 8, attackRange: 3, power: 1, dmgType: "souldrain",
		terrainTags: {"obstacle": 4, "obstacletile": 8, "increasingWeight":-1,}, allFloors: true, shrines: [],
		events: [
			{trigger: "enemyMove", type: "damageOnMove", power: 1, mult: 0.25},
		],
	},
	{name: "BarricadeShadowMetal", faction: "Door",
		lowpriority: true,
		nonDirectional: true, noFlip: true,
		cueSfx: {
			Block: "Clang",
			Resist: "Clang",
			Damage: "ArmorHit",
		},
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			alertAmount: 0,
		},
		GFX: {
			lighting: true,
		},
		Resistance: {
			profile: ["construct"],
		},
		ondeath: [{type: "spellOnSelf", spell: "ShadowGrasp"}],
		tags: KDMapInit(["obstacledoor", "scenery", "barricade", "minor", "inactive", "nonvulnerable", "unstoppable", "immobile", "nobrain", "nosignal", "poisonimmune", "harmless", "temporary",
			"soulimmune", "electricimmune", "acidweakness", "meleeresist", "glueresist", "tickleimmune", "coldimmune", "gropeimmune", "painimmune", "charmimmune",
		]), spellResist: 1, sneakthreshold: 0.6,
		evasion: -9, ignorechance: 1.0, armor: 1, followRange: 1, AI: "ambush", ambushRadius: 0, difficulty: -0.05,
		visionRadius: 0, maxhp: 10, minLevel:0, weight:-10, movePoints: 99999, attackPoints: 4, attack: "", attackWidth: 8, attackRange: 3, power: 1, dmgType: "souldrain",
		terrainTags: {"obstacle": 4, "obstacletile": 8, "shadow":8,}, allFloors: true, shrines: [],
		events: [
			{trigger: "enemyMove", type: "damageOnMove", power: 1, mult: 0.25},
		],
	},

	{name: "BarricadeRobot", faction: "Door",
		lowpriority: true,
		nonDirectional: true, noFlip: true,
		cueSfx: {
			Block: "Clang",
			Resist: "Clang",
			Damage: "ArmorHit",
		},
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			alertAmount: 0,
		},
		tags: KDMapInit(["obstacledoor", "scenery", "barricade", "minor", "inactive", "nonvulnerable", "unstoppable", "immobile", "nobrain", "nosignal", "poisonimmune", "harmless", "temporary",
			"soulimmune", "pierceresist", "electricresist", "crushweakness", "unarmedresist", "glueresist", "acidweakness", "soapweakness", "tickleresist", "groperesist", "painresist", "charmimmune",
			"bulwark",
		]), spellResist: 1, sneakthreshold: 0.6,
		evasion: -9, ignorechance: 1.0, armor: 1, followRange: 1, AI: "ambush", ambushRadius: 0, difficulty: -0.05,
		visionRadius: 0, maxhp: 10, minLevel:0, weight:-10, movePoints: 99999, attackPoints: 4, attack: "", attackWidth: 8, attackRange: 3, power: 1, dmgType: "souldrain",
		terrainTags: {"obstacle": 4, "obstacletile": 8, "increasingWeight":-1,}, allFloors: true, shrines: [],
		events: [
			{trigger: "enemyMove", type: "damageOnMove", power: 1, mult: 0.25},
		],
	},

	{name: "BarricadeMagic", faction: "Door",
		lowpriority: true,
		nonDirectional: true, noFlip: true,
		cueSfx: {
			Block: "Shield",
			Resist: "Shield",
			Damage: "Shield",
		},
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			alertAmount: 0,
		},
		Resistance: {
			profile: ["construct"],
		},
		tags: KDMapInit(["obstacledoor", "scenery", "barricade", "minor", "inactive", "nonvulnerable", "unstoppable", "immobile", "nobrain", "nosignal", "poisonimmune", "harmless", "temporary",
			"soulimmune", "pierceresist", "electricresist", "crushweakness", "unarmedresist", "glueresist", "tickleresist", "groperesist", "painresist", "charmimmune",
			"bulwark",
		]), spellResist: 3, sneakthreshold: 0.6,
		evasion: -9, ignorechance: 1.0, armor: 0, followRange: 1, AI: "ambush", ambushRadius: 0, difficulty: -0.05, regen: 0.5,
		visionRadius: 0, maxhp: 6, minLevel:0, weight:-10, movePoints: 99999, attackPoints: 4, attack: "", attackWidth: 8, attackRange: 3, power: 1, dmgType: "souldrain",
		terrainTags: {"obstacle": 4, "obstacletile": 8, "increasingWeight":-1,}, allFloors: true, shrines: [],
		events: [
			{trigger: "enemyMove", type: "damageOnMove", power: 1, mult: 0.25},
			{trigger: "afterEnemyTick", type: "requireNearbyEnemyTag", power: 0.6, dist: 5.5, tags: ["mage"]},
		],
	},

	{name: "BarricadeShadow", faction: "Ghost", color: KDBasePurple,
		lowpriority: true,
		nonDirectional: true, noFlip: true,
		cueSfx: {
			Block: "Shield",
			Resist: "Shield",
			Damage: "Shield",
		},
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			alertAmount: 0,
		},
		tags: KDMapInit(["obstacledoor", "shadow", "barricade", "holyweakness", "scenery", "minor", "inactive", "nonvulnerable", "unstoppable", "immobile", "nobrain", "nosignal", "poisonimmune", "temporary",
			"soulimmune", "meleeresist", "fireweakness", "glueresist", "coldimmune", "tickleresist", "groperesist", "painresist", "charmimmune", "shadowHands", "ghost",
		]), spellResist: 1, sneakthreshold: 0.6,
		evasion: -1, ignorechance: 1.0, armor: 0, followRange: 1, AI: "ambush", ambushRadius: 0, difficulty: -0.05, regen: 0.25,
		visionRadius: 0, maxhp: 7, minLevel:0, weight:-15, movePoints: 99999, attackPoints: 4, attack: "MeleeBindWillSuicide", attackWidth: 8, attackRange: 1, power: 2, dmgType: "cold",
		terrainTags: {"obstacle": 4, "obstacletile": 8, "shadow": 18}, allFloors: true, shrines: [],
		events: [
			{trigger: "enemyMove", type: "damageOnMove", power: 1, mult: 0.25},
		],
	},


	{name: "BarricadeAir", faction: "Elemental", color: KDBaseWhite,
		lowpriority: true,
		nonDirectional: true, noFlip: true,
		effect: {
			effect: {name: "PushAway", damage: "stun", power: 1, dist: 1},
		},
		Sound: {
			baseAmount: 4.5,
			moveAmount: 0,
			alertAmount: 0,
		},
		Resistance: {
			profile: ["construct"],
		},
		tags: KDMapInit(["scenery", "minor", "inactive", "nonvulnerable", "unstoppable", "immobile", "nobrain", "nosignal", "air", "temporary",
			"poisonimmune", "soulimmune", "meleeresist", "pierceimmune", "stunweakness", "glueweakness", "tickleresist", "groperesist", "painresist", "charmimmune",
		]),
		spellResist: 0, armor: 0,
		sneakthreshold: 0.6,
		evasion: 1.5, ignorechance: 1.0, followRange: 1, AI: "ambush", ambushRadius: 0, difficulty: -0.05, regen: 0.75,
		visionRadius: 0, maxhp: 8, minLevel:0, weight:-10, movePoints: 99999, attackPoints: 4, attack: "MeleeEffect", attackWidth: 8, attackRange: 1, power: 2, dmgType: "stun",
		terrainTags: {}, allFloors: false, shrines: ["Elements"],
		events: [
			{trigger: "afterEnemyTick", type: "requireNearbyEnemyTag", power: 1.25, dist: 4.5, tags: ["air"]},
		],
	},
	{name: "BarricadeElectric", faction: "Elemental", color: "#e7cf1a",
		lowpriority: true,
		nonDirectional: true, noFlip: true,
		effect: {
			effect: {name: "Shock", damage: "electric", time: 2, power: 2.5},
		},
		Sound: {
			baseAmount: 3,
			moveAmount: 0,
			alertAmount: 0,
		},
		Resistance: {
			profile: ["construct"],
		},
		tags: KDMapInit(["scenery", "minor", "barricade", "inactive", "nonvulnerable", "unstoppable", "immobile", "nobrain", "nosignal", "electric", "temporary",
			"poisonimmune", "soulimmune", "electricresist", "crushweakness", "acidweakness", "soapweakness", "iceweakness", "glueweakness", "tickleresist", "groperesist", "painresist", "charmimmune",
		]),
		spellResist: 0, armor: 2,
		sneakthreshold: 0.6,
		evasion: -9, ignorechance: 1.0, followRange: 3.5, AI: "ambush", ambushRadius: 0, difficulty: -0.05, regen: 0.05,
		visionRadius: 3.5, maxhp: 15, minLevel:0, weight:-10, movePoints: 99999, attackPoints: 4, attack: "MeleeEffect", attackWidth: 1.25, attackRange: 3.5, power: 2.5, dmgType: "electric",
		terrainTags: {}, allFloors: false, shrines: ["Elements"],
		events: [
			{trigger: "afterEnemyTick", type: "requireNearbyEnemyTag", power: 0.5, dist: 4.5, tags: ["electric"]},
		],
	},


	{name: "BarricadeFire", faction: "Elemental", color: "#e7cf1a",
		lowpriority: true,
		nonDirectional: true, noFlip: true,
		Sound: {
			baseAmount: 1,
			moveAmount: 0,
			alertAmount: 0,
		},
		Resistance: {
			profile: ["construct"],
		},
		tags: KDMapInit(["scenery", "minor", "barricade", "inactive", "nonvulnerable", "unstoppable", "immobile", "nobrain", "nosignal", "fire", "temporary",
			"poisonimmune", "soulimmune", "fireimmune", "pierceresist", "soapsevereweakness", "iceweakness", "glueweakness", "tickleresist", "groperesist", "painresist", "charmimmune",
			"bulwark",
		]),
		spellResist: 1, armor: 2,
		sneakthreshold: 0.6,
		evasion: -9, ignorechance: 1.0, followRange: 3.5, AI: "ambush", ambushRadius: 0, difficulty: -0.05, regen: 0.05,
		visionRadius: 3.5, maxhp: 15, minLevel:0, weight:-10, movePoints: 99999, attackPoints: 4, attack: "", attackWidth: 1.25, attackRange: 1, power: 1, dmgType: "fire",
		terrainTags: {}, allFloors: false, shrines: ["Elements"],
		events: [
			{trigger: "afterEnemyTick", type: "requireNearbyEnemyTag", power: 0.5, dist: 5.5, tags: ["fire"]},
			{trigger: "afterPlayerAttack", type: "spellReflect", spell: "Fireexp", time: 1},
			{trigger: "NPCHitNPC", type: "spellReflect", spell: "Fireexp", time: 1},
		],
	},


	{name: "BarricadeEarth", faction: "Elemental", color: "#ff8933",
		lowpriority: true,
		nonDirectional: true, noFlip: true,
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			alertAmount: 0,
		},
		Resistance: {
			profile: ["construct"],
		},
		tags: KDMapInit(["scenery", "minor", "barricade", "inactive", "nonvulnerable", "unstoppable", "immobile", "nobrain", "nosignal", "earth", "temporary",
			"poisonimmune", "soulimmune", "crushweakness", "meleeresist", "chainweakness", "stunweakness", "tickleresist", "groperesist", "painresist", "charmimmune",
			"bulwark",
		]),
		spellResist: 0, armor: 1,
		sneakthreshold: 0.6,
		evasion: -9, ignorechance: 1.0, followRange: 2.5, AI: "ambush", ambushRadius: 0, difficulty: -0.05, regen: 0.05,
		spells: ["GravityPullEarth"], spellCooldownMult: 1.3, spellCooldownMod: 0, stopToCast: true, castWhileMoving: true, selfCast: {GravityPullEarth: true},
		visionRadius: 2.5, maxhp: 12, minLevel:0, weight:-10, movePoints: 99999, attackPoints: 4, attack: "Spell", attackWidth: 8, attackRange: 1, power: 3, dmgType: "crush",
		terrainTags: {}, allFloors: false, shrines: ["Elements"],
		events: [
			{trigger: "afterEnemyTick", type: "requireNearbyEnemyTag", power: 0.5, dist: 4.5, tags: ["earth", "gravity"]},
		],
	},

	{name: "BarricadeIce", faction: "Elemental", color: "#8899ff",
		lowpriority: true,
		nonDirectional: true, noFlip: true,
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			alertAmount: 0,
		},
		Resistance: {
			profile: ["construct"],
		},
		tags: KDMapInit(["scenery", "minor", "barricade", "inactive", "nonvulnerable", "unstoppable", "immobile", "nobrain", "nosignal", "ice", "temporary",
			"poisonimmune", "soulimmune", "crushweakness", "iceimmune", "fireweakness", "stunweakness", "tickleresist", "groperesist", "painresist", "charmimmune",
			"bulwark",
		]),
		spellResist: 0, armor: 1,
		sneakthreshold: 0.6,
		evasion: -9, ignorechance: 1.0, followRange: 2.5, AI: "ambush", ambushRadius: 0, difficulty: -0.05, regen: 0.05,
		visionRadius: 2.5, maxhp: 12, minLevel:0, weight:-10, movePoints: 99999, attackPoints: 4, attack: "", attackWidth: 8, attackRange: 1, power: 3, dmgType: "ice",
		terrainTags: {}, allFloors: false, shrines: ["Elements"],
		events: [
			{trigger: "afterEnemyTick", type: "createIce", power: 1, chance: 1.0, aoe: 2.5},
			{trigger: "afterEnemyTick", type: "requireNearbyEnemyTag", power: 0.5, dist: 4.5, tags: ["ice"]},
		],
	},

	{name: "BarricadeWater", faction: "Elemental", color: "#4fa4b8",
		lowpriority: true,
		nonDirectional: true, noFlip: true,
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			alertAmount: 0,
		},
		Resistance: {
			profile: ["construct"],
		},
		tags: KDMapInit(["scenery", "minor", "inactive", "nonvulnerable", "unstoppable", "immobile", "nobrain", "nosignal", "water", "temporary",
			"poisonweakness", "iceweakness", "soulimmune", "fireresist", "meleeresist", "pierceimmune", "soapimmune", "glueweakness", "tickleresist", "groperesist", "painresist", "charmimmune",
		]),
		spellResist: 0, armor: 0,
		sneakthreshold: 0.6,
		evasion: 1.5, ignorechance: 1.0, followRange: 1, AI: "ambush", ambushRadius: 0, difficulty: -0.05, regen: 2,
		visionRadius: 0, maxhp: 5, minLevel:0, weight:-10, movePoints: 99999, attackPoints: 4, attack: "", attackWidth: 8, attackRange: 1, power: 2, dmgType: "stun",
		terrainTags: {}, allFloors: false, shrines: ["Elements"],
		events: [
			{trigger: "afterEnemyTick", type: "bubbleBarrier", power: 2, chance: 1.0, aoe: 1.5, always: true,},
			{trigger: "afterEnemyTick", type: "requireNearbyEnemyTag", power: 2.5, dist: 4.5, tags: ["water"]},
		],
	},

	{name: "StoneDoor", faction: "Door", blockVision: true,
		lowpriority: true,
		cueSfx: {
			Block: "Clang",
			Resist: "Clang",
			Damage: "ArmorHit",
		},
		pathcondition: "stonedoor",
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			alertAmount: 0,
		},
		GFX: {
			lighting: true,
		},
		tags: KDMapInit(["obstacledoor", "scenery", "minor", "inactive", "nonvulnerable", "unstoppable", "immobile", "nobrain", "nosignal", "poisonimmune", "harmless",
			"soulimmune", "slashresist", "electricresist", "crushweakness", "unarmedresist", "chainimmune", "glueresist", "soapresist", "tickleresist", "groperesist", "painresist", "charmimmune",
			"bulwark",
		]), spellResist: 2, sneakthreshold: 0.6,
		nonDirectional: true,
		evasion: -9, ignorechance: 1.0, armor: 3, followRange: 1, AI: "ambush", ambushRadius: 0, difficulty: -0.05, immobile: true,
		visionRadius: 0, maxhp: 10, minLevel:0, weight:-4, movePoints: 99999, attackPoints: 4, attack: "", attackWidth: 8, attackRange: 3, power: 1, dmgType: "souldrain",
		terrainTags: {"obstacle": 10, "obstacletile": 50}, allFloors: true, shrines: [],
		events: [
			{trigger: "duringDamageEnemy", type: "damageThreshold", power: 1, chance: 1.0},
		],
	},
	{name: "SteelDoor", faction: "Door", blockVision: true,
		nonDirectional: true,
		lowpriority: true,
		pathcondition: "stonedoor",
		cueSfx: {
			Block: "Clang",
			Resist: "Clang",
			Damage: "ArmorHit",
		},
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			alertAmount: 0,
		},
		GFX: {
			lighting: true,
		},
		tags: KDMapInit(["obstacledoor", "steeldoor", "scenery", "minor", "inactive", "nonvulnerable", "unstoppable", "immobile", "nobrain", "nosignal", "poisonimmune", "harmless",
			"soulimmune", "slashresist", "pierceresist", "electricimmune", "unarmedresist", "chainimmune", "glueresist", "tickleresist", "groperesist", "painresist", "charmimmune",
			"bulwark",
		]), spellResist: 3, sneakthreshold: 0.6,
		evasion: -9, ignorechance: 1.0, armor: 5, followRange: 1, AI: "ambush", ambushRadius: 0, difficulty: -0.05, immobile: true,
		visionRadius: 0, maxhp: 15, minLevel:9, weight:-4, movePoints: 99999, attackPoints: 4, attack: "", attackWidth: 8, attackRange: 3, power: 1, dmgType: "souldrain",
		terrainTags: {"obstacle": 10, "obstacletile": 30}, allFloors: true, shrines: [],
		events: [
			{trigger: "duringDamageEnemy", type: "damageThreshold", power: 1, chance: 1.0},
		],
	},
	{name: "DollDoor", faction: "Door", blockVision: true,
		nonDirectional: true,
		lowpriority: true,
		cueSfx: {
			Block: "Clang",
			Resist: "Clang",
			Damage: "ArmorHit",
		},
		Sound: {
			baseAmount: 0,
			alertAmount: 0,
			moveAmount: 0,
		},
		GFX: {
			lighting: true,
		},
		tags: KDMapInit(["dolldoor", "scenery", "minor", "inactive", "nonvulnerable", "unstoppable", "immobile", "nobrain", "nosignal", "poisonimmune", "harmless",
			"soulimmune", "slashresist", "pierceresist", "electricimmune", "unarmedresist", "chainimmune", "glueresist", "tickleresist", "groperesist", "painresist", "charmimmune",
			"bulwark",
		]), spellResist: 5, armor: 5, sneakthreshold: 0.6,
		evasion: -9, ignorechance: 1.0, followRange: 1, AI: "ambush", ambushRadius: 0, difficulty: -0.05, immobile: true,
		visionRadius: 0, maxhp: 60, minLevel:0, weight:-100, movePoints: 99999, attackPoints: 4, attack: "", attackWidth: 8, attackRange: 3, power: 1, dmgType: "souldrain",
		terrainTags: {dolldoor: 200}, allFloors: true, shrines: [],
		events: [
			{trigger: "duringDamageEnemy", type: "damageThreshold", power: 1, chance: 1.0},
		],
	},

	{name: "GiantMushroom", faction: "Natural", clusterWith: "mushroom", tags: KDMapInit(["mushroom", "nofidget", "scenery", "nonvulnerable", "minor", "inactive", "harmless", "immobile", "unstoppable", "soulimmune", "slashweakness", "fireweakness", "glueresist", "poisonimmune", "coldweakness"]), spellResist: 0.33, sneakthreshold: 0.6,
		lowpriority: true,
		nonDirectional: true,
		evasion: -9, ignorechance: 1.0, armor: 0, followRange: 1, AI: "ambush", ambushRadius: 0, difficulty: -0.05,
		visionRadius: 0, maxhp: 1, minLevel:0, weight:5, movePoints: 99999, attackPoints: 4, attack: "", attackWidth: 8, attackRange: 3, power: 1, dmgType: "souldrain",
		terrainTags: {}, floors:KDMapInit(["cry", "jngWild", "cav"]), shrines: ["Will"], ondeath: [{type: "spellOnSelf", spell: "Spores"}],
		Sound: {
			baseAmount: 0,
			moveAmount: 0,
			alertAmount: 0,
		},
		GFX: {
			lighting: true,
		},
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Slime", aoe: 1.5, power: 1, chance: 1.0},
		],},
	{name: "Toad", faction: "Beast", clusterWith: "beast", color: "#00FF44", tags: KDMapInit(["ignoreharmless", "beast", "soulresist", "ranged", "pierceweakness", "electricsevereweakness", "soapresist"]), followLeashedOnly: true, armor: 1, followRange: 1, AI: "hunt",
		pullTowardSelf: true, pullDist: 3, master: {type: "GiantMushroom", range: 3}, projectileAttack: true, projectileTargeting: true,
		evasion: -0.4,
		visionRadius: 5, maxhp: 16, minLevel:0, weight:7, movePoints: 2, attackPoints: 3, attack: "MeleePullWill", attackRange: 5, attackWidth: 1, power: 2, strictAttackLOS: true, dmgType: "tickle",
		terrainTags: {"increasingWeight":2, "secondhalf":3, }, floors:KDMapInit(["cry"]), dropTable: [{name: "Nothing", weight: 12}, {name: "WaterRune", weight: 3}]},
	{name: "Mushy", faction: "Mushy", clusterWith: "mushroom", color: "#4fa4b8", difficulty: 0.2,
		tags: KDMapInit(["leashing", "mushroom", "soulresist", "mushy", "mushroomTrap", "melee", "minor", "slashweakness", "fireweakness", "glueresist", "poisonimmune", "coldweakness", "ropeMagicStrong", "ropeAuxiliary", "ropeRestraintsHogtie", "clothRestraints", "tapeRestraints"]),
		Animations: ["squishy"],
		squeeze: true, evasion: -0.5, followRange: 1, AI: "patrol", regen: 0.1,
		visionRadius: 5, maxhp: 8, minLevel: 4, weight:14, movePoints: 4, attackPoints: 2, attack: "MeleeBindBlindWill", blindTime: 2, attackWidth: 3, attackRange: 1, power: 2, dmgType: "poisongas", fullBoundBonus: 2,
		terrainTags: {"mushy": 10, "mushroomTrap": 50}, floors:KDMapInit(["cry"]), shrines: [], ondeath: [{type: "spellOnSelf", spell: "Spores"}],
		dropTable: [{name: "Gold", amountMin: 5, amountMax: 10, weight: 10}],
		attackLock: "White",
		stamina: 4,
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Slime", aoe: 1.5, power: 1, chance: 1.0},
		],},
	{name: "MushyHappy", clusterWith: "mushroom", color: "#4fa4b8", difficulty: 0.1,
		tags: KDMapInit(["ignorenoSP", "mushroom", "soulresist", "mushy", "melee", "mushroomTrap", "minor", "slashweakness", "fireweakness", "glueresist", "poisonimmune", "coldweakness"]),
		Animations: ["squishy"],
		squeeze: true, evasion: -0.5, followRange: 1, AI: "hunt", regen: 0.1,
		spells: ["SporesHappy"], spellCooldownMult: 1, spellCooldownMod: 0, stopToCast: true, castWhileMoving: true,
		visionRadius: 5, maxhp: 8, minLevel: 7, weight:14, movePoints: 4, attackPoints: 2, attack: "SpellMeleeWillBlind", blindTime: 2, attackWidth: 1, attackRange: 1, power: 4, dmgType: "tickle", 
		terrainTags: {"mushy": 10, "mushroomTrap": 50}, floors:KDMapInit(["cry"]), shrines: [], ondeath: [{type: "spellOnSelf", spell: "Spores"}],
		dropTable: [{name: "Gold", amountMin: 5, amountMax: 10, weight: 10}],
		stamina: 4,
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Slime", aoe: 1.5, power: 1, chance: 1.0},
			{trigger: "getLights", type: "enemyTorch", power: 4.5, color: "#ff44aa"},
		],},
	{name: "MushySick", clusterWith: "mushroom", color: "#4fa4b8", difficulty: 0.1,
		tags: KDMapInit(["ignorenoSP", "mushroom", "soulresist", "mushy", "melee", "mushroomTrap", "minor", "slashweakness", "fireweakness", "glueresist", "poisonimmune", "coldweakness"]),
		Animations: ["squishy"],
		squeeze: true, evasion: -0.5, followRange: 1, AI: "hunt",
		spells: ["SporesSick"], spellCooldownMult: 1, spellCooldownMod: 0, stopToCast: true, castWhileMoving: true,
		visionRadius: 5, maxhp: 8, minLevel: 0, weight:4, movePoints: 4, attackPoints: 2, attack: "SpellMeleeWillBlind", blindTime: 2, attackWidth: 1, attackRange: 1, power: 2, dmgType: "poisongas",
		terrainTags: {"mushy": 17, "mushroomTrap": 75}, floors:KDMapInit(["cry", "cat"]), shrines: ["Will"], ondeath: [{type: "spellOnSelf", spell: "Spores"}],
		dropTable: [{name: "Gold", amountMin: 5, amountMax: 10, weight: 10}],
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Slime", aoe: 1.5, power: 1, chance: 1.0},
			{trigger: "getLights", type: "enemyTorch", power: 4.5, color: "#4fd658"},
		],},

	{name: "DragonQueenPoison", color: "#9bd45d",
		faction: "DragonQueen",
		tags: KDMapInit(["opendoors", "noreinforce", "boss", "vineRestraints", "nokillescape", "dragonqueen", "unstoppable",
			"bulwark", "slashweakness", "meleeresist", "fireresist", "poisonresist", "melee", "beast", "search", "nature"]), cohesion: 0.1,
		GFX: {
			spriteHeight: 144,
			spriteWidth: 144,
		},
		projectileTargeting: true, projectileAttack: true,
		castWhileMoving: true,

		dontKiteWhenDisabled: true,
		noLeash: true,

		wanderAISetting: "Dragon",
		spawnAISetting: "Dragon",

		evasion: -1, disarm: 0.4,
		stamina: 12, sprintspeed: 2.0,
		preferBlock: true, maxdodge: 0,
		maxblock: 1,
		followLeashedOnly: true, ignorechance: 0, followRange: 1, AI: "hunt", guardChance: 0.0, kite: 1.5,
		kiteChance: 0.5, // doesnt always kite-- usually turns around to use Breath
		Sound: {
			moveAmount: 12,
			attackAmount: 20,
		},
		Awareness: {
			chaseradius: 25,
			hearingMult: 2,
			vision: 1.5,
			senseSpeed: 1.1,
			hearingRadius: 20,
		},
		startBuffs: [
			{
				id: "DragonQueenCritArmor",
				power: 1,
				type: "ToughArmor",
				duration: 9999, infinite: true,
				aura: KDBaseWhite,
				currentCount: 0, maxCount: 3, tags: ["defense", "crit"],
			}
		],
		Resistance: {
			block_magic: 3.0,
		},
		effect: {
			effect: {name: "VineSuspend"},
		},
		events: [
			{trigger: "beforeDamage", type: "dragonLairDefeat", power: 0, color: KDBaseRed},
			{trigger: "afterEnemyTick", type: "DragonRegen", power: 0.2},
			{trigger: "afterEnemyTick", type: "createEffectTile", kind: "Vines", time: 45, power: 2, chance: 0.5, aoe: 1.5},
		],
		spells: ["SummonDragonVinePlant", "PoisonBreath"],  spellCooldownMult: 1, spellCooldownMod: -1,
		visionRadius: 7, blindSight: 2.5, maxhp: 40, armor: 3, minLevel:12, weight:2.5, movePoints: 3, attackPoints: 2, attack: "SpellMeleeWillBindEffect",
		attackWidth: 3, attackRange: 1, tilesMinRange: 1, power: 5, dmgType: "slash",
		terrainTags: {"nature": 4, "lair": -100, "dragonqueen": 50}, shrines: ["Leather"], allFloors: true, // Adventurers don't appear in lairs
		ondeath: [{type: "summon", enemy: "DragonGirlPoison", range: 0.5, count: 1, sameid: true, storeTrueForm: true, strict: false}],
		Defeat: {
			furnitureTags: [
				{tags: ["vineRestraints"], count: 12},
				{tags: ["vineSuspend"], count: 1},
			],
		},
		ignoreflag: ["dragonIgnore"],
		creationScript: "DragonLair",
		dropTable: [{name: "Gold", amountMin: 200, amountMax: 300, weight: 15}]},

	{name: "DragonGirlPoison", nameList: "DragonGirl", outfit: "DragonGirlPoison", style: "DragonPoison", faction: "DragonQueen", clusterWith: "beast",
		bound: "DragonPoison", color: "#8d3fab",
		playLine: "DragonGirl",
		tags: KDMapInit(["opendoors", "noreinforce", "poison", "nature", "dragongirl", "nokillescape", "human", "melee", "miniboss", "vineRestraints", "relentless",
			"poisonresist", "fireresist", "chainweakness"]), cohesion: 0.75,
		followLeashedOnly: true, ignorechance: 0, armor: 1.5, followRange: 1, AI: "hunt", guardChance: 0.6, master: {type: "DragonQueenPoison", range: 4, loose: true, aggressive: true},
		spells: ["SummonDragonFlower", "DragonSlash"], spellCooldownMult: 1, spellCooldownMod: 0, castWhileMoving: true, spellRdy: true,

		effect: {
			effect: {name: "VineSuspend"},
		},
		noKiteWhenHarmless: true,
		dontKiteWhenDisabled: true,
		noLeash: true,
		kite: 2.5,

		wanderAISetting: "Dragon",
		spawnAISetting: "Dragon",

		events: [
			{trigger: "beforeDamage", type: "dragonLairDefeat", power: 0, color: KDBaseRed},
			{trigger: "afterEnemyTick", type: "DragonRegen", power: 0.2},
			{trigger: "afterEnemyTick", type: "createEffectTile", kind: "Vines", time: 45, power: 2, chance: 0.2, aoe: 1.5},
			{trigger: "afterEnemyTick", type: "createEffectTile", kind: "Cracked", time: 1400, power: 2, chance: 0.02, aoe: 0.5},
		],
		visionRadius: 9, maxhp: 30, minLevel:0, weight:0, movePoints: 1.4, attackPoints: 3, attack: "SpellMeleeBindLockWillEffect", multiBind: 2,
		stunTime: 1, attackWidth: 2.5, attackRange: 1, power: 4.5, dmgType: "slash", fullBoundBonus: 2,
		terrainTags: {"nature": 7, "dragongirl": 50}, shrines: ["Leather", "Will"], floors: {},
		attackLock: "Purple", maxdodge: 0,
		stamina: 7,
		preferBlock: true,
		ondeath: [{type: "DragonSeal"}],
		Defeat: {
			furnitureTags: [
				{tags: ["vineRestraints"], count: 12},
				{tags: ["vineSuspend"], count: 1},
			],
		},
		ignoreflag: ["dragonIgnore"],
		creationScript: "DragonLair",
		dropTable: [{name: "WaterRune", weight: 3}]},

	{name: "DragonQueenCrystal", color: "#92e8c0",
		faction: "DragonQueen",
		tags: KDMapInit(["opendoors", "noreinforce", "boss", "dragonqueen", "nokillescape", "pierceweakness", "unstoppable",
			"bulwark", "meleeresist", "electricresist", "fireresist", "melee", "beast", "search", "crystalline"]), cohesion: 0.1,
		GFX: {
			spriteHeight: 144,
			spriteWidth: 144,
		},
		specialCD: 20, specialAttack: "DashStun", specialRemove: "WillEffect", specialPower: 1, specialDamage: "soul", dashThrough: true, stunTime: 4, specialAttackPoints: 3,
		specialRange: 12, projectileTargeting: true, projectileAttack: true, specialMinRange: 4, specialCDonAttack: true, specialWidth: 1.25,
		castWhileMoving: true,


		wanderAISetting: "Dragon",
		spawnAISetting: "Dragon",
		noLeash: true,

		evasion: -1, disarm: 0.4,
		stamina: 12, sprintspeed: 2.0,
		preferBlock: true, maxdodge: 0,
		maxblock: 1,
		followLeashedOnly: true, ignorechance: 0, followRange: 1, AI: "hunt", guardChance: 0.0,
		Sound: {
			moveAmount: 12,
			attackAmount: 20,
		},
		Awareness: {
			chaseradius: 25,
			hearingMult: 2,
			vision: 1.5,
			senseSpeed: 1.1,
			hearingRadius: 20,
		},
		Defeat: {
			furnitureTags: [
				{tags: ["crystalCuffs"], count: 7},
				{tags: ["crystalEncase"], count: 1},
			],
		},
		ignoreflag: ["dragonIgnore"],
		startBuffs: [
			{
				id: "DragonQueenCritArmor",
				power: 1,
				type: "ToughArmor",
				duration: 9999, infinite: true,
				aura: KDBaseWhite,
				currentCount: 0, maxCount: 3, tags: ["defense", "crit"],
			}
		],
		Resistance: {
			block_magic: 3.0,
		},
		effect: {
			effect: {name: "CrystalEncase"},
		},
		events: [
			{trigger: "beforeDamage", type: "dragonLairDefeat", power: 0, color: KDBaseRed},
			{trigger: "afterEnemyTick", type: "DragonRegen", power: 0.2},
			{trigger: "getLights", type: "enemyTorch", power: 4.5, color: "#ff44aa"},
			{trigger: "afterEnemyTick", type: "createEffectTile", kind: "Cracked", time: 1400, power: 2, chance: 0.02, aoe: 0.5},
		],
		spells: ["CrystalBolt", "CrystalSlash"],  spellCooldownMult: 1, spellCooldownMod: -1,
		visionRadius: 7, blindSight: 2.5, maxhp: 40, armor: 3, minLevel:12, weight:2.5, movePoints: 3, attackPoints: 2, attack: "SpellMeleeWillEffect",
		attackWidth: 3, attackRange: 1, tilesMinRange: 1, power: 5, dmgType: "slash",
		attackLock: "Crystal",

		terrainTags: {"crystalline": 4, "lair": -100, "dragonqueen": 50}, shrines: ["Leather"], allFloors: true, // Adventurers don't appear in lairs
		ondeath: [{type: "summon", enemy: "DragonGirlCrystal", range: 0.5, sameid: true, storeTrueForm: true, count: 1, strict: false}],
		creationScript: "DragonLair",
		dropTable: [{name: "Gold", amountMin: 200, amountMax: 300, weight: 15}]},

	{name: "DragonGirlCrystal", nameList: "DragonGirl", outfit: "DragonGirlCrystal", style: "DragonCrystal", faction: "DragonQueen", clusterWith: "beast",
		bound: "DragonCrystal", color: KDBaseRed,
		playLine: "DragonGirl",
		tags: KDMapInit(["opendoors", "noreinforce", "chaos", "crystal", "dragongirl", "nokillescape", "human", "melee", "miniboss", "crystalRestraints", "relentless",
			"electricresist", "fireresist", "chainweakness"]), cohesion: 0.75,
		followLeashedOnly: true, ignorechance: 0, armor: 1.5, followRange: 1, AI: "hunt", guardChance: 0.6, master: {type: "DragonQueenCrystal", range: 4, loose: true, aggressive: true},
		spells: ["CrystalShockBolt", "CrystalSlash", "CrystalBoltSingle"], spellCooldownMult: 1, spellCooldownMod: 2, castWhileMoving: true, spellRdy: true,
		events: [
			{trigger: "beforeDamage", type: "dragonLairDefeat", power: 0, color: KDBaseRed},
			{trigger: "afterEnemyTick", type: "DragonRegen", power: 0.2},
			{trigger: "getLights", type: "enemyTorch", power: 4.5, color: "#ff44aa"},
		],
		effect: {
			effect: {name: "CrystalEncase"},
		},
		wanderAISetting: "Dragon",
		spawnAISetting: "Dragon",
		noLeash: true,
		noKiteWhenHarmless: true,
		dontKiteWhenDisabled: true,
		kite: 2.5,
		ondeath: [{type: "DragonSeal"}],
		Defeat: {
			furnitureTags: [
				{tags: ["crystalCuffs"], count: 3},
				{tags: ["crystalEncase"], count: 1},
			],
		},
		ignoreflag: ["dragonIgnore"],
		visionRadius: 9, maxhp: 30, minLevel:0, weight:0, movePoints: 1.5, attackPoints: 2, attack: "SpellMeleeBindLockWillEffect",
		stunTime: 1, attackWidth: 1, attackRange: 1, power: 4.5, dmgType: "crush", fullBoundBonus: 2,
		terrainTags: {"magic": 7, "dragongirl": 50}, shrines: ["Leather", "Conjure"], floors: {},
		attackLock: "Crystal", maxdodge: 0,
		stamina: 7,
		preferBlock: true,
		creationScript: "DragonLair",
		dropTable: [{name: "EarthRune", weight: 3}]},


	{name: "DragonQueenShadow", color: "#92e8c0",
		faction: "DragonQueen",
		tags: KDMapInit(["opendoors", "noreinforce", "boss", "dragonqueen", "nokillescape", "chainweakness",
			"bulwark", "unstoppable", "meleeresist", "coldresist", "fireresist", "melee", "beast", "search", "shadow", "shadowLatexRestraints"]), cohesion: 0.1,
		GFX: {
			spriteHeight: 144,
			spriteWidth: 144,
		},
		castWhileMoving: true,

		wanderAISetting: "Dragon",
		spawnAISetting: "Dragon",
		noLeash: true,

		RestraintFilter: {
			unlimitedRestraints: true,
			levelBonus: 3,
		},

		evasion: -0.5, disarm: 0.4,
		stamina: 12, sprintspeed: 1.8,
		maxdodge: 1,
		followLeashedOnly: true, ignorechance: 0, followRange: 1, AI: "hunt", guardChance: 0.0,
		Sound: {
			moveAmount: 12,
			attackAmount: 20,
		},
		Awareness: {
			chaseradius: 25,
			hearingMult: 2,
			vision: 1.5,
			senseSpeed: 1.1,
			hearingRadius: 20,
		},
		Defeat: {
			furnitureTags: [
				{tags: ["shadowLatexRestraints"], count: 5},
				{tags: ["shadowBall"], count: 1},
			],
		},
		ignoreflag: ["dragonIgnore"],
		startBuffs: [
			{
				id: "DragonQueenCritArmor",
				power: 1,
				type: "ToughArmor",
				duration: 9999, infinite: true,
				aura: KDBaseWhite,
				currentCount: 0, maxCount: 3, tags: ["defense", "crit"],
			}
		],
		Resistance: {
			block_magic: 3.0,
		},
		effect: {
			effect: {name: "ShadowEncase"},
		},
		events: [
			{trigger: "beforeDamage", type: "dragonLairDefeat", power: 0, color: KDBaseRed},
			{trigger: "afterEnemyTick", type: "DragonRegen", power: 0.2},
			{trigger: "afterEnemyTick", type: "ShadowBubbles", spell: "ShadowBubble", power: 1, count: 1, dist: 10, aoe: 6.5, time: 2},
			{trigger: "afterEnemyTick", type: "createEffectTile", kind: "Cracked", time: 1400, power: 2, chance: 0.02, aoe: 0.5},
		],
		spells: ["ShadowShroud", "ShadowShroudTele"],  spellCooldownMult: 1, spellCooldownMod: 0,
		visionRadius: 7, blindSight: 7.5, maxhp: 40, armor: 3, minLevel:12, weight:2.5, movePoints: 2, attackPoints: 2, attack: "MeleeWillEffectSpell",
		attackWidth: 3, attackRange: 1, tilesMinRange: 1, power: 5, dmgType: "slash",

		terrainTags: {"shadow": 4, "lair": -100, "dragonqueen": 50}, shrines: ["Leather"], allFloors: true, // Adventurers don't appear in lairs
		ondeath: [{type: "summon", enemy: "DragonGirlShadow", range: 0.5, sameid: true, storeTrueForm: true, count: 1, strict: false}],
		creationScript: "DragonLair",
		dropTable: [{name: "Gold", amountMin: 200, amountMax: 300, weight: 15}]},

	{name: "DragonGirlShadow", nameList: "DragonGirl", outfit: "DragonGirlShadow", style: "DragonShadow", faction: "DragonQueen", clusterWith: "beast",
		bound: "DragonShadow", color: "#999999",
		playLine: "DragonGirl",
		tags: KDMapInit(["opendoors", "noreinforce", "shadow", "dragongirl", "nokillescape", "human", "melee", "miniboss", "shadowLatexRestraints", "relentless",
			"coldresist", "fireresist", "chainweakness"]), cohesion: 0.75,
		followLeashedOnly: true, ignorechance: 0, armor: 0, spellResist: 2, followRange: 1, AI: "hunt", guardChance: 0.6, master: {type: "DragonQueenShadow", range: 4, loose: true, aggressive: true},
		spells: ["DarkTele", "ShadowShroudGirl",], spellCooldownMult: 1, spellCooldownMod: 0, castWhileMoving: true, spellRdy: true,
		events: [
			{trigger: "beforeDamage", type: "dragonLairDefeat", power: 0, color: KDBaseRed},
			{trigger: "afterEnemyTick", type: "DragonRegen", power: 0.2},
			//{trigger: "getLights", type: "enemyTorch", power: 4.5, color: "#ff44aa"},
		],
		effect: {
			effect: {name: "ShadowEncase"},
		},
		Resistance: {
			block_phys: 1,
		},
		Defeat: {
			furnitureTags: [
				{tags: ["shadowLatexRestraints"], count: 3},
				{tags: ["shadowBall"], count: 1},
			],
		},
		RestraintFilter: {
			unlimitedRestraints: true,
			levelBonus: 2,
		},
		ignoreflag: ["dragonIgnore"],
		wanderAISetting: "Dragon",
		spawnAISetting: "Dragon",
		noLeash: true,
		noKiteWhenHarmless: true,
		dontKiteWhenDisabled: true,
		kite: 3.5, kiteChance: 0.25,
		visionRadius: 9, blindSight: 6.5, maxhp: 30, minLevel:0, weight:0, movePoints: 1.3, attackPoints: 2, attack: "SpellMeleeBindLockWillEffect",
		stunTime: 1, attackWidth: 3, attackRange: 1, power: 4.5, dmgType: "soul", fullBoundBonus: 2,
		terrainTags: {"shadow": 7, "dragongirl": 50}, shrines: ["Leather", "Illusion"], floors: {},
		attackLock: "Purple", maxdodge: 0,
		stamina: 6,
		preferBlock: true,
		ondeath: [{type: "DragonSeal"}],
		creationScript: "DragonLair",
		dropTable: [{name: "PotionInvisibility", weight: 3}]},



	{name: "DragonQueenIce", color: "#92e8c0",
		faction: "DragonQueen",
		tags: KDMapInit(["opendoors", "noreinforce", "ice", "boss", "iceRestraints", "dragonqueen", "nokillescape",
			"bulwark", "unstoppable", "crushweakness", "meleeresist", "soapresist", "fireresist", "iceresist", "melee", "beast", "search"]), cohesion: 0.1,
		GFX: {
			spriteHeight: 144,
			spriteWidth: 144,
		},
		projectileAttack: true,
		castWhileMoving: true,

		dontKiteWhenDisabled: true,

		wanderAISetting: "Dragon",
		spawnAISetting: "Dragon",
		noLeash: true,
		evasion: -1, disarm: 0.4,
		stamina: 12, sprintspeed: 2.0,
		preferBlock: true, maxdodge: 0,
		maxblock: 1,
		followLeashedOnly: true, ignorechance: 0, followRange: 1, AI: "hunt", guardChance: 0.0, kite: 1.5,
		kiteChance: 0.5, // doesnt always kite-- usually turns around to use Breath
		Sound: {
			moveAmount: 12,
			attackAmount: 20,
		},
		Defeat: {
			furnitureTags: [
				{tags: ["iceCuffs"], count: 7},
				{tags: ["iceEncase"], count: 1},
			],
		},
		ignoreflag: ["dragonIgnore"],
		Awareness: {
			chaseradius: 25,
			hearingMult: 2,
			vision: 1.5,
			senseSpeed: 1.1,
			hearingRadius: 20,
		},
		startBuffs: [
			{
				id: "DragonQueenCritArmor",
				power: 1,
				type: "ToughArmor",
				duration: 9999, infinite: true,
				aura: KDBaseWhite,
				currentCount: 0, maxCount: 3, tags: ["defense", "crit"],
			}
		],
		Resistance: {
			block_magic: 3.0,
		},
		effect: {
			effect: {name: "IceEncase"},
		},

		Magic: {
			priority: {
				SummonIceWall: 9,
				SummonIceWall2: 10,
			},
		},
		spells: ["SummonIceWall", "SummonIceWall2", "IceBreathChannel", "DragonIceBolt"],  spellCooldownMult: 1, spellCooldownMod: 0,
		visionRadius: 7, blindSight: 2.5, maxhp: 40, armor: 3, minLevel:12, weight:2.5, movePoints: 4, attackPoints: 2, attack: "SpellMeleeWillBindEffect",
		attackWidth: 3, attackRange: 1, tilesMinRange: 1, power: 5, dmgType: "crush",
		events: [
			{trigger: "beforeDamage", type: "dragonLairDefeat", power: 0, color: KDBaseRed},
			{trigger: "afterEnemyTick", type: "createIce", power: 1, chance: 1.0, aoe: 1.0},
			{trigger: "afterEnemyTick", type: "createEffectTile", kind: "Cracked", time: 1400, power: 2, chance: 0.02, aoe: 0.5},
		],
		terrainTags: {"ice": 4, "lair": -100, "dragonqueen": 50}, shrines: ["Leather"], allFloors: true, // Adventurers don't appear in lairs
		ondeath: [{type: "summon", enemy: "DragonGirlIce", range: 0.5, sameid: true, storeTrueForm: true, count: 1, strict: false}],
		creationScript: "DragonLair",
		dropTable: [{name: "Gold", amountMin: 200, amountMax: 300, weight: 15}]},


	{name: "DragonGirlIce", nameList: "DragonGirl", outfit: "DragonGirlIce", style: "DragonIce", faction: "DragonQueen", clusterWith: "beast",
		bound: "DragonIce", color: "#92e8c0",
		playLine: "DragonGirl",
		tags: KDMapInit(["opendoors", "noreinforce", "water", "ice", "dragongirl", "nokillescape", "human", "melee", "miniboss", "iceRestraints", "relentless",
			"soapresist", "fireresist", "chainweakness"]), cohesion: 0.75,
		followLeashedOnly: true, ignorechance: 0, armor: 1.5, followRange: 1, AI: "hunt", guardChance: 0.6, master: {type: "DragonQueenCrystal", range: 4, loose: true, aggressive: true},
		spells: [ "IceBreathChannel", "DragonIceBolt", "EnemyWinterblast"], spellCooldownMult: 1, spellCooldownMod: 2, castWhileMoving: true, spellRdy: true,

		effect: {
			effect: {name: "IceEncase"},
		},
		Magic: {
			priority: {
				EnemyWinterblast: 10,
			},
		},
		Defeat: {
			furnitureTags: [
				{tags: ["iceCuffs"], count: 3},
				{tags: ["iceEncase"], count: 1},
			],
		},
		ignoreflag: ["dragonIgnore"],
		wanderAISetting: "Dragon",
		spawnAISetting: "Dragon",
		noLeash: true,
		ondeath: [{type: "DragonSeal"}],
		events: [
			{trigger: "beforeDamage", type: "dragonLairDefeat", power: 0, color: KDBaseRed},
			{trigger: "afterEnemyTick", type: "createIce", power: 1, chance: 0.5, aoe: 1.0},
		],
		noKiteWhenHarmless: true,
		dontKiteWhenDisabled: true,
		kite: 2.5,
		visionRadius: 9, maxhp: 30, minLevel:0, weight:0, movePoints: 1.5, attackPoints: 2, attack: "SpellMeleeBindLockWillEffect",
		stunTime: 1, attackWidth: 1, attackRange: 1, power: 4.5, dmgType: "crush", fullBoundBonus: 2,
		terrainTags: {"ice": 7, "dragongirl": 50}, shrines: ["Leather", "Elements"], floors: {},
		attackLock: "Purple", maxdodge: 0,
		stamina: 7,
		preferBlock: true,
		creationScript: "DragonLair",
		dropTable: [{name: "IceRune", weight: 3}]},




	{name: "Dragon", nameList: "dragonheart", outfit: "Dragon", style: "Fire", faction: "Dragon", playLine: "Adventurer_Brat_Fighter", clusterWith: "dragon", bound: "Dragon", color: "#F92900",
		tags: KDMapInit(["opendoors", "fire", "guardCall", "jailer", "leashing", "imprisonable", "minor", "dragon", "melee",  "relentless","dragonRestraints", "handcuffer", "leatherRestraints", "fireresist", "jail", "jailer", "search"]), cohesion: 0.75,
		followLeashedOnly: true, ignorechance: 0, armor: 1, followRange: 1, AI: "hunt", guardChance: 0.6, master: {type: "DragonLeader", range: 4, loose: true, aggressive: true}, difficulty: 0.5,
		visionRadius: 6, maxhp: 9, minLevel:0, weight:-1, movePoints: 2, attackPoints: 2, attack: "MeleeBindLock", attackWidth: 1, attackRange: 1, power: 2, dmgType: "grope", fullBoundBonus: 1, maxLevel: 7,
		terrainTags: {"secondhalf":2, "leatherAnger":3, "dragon": 30, "fire": 4}, shrines: ["Leather"], allFloors: true,
		attackLock: "White",
		preferBlock: true, maxdodge: 0,
		stamina: 5,
		dropTable: [{name: "Gold", amountMin: 5, amountMax: 10, weight: 15}]},
	{name: "DragonShield", nameList: "dragonheart", outfit: "DragonShield", style: "Fire", faction: "Dragon", clusterWith: "dragon", bound: "DragonShield", color: "#F92900",
		tags: KDMapInit(["opendoors", "guardCall", "fire", "imprisonable", "leashing", "dragon", "melee", "dragonRestraints", "handcuffer",  "relentless","leatherRestraints", "fireresist", "jail", "jailer", "search"]),
		cohesion: 0.75,
		stunTime: 2, specialCD: 6, specialAttack: "Stun", specialRemove: "BindLock", specialPower: 6, specialDamage: "pain",
		spells: ["ArmorUpArea"], spellCooldownMult: 1, spellCooldownMod: 5, buffallies: true,
		startBuffs: [
			{
				id: "DragonShieldCritArmor",
				power: 1,
				type: "ToughArmor",
				duration: 9999, infinite: true,
				aura: KDBaseWhite,
				currentCount: 0, maxCount: 1, tags: ["defense", "crit"],
			}
		],
		shield: 3,
		preferBlock: true, maxdodge: 0,
		followLeashedOnly: true, ignorechance: 0, armor: 1, followRange: 1, AI: "hunt", guardChance: 0.6, master: {type: "DragonLeader", range: 4, loose: true, aggressive: true},
		visionRadius: 7, maxhp: 9, minLevel:4, weight:-1, movePoints: 2, attackPoints: 2, attack: "SpellMeleeBindLock", attackWidth: 3, attackRange: 1, tilesMinRange: 1, power: 2, dmgType: "grope", fullBoundBonus: 1,
		terrainTags: {"secondhalf":1, "thirdhalf":1, "leatherAnger":3, "leatherRage":4, "dragon": 25, "fire": 4}, shrines: ["Leather"], allFloors: true,
		attackLock: "White",
		stamina: 5,
		dropTable: [{name: "Gold", amountMin: 15, amountMax: 20, weight: 15}]},
	{name: "DragonIce", nameList: "dragonheart", outfit: "DragonIce", style: "Ice", faction: "Dragon", clusterWith: "dragon", bound: "DragonIce", color: "#aaaaff",
		tags: KDMapInit(["opendoors", "ice", "leashing", "dragon", "melee", "elite", "dragonRestraints", "handcuffer", "leatherRestraints",  "relentless","iceimmune", "fireweakness", "crushweakness", "jail", "jailer", "hunter"]), cohesion: 0.75,
		followLeashedOnly: true, ignorechance: 0, armor: 2.0, followRange: 1, AI: "hunt", guardChance: 0.6, master: {type: "DragonLeader", range: 4, loose: true, aggressive: true},
		spells: ["IceDragonBreathPrepare"], spellCooldownMult: 1, spellCooldownMod: 3, spellRdy: true,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 3, color: KDBaseCyan},
		],
		preferBlock: true, maxdodge: 0,
		visionRadius: 7, maxhp: 14, minLevel:4, weight:-2, movePoints: 2, attackPoints: 2, attack: "SpellMeleeBindLockAll", attackWidth: 1, attackRange: 1, power: 3, dmgType: "grope", fullBoundBonus: 1,
		attackLock: "Purple",
		stamina: 5,
		terrainTags: {"secondhalf":2, "thirdhalf":2, "dragon": 16, "ice": 4}, shrines: ["Leather", "Elements"], allFloors: true,
		dropTable: [{name: "Gold", amountMin: 20, amountMax: 30, weight: 12}, {name: "IceRune", weight: 3}, {name: "IceBreaker", weight: 0.1, ignoreInInventory: true}]},
	{name: "DragonPoison", nameList: "dragonheart", outfit: "DragonPoison", style: "GreenHair", faction: "Dragon", clusterWith: "dragon", bound: "DragonPoison", color: "#44ff77",
		tags: KDMapInit(["opendoors", "nature", "leashing", "imprisonable", "dragon", "melee", "elite", "dragonRestraints", "handcuffer", "leatherRestraints", "unflinching", "fireresist", "jail", "jailer", "hunter"]), cohesion: 0.75,
		followLeashedOnly: true, ignorechance: 0, armor: 0.5, followRange: 1, AI: "hunt", guardChance: 0.6, master: {type: "DragonLeader", range: 4, loose: true, aggressive: true},
		spells: ["PoisonDragonBlast", "EnemyCM1"], unlockCommandLevel: 1, unlockCommandCD: 90, spellCooldownMult: 1, spellCooldownMod: -1, tilesMinRange: 2, stopToCast: true, spellRdy: true,
		visionRadius: 7, maxhp: 11, minLevel:6, weight:-2, movePoints: 3, attackPoints: 4, attack: "SpellMeleeStunWillLock", stunTime: 1, attackWidth: 3, attackRange: 2, power: 3, dmgType: "grope", fullBoundBonus: 2,
		terrainTags: {"secondhalf":2, "thirdhalf":2, "dragon": 16, "nature": 4}, shrines: ["Leather", "Will"], allFloors: true,
		attackLock: "Purple",
		stamina: 5,
		preferBlock: true, maxdodge: 0,
		dropTable: [{name: "Gold", amountMin: 20, amountMax: 30, weight: 12}, {name: "Pick", weight: 4}, {name: "PotionStamina", weight: 3}]},
	{name: "DragonCrystal", nameList: "dragonheart", outfit: "DragonCrystal", style: "Water", faction: "Dragon", clusterWith: "dragon", bound: "DragonCrystal", color: "#ff00aa",
		tags: KDMapInit(["opendoors", "chaos", "crystal", "leashing", "dragon", "melee", "elite", "dragonRestraints", "handcuffer", "leatherRestraints", "leatherRestraintsHeavy", "relentless",
			"pierceweakness", "electricresist", "crushweakness", "fireresist", "jail", "jailer", "hunter"]), cohesion: 0.75,
		followLeashedOnly: true, ignorechance: 0, armor: 1.5, followRange: 1, AI: "hunt", guardChance: 0.6, master: {type: "DragonLeader", range: 4, loose: true, aggressive: true},
		spells: ["SummonCrystals"], spellCooldownMult: 1, spellCooldownMod: 2, castWhileMoving: true, spellRdy: true,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 4.5, color: "#ff44aa"},
		],
		visionRadius: 7, maxhp: 10, minLevel:7, weight:-1, movePoints: 1.5, attackPoints: 2, attack: "SpellMeleeBindLockWill", stunTime: 1, attackWidth: 1, attackRange: 1, power: 3, dmgType: "crush", fullBoundBonus: 2,
		terrainTags: {"secondhalf":1, "thirdhalf":2, "crystalline": 10, "dragon": 13}, shrines: ["Leather", "Conjure"], allFloors: true,
		attackLock: "White", maxdodge: 0,
		stamina: 5,
		preferBlock: true,
		dropTable: [{name: "Gold", amountMin: 20, amountMax: 30, weight: 15}, {name: "EarthRune", weight: 3}]},
	{name: "DragonShadow", nameList: "dragonheart", outfit: "DragonShadow", style: "Shadow", faction: "Dragon", clusterWith: "dragon", bound: "DragonShadow", color: "#4400ff",
		tags: KDMapInit(["opendoors", "shadowclan", "shadow", "holyweakness", "chaos", "leashing", "dragon", "melee", "elite", "dragonRestraints", "handcuffer", "shadowRestraints",  "relentless", "coldimmune", "fireresist", "jail", "jailer", "hunter"]),
		cohesion: 0.75,
		followLeashedOnly: true, ignorechance: 0, armor: 0.5, followRange: 1, AI: "hunt", guardChance: 0.6, master: {type: "DragonLeader", range: 4, loose: true, aggressive: true},
		spells: ["ShadowOrb"],  spellCooldownMult: 1, spellCooldownMod: 0, pullTowardSelf: true, pullDist: 3, disarm: 0.4,
		specialCD: 7, specialAttack: "Pull", specialCDonAttack: true, specialAttackPoints: 2, specialRange: 4, specialsfx: "MagicSlash",
		visionRadius: 7, maxhp: 15, minLevel:9, weight:-1, movePoints: 2, attackPoints: 2, attack: "SpellMeleeWillLock", stunTime: 3, attackWidth: 1, attackRange: 1, power: 3, dmgType: "grope", fullBoundBonus: 2,
		terrainTags: {"secondhalf":1, "thirdhalf":2, "dragon": 13, "shadow": 4}, shrines: ["Leather", "Conjure"], allFloors: true,
		attackLock: "Purple", maxdodge: 1,
		stamina: 5,
		preferBlock: true,
		dropTable: [{name: "Gold", amountMin: 15, amountMax: 20, weight: 10}, {name: "Knife", ignoreInInventory: true, weight: 4}]},
	{name: "DragonLeader", nameList: "dragonheart", outfit: "DragonLeader", style: "Fire", faction: "Dragon", clusterWith: "dragon", bound: "DragonLeader", color: "#F92900",
		tags: KDMapInit(["opendoors", "antiMagic", "fire", "leashing", "dragon", "melee", "boss", "dragonRestraints", "unflinching", "handcuffer", "leatherRestraints", "leatherRestraintsHeavy", "jailer", "fireimmune"]),
		ignorechance: 0, armor: 1, followRange: 1, AI: "patrol", focusPlayer: true,
		preferBlock: true, maxdodge: 2,
		summon: [
			{enemy: "Dragon", range: 2, count: 2, chance: 0.4, strict: true},
			{enemy: "DragonIce", range: 3, count: 1, chance: 0.25, strict: true},
			{enemy: "DragonPoison", range: 3, count: 1, chance: 0.25, strict: true},
			{enemy: "DragonCrystal", range: 3, count: 1, chance: 0.25, strict: true},
			{enemy: "DragonShadow", range: 3, count: 1, chance: 0.25, strict: true},],
		specialCD: 5, specialAttack: "Dash", specialRemove: "BindLockWill", specialCDonAttack: true, specialAttackPoints: 1, specialRange: 3, specialMinRange: 1.5, specialsfx: "Miss",
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 3, color: KDBaseRed},
		],
		stamina: 8,
		sprintspeed: 1.25,
		visionRadius: 8, maxhp: 18, minLevel:4, weight:-11, movePoints: 2, attackPoints: 2, attack: "MeleeBindLockWill", attackWidth: 1, attackRange: 1, power: 4, dmgType: "crush", fullBoundBonus: 2,
		terrainTags: {"secondhalf":2, "thirdhalf":4, "open": 10, "fire": 4, "leatherAnger":6, "leatherRage":30, "boss": -55, "increasingWeight":0.5, "dragon": 5}, shrines: ["Leather"], allFloors: true,
		dropTable: [{name: "Gold", amountMin: 30, amountMax: 40, weight: 10}, {name: "Sword", ignoreInInventory: true, weight: 100}, {name: "EnchKnife", ignoreInInventory: true, weight: 1}]},

	{name: "Adventurer_Brat_Fighter", nameList: "dragonheart", outfit: "AdventurerBrat", style: "GreenHair", clusterWith: "adventurer", bound: "Adventurer_Brat", color: KDBaseWhite,
		playLine: "Adventurer_Brat_Fighter",
		tags: KDMapInit(["opendoors", "elite", "imprisonable", "leashing", "adventurer", "human", "melee", "ropeRestraints", "ropeRestraintsHogtie", "charmweakness", "jail", "jailer", "brat", "search",
			"bulwark"]), cohesion: 0.9,
		stunTime: 2, specialCD: 5, specialAttack: "Stun", specialRemove: "BindLock", specialPower: 6, specialDamage: "pain",
		evasion: -0.5,
		preferBlock: true, maxdodge: 1,
		spells: ["RopeEngulfWeak", "WitchRope"], spellCooldownMult: 2, spellCooldownMod: 1, buffallies: true,
		followLeashedOnly: true, ignorechance: 0, armor: 3, followRange: 1, AI: "hunt", guardChance: 0.0,
		visionRadius: 8, maxhp: 20, minLevel:2, weight:1, movePoints: 2.0, attackPoints: 2, attack: "SpellMeleeWillBindLock",
		attackWidth: 1, attackRange: 1, tilesMinRange: 1, power: 3, dmgType: "pain", fullBoundBonus: 1,
		stamina: 5,
		block: 0.1,
		events: [
			{trigger: "tick", type: "AdventurerAssignFaction", dist: 4.0, tags: ["Adventurer", "Bandit", "Nevermere", "Bountyhunter", "Dragon"]},
		],
		terrainTags: {"adventurer": 10, "lair": -10, "brat": 50}, shrines: ["Rope"], allFloors: true, // Adventurers don't appear in lairs
		dropTable: [{name: "Gold", amountMin: 20, amountMax: 40, weight: 15}, {name: "Axe", ignoreInInventory: true, weight: 100}, {name: "MagicAxe", ignoreInInventory: true, weight: 1}, {name: "Breastplate", ignoreInInventory: true, weight: 200}]},

	{name: "Adventurer_Dom_Fighter", nameList: "dragonheart", outfit: "AdventurerDom", style: "BlackCatGirl", clusterWith: "adventurer", bound: "Adventurer_Dom", color: KDBaseWhite,
		playLine: "Adventurer_Dom_Fighter",
		Resistance: {
			profile: ["catgirl"],
		},
		preferDodge: true, maxdodge: 3, maxblock: 2,
		tags: KDMapInit(["opendoors", "elite", "imprisonable", "leashing", "adventurer", "human", "melee", "latexRestraints", "soulweakness", "jail", "jailer", "dom", "search"]), cohesion: 0.9,
		stunTime: 2, specialCD: 7, specialAttack: "Dash", specialRemove: "WillBindLock", specialPower: 6, specialDamage: "pain",
		specialAttackPoints: 1, specialRange: 3.5, specialMinRange: 2.4, specialsfx: "Miss", castWhileMoving: true, dashThruWalls: true, dashThrough: true,
		bindOnDisable: true,
		smartBind: true,
		block: 0.15,
		evasion: 0.4, disarm: 0.4,
		followLeashedOnly: true, ignorechance: 0, armor: 1.5, followRange: 1, AI: "hunt", guardChance: 0.0,
		visionRadius: 8, maxhp: 17, minLevel:5, weight:1, movePoints: 1.4, attackPoints: 2, attack: "MeleeWillBindLock",
		attackWidth: 1, attackRange: 2.5, tilesMinRange: 1, power: 2, dmgType: "pain", fullBoundBonus: 2,
		stamina: 7,
		events: [
			{trigger: "tick", type: "AdventurerAssignFaction", dist: 4.0, tags: ["Adventurer", "Bandit", "Maidforce", "Bountyhunter", "Bast"]},
		],
		terrainTags: {"adventurer": 10, "lair": -10, "dom": 50}, shrines: ["Latex"], allFloors: true, // Adventurers don't appear in lairs
		dropTable: [{name: "Gold", amountMin: 20, amountMax: 40, weight: 15}, {name: "Foil", ignoreInInventory: true, weight: 100}, {name: "Rapier", ignoreInInventory: true, weight: 100}, {name: "Dirk", ignoreInInventory: true, weight: 100}, {name: "Bracers", ignoreInInventory: true, weight: 200}]},

	{name: "Adventurer_Switch_Fighter", nameList: "dragonheart", outfit: "AdventurerSwitch", style: "WhiteHair", clusterWith: "adventurer", bound: "Adventurer_Switch", color: KDBaseWhite,
		playLine: "Adventurer_Switch_Fighter",
		armor: 1.0,
		tags: KDMapInit(["opendoors", "elite", "imprisonable", "leashing", "adventurer", "human", "melee", "mithrilRestraints", "gropeweakness", "jail", "jailer", "switch", "search"]), cohesion: 0.9,
		specialCD: 6, specialAttack: "Bind", specialRemove: "Lock", specialCDonAttack: true, strictAttackLOS: true, specialDamage: "chain",
		specialRange: 4, projectileTargeting: true, specialWidth: 1, ignoreStaminaForBinds: true,
		projectileAttack: true,
		evasion: 0.2, kite: 1.5,
		spells: ["ArmorUpArea"], spellCooldownMult: 2, spellCooldownMod: 1, buffallies: true,
		followLeashedOnly: true, ignorechance: 0, spellResist: 1.5, followRange: 2.5, AI: "hunt", guardChance: 0.0,
		visionRadius: 8, maxhp: 15, minLevel:3, weight:1, movePoints: 2.4, attackPoints: 3, attack: "SpellMeleeWillBindLock",
		attackWidth: 3, attackRange: 1, tilesMinRange: 1, power: 3, dmgType: "chain", fullBoundBonus: 1,
		stamina: 3,
		preferDodge: true, maxblock: 0,
		events: [
			{trigger: "tick", type: "AdventurerAssignFaction", dist: 4.0, tags: ["Adventurer", "Bandit", "Nevermere", "Bountyhunter", "Alchemist"]},
		],
		terrainTags: {"adventurer": 10, "lair": -10, "switch": 50}, shrines: ["Metal"], allFloors: true, // Adventurers don't appear in lairs
		dropTable: [{name: "Gold", amountMin: 20, amountMax: 40, weight: 15}, {name: "ManaOrb", weight: 30}, {name: "PotionStamina", weight: 10}, {name: "LeatherBoots", ignoreInInventory: true, weight: 200}]},

	{name: "Adventurer_Sub_Fighter", nameList: "elf", outfit: "AdventurerSub", style: "DarkElf", clusterWith: "adventurer", bound: "Adventurer_Sub", color: KDBaseWhite,
		playLine: "Adventurer_Sub_Fighter",
		tags: KDMapInit(["opendoors", "elite", "imprisonable", "leashing", "adventurer", "human", "melee", "leatherRestraints", "leatherRestraintsHeavy", "painweakness", "jail", "jailer", "sub", "search"]), cohesion: 0.9,
		stunTime: 2, specialCD: 10, specialAttack: "StunDash", specialRemove: "WillBindLock", specialPower: 6, specialDamage: "cold",
		specialAttackPoints: 3, specialRange: 6,
		evasion: -0.1, disarm: 0.2,
		stamina: 4,
		preferBlock: true, maxdodge: 1,
		spells: ["ShadowOrb"], spellCooldownMult: 2, spellCooldownMod: 1,
		followLeashedOnly: true, ignorechance: 0, spellResist: 2.0, followRange: 1, AI: "hunt", guardChance: 0.0,
		visionRadius: 8, maxhp: 30, minLevel:6, weight:1, movePoints: 1.8, attackPoints: 2, attack: "SpellMeleeWillBindLock",
		attackWidth: 1, attackRange: 1, tilesMinRange: 1, power: 3, dmgType: "grope", fullBoundBonus: 1,
		events: [
			{trigger: "tick", type: "AdventurerAssignFaction", dist: 4.0, tags: ["Adventurer", "Bandit", "Nevermere", "Bountyhunter", "Elf"]},
		],
		terrainTags: {"adventurer": 10, "lair": -10, "sub": 50}, shrines: ["Leather"], allFloors: true, // Adventurers don't appear in lairs
		dropTable: [{name: "Gold", amountMin: 20, amountMax: 40, weight: 15}, {name: "Spear", ignoreInInventory: true, weight: 100}, {name: "MagicSpear", ignoreInInventory: true, weight: 1}, {name: "ElfCrystal", weight: 5}]},

	{name: "ElementalFire", nameList: "elemental", outfit: "ElementalFire", style: "FireElemental", faction: "Elemental", playLine: "Elemental", clusterWith: "fire", bound: "ElementalFire", color: "#FF6200", tags: KDMapInit(["opendoors", "flying", "imprisonable", "nowet", "fire", "guardCall", "elemental", "fireimmune", "ranged", "coldweakness", "icesevereweakness", "obsidianRestraints",
		"shackleRestraints", "steelCuffs", "leashing", "jail", "jailer", "search"]),
		armor: 0.5, kite: 1.5, followRange: 3, AI: "hunt",
		spells: ["HeatBolt"], spellCooldownMult: 1, spellCooldownMod: 1, followLeashedOnly: true, stopToCast: true, spellRdy: true, projectileTargeting: true,
		visionRadius: 7, maxhp: 8, minLevel:0, weight:-1, movePoints: 1.5, attackPoints: 3, attack: "SpellMeleeWillBindLock", attackWidth: 1, attackRange: 1, power: 2, dmgType: "pain", fullBoundBonus: 2,
		terrainTags: {"secondhalf":2, "thirdhalf":1, "open": 1, "elementsAnger": 12, "elementsRage": 6, "temple": 5, "elemental": 6}, allFloors: true, shrines: ["Elements", "Metal"],
		attackLock: "White",
		RestraintFilter: {
			bonusRestraints: 1,
			requiredItems: ["ObsidianArmCuffs"],
		},
		maxblock: 0,
		dropTable: [{name: "Gold", amountMin: 5, amountMax: 10, weight: 10}, {name: "Gunpowder", weight: 1}],
		events: [
			{trigger: "afterEnemyTick", type: "createEffectTile", kind: "Ember", time: 5, power: 2, chance: 0.2, aoe: 1.5},
			{trigger: "getLights", type: "enemyTorch", power: 5.5, color: "#ff8933"}],
	},
	/*{name: "KeeperFire", faction: "Elemental", playLine: "Elemental", clusterWith: "fire", bound: "ElementalFire", color: "#FF6200",
		tags: KDMapInit(["opendoors", "miniboss",
			"imprisonable", "fire", "guardCall", "elemental", "fireimmune", "ranged", "coldweakness", "icesevereweakness", "obsidianRestraints", "shackleRestraints", "leashing", "jail", "jailer", "search"]),
		armor: 0.5, kite: 1.5, followRange: 3, AI: "hunt",
		spells: ["FlameDash"], spellCooldownMult: 1, spellCooldownMod: 0, followLeashedOnly: true, stopToCast: true, spellRdy: true, projectileTargeting: true,
		visionRadius: 6.5, maxhp: 8, minLevel:0, weight:-1, movePoints: 1.5, attackPoints: 2, attack: "SpellMeleeWillBindLockEffect", attackWidth: 1.5, attackRange: 1, power: 2, dmgType: "pain", fullBoundBonus: 2,
		terrainTags: {"secondhalf":2, "thirdhalf":1, "open": 1, "elementsAnger": 12, "elementsRage": 6, "temple": 5, "elemental": 6}, allFloors: true, shrines: ["Elements", "Metal"],
		attackLock: "Purple",
		RestraintFilter: {
			bonusRestraints: 1,
			requiredItems: ["ObsidianArmCuffs", "ObsidianAnkleCuffs", "ObsidianLegCuffs"],
		},
		dropTable: [{name: "Gold", amountMin: 15, amountMax: 20, weight: 10}, {name: "Gunpowder", amount: 3, weight: 5}],
		events: [
			{trigger: "afterEnemyTick", type: "createEffectTile", kind: "Ember", time: 3, power: 2, chance: 0.2, aoe: 1.5},
			{trigger: "getLights", type: "enemyTorch", power: 5.5, color: "#ff8933"},
			{trigger: "hit", type: "castSpell", time: 3, spell: "FlameKeeperBlade", color: "#ff8933"},
			{trigger: "miss", type: "castSpell", time: 3, spell: "FlameKeeperBlade", color: "#ff8933"},
		],
	},*/

	//region MaidKnight

	{name: "MaidKnightHeavy", nameList: "MaidKnightHeavy",
		outfit: "MaidKnightHeavy", style: "MaidKnightHeavy",
		clusterWith: "adventurer",
		bound: "MaidKnightHeavy",
		color: KDBaseWhite,
		faction: "Adventurer",
		playLine: "Adventurer_Dom_Fighter",
		preferDodge: true, maxdodge: 1, maxblock: 2,
		tags: KDMapInit(["opendoors", "elite", "imprisonable",
			"leashing", "adventurer", "human", "melee",
			"leatherRestraintsHeavy", "maidRestraints",
			"soulweakness", "jail", "jailer", "dom", "search"]),
		cohesion: 0.5,
		bindOnDisable: true,
		smartBind: true,
		block: 0.2,
		spells: ["HeavySlash", "SelfCharge"], spellCooldownMult: 1, spellCooldownMod: 0,
		evasion: 0.25, disarm: 0.35,
		followLeashedOnly: true, ignorechance: 0, armor: 2.5, followRange: 1, AI: "hunt", guardChance: 0.0,
		visionRadius: 11, maxhp: 50, minLevel:0, weight: -100, movePoints: 1.4, attackPoints: 2, attack: "SpellMeleeWillBindLock",
		attackWidth: 2.5, attackRange: 1.5, power: 3, dmgType: "tickle", fullBoundBonus: 3,
		stamina: 7,
		events: [
			{trigger: "enemyCast", type: "DelayedJump"},
			{trigger: "tickAfter", type: "WeaponEquip"},
			{trigger: "enemyKnockdown", type: "MaidKnights"},
			{trigger: "kill", type: "MaidKnights"},
			{trigger: "getCustomDefeat", type: "MaidKnights"},
		],
		Defeat: {
			specificRestraints: [
				{name: "MaidDress", minlevel: 0},
				{name: "MaidGag", minlevel: 4},
				{name: "MaidMuzzle", minlevel: 8},
				{name: "TrapBoots", minlevel: 2},
				{name: "TrapHarness", minlevel: 6},
			],
		},
		specialScript: "MaidKnightAndSquire",
		wanderAISetting: "Targeted",
		terrainTags: {}, shrines: ["Leather"], floors: {}, // Adventurers don't appear in lairs
		dropTable: [{name: "Gold", amountMin: 699, amountMax: 799, weight: 10},
			{name: "Sweeper", weight: 100, ignoreInInventory: true},]},

	{name: "MaidKnightLight", nameList: "MaidKnightLight",
		outfit: "MaidKnightLight", style: "MaidKnightLight",
		clusterWith: "adventurer",
		bound: "MaidKnightLight", color: KDBaseWhite,
		faction: "Adventurer",
		playLine: "Adventurer_Sub_Fighter",
		tags: KDMapInit(["opendoors", "elite", "imprisonable", "leashing", "adventurer", "human",
			"melee", "leatherRestraints", "trap", "painweakness", "jail", "jailer", "sub", "search"]),
			cohesion: 0.9, stunTime: 2,
		evasion: -0.1,
		stamina: 4,
		preferBlock: true, maxdodge: 1,
		castWhileMoving: true,
		Defeat: {
			specificRestraints: [
				{name: "MaidDress", minlevel: 0},
				{name: "MaidGag", minlevel: 4, maxlevel: 12},
				{name: "MaidGag", minlevel: 12, applyVariant: "AntiMagic"},
				{name: "MaidMuzzle", minlevel: 8},
				{name: "TrapBoots", minlevel: 2},
				{name: "TrapHarness", minlevel: 6},
			],
		},
		events: [
			{trigger: "tickAfter", type: "WeaponEquip"},
			{trigger: "enemyKnockdown", type: "MaidKnights"},
			{trigger: "kill", type: "MaidKnights"},
			{trigger: "tickAfter", type: "MaidKnightFollow"},
			{trigger: "getCustomDefeat", type: "MaidKnights"},

		],
		specialScript: "MaidKnightAndSquire",
		wanderAISetting: "Targeted",
		spells: ["Aim_MaidKnightLight"], spellCooldownMult: 1, spellCooldownMod: 0,
		followLeashedOnly: true, ignorechance: 0, armor: 0.8, followRange: 1, AI: "hunt", guardChance: 0.0,
		visionRadius: 11, maxhp: 40, minLevel:0, weight: -100, movePoints: 1.5, attackPoints: 2, attack: "SpellMeleeWillBindLock",
		attackWidth: 1, attackRange: 1, tilesMinRange: 1, power: 2.5, dmgType: "tickle", fullBoundBonus: 1.5,
		terrainTags: {}, shrines: ["Leather"], floors: {}, // Adventurers don't appear in lairs
		dropTable: [{name: "Gold", amountMin: 399, amountMax: 499, weight: 10},
			{name: "Persuader", weight: 100, ignoreInInventory: true},]},


	// endregion



	{name: "ElementalIce", nameList: "elemental", outfit: "ElementalIce", style: "IceElemental", faction: "Elemental", playLine: "Elemental", clusterWith: "ice", bound: "ElementalIce", color: "#aaaaff", tags: KDMapInit(["opendoors", "flying", "antiMagic", "imprisonable", "elemental", "guardCall", "ice", "ranged", "firesevereweakness", "crushweakness", "coldresist", "iceimmune", "iceRestraints", "leashing", "jail", "jailer", "search"]),
		armor: 1.5, kite: 1.5, followRange: 3, AI: "hunt",
		spells: ["IceSlowPrepare"], spellCooldownMult: 1, spellCooldownMod: 1, followLeashedOnly: true, noSpellLeashing: true, spellRdy: true, projectileTargeting: true,
		visionRadius: 7, maxhp: 8, minLevel:3, weight:-2, movePoints: 1.5, attackPoints: 3, attack: "SpellMeleeWillBindLockAll", attackWidth: 1, attackRange: 1, power: 2, dmgType: "grope", fullBoundBonus: 2, multiBind: 2,
		terrainTags: {"secondhalf":1, "thirdhalf":1, "open": 1, "elementsAnger": 8, "elementsRage": 3, "temple": 6, "elemental": 6, "ice": 4}, allFloors: true, shrines: ["Elements"], attackLock: "Purple",
		RestraintFilter: {
			unlimitedRestraints: true,
		},
		maxblock: 2,
		maxdodge: 0,
		events: [
			{trigger: "afterEnemyTick", type: "createIce", power: 1, chance: 1.0, aoe: 1.0},
			{trigger: "getLights", type: "enemyTorch", power: 3.5, color: KDBaseCyan},
		],
		dropTable: [{name: "Gold", amountMin: 5, amountMax: 10, weight: 10}, {name: "IceRune", weight: 1}, {name: "IceBreaker", weight: 1, ignoreInInventory: true}]},
	{name: "ElementalWater", nameList: "elemental", outfit: "ElementalWater", style: "WaterElemental", faction: "Elemental", playLine: "Elemental", clusterWith: "ice", bound: "ElementalWater", color: "#57ff88", tags: KDMapInit(["opendoors", "flying", "antiMagic", "water", "elemental", "ranged", "fireresist", "soapimmune", "acidresist", "electricsevereweakness", "latexRestraints", "ropeRestraints", "elite", "leashing", "jail", "jailer", "hunter"]),
		armor: 0, kite: 1.5, followRange: 3, AI: "hunt", guardChance: 0.6, evasion: 0.25, summon: [{enemy: "ElementalIce", range: 2.5, count: 1, chance: 0.6, strict: true}],
		specialCD: 5, specialAttack: "PullWill", specialCDonAttack: true, specialAttackPoints: 4, specialRange: 4, specialWidth: 3, specialMinRange: 1.5, specialsfx: "Song", hitsfx: "Song", tilesMinRangeSpecial: 2,
		visionRadius: 7, maxhp: 12, minLevel:3, weight:-2, movePoints: 1.5, followLeashedOnly: true, projectileTargeting: true,
		attackPoints: 3, attack: "MeleeBindLockAll", attackWidth: 3, attackRange: 1, power: 5, dmgType: "charm", pullTowardSelf: true, pullDist: 2, pullMsg: true,
		attackLock: "Purple",
		stamina: 5,
		maxblock: 0,
		maxdodge: 2,
		RestraintFilter: {
			bonusRestraints: 1,
			requiredItems: ["LatexArmbinder", "LatexStraitjacket", "LatexBoxbinder"],
		},
		terrainTags: {"secondhalf":1, "thirdhalf":1, "open": 1, "elementsAnger": 8, "elementsRage": 3, "illusionAnger": 2, "latexAnger": 2, "temple": 5, "elemental": 4, "water": 4}, allFloors: true, shrines: ["Elements"],
		events: [{trigger: "afterEnemyTick", type: "createWater", power: 2, chance: 1.0, aoe: 0.5}],
		dropTable: [{name: "Gold", amountMin: 15, amountMax: 20, weight: 10}, {name: "WaterRune", weight: 2}]},
	{name: "ElementalEarth", nameList: "elemental", outfit: "ElementalEarth", style: "EarthElemental", faction: "Elemental", playLine: "Elemental", clusterWith: "elemental", bound: "ElementalEarth", color: "#C1703A",
		tags: KDMapInit(["opendoors", "flying", "imprisonable", "elemental", "fireresist", "melee", "nofreeze", "earth", "miniboss", "electricimmune", "guardCall", "unflinching", "iceweakness", "unarmedresist", "slashresist", "pierceresist", "obsidianRestraints",
			"shackleRestraints", "steelCuffs", "leashing", "magicresist", "jail", "jailer", "hunter"]),
		armor: 2.0, followRange: 1, AI: "hunt",
		earthmove: true,
		blindSight: 2.5,
		specialCD: 15, specialAttack: "Dash", specialRemove: "BindWill", specialCDonAttack: true, specialAttackPoints: 1, specialRange: 4, specialMinRange: 1.5, specialsfx: "Miss", castWhileMoving: true, dashThruWalls: true,
		spells: ["ArmorUp", "Earthfield",], spellCooldownMult: 1, spellCooldownMod: 14, followLeashedOnly: true, spellRdy: true,
		attackLock: "White",
		stamina: 4,
		maxblock: 2,
		maxdodge: 0,
		RestraintFilter: {
			bonusRestraints: 2,
			requiredItems: ["LatexArmbinder", "LatexStraitjacket", "LatexBoxbinder"],
		},
		visionRadius: 7, maxhp: 16, minLevel:4, weight:-2, movePoints: 2, attackPoints: 3, attack: "SpellMeleeBindLockWill", attackWidth: 3, attackRange: 1, power: 2, dmgType: "plush", fullBoundBonus: 2,
		terrainTags: {"secondhalf":1, "thirdhalf":2, "elementsAnger": 12, "elementsRage": 6, "temple": 6, "elemental": 4, "earth": 4}, allFloors: true, shrines: ["Elements", "Metal"],
		dropTable: [{name: "Gold", amountMin: 15, amountMax: 20, weight: 10}, {name: "EarthRune", weight: 3}],
		events: [{trigger: "afterEnemyTick", type: "createEffectTile", kind: "Cracked", time: 10, power: 2, chance: 0.3, aoe: 0.5}],
	},
	{name: "KeeperEarth", nameList: "elemental", outfit: "KeeperEarth", style: "EarthElemental", faction: "Elemental", playLine: "Elemental", clusterWith: "elemental", bound: "ElementalEarth", color: "#C1703A",
		tags: KDMapInit(["opendoors", "flying", "imprisonable", "elemental", "fireresist", "melee", "nofreeze", "earth", "elite", "electricimmune", "guardCall", "unflinching", "iceweakness", "unarmedresist", "slashresist", "pierceresist", "obsidianRestraints",
			"shackleRestraints", "steelRestraints", "leashing", "magicresist", "jail", "jailer", "hunter"]),
		armor: 2.0, followRange: 3.5, AI: "hunt",
		earthmove: true,
		blindSight: 2.5,
		effect: {
			effect: {name: "PushAway", damage: "crush", power: 1, dist: 2, msg: "KDKeeperKick"},
		},
		castWhileMoving: true, dontKiteWhenDisabled: true,
		specialCD: 15, specialAttack: "SlowEffect", specialRemove: "Bind", specialCDonAttack: true, specialWidth: 3, specialAttackPoints: 2, specialsfx: "HeavySwing",
		spells: ["WitchBoulder", "GravityPullEarth", "EnemyCM1"], unlockCommandLevel: 1, unlockCommandCD: 30, specialDamage: "crush", spellCooldownMult: 1, spellCooldownMod: 0, followLeashedOnly: true,
		attackLock: "White",
		stamina: 4,
		maxblock: 2,
		maxdodge: 0,
		RestraintFilter: {
			bonusRestraints: 2,
			requiredItems: ["LatexArmbinder", "LatexStraitjacket", "LatexBoxbinder"],
		},
		visionRadius: 8, kite: 1.5, maxhp: 8, shield: 2, minLevel:5, weight:-1, movePoints: 2.4, attackPoints: 3, attack: "SpellMeleeBindLockWill", attackWidth: 1.5, attackRange: 1, power: 2, dmgType: "plush", fullBoundBonus: 2,
		terrainTags: {"secondhalf":4, "thirdhalf":2, "elementsAnger": 8, "elementsRage": 9, "temple": 5, "elemental": 2, "earth": 3}, allFloors: true, shrines: ["Elements", "Metal"],
		dropTable: [{name: "Gold", amountMin: 15, amountMax: 20, weight: 10}, {name: "EarthRune", weight: 5}],
		events: [{trigger: "afterEnemyTick", type: "createEffectTile", kind: "Cracked", time: 10, power: 2, chance: 0.3, aoe: 0.5}],
	},
	{name: "ElementalAir", nameList: "elemental", outfit: "ElementalAir", style: "AirElemental", faction: "Elemental", playLine: "Elemental", clusterWith: "electric", bound: "ElementalAir", color: "#88aaff", tags: KDMapInit(["opendoors", "flying", "air", "electric", "nofreeze", "elemental", "melee", "elite", "fireweakness", "electricresist", "coldweakness", "latexRestraints", "ropeRestraints", "leashing", "jail", "jailer", "hunter"]),
		armor: -1, followRange: 1, AI: "hunt", guardChance: 0.6, evasion: 0.5,
		specialCD: 5, specialAttack: "Dash", specialRemove: "Bind", specialCDonAttack: true, specialAttackPoints: 1, specialRange: 3, specialMinRange: 1.5, specialsfx: "Miss", castWhileMoving: true, dashThruWalls: true, dashThrough: true,
		spells: ["AreaElectrify"], spellCooldownMult: 1, spellCooldownMod: 3, followLeashedOnly: true, disarm: 1, noSpellLeashing: true, spellRdy: true, noChannel: true,
		attackLock: "White",
		RestraintFilter: {
			bonusRestraints: 2,
			requiredItems: ["ObsidianArmCuffs"],
		},
		maxblock: 0,
		maxdodge: 3,
		stamina: 10,
		visionRadius: 7, maxhp: 12, minLevel:7, weight:-2, movePoints: 1.25, attackPoints: 2, attack: "SpellMeleeBindLock", attackWidth: 1, attackRange: 1, power: 1, dmgType: "grope", fullBoundBonus: 3,
		terrainTags: {"secondhalf":1, "thirdhalf":2, "elementsAnger": 12, "elementsRage": 6, "temple": 5, "elemental": 4, "electric": 4, "air": 4}, allFloors: true, shrines: ["Elements", "Latex"],
		dropTable: [{name: "Gold", amountMin: 15, amountMax: 20, weight: 10}, {name: "StormBreaker", weight: 1, ignoreInInventory: true}]},

	{name: "Dryad", nameList: "elf", outfit: "Dryad", style: "Dryad", faction: "Elf", clusterWith: "nature", bound: "Dryad", playLine: "Dryad", color: "#67ff44", tags: KDMapInit(["opendoors", "nature", "elf", "leashing", "plant", "ranged", "vineRestraints", "slashweakness", "pierceweakness", "fireweakness", "search"]), cohesion: 0.0,
		followLeashedOnly: true, ignorechance: 0, armor: 0, followRange: 3, AI: "hunt",
		specialCD: 15, specialAttack: "Stun", specialRemove: "Bind", specialCDonAttack: true, specialAttackPoints: 2, specialRange: 4, specialWidth: 2, specialMinRange: 1.5, specialsfx: "Song", tilesMinRangeSpecial: 2, stunTime: 4,
		specialDamage: "charm", spellRdy: true,
		stamina: 3,
		maxdodge: 0,
		spells: ["PoisonDragonBlast", "EnemyCM1"], unlockCommandLevel: 1, unlockCommandCD: 90, spellCooldownMult: 1, spellCooldownMod: -2, tilesMinRange: 1, stopToCast: true, kite: 1.5,
		visionRadius: 6, maxhp: 10, minLevel:2, weight:-3, movePoints: 1.5, attackPoints: 3, attack: "SpellMeleeBind", attackWidth: 3, attackRange: 1, power: 2, dmgType: "tickle", fullBoundBonus: 2, 
		terrainTags: {"secondhalf":1, "thirdhalf":2, "willAnger": 11, "willRage": -6, "elf": 5, "nature": 4}, shrines: ["Will"], allFloors: true,
		dropTable: [{name: "Gold", amountMin: 10, amountMax: 20, weight: 12}, {name: "WaterRune", weight: 4}]},
	{name: "JungleDryad", nameList: "elf", outfit: "Dryad", style: "Dryad", faction: "Enemy", clusterWith: "nature", bound: "JungleDryad", playLine: "Dryad", color: "#67ff44", tags: KDMapInit(["opendoors", "nature", "elf", "leashing", "plant", "ranged", "vineRestraints", "slashweakness", "pierceweakness", "fireweakness", "search"]), cohesion: 0.0,
		followLeashedOnly: true, ignorechance: 0, armor: 0, followRange: 3, AI: "hunt",
		spellRdy: true,
		stamina: 3,
		maxdodge: 0,
		spells: ["PoisonDragonBlast", "EnemyCM1"], unlockCommandLevel: 1, unlockCommandCD: 90, spellCooldownMult: 1, spellCooldownMod: -2, tilesMinRange: 1, stopToCast: true, kite: 1.5,
		visionRadius: 6, maxhp: 10, minLevel:7, weight:5, movePoints: 1, attackPoints: 3, attack: "SpellMeleeBind", attackWidth: 3, attackRange: 1, power: 2, dmgType: "tickle", fullBoundBonus: 2, 
		terrainTags: {"secondhalf":3, "thirdhalf":4}, shrines: ["Will"], floors:KDMapInit(["jngWild"]), noOverrideFloor: true,
		dropTable: [{name: "Gold", amountMin: 10, amountMax: 20, weight: 12}, {name: "WaterRune", weight: 4}]},

	{name: "ElfRanger", nameList: "elf", outfit: "Elven", style: "Elf", faction: "Elf", clusterWith: "nature", bound: "ElfRanger", playLine: "Elf", color: "#67ff44",
		tags: KDMapInit(["opendoors", "guardCall", "leashing", "elf", "imprisonable", "ranged", "elite", "mithrilRope", "pierceweakness", "iceweakness", "chainresist", "jail", "jailer", "hunter"]), cohesion: 0.0,
		followLeashedOnly: true, ignorechance: 0, armor: 0.5, followRange: 3, AI: "hunt",  stealth: 3, focusPlayer: true,
		spellResist: 1.0,
		stamina: 5,
		maxblock: 0,
		maxdodge: 3,
		spells: ["ElfArrow"], miscastmsg: "KDBanditMiscast", miscastsfx: "Miss", spellCooldownMult: 1, spellCooldownMod: 0, stopToCast: true, castWhileMoving: true, kite: 1.5, projectileAttack: true,
		visionRadius: 9, maxhp: 13, minLevel:3, weight:-0.5, movePoints: 1, attackPoints: 3, attack: "SpellMeleeBindLock", attackWidth: 3, attackRange: 1, tilesMinRange: 1, power: 2, dmgType: "grope", fullBoundBonus: 2,
		attackLock: "White",
		terrainTags: {"secondhalf":1, "thirdhalf":1, "willAnger": 5, "willRage": 8, "temple": 5, "nature": 1.5, "elf": 12}, shrines: ["Will"], allFloors: true,
		dropTable: [{name: "Gold", amountMin: 10, amountMax: 20, weight: 12}, {name: "BowRecurve", ignoreInInventory: true, weight: 100}, {name: "ElfCrystal", weight: 3}]},
	{name: "Elf", nameList: "elf", outfit: "Elven2", style: "Elf", faction: "Elf", clusterWith: "elf", bound: "Elf", playLine: "Elf", color: "#67ff44",
		tags: KDMapInit(["opendoors", "antiMagic", "guardCall", "religious", "jailer", "leashing", "elf", "imprisonable", "ranged", "elite", "mithrilRestraints", "pierceweakness", "iceweakness", "chainresist", "jail", "jailer", "hunter"]), cohesion: 0.7,
		followLeashedOnly: true, ignorechance: 0, armor: 0, followRange: 3, AI: "hunt", guardChance: 0.6, buffallies: true, spellRdy: true,
		spellResist: 2.0,
		stamina: 2,
		maxdodge: 1,
		maxblock: 0,
		spells: ["Entangle", "OrbHeal", "EnemyCM1"], unlockCommandLevel: 1, unlockCommandCD: 16, spellCooldownMult: 1, spellCooldownMod: 0, stopToCast: true, castWhileMoving: true, kite: 1.5,
		visionRadius: 9, maxhp: 16, minLevel:7, weight:-3, movePoints: 2, attackPoints: 3, attack: "SpellMeleeBindLock", attackWidth: 3, attackRange: 1, tilesMinRange: 1, power: 2, dmgType: "grope", fullBoundBonus: 1,
		attackLock: "Purple",
		terrainTags: {"secondhalf":1, "thirdhalf":1, "willAnger": 4, "willRage": 6, "nature": 3, "temple": 5, "elf": 8}, shrines: ["Will"], allFloors: true,
		dropTable: [{name: "Gold", amountMin: 10, amountMax: 20, weight: 9}, {name: "ElfCrystal", weight: 4}],
		ondeath: [
			{type: "summon", enemy: "Bramble", range: 0.5, count: 1, strict: true, faction: "Plant"}
		],
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 4, color: KDBaseWhite}
		],
	},

	{name: "OrbOfLight", clusterWith: "nature", color: "#e7cf1a", tags: KDMapInit(["opendoors", "ignorenoSP", "nosignal", "nature", "ghost", "ranged", "soulimmune", "unstoppable", "coldsevereweakness", "flying"]), cohesion: 1.0, cohesionRange: 10,
		followLeashedOnly: true, ignorechance: 0, armor: 0, followRange: 3, AI: "hunt",  buffallies: true, spellRdy: true, sneakthreshold: 0.95,
		spellResist: 2.0,
		evasion: -0.5,
		maxdodge: 0,
		maxblock: 0,
		nonDirectional: true,
		spells: ["OrbHeal"], spellCooldownMult: 1, spellCooldownMod: 0, tilesMinRange: 1, stopToCast: true, kite: 1.5, kiteChance: 0.9,
		visionRadius: 10, blindSight: 10, maxhp: 10, minLevel:3, weight:1.5, movePoints: 3, attackPoints: 4, attack: "SpellMeleeBlindWill", blindTime: 3, attackWidth: 8, attackRange: 1, power: 6, dmgType: "fire",
		terrainTags: {"willAnger":4, "willRage":4, "magical": 4, "elf": 6}, shrines: ["Will"], allFloors: true, dropTable: [{name: "Ectoplasm", weight: 9}, {name: "ElfCrystal", weight: 3}],
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 3, color: "#ffff44"}
		],
	},

	{name: "Monolith", clusterWith: "chaos", color: KDBaseRed,
		tags: KDMapInit(["opendoors", "ignoreharmless", "construct", "nosignal", "poisonimmune", "soulimmune", "temple", "minor", "chaos", "ranged", "slashimmune", "unarmedresist", "pierceimmune", "fireresist", "unstoppable", "tickleresist", "groperesist", "electricresist", "flying"]),
		cohesion: 0, cohesionRange: 10, difficulty: 0.3,
		evasion: -2.0,
		nonDirectional: true,
		followLeashedOnly: true, ignorechance: 0, armor: 1.5, spellResist: 0.5, followRange: 2.5, AI: "guard", buffallies: true, spellRdy: false, sneakthreshold: 0.95,
		spells: ["MonolithBeam"], spellCooldownMult: 1, spellCooldownMod: 0, stopToCast: true, kite: 1.5, kiteChance: 0.9,
		visionRadius: 5, blindSight: 5, maxhp: 7, minLevel:10, weight:4, movePoints: 4, attackPoints: 4, attack: "Spell", attackWidth: 8, attackRange: 1, power: 3, dmgType: "fire",
		terrainTags: {"open": 25, "temple": 6}, shrines: [], floors:KDMapInit(["tmp", "tmb", "cry"]), dropTable: [{name: "EarthRune", weight: 7}, {name: "ElfCrystal", weight: 3}],
	},

	{name: "Pixie", nameList: "elf", clusterWith: "nature", tags: KDMapInit(["ignorenoSP", "fairy", "soulresist", "chaos", "melee", "minor", "magicweakness", "flying"]), followRange: 1, AI: "hunt",  squeeze: true, ethereal: true, cohesion: 1.0,
		summon: [
			{enemy: "Pixie", range: 3, count: 2, chance: 0.2, strict: true},],
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 3.5, color: KDBaseWhite}
		],
		difficulty: 0.2,
		spells: ["EnemyFlash"],  spellCooldownMult: 1, spellCooldownMod: 14, castWhileMoving: true,
		visionRadius: 6, blindSight: 4, maxhp: 1, evasion: 1.0, minLevel:0, weight:0.1, movePoints: 1.25, attackPoints: 2, attack: "MeleeWillSpell", attackWidth: 1, attackRange: 1, power: 2, dmgType: "charm",
		terrainTags: {"willAnger": 2, "willRage": 3, "elf": 0.4}, shrines: ["Will"], allFloors: true},

	{name: "ChaoticCrystal", faction: "Natural", clusterWith: "chaos", color: "#ff00aa", immobile: true, hitsfx: "Evil", tags: KDMapInit(["crystal", "chaos", "minor", "inactive", "melee", "crushweakness", "soulimmune"]),
		evasion: -9, ignorechance: 1.0, armor: 1, followRange: 1, AI: "wander", sneakthreshold: 0.6,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 2, color: "#ff44aa"},
			{trigger: "afterEnemyTick", type: "breakDownForDragonQueen", power: 4, dist: 1.5},
		],
		nopickpocket: true,
		nonDirectional: true,
		visionRadius: 1.5, blindSight: 1.5, maxhp: 8, minLevel:0, weight:0, movePoints: 99999, attackPoints: 1, attack: "MeleeWill", attackWidth: 8, attackRange: 1, power: 1, dmgType: "drain",
		terrainTags: {"passage": -999, "door": -99, "crystalline": 45}, floors:KDMapInit(["cry"]), shrines: []},
	{name: "ChaoticCrystalActive", faction: "Natural", clusterWith: "chaos", immobile: true, color: "#ff00aa", hitsfx: "Evil", tags: KDMapInit(["crystal", "active", "chaos", "melee", "crushweakness", "crystalRestraints", "soulimmune"]),
		evasion: -9, ignorechance: 1.0, armor: 1, followRange: 1, AI: "wander", sneakthreshold: 0.6,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 4.5, color: "#ff44aa"}
		],
		nopickpocket: true,
		nonDirectional: true,
		visionRadius: 5, blindSight: 5, maxhp: 16, minLevel:0, weight:0, movePoints: 99999, attackPoints: 4, attack: "MeleeWillBind", attackWidth: 8, attackRange: 2, power: 2, dmgType: "drain", fullBoundBonus: 2,
		terrainTags: {"passage": -999, "door": -99, "crystalline": 5, "open": 45}, floors:KDMapInit(["cry"]), shrines: []},

	{name: "Statue", faction: "Natural",
		tags: KDMapInit(["mimicBlock", "statue", "minor", "melee",
			"unflinching", "crushweakness", "harmless", "pierceweakness", "chainresist", "soulimmune"]),
		immobile: true, spellResist: 0.33, sneakthreshold: 0.6,
		evasion: -9, ignorechance: 1.0, armor: 2, followRange: 1, AI: "ambush", ambushRadius: 0, difficulty: 0.05,
		GFX: {
			lighting: true,
		},
		Sound: {
			baseAmount: 0,
		},
		nonDirectional: true,
		nopickpocket: true,
		visionRadius: 0, maxhp: 8, minLevel:0, weight:140, movePoints: 99999, attackPoints: 4, attack: "", attackWidth: 8, attackRange: 3, power: 4, dmgType: "souldrain",
		terrainTags: {"passage": -999, "temple": 82, "open": 10}, floors:KDMapInit(["tmp"]), shrines: []},
	{name: "StatueGag",
		tags: KDMapInit(["ignoregagged", "mimicBlock", "statue", "minor", "melee",
			"unflinching", "ballGagRestraintsMagic", "crushweakness", "pierceweakness", "chainresist", "soulimmune"]),
		spellResist: 0.33, sneakthreshold: 0.6,
		evasion: -9, ignorechance: 1.0, armor: 2, followRange: 1, AI: "ambush", ambushRadius: 1.5, difficulty: 0.05,
		RestraintFilter: {
			unlimitedRestraints: true,
		},
		nonDirectional: true,
		GFX: {
			lighting: true,
		},
		Sound: {
			baseAmount: 0,
		},
		nopickpocket: true,
		noOverrideFloor: true,
		visionRadius: 8, maxhp: 12, minLevel:0, weight:80, movePoints: 2, attackPoints: 2, attack: "MeleeBindWill", attackWidth: 1, attackRange: 1, power: 4, dmgType: "grope",
		terrainTags: {"passage": -999, "temple": 72, "open": 20}, floors:KDMapInit(["tmp"]), shrines: []},
	{name: "StatueDart",
		tags: KDMapInit(["mimicBlock", "statue", "minor", "melee", "unflinching", "crushweakness",
			"pierceweakness", "chainresist", "soulimmune"]),
		immobile: true, spellResist: 0.33, sneakthreshold: 0.3,
		spells: ["SleepDart"], spellCooldownMult: 1, spellCooldownMod: 30,
		stopToCast: true, castWhileMoving: true, projectileAttack: true,
		evasion: -9, ignorechance: 1.0, armor: 2, followRange: 1, AI: "ambush",
		ambushRadius: 2.1, difficulty: 0.1,
		nonDirectional: true,
		GFX: {
			lighting: true,
		},
		Sound: {
			baseAmount: 0,
		},
		nopickpocket: true,
		noOverrideFloor: true,
		visionRadius: 8, maxhp: 8, minLevel:5, weight:0, movePoints: 99999, attackPoints: 4, attack: "Spell", attackWidth: 8, attackRange: 3, power: 4, dmgType: "souldrain",
		terrainTags: {"passage": -999, "temple": 50, "open": 90, increasingWeight: 5}, floors:KDMapInit(["tmp"]), shrines: []},

	// region ancientworship
	{name: "CuffedGirl", clusterWith: "chaos", bound: "CuffedGirl", playLine: "Gagged", color: "#9564b8",
		tags: KDMapInit([
			"minor", "leashing", "obsidianLeash", "obsidianCollar",
			"ignoretiedup", "elementsTrap", "chaos", "disarmresist", "blindimmune", "melee",
			"crystalRestraints", "crystalRestraintsHeavy",
			"soulresist", "crushweakness", "charmweakness",
			"submissive", "noshop", "gagged", "imprisonable", "rescuecrystal", "noarms",
		]),
		style: "Worshipper",
		outfit: "Worshipper",
		events: [
			{trigger: "tick", type: "secretToy"},
		],
		Sound: {
			baseAmount: 4,
			moveAmount: 5,
		},
		nopickpocket: true,
		maxblock: 0,
		maxdodge: 0,
		nonDirectional: true,
		ignorechance: 0, armor: 2, spellResist: 1, followRange: 1.5, AI: "hunt",  cohesion: 0.45, sneakThreshold: 1,
		evasion: -0.4,
		master: {type: "SoulCrystalActive", range: 4, loose: true, aggressive: true},
		visionRadius: 7.5, maxhp: 7, minLevel:0, weight:9, movePoints: 2.7,
		attackPoints: 3, attack: "MeleeBindLock", attackWidth: 2.5, attackRange: 1, power: 2,
		dmgType: "soul", fullBoundBonus: 2,
		ondeath: [{type: "spellOnSelf", spell: "SoulCrystalBind"}],
		terrainTags: {"elementsAnger": 3, "elementsRage": 3, temple: 13,
			"soul": 24, "chaos": 35, "elemental": 1,
			revenge: 10}, shrines: ["Elements"], floors:KDMapInit(["tmp", "ore", "DemonTransition"]),
	},
	{name: "CuffedGirl2", clusterWith: "chaos", bound: "CuffedGirl2",
		playLine: "Gagged", color: "#9564b8",
		tags: KDMapInit([
			"leashing", "obsidianLeash", "obsidianCollar",
			"ignoretiedup", "elementsTrap", "chaos", "disarmresist", "blindimmune", "melee",
			"crystalRestraints", "crystalRestraintsHeavy",
			"soulresist", "crushweakness", "charmweakness",
			"submissive", "noshop", "gagged", "imprisonable", "rescuecrystal", "noarms",
		]),
		style: "Worshipper",
		outfit: "Worshipper",
		events: [
			{trigger: "tick", type: "secretToy"},
		],
		spells: ["CrystalBoltSingle"],  spellCooldownMult: 1, spellCooldownMod: 3,
		Sound: {
			baseAmount: 4,
			moveAmount: 5,
		},
		nopickpocket: true,
		maxblock: 0,
		maxdodge: 0,
		nonDirectional: true,
		ignorechance: 0, armor: 1, spellResist: 2, followRange: 2.5, AI: "hunt",  cohesion: 0.45, sneakThreshold: 1,
		evasion: -0.4,
		kite: 1.5, noKiteWhenHarmless: true, projectileTargeting: true,
		master: {type: "SoulCrystalActive", range: 4, loose: true, aggressive: true},
		visionRadius: 8.5, maxhp: 14, minLevel:0, weight:4, movePoints: 2.4,
		attackPoints: 3, attack: "SpellMeleeBindLockAll", attackWidth: 1, attackRange: 1, power: 2,
		dmgType: "soul", fullBoundBonus: 2,
		ondeath: [{type: "spellOnSelf", spell: "SoulCrystalBind"}],
		terrainTags: {"elementsAnger": 3, "elementsRage": 3, temple: 7,
			"soul": 24, "chaos": 35, "elemental": 1,
			revenge: 5}, shrines: ["Elements"], floors:KDMapInit(["tmp", "ore", "DemonTransition"]),
	},
	{name: "CuffedGirl3", clusterWith: "chaos", bound: "CuffedGirl2",
		playLine: "Gagged", color: "#9564b8",
		tags: KDMapInit([
			"elite",
			"leashing", "obsidianLeash", "obsidianCollar",
			"ignoretiedup", "elementsTrap", "chaos", "disarmresist", "blindimmune", "melee",
			"crystalRestraints", "crystalRestraintsHeavy",
			"soulresist", "crushweakness", "charmweakness",
			"submissive", "noshop", "gagged", "imprisonable", "rescuecrystal", "noarms",
		]),
		style: "Worshipper",
		outfit: "Worshipper",
		events: [
			{trigger: "tick", type: "secretToy"},
		],
		spells: ["CrystalShockBolt", "CrystalBoltMany"],  spellCooldownMult: 1, spellCooldownMod: 3,
		Magic: {
			castCooldownUnique: {
				CrystalShockBolt: 24,
			},
			priority: {
				CrystalShockBolt: 10,
			},
		},
		Sound: {
			baseAmount: 4,
			moveAmount: 5,
		},
		nopickpocket: true,
		maxblock: 0,
		maxdodge: 0,
		nonDirectional: true,
		ignorechance: 0, armor: 0, spellResist: 3, followRange: 3.5, AI: "hunt",  cohesion: 0.45, sneakThreshold: 1,
		evasion: -0.4,
		kite: 2.5, noKiteWhenHarmless: true, projectileTargeting: true,
		master: {type: "SoulCrystalActive", range: 4, loose: true, aggressive: true},
		visionRadius: 9.5, maxhp: 21, minLevel:0, weight:3, movePoints: 3.0,
		attackPoints: 3, attack: "SpellMeleeBindLockAll", attackWidth: 3, attackRange: 1, power: 2,
		dmgType: "soul", fullBoundBonus: 2,
		ondeath: [{type: "spellOnSelf", spell: "SoulCrystalBind"}],
		terrainTags: {"elementsAnger": 3, "elementsRage": 3, temple: 4,
			"soul": 17, "chaos": 20, "elemental": 1,
			revenge: 3}, shrines: ["Elements"], floors:KDMapInit(["tmp", "ore", "DemonTransition"]),
	},
	//endregion

	{name: "SoulCrystal", clusterWith: "chaos", color: "#880000", immobile: true, hitsfx: "Evil",
		tags: KDMapInit(["crystal", "soul", "minor", "unstoppable", "ranged",
			"crushweakness", "soulimmune", "flying"]), spellResist: 0.33, sneakthreshold: 0.6,
		evasion: -9, ignorechance: 1.0, armor: 1.5, followRange: 1, AI: "wander",
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 2, color: KDBaseRed}
		],
		Sound: {
			baseAmount: 4,
		},
		nopickpocket: true,
		nonDirectional: true,
		visionRadius: 100, maxhp: 20, minLevel:0, weight:-99, movePoints: 99999, attackPoints: 4, attack: "MeleeWill", attackWidth: 2.5, attackRange: 3, power: 4, dmgType: "souldrain",
		terrainTags: {"passage": -999, "temple": 20, "open": 125}, floors:KDMapInit(["tmp"]), shrines: ["Conjure"],
		dropTable: [{name: "AncientPowerSourceSpent", weight: 9}, {name: "AncientPowerSource", weight: 1}]},
	{name: "SoulCrystalActive", clusterWith: "chaos", color: "#880000", immobile: true, hitsfx: "Evil",
		tags: KDMapInit(["crystal", "soul", "active", "unstoppable", "minor", "ranged", "crushweakness", "soulimmune", "flying"]), spellResist: 0.33,
		evasion: -9, ignorechance: 1.0, armor: 1.5, followRange: 1, AI: "wander",
		difficulty: 0.5,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 5.5, color: KDBaseRed}
		],
		Sound: {
			baseAmount: 6,
		},
		nopickpocket: true,
		nonDirectional: true,
		spells: ["SoulCrystalBind"], spellCooldownMult: 1, spellCooldownMod: 0, followLeashedOnly: true, stopToCast: true, castWhileMoving: true, sneakthreshold: 0.6,
		visionRadius: 100, maxhp: 20, minLevel:0, weight:-99, movePoints: 99999, attackPoints: 4, attack: "SpellMeleeWill", attackWidth: 2.5, attackRange: 3, power: 4, dmgType: "souldrain",
		terrainTags: {"passage": -999, "temple": 10, "open": 115}, floors:KDMapInit(["tmp"]), shrines: ["Conjure"],
		dropTable: [{name: "AncientPowerSource", weight: 10}]},




	{name: "ShadowHand", faction: "Ghost", clusterWith: "ghost", color: "#880044", tags: KDMapInit(["opendoors", "shadow", "holyweakness", "shadowHandEnemy", "shadowTrap", "ghost", "soulimmune", "fireweakness", "melee", "shadowimmune", "glueimmune", "chainimmune", "shadowHands", "poisonimmune", "meleeresist", "flying"]),
		ignorechance: 0, armor: 0, followRange: 1, AI: "huntshadow", noAlert: true, hitsfx: "Evil", ignoreflag: ["ShadowHand"], failAttackflag: ["ShadowHand"], failAttackflagDuration: 2,
		visionRadius: 10, blindSight: 4, evasion: 0.4, maxhp: 6, minLevel: 0, weight:-5, movePoints: 1, attackPoints: 2, attack: "MeleeWillBind", attackWidth: 1, attackRange: 1, power: 1.0, dmgType: "grope", fullBoundBonus: 4,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 0, color: "#880044"},
			{trigger: "beforeDamage", type: "shadowEngulf", power: 0, color: "#880044"},
			{trigger: "afterEnemyTick", type: "shadowDebuff", power: -0.5},
		],
		Sound: {
			baseAmount: 0,
			moveAmount: 1.4,
			attackAmount: 3,
			decay: 1,
		},
		terrainTags: {"trap": 100, revenge: 10}, shrines: [], allFloors: true},

	{name: "ShadowGhast", faction: "Ghost", clusterWith: "ghost", color: "#880044", tags: KDMapInit(["opendoors", "shadow", "holyweakness", "shadowHandEnemy", "shadowTrap", "ghost", "soulimmune", "fireweakness", "melee", "shadowimmune", "glueimmune", "chainimmune", "shadowHands", "poisonimmune", "meleeresist", "flying"]),
		ignorechance: 0, armor: 0, followRange: 1, AI: "huntshadow", hitsfx: "Evil", ignoreflag: ["ShadowHand"], failAttackflag: ["ShadowHand"], failAttackflagDuration: 2,
		visionRadius: 10, blindSight: 5, evasion: 0.15, maxhp: 14, minLevel: 0, weight:-4, movePoints: 4, attackPoints: 3, attack: "SpellMeleeWillBindSlow", attackWidth: 1, attackRange: 3, power: 2.0, dmgType: "cold", fullBoundBonus: 2,
		projectileAttack: true,
		spells: ["SummonShadowHand"], spellCooldownMult: 2, spellCooldownMod: 0, castWhileMoving: true, followLeashedOnly: true,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 0, color: "#880044"},
			{trigger: "beforeDamage", type: "shadowEngulf", power: 0, color: "#880044"},
			{trigger: "afterEnemyTick", type: "shadowDebuff", power: -0.5},
		],
		Sound: {
			baseAmount: 0.5,
			moveAmount: 1.4,
			attackAmount: 3,
			decay: 1,
		},
		terrainTags: {"shadowcreature" : 20, "increasingWeight": 0.1, "trap": 10, revenge: 10, "goddessRage": 1}, shrines: [], allFloors: true,
		dropTable: [{name: "Ectoplasm", weight: 1}]},

	{name: "CorruptedAdventurer", nameList: "demon", outfit: "CorrAdv", style: "Fire", faction: "Ghost", clusterWith: "ghost", bound: "CorruptedAdventurer", playLine: "Elemental", color: "#880044",
		tags: KDMapInit(["shadowHandEnemy", "shadowclan", "shadow", "holyweakness", "shadowTrap", "ghost", "soulresist", "fireweakness", "melee", "shadowresist", "glueresist", "chainresist", "shadowHands", "opendoors"]),
		followRange: 1, ignoreflag: ["ShadowDommed"], failAttackflag: ["ShadowDommed"],
		spells: ["ShadowBolt"], spellCooldownMult: 1, spellCooldownMod: 0,
		AI: "huntshadow",  visionRadius: 10, maxhp: 20, minLevel: 3, weight:-1, movePoints: 4, disarm: 0.33,
		events: [
			{trigger: "afterEnemyTick", type: "shadowDebuff", power: -0.5},
			{trigger: "afterEnemyTick", type: "shadowDommeRefresh"},
			{trigger: "beforeDamage", type: "shadowDomme", power: 0, color: "#880044"},
		],
		attackPoints: 4, attack: "MeleeBindWillSpellLock", attackWidth: 3, attackRange: 1, tilesMinRange: 1, power: 3, dmgType: "cold", multiBind: 2,
		attackLock: "White",
		terrainTags: {"shadowcreature" : 9, revenge: 3, "increasingWeight": 0.1, "goddessRage": 3}, shrines: [], allFloors: true,
		dropTable: [{name: "Gold", amountMin: 15, amountMax: 20, weight: 10}, {name: "Ectoplasm", weight: 10}]
	},

	{name: "ChainBeing", nameList: "demon", outfit: "ChainBeing", style: "FireElemental", clusterWith: "elemental", bound: "ChainBeing", playLine: "Elemental", color: "#c7a9fa",
		tags: KDMapInit(["construct", "shadow", "holyweakness", "metalTrap", "soulresist", "fireweakness", "melee", "shadowresist", "glueresist", "chainimmune", "obsidianRestraints", "chainRestraintsMagic", "leashing"]),
		armor: 1.5, kite: 1.5, followRange: 3, AI: "hunt",
		spells: ["ObsidianBolt"], spellCooldownMult: 1, spellCooldownMod: 1, followLeashedOnly: true, stopToCast: true, spellRdy: true, projectileTargeting: true,
		visionRadius: 10, maxhp: 11, minLevel: 0, weight:-10, movePoints: 2,
		attackPoints: 4, attack: "MeleeBindLockAllSpell", attackWidth: 1, attackRange: 1, tilesMinRange: 1, power: 2, dmgType: "soul", fullBoundBonus: 2.5,
		attackLock: "White",
		stamina: 3,
		Sound: {
			baseAmount: 5,
			moveAmount: 6,
			attackAmount: 10,
		},
		terrainTags: {"shadowcreature" : 6, revenge: 6, "increasingWeight": 0.1, "metalAnger": 10, "metalPleased": 10, }, shrines: ["Metal"], allFloors: true,
		events: [
			{trigger: "afterEnemyTick", type: "createEffectTile", kind: "Chains", time: 12, power: 1, chance: 0.5, aoe: 0.5},
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Chains", aoe: 1.5, power: 1, chance: 1.0},
		],
		dropTable: [{name: "Gold", amountMin: 15, amountMax: 20, weight: 10}]
	},


	{name: "DemonEye", nameList: "cthulu", outfit: "Demon", style: "Demon", clusterWith: "demon", bound: "Demon", faction: "Observer", playLine: "Elemental", color: "#ff5577",
		tags: KDMapInit(["opendoors", "special", "chaos", "observer", "demon", "holyweakness", "obsAttract", "melee", "miniboss", "obsidianRestraints", "electricresist", "fireresist", "coldresist", "soulweakness", "charmweakness"]),
		armor: 2, spellResist: 2, followRange: 0, AI: "hunt", disarm: 0.33,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 4, color: KDBaseRed},
		],
		effect: {
			effect: {name: "TheShadowCurse", power: 4, count: 1},
		},
		spells: ["GravityPull", "ShadowGraspMulti"], spellCooldownMult: 1.4, spellCooldownMod: 0, followLeashedOnly: true, castWhileMoving: true, spellRdy: true, projectileTargeting: true,

		Magic: {
			castCooldownUnique: {
				ShadowGraspMulti: 12,
			},
			priority: {
				ShadowGraspMulti: 10,
			},
		},
		Sound: {
			baseAmount: 0,
			moveAmount: 2.5,
			attackAmount: 5,
		},
		nonDirectional: true,
		stamina: 4,
		visionRadius: 15, blindSight: 4, maxhp: 30, minLevel: 0, weight:-10, movePoints: 4, regen: 0.04, keys: true,
		attackPoints: 4, attack: "SpellMeleeBindLockAllWillEffect", attackWidth: 3, attackRange: 1, power: 5, dmgType: "cold",
		fullBoundBonus: 5, multiBind: 4,
		attackLock: "Purple",
		useLock: "Purple",
		terrainTags: {}, shrines: [], floors:KDMapInit([]),
		dropTable: [{name: "ManaOrb", weight: 10}]
	},
	{name: "Observer", faction: "Observer", color: "#ff5577", clusterWith: "demon", tags: KDMapInit(["chaos", "shadow", "holyweakness", "melee", "minor", "soulimmune", "meleeresist", "flying"]),
		squeeze: true, followRange: 1, AI: "hunt",  sneakThreshold: 1, hitsfx: "", ethereal: true,
		spells: ["ObserverBeam"], spellCooldownMult: 1, spellCooldownMod: 1, evasion: 0.4, sneakthreshold: 3.5,
		events: [
			{trigger: "enemyCast", type: "RandomRespawn"},
		],
		Sound: {
			baseAmount: 0,
			moveAmount: 1,
		},
		nopickpocket: true,
		nonDirectional: true,
		visionRadius: 4.5, maxhp: 3, minLevel: 0, weight:-100, movePoints: 3, attackPoints: 3,
		attack: "Spell", suicideOnSpell: true, attackWidth: 1, attackRange: 1, power: 1, dmgType: "soul",
		terrainTags: {}, floors:KDMapInit([]), shrines: []},

	{name: "DemonStar", nameList: "aztec", outfit: "Demon", style: "Demon", clusterWith: "demon", bound: "Demon", playLine: "Elemental", color: "#9ea7de",
		tags: KDMapInit(["opendoors", "order", "leashing", "demon", "holyweakness", "melee", "miniboss", "mithrilRestraints", "electricresist", "fireresist", "coldresist", "soulweakness", "charmweakness", "jail", "jailer", "hunter"]),
		armor: 1.5, followRange: 0, AI: "hunt",
		spells: ["BoundByFate"], spellCooldownMult: 1, spellCooldownMod: 0, followLeashedOnly: true, stopToCast: true, spellRdy: true, projectileTargeting: true,
		visionRadius: 10, maxhp: 16, minLevel: 0, weight:-10, movePoints: 4,
		attackPoints: 3, attack: "MeleeBindLockSpell", attackWidth: 1, attackRange: 1, tilesMinRange: 1, power: 4, dmgType: "cold", fullBoundBonus: 2,
		attackLock: "Purple",multiBind: 3,
		stamina: 5,
		Sound: {
			baseAmount: 0,
			moveAmount: 2.5,
			attackAmount: 5,
		},
		terrainTags: {"demon" : 15, "increasingWeight": 0.1, "goddessRage": 10, "goddessPleased": 10, }, shrines: [], allFloors: true,
		dropTable: [{name: "Gold", amountMin: 25, amountMax: 35, weight: 10}]
	},

	{name: "DemonMoon", nameList: "space", outfit: "Demon", style: "Demon", clusterWith: "demon", bound: "Demon", playLine: "Elemental", color: "#9ea7de",
		tags: KDMapInit(["opendoors", "order", "leashing", "demon", "holyweakness", "melee", "miniboss", "mithrilRestraints", "electricresist", "fireresist", "coldresist", "soulweakness", "charmweakness", "jail", "jailer", "hunter"]),
		armor: 1.5, followRange: 0, AI: "hunt",
		spells: ["CrushingFate"], spellCooldownMult: 1, spellCooldownMod: 0, followLeashedOnly: true, stopToCast: true, spellRdy: true, projectileTargeting: true,
		visionRadius: 10, maxhp: 16, minLevel: 0, weight:-10, movePoints: 4,
		attackPoints: 3, attack: "MeleeBindLockSpell", attackWidth: 1, attackRange: 1, tilesMinRange: 1, power: 4, dmgType: "cold", fullBoundBonus: 2,
		attackLock: "Purple", multiBind: 3,
		stamina: 5,
		Sound: {
			baseAmount: 0,
			moveAmount: 2.5,
			attackAmount: 5,
		},
		terrainTags: {"demon" : 15, "increasingWeight": 0.1, "goddessRage": 10, "goddessPleased": 10, }, shrines: [], allFloors: true,
		dropTable: [{name: "Gold", amountMin: 25, amountMax: 35, weight: 10}]
	},
	{name: "DemonVoid", nameList: "science", outfit: "Demon", style: "Demon", clusterWith: "demon", bound: "Demon", playLine: "Elemental", color: "#9ea7de",
		tags: KDMapInit(["opendoors", "order", "leashing", "demon", "holyweakness", "melee", "miniboss", "obsidianRestraints", "electricresist", "fireresist", "coldresist", "soulweakness", "charmweakness", "jail", "jailer", "hunter"]),
		armor: 1.5, followRange: 0, AI: "hunt",
		spells: ["GravityPull"], spellCooldownMult: 1, spellCooldownMod: 0, followLeashedOnly: true, castWhileMoving: true, spellRdy: true, projectileTargeting: true,
		visionRadius: 10, maxhp: 18, minLevel: 0, weight:-10, movePoints: 2.5,
		attackPoints: 2, attack: "MeleeBindLockSpell", attackWidth: 1.5, attackRange: 1, tilesMinRange: 1, power: 2, dmgType: "cold", fullBoundBonus: 2,
		attackLock: "Purple", multiBind: 2,
		Sound: {
			baseAmount: 0,
			moveAmount: 2.5,
			attackAmount: 5,
		},
		stamina: 9, sprintspeed: 1.7,
		terrainTags: {"demon" : 15, "increasingWeight": 0.1, "goddessRage": 10, "goddessPleased": 10, }, shrines: [], allFloors: true,
		dropTable: [{name: "Gold", amountMin: 25, amountMax: 35, weight: 10}]
	},

	{name: "Demon", nameList: "demon", outfit: "DemonHeavy", style: "Demon", clusterWith: "demon", bound: "Demon", playLine: "Elemental", color: "#9ea7de",
		tags: KDMapInit(["opendoors", "order", "leashing", "demon", "holyweakness", "relentless", "melee", "obsidianRestraints", "electricresist", "fireresist", "coldresist", "soulweakness", "charmweakness", "jail", "jailer", "hunter"]),
		armor: 3, followRange: 0, AI: "hunt",
		stunTime: 2, specialCD: 8, specialAttack: "Stun", specialRemove: "BindLock", specialPower: 4, specialDamage: "crush", specialWidth: 3, specialCDonAttack: true,
		visionRadius: 10, maxhp: 8, minLevel: 0, weight:-14, movePoints: 2,
		attackPoints: 2, attack: "MeleeBindLock", attackWidth: 1.5, attackRange: 1, tilesMinRange: 1, power: 1.5, dmgType: "cold", fullBoundBonus: 0.5,
		attackLock: "Purple",
		Sound: {
			baseAmount: 1,
			moveAmount: 3.5,
			attackAmount: 5,
		},
		stamina: 6, sprintspeed: 2,
		terrainTags: {"demon" : 27, "increasingWeight": 0.15, "goddessRage": 14, "goddessPleased": 14, }, shrines: [], allFloors: true,
		dropTable: [{name: "Gold", amountMin: 10, amountMax: 15, weight: 10}]
	},

	{name: "Gag", faction: "KinkyConstruct", clusterWith: "construct",
		tags: KDMapInit(["leatherTrap", "ropeTrap", "ignoregagged", "construct", "nosignal", "poisonresist", "soulimmune", "melee", "ballGagRestraints", "gagSpell", "minor", "chainresist", "doortrap", "flying"]),
		ignorechance: 0.75, followRange: 1, AI: "hunt",  ignoreflag: ["FA_Gag"], failAttackflag: ["FA_Gag"], squeeze: true, ignoreStaminaForBinds: true,
		Attack: {
			mustBindorFail: true,
		},
		Resistance: {
			profile: ["construct"],
		},
		RestraintFilter: {
			unlimitedRestraints: true,
			levelBonus: 4,
		},
		nopickpocket: true,
		specialCD: 8, specialAttack: "DashBonus", specialRemove: "BindSuicide", specialCDonAttack: true, specialAttackPoints: 1, specialRange: 4.99, specialMinRange: 1.5, dashThrough: true, specialsfx: "Miss",
		visionRadius: 5, visionSummoned: 12, maxhp: 4, minLevel: 0, weight:0, movePoints: 1, attackPoints: 2, attack: "MeleeBindSuicide", focusPlayer: true,
		suicideOnAdd: true, attackWidth: 1, attackRange: 1, power: 1, dmgType: "grope", fullBoundBonus: 1,
		terrainTags: {"trap": 50, revenge: 50, gag: -40}, allFloors: true, shrines: [], summonTags: ["gag"],
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Belts", aoe: 1.5, power: 1, chance: 1.0},
		],
	},
	{name: "AnimLegbinder", faction: "KinkyConstruct", clusterWith: "construct",
		tags: KDMapInit(["leatherTrap", "ignoreharmless", "construct", "nosignal", "poisonresist", "soulimmune", "melee", "legbinderSpell", "minor", "chainresist", "doortrap", "flying",
			"backup_harness", "harnessSpell",
		]),
		ignorechance: 0.75, followRange: 1, AI: "hunt",  ignoreflag: ["FA_Legb"], failAttackflag: ["FA_Legb"], squeeze: true, ignoreStaminaForBinds: true,
		Attack: {
			mustBindorFail: true,
		},
		Resistance: {
			profile: ["construct"],
		},
		RestraintFilter: {
			unlimitedRestraints: true,
			levelBonus: 4,
		},
		nopickpocket: true,
		visionRadius: 6, visionSummoned: 12, maxhp: 10, minLevel: 5, weight:0, movePoints: 2, attackPoints: 3, attack: "MeleeBindSuicide", focusPlayer: true,
		suicideOnAdd: true, attackWidth: 3, attackRange: 1, power: 3, dmgType: "grope", fullBoundBonus: 1,
		terrainTags: {"trap": 30, revenge: 30, legbinder: -25}, allFloors: true, shrines: [], summonTags: ["legbinder"],
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Belts", aoe: 1.5, power: 1, chance: 1.0},
		],
	},
	{name: "AnimArmbinder", faction: "KinkyConstruct", clusterWith: "construct",
		tags: KDMapInit(["leatherTrap", "ignoreharmless", "construct", "nosignal", "poisonresist", "soulimmune", "melee", "armbinderSpell", "minor", "chainresist", "doortrap", "flying",
			"backup_harness", "harnessSpell",
		]),
		ignorechance: 0.75, followRange: 1, AI: "hunt",  ignoreflag: ["FA_Armb"], failAttackflag: ["FA_Armb"], squeeze: true, ignoreStaminaForBinds: true,
		Attack: {
			mustBindorFail: true,
		},
		Resistance: {
			profile: ["construct"],
		},
		RestraintFilter: {
			unlimitedRestraints: true,
			levelBonus: 4,
		},
		nopickpocket: true,
		visionRadius: 6, visionSummoned: 12, maxhp: 8, minLevel: 3, weight:0, movePoints: 1.5, attackPoints: 3, attack: "MeleeBindSuicide", focusPlayer: true,
		suicideOnAdd: true, attackWidth: 3, attackRange: 1, power: 3, dmgType: "grope", fullBoundBonus: 1,
		terrainTags: {"trap": 30, revenge: 30, armbinder: -25}, allFloors: true, shrines: [], summonTags: ["armbinder"],
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Belts", aoe: 1.5, power: 1, chance: 1.0},
		],
	},
	{name: "AnimHarness", faction: "KinkyConstruct", clusterWith: "construct",
		tags: KDMapInit(["leatherTrap", "ignoreharmless", "construct", "nosignal", "poisonresist", "soulimmune", "melee", "harnessSpell", "binderharnessSpell", "minor", "chainresist", "doortrap", "flying"]),
		ignorechance: 0.75, followRange: 1, AI: "hunt",  ignoreflag: ["FA_Harness"], failAttackflag: ["FA_Harness"], squeeze: true, ignoreStaminaForBinds: true,
		Attack: {
			mustBindorFail: true,
		},
		Resistance: {
			profile: ["construct"],
		},
		RestraintFilter: {
			unlimitedRestraints: true,
			levelBonus: 4,
		},
		nopickpocket: true,
		visionRadius: 6, visionSummoned: 12, maxhp: 6, minLevel: 0, weight:0, movePoints: 1.5, attackPoints: 2, attack: "MeleeBindSuicide", focusPlayer: true,
		suicideOnAdd: true, attackWidth: 1, attackRange: 1, power: 2, dmgType: "crush", fullBoundBonus: 1,
		terrainTags: {"trap": 25, revenge: 25, harness: -20}, allFloors: true, shrines: [], summonTags: ["harness"],
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Belts", aoe: 1.5, power: 1, chance: 1.0},
		],
	},
	{name: "AnimBlindfold", faction: "KinkyConstruct", clusterWith: "construct",
		tags: KDMapInit(["leatherTrap", "ropeTrap", "ignoreharmless", "construct", "nosignal", "poisonresist", "soulimmune", "melee", "blindfoldSpell", "minor", "chainresist", "doortrap", "flying"]),
		ignorechance: 0.75, followRange: 1, AI: "hunt",  ignoreflag: ["FA_BF"], failAttackflag: ["FA_BF"], squeeze: true, ignoreStaminaForBinds: true,
		Attack: {
			mustBindorFail: true,
		},
		Resistance: {
			profile: ["construct"],
		},
		RestraintFilter: {
			unlimitedRestraints: true,
			levelBonus: 4,
		},
		nopickpocket: true,
		specialCD: 8, specialAttack: "DashBonus", specialRemove: "BindSuicide", specialCDonAttack: true, specialAttackPoints: 1, specialRange: 4.99, specialMinRange: 1.5, dashThrough: true, specialsfx: "Miss",
		visionRadius: 9, visionSummoned: 12, maxhp: 4, minLevel: 4, weight:0, movePoints: 1, attackPoints: 2, attack: "MeleeBindSuicide", focusPlayer: true,
		suicideOnAdd: true, attackWidth: 1, attackRange: 1, power: 2, dmgType: "grope", fullBoundBonus: 1,
		terrainTags: {"trap": 25, revenge: 25, blindfold: -20}, allFloors: true, shrines: [], summonTags: ["blindfold"],
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Belts", aoe: 1.5, power: 1, chance: 1.0},
		],
	},
	{name: "AnimStraitjacket", faction: "KinkyConstruct", clusterWith: "construct",
		tags: KDMapInit(["leatherTrap", "ignoreharmless", "construct", "nosignal", "poisonresist", "soulimmune", "melee", "jacketSpell", "minor", "chainresist", "doortrap", "flying",
			"backup_harness", "harnessSpell", "transportJacket"
		]),
		ignorechance: 0.75, followRange: 1, AI: "hunt",  ignoreflag: ["FA_Jacket"], failAttackflag: ["FA_Jacket"], squeeze: true, ignoreStaminaForBinds: true,
		Attack: {
			mustBindorFail: true,
		},
		Resistance: {
			profile: ["construct"],
		},
		RestraintFilter: {
			unlimitedRestraints: true,
			levelBonus: 4,
		},
		nopickpocket: true,
		visionRadius: 9, visionSummoned: 12, maxhp: 12, minLevel: 7, weight:0, movePoints: 1.5, attackPoints: 3, attack: "MeleeBindSuicide", focusPlayer: true,
		suicideOnAdd: true, attackWidth: 1, attackRange: 1, power: 2, dmgType: "grope", fullBoundBonus: 1,
		terrainTags: {"trap": 20, revenge: 20, "leatherRage": 5, jacket: -20}, allFloors: true, shrines: [], summonTags: ["jacket"],
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Belts", aoe: 1.5, power: 1, chance: 1.0},
		],
	},
	{
        name: "AnimPetsuit", faction: "KinkyConstruct", clusterWith: "construct",
		tags: KDMapInit(["leatherTrap", "ignoreharmless", "construct", "nosignal", "poisonresist", 
            "soulimmune", "melee", "petsuitSpell", "minor", "chainresist", "doortrap", "petsuit",
			"backup_harness", "harnessSpell"
		]),
		ignorechance: 0, followRange: 2, AI: "hunt",  ignoreflag: ["FA_Petsuit"], failAttackflag: ["FA_Petsuit"], squeeze: true, ignoreStaminaForBinds: true,
		Attack: {
			mustBindorFail: true,
		},
		Resistance: {
			profile: ["construct"],
		},
		RestraintFilter: {
			unlimitedRestraints: true,
			levelBonus: 5,
		},
		nopickpocket: true, specialCD: 8, specialAttack: "DashBonus", specialRemove: "BindSuicide", specialCDonAttack: true, specialAttackPoints: 2,
        specialWidth:1 ,specialRange: 5, specialMinRange: 1.5, dashThrough: true, specialsfx: "Miss",
		visionRadius: 6, visionSummoned: 12, maxhp: 12, minLevel: 10, weight:1, movePoints: 2.4, attackPoints: 3, attack: "MeleeBindSuicide", focusPlayer: true,
		suicideOnAdd: true, attackWidth: 3, attackRange: 1, power: 3, dmgType: "grope", fullBoundBonus: 2,
		terrainTags: {"trap": 35, revenge: 40, "petOptout": -15, "petPref": 4 }, allFloors: true, shrines: ["Leather"], summonTags: ["petsuit"],
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Belts", aoe: 1.5, power: 1, chance: 1.0},
		],
    },
	{name: "Cuffs", faction: "KinkyConstruct", clusterWith: "construct",
		tags: KDMapInit(["metalTrap", "doortrap", "ignoreharmless", "construct", "nosignal", "poisonimmune", "soulimmune", "melee", "cuffsSpell", "minor", "chainresist", "meleeresist", "glueweakness", "iceweakness", "flying"]), ignorechance: 0.75,
		armor: 1, followRange: 1, AI: "hunt",  ignoreflag: ["FA_Cuffs"], failAttackflag: ["FA_Cuffs"], squeeze: true, ignoreStaminaForBinds: true,
		Attack: {
			mustBindorFail: true,
		},
		Resistance: {
			profile: ["construct"],
		},
		RestraintFilter: {
			unlimitedRestraints: true,
			levelBonus: 4,
		},
		nopickpocket: true,
		specialCD: 8, specialAttack: "DashBonus", specialRemove: "BindSuicide", specialCDonAttack: true, specialAttackPoints: 1, specialRange: 4.99, specialMinRange: 1.5, dashThrough: true, specialsfx: "Miss",
		visionRadius: 5, visionSummoned: 12, maxhp: 2, minLevel: 0, weight:0, movePoints: 1, attackPoints: 2, attack: "MeleeBindSuicide", suicideOnAdd: true, attackWidth: 1, attackRange: 1, power: 1, dmgType: "charm", fullBoundBonus: 1,
		terrainTags: {"doortrap": 6, revenge: 50, "trap": 50, cuffs: -40}, allFloors: true, shrines: ["Metal"], summonTags: ["cuffs"],
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Chains", aoe: 1.5, power: 1, chance: 1.0},
		],
	},
	{name: "AnimChastity", arousalMode: true, faction: "KinkyConstruct", clusterWith: "construct",
		tags: KDMapInit(["metalTrap", "ignoreharmless", "doortrap", "construct", "nosignal", "poisonimmune", "soulimmune", "melee", 
			"chastitySpell", "chastitybraSpellBackup", "minor", "chainresist", "meleeresist", "glueweakness", "iceweakness", "flying"]), ignorechance: 0.75,
		armor: 2, followRange: 1, AI: "hunt",  ignoreflag: ["FA_Chastity"], failAttackflag: ["FA_Chastity"], squeeze: true, ignoreStaminaForBinds: true,
		Attack: {
			mustBindorFail: true,
		},
		Resistance: {
			profile: ["construct"],
		},
		RestraintFilter: {
			unlimitedRestraints: true,
			levelBonus: 4,
		},
		nopickpocket: true,
		visionRadius: 6, visionSummoned: 12, maxhp: 5, minLevel: 2, weight:0, movePoints: 1.5, attackPoints: 3, attack: "MeleeBindSuicide", suicideOnAdd: true, attackWidth: 3, attackRange: 1, power: 2, dmgType: "charm", fullBoundBonus: 1,
		terrainTags: {"doortrap": 6, revenge: 35, "trap": 35, chastity: -25}, allFloors: true, shrines: ["Metal"], summonTagsMulti: ["chastity"],
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Chains", aoe: 1.5, power: 1, chance: 1.0},
		],
	},
	{name: "AnimYoke", arousalMode: true, faction: "KinkyConstruct", clusterWith: "construct",
		tags: KDMapInit(["metalTrap", "ignoreharmless", "doortrap", "construct", "nosignal", "poisonimmune", "soulimmune", "melee", "spreaderSpell", "yokeSpell", "minor", "chainresist", "meleeresist", "glueweakness", "iceweakness", "flying"]), ignorechance: 0.75,
		armor: 2, followRange: 1, AI: "hunt",  ignoreflag: ["FA_Yoke"], failAttackflag: ["FA_Yoke"], squeeze: true, ignoreStaminaForBinds: true,
		Attack: {
			mustBindorFail: true,
		},
		Resistance: {
			profile: ["construct"],
		},
		RestraintFilter: {
			unlimitedRestraints: true,
			levelBonus: 4,
		},
		nopickpocket: true,
		visionRadius: 6, visionSummoned: 12, maxhp: 5, minLevel: 4, weight:0, movePoints: 1.5, attackPoints: 3, attack: "MeleeBindSuicide", suicideOnAdd: true, attackWidth: 3, attackRange: 1, power: 2, dmgType: "charm", fullBoundBonus: 1,
		terrainTags: {"doortrap": 6, revenge: 35, "trap": 35, yoke: -30}, allFloors: true, shrines: ["Metal"], summonTags: ["yoke"],
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Chains", aoe: 1.5, power: 1, chance: 1.0},
		],
	},
	{name: "Lock", faction: "KinkyConstruct", clusterWith: "construct", color: "#bbbbbb",
		tags: KDMapInit(["metalTrap", "leatherTrap", "ignorenoSP", "lock", "construct", "nosignal", "poisonimmune", "soulimmune", "melee", "minor", "chainresist", "meleeresist", "glueweakness", "iceweakness", "doortrap", "flying"]), difficulty: 0.2,
		ignorechance: 0.75, armor: 1, followRange: 1, AI: "hunt",  ignoreflag: ["FA_Lock"], failAttackflag: ["FA_Lock"], squeeze: true, suicideOnLock: true,
		Attack: {
			mustBindorFail: true,
		},
		Resistance: {
			profile: ["construct"],
		},
		nopickpocket: true,
		maxblock: 0,
		maxdodge: 0,
		nonDirectional: true,
		specialCD: 8, specialAttack: "MeleeDash", specialRemove: "SuicideMeleeBindLockWill", specialCDonAttack: true, specialAttackPoints: 1, specialRange: 4.99, specialMinRange: 1.5, dashThrough: false, specialsfx: "Miss",
		visionRadius: 5, visionSummoned: 12, maxhp: 4, minLevel: 0, weight:0, movePoints: 1, attackPoints: 3, attack: "SuicideMeleeBindLockWill", attackWidth: 3, tilesMinRange: 1, attackRange: 1, power: 1, dmgType: "grope", fullBoundBonus: 2,
		terrainTags: {"secondhalf":1, "lastthird":1, revenge: 60, "doortrap": 5, "trap": 40}, allFloors: true, shrines: ["Metal"],
		maxLevel: 3,
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Chains", aoe: 1.5, power: 1, chance: 1.0},
		],
	},
	{name: "LockMaster", faction: "KinkyConstruct", clusterWith: "construct", color: "#bbbbbb",
		tags: KDMapInit(["metalTrap", "leatherTrap",
			"lock", "construct", "nosignal", "poisonimmune", "soulimmune", "melee", "minor",
			"chainresist", "meleeresist", "glueweakness", "iceweakness", "doortrap", "flying"]),
		Resistance: {
			profile: ["construct"],
		},
		nopickpocket: true,
		maxblock: 0,
		maxdodge: 0,
		difficulty: 0.5,
		armor: 2, spellResist: 2, followRange: 2.5, AI: "hunt",
		squeeze: true,
		nonDirectional: true, kite: 1.5,
		spells: ["LockBullet"], castWhileMoving: true, projectileTargeting: true,
		spellCooldownMod: 0, spellCooldownMult: 1,
		visionRadius: 5.5, visionSummoned: 12, maxhp: 10, minLevel: 3, weight:0, movePoints: 2,
		stamina: 5,
		sprintspeed: 2.0,
		attackLock: "Purple",
		attackPoints: 3, attack: "SpellMeleeLockWill", attackWidth: 1, tilesMinRange: 1, attackRange: 1, power: 1, dmgType: "soul", fullBoundBonus: 2,
		terrainTags: {"secondhalf":2, "lastthird":2, "doortrap": 8, revenge: 50, "trap": 100}, allFloors: true, shrines: ["Metal"],
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Chains", aoe: 1.5, power: 1, chance: 1.0},
		],
	},


	{name: "MasterGear", faction: "KinkyConstruct", clusterWith: "construct",
		playLine: "KinkyConstruct",
		style: "Invisible",
		outfit: "Masterwork",
		bound: "MasterGear", color: KDBasePink,
		tags: KDMapInit(["opendoors", "nocapture", "masterworkTrap", "miniboss",
			"unflinching", "masterwork", "notalk",
			"construct", "nosignal", "poisonimmune", "soulimmune", "melee",
			"chainresist", "meleeresist", "glueweakness", "iceweakness"]),
		ignorechance: 0, followRange: 1, AI: "hunt",
		kite: 1.5, projectileAttack: true,
		spells: ["LeashBolt"], spellCooldownMult: 1, spellCooldownMod: 1,
		kiteChance: 0.2,
		noLeash: true,
		attackLock: "White",
		stamina: 5, sprintspeed: 2.0,
		Resistance: {
			profile: ["construct"],
		},
		effect: {
			effect: {name: "Masterwork", damage: "plush", power: 10},
		},
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Belts", aoe: 1.5, power: 1, chance: 1.0},
			{trigger: "addEntity", type: "MasterworkAssignHP"},
		],
		ondeath: [{type: "MasterGear"}],
		visionRadius: 7, blindSight: 4.5, maxhp: 50, minLevel:0, weight:-100,
		movePoints: 2.2, attackPoints: 2, attack: "SpellMeleeEffect",
		attackWidth: 1, attackRange: 1, power: 4, dmgType: "chain", fullBoundBonus: 1,
		terrainTags: {masterworkTrap: 200}, shrines: ["Leather"], allFloors: true,
		dropTable: [{name: "RedKey", amount: 1, weight: 10}]},


	{name: "Feathers", faction: "KinkyConstruct", clusterWith: "construct", tags: KDMapInit(["ignorenoSP", "construct", "nosignal", "poisonresist", "soulimmune", "melee", "chainRestraints", "minor", "firesevereweakness", "meleeresist", "doortrap", "flying"]), ignorechance: 0.75, armor: -1, followRange: 1, AI: "hunt",  ignoreflag: ["feathers"], failAttackflag: ["feathers"], squeeze: true,
		visionRadius: 5, visionSummoned: 12, maxhp: 3, minLevel: 0, weight:0.25, movePoints: 2, attackPoints: 2, attack: "MeleeWill",
		nonDirectional: true,
		Resistance: {
			profile: ["construct"],
		},
		nopickpocket: true,
		maxblock: 0,
		maxdodge: 0,
		attackWidth: 3, tilesMinRange: 1, attackRange: 1, power: 1, dmgType: "tickle", ondeath: [{type: "spellOnSelf", spell: "Feathers"}],
		terrainTags: {"secondhalf":2, "lastthird":-1, "increasingLevel": -0.25, revenge: 7, "doortrap": 8}, allFloors: true, shrines: [], difficulty: 0.7, },
	{name: "Scarves", faction: "KinkyConstruct", clusterWith: "construct", tags: KDMapInit(["ignoreharmless", "construct", "nosignal", "flying", "poisonresist", "soulimmune", "melee", "scarfRestraints", "minor", "firesevereweakness", "acidweakness", "soapweakness", "slashweakness", "meleeresist", "doortrap"]), ignorechance: 0.75, armor: 0, followRange: 1, AI: "hunt",  ignoreflag: ["scarves"], failAttackflag: ["scarves"], squeeze: true,
		visionRadius: 3, visionSummoned: 12, maxhp: 1, minLevel: 0, maxLevel: 3, weight:1, movePoints: 1.5, attackPoints: 2, attack: "MeleeBind", attackWidth: 1, attackRange: 1, power: 1, dmgType: "plush", fullBoundBonus: 1,
		Attack: {
			mustBindorFail: true,
		},
		Resistance: {
			profile: ["construct"],
		},
		nopickpocket: true,
		maxblock: 0,
		maxdodge: 1,
		stamina: 6,
		nonDirectional: true,
		terrainTags: {"secondhalf":-1, "lastthird":-2, "increasingLevel": -2, revenge: 12, "doortrap": 6, "ribbon": 3}, allFloors: true, shrines: [], difficulty: 0.4},
	{name: "Ribbons", faction: "KinkyConstruct", color: "#f135a4", clusterWith: "dressmaker", tags: KDMapInit(["ropeTrap", "ignoreharmless", "construct", "ribbon", "nosignal", "ribbon", "melee", "magicRibbons", "minor", "meleeresist", "doortrap", "flying"]), ignorechance: 0.75, armor: 0, followRange: 1, AI: "hunt",  ignoreflag: ["ribbons"], failAttackflag: ["ribbons"], squeeze: true,
		visionRadius:5, visionSummoned: 12, maxhp: 6, minLevel: 0, weight:0, movePoints: 1.25, attackPoints: 3, attack: "MeleeBind", attackWidth: 1, attackRange: 1, power: 1, dmgType: "chain", fullBoundBonus: 1,
		Resistance: {
			profile: ["rope", "construct"],
		},
		nopickpocket: true,
		maxblock: 0,
		maxdodge: 1,
		nonDirectional: true,
		Attack: {
			mustBindorFail: true,
		},
		terrainTags: { "dressmaker": 7, "conjureAnger": 4, "ribbon": 3, revenge: 4}, allFloors: true, shrines: ["Conjure", "Rope"], difficulty: 0.2, ondeath: [{type: "spellOnSelf", spell: "RibbonBurst"}]},
	{name: "RopeSnake", faction: "KinkyConstruct", clusterWith: "construct", color: "#ffae70", tags: KDMapInit(["ropeTrap", "ignoreharmless", "construct", "nosignal", "melee", "ropeRestraints", "minor", "doortrap"]), ignorechance: 0.75, followRange: 1, AI: "wander", squeeze: true,
		Resistance: {
			profile: ["rope", "construct"],
		},
		ignoreflag: ["ropesnake"], failAttackflag: ["ropesnake"],
		Attack: {
			mustBindorFail: true,
		},
		nopickpocket: true,
		maxblock: 0,
		maxdodge: 0,
		stamina: 6,
		visionRadius: 3, maxhp: 4, minLevel: 0, weight:3, movePoints: 1.5, attackPoints: 3, attack: "MeleeBindSuicideWill", suicideOnAdd: true, attackWidth: 1, attackRange: 1, power: 1, dmgType: "chain", fullBoundBonus: 1,
		terrainTags: {"increasingWeight":-3, revenge: 40, "trap": 40}, allFloors: true, shrines: ["Rope"],
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Ropes", aoe: 1.5, power: 1, chance: 1.0},
		],
		dropTable: [{name: "RopeSnakeRaw", amount: 1, weight: 10}],
	},
	{name: "UnforseenRope", faction: "KinkyConstruct", clusterWith: "construct", color: "#ffae70", tags: KDMapInit(["ignoreharmless", "construct", "nosignal", "melee", "ropeRestraints", "ropeRestraints2", "minor", "search"]), ignorechance: 0.75, followRange: 1, AI: "hunt",  stealth: 2.5, squeeze: true,
		ignoreflag: ["ropesnake"], failAttackflag: ["ropesnake"],
		Resistance: {
			profile: ["rope", "construct"],
		},
		nopickpocket: true,
		maxblock: 0,
		maxdodge: 0,
		stamina: 6,
		visionRadius: 10, blindSight: 8, maxhp: 4, minLevel: 0, weight:0, movePoints: 1, attackPoints: 2, attack: "MeleeBindSuicideWill", suicideOnAdd: true, attackWidth: 1, attackRange: 1, power: 1, dmgType: "chain", fullBoundBonus: 1,
		terrainTags: {"secondhalf":1, "lastthird":3, revenge: 20, "trap": 20}, allFloors: true, shrines: ["Rope"],
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Ropes", aoe: 1.5, power: 1, chance: 1.0},
			{trigger: "death", type: "RandomRespawn", chance: 0.33},
		],
		dropTable: [{name: "RopeSnakeRaw", amount: 1, weight: 10}],
	},
	{name: "LearnedRope", faction: "KinkyConstruct", clusterWith: "construct", color: "#ffae70", tags: KDMapInit(["ignoreharmless", "construct", "nosignal", "melee", "ropeRestraints", "ropeRestraints2", "search"]), ignorechance: 0.75, followRange: 1, AI: "hunt",  squeeze: true, disarm: 0.5,
		ignoreflag: ["ropesnake"], failAttackflag: ["ropesnake"],
		Attack: {
			mustBindorFail: true,
		},
		nopickpocket: true,
		maxblock: 0,
		maxdodge: 2,
		stamina: 6,
		Resistance: {
			profile: ["rope", "construct"],
		},
		specialCD: 8, specialAttack: "DashBonus", specialRemove: "BindSuicide", specialCDonAttack: true, specialAttackPoints: 1, specialRange: 4.99, specialMinRange: 1.5, dashThrough: true, specialsfx: "Miss",
		visionRadius: 5, maxhp: 8, minLevel: 2, weight:1, movePoints: 1, attackPoints: 3, attack: "MeleeBindSuicideWill", suicideOnAdd: true, attackWidth: 1, attackRange: 2.5, power: 2, multiBind: 2, dmgType: "chain", fullBoundBonus: 2,
		terrainTags: {"trap": 30, revenge: 30}, allFloors: true, shrines: ["Rope"],
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Ropes", aoe: 1.5, power: 1, chance: 1.0},
		],
		dropTable: [{name: "RopeSnakeRaw", amount: 1, weight: 10}],
	},
	{name: "MonsterRope", faction: "KinkyConstruct", clusterWith: "construct", color: "#ffae70",
		tags: KDMapInit(["ropeTrap", "ignoreharmless", "doortrap", "construct", "nosignal", "melee",
			"unstoppable", "ropeRestraintsHogtie", "ropeRestraints", "ropeRestraints2", "elite", "hunter"]),
		ignorechance: 0.75, followRange: 1, AI: "guard",
		armor: 2.0,
		ignoreflag: ["ropesnake"], failAttackflag: ["ropesnake"], disarm: 0.5, ignoreStaminaForBinds: true,
		Resistance: {
			profile: ["rope", "construct"],
		},
		effect: {
			effect: {name: "Hogtie", power: 4},
		},
		nopickpocket: true,
		maxblock: 0,
		maxdodge: 0,
		stamina: 2,
		visionRadius: 6, maxhp: 20, minLevel: 3, weight:0, movePoints: 3.5, attackPoints: 3,
		attack: "EffectMeleeBindSuicideWill", suicideOnAdd: true, attackWidth: 3, attackRange: 1,
		power: 8, multiBind: 10, dmgType: "chain", fullBoundBonus: 6,
		terrainTags: {"secondhalf":1, "lastthird":4, "increasingWeight":2, "trap": 20, revenge: 20}, allFloors: true, shrines: ["Rope"],
		ondeath: [
			{type: "summon", enemy: "RopeSnake", range: 2.5, count: 3, strict: true, lifetime: 30},
			{type: "summon", enemy: "LearnedRope", range: 2.5, count: 1, strict: true, lifetime: 30},
		],
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Ropes", aoe: 1.5, power: 1, chance: 1.0},
		],
		dropTable: [{name: "RopeSnakeRaw", amount: 8, weight: 10}],
	},

	{name: "ElementalRope", outfit: "Lingerie", style: "EarthElemental", faction: "Elemental", playLine: "Elemental", clusterWith: "elemental", bound: "ElementalRope", squeeze: true, color: "#ffae70",
		tags: KDMapInit(["opendoors", "elemental", "rope", "melee", "chainresist", "jail", "jailer", "unarmedresist", "ropeRestraints", "ropeRestraints2", "ballGagRestraints", "leashing", "search", "doortrap"]),
		armor: 0, followRange: 1, AI: "hunt",
		Resistance: {
			profile: ["rope"],
		},
		stamina: 6,
		RestraintFilter: {
			unlimitedRestraints: true,
		},
		maxblock: 2,
		maxdodge: 0,
		visionRadius: 6, maxhp: 14, minLevel:0, weight:-2, movePoints: 1.5, attackPoints: 3, attack: "MeleeBind", attackWidth: 3, attackRange: 1, tilesMinRange: 1, power: 2.5, dmgType: "chain", fullBoundBonus: 2.5,
		terrainTags: {"secondhalf":2, "thirdhalf":1, "ropeAnger": 4, "ropeRage": 4, "temple": 8, "doortrap": 4, revenge: 5, "elemental": 3, "witch": 5, "rope": 4}, allFloors: true, shrines: ["Rope", "Elements"],
		dropTable: [{name: "RopeSnakeRaw", amount: 5, weight: 10}, {name: "WeakMagicRopeRaw", amount: 3, weight: 10}, {name: "Knife", ignoreInInventory: true, weight: 3, noSummon: true}],
		events: [
			{trigger: "afterEnemyTick", type: "createEffectTile", kind: "Ropes", time: 15, power: 1, chance: 0.5, aoe: 0.5},
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Ropes", aoe: 1.5, power: 1, chance: 1.0},
		],
	},

	{name: "ElementalRubber", outfit: "ElementalRubber", style: "EarthElemental", faction: "Elemental", playLine: "Elemental", clusterWith: "Elemental", bound: "ElementalRubber", squeeze: true,
		tags: KDMapInit(["opendoors", "latexTrap", "latex", "elemental", "slashweakness", "melee", "glueimmune", "coldweakness", "jail", "jailer", "electricresist", "pierceweakness", "latexRestraints", "latexGag", "leashing", "search", "doortrap"]),
		armor: -0.5, followRange: 1, AI: "hunt", Resistance: {
			block_phys: 1.5,
			block_magic: 0,
		},
		color: "#73a0ef",
		spells: ["EnemySummonLatexArmbinder", "EnemySummonLatexLegbinder", "EnemySummonLatexGag", "EnemySummonLatexRestraint"], spellCooldownMult: 1, spellCooldownMod: 1, followLeashedOnly: true, stopToCast: true, spellRdy: false, projectileTargeting: true,
		stamina: 3,
		maxblock: 2,
		maxdodge: 0,
		useLock: "Rubber", attackLock: "Rubber",
		visionRadius: 7, maxhp: 10, minLevel:0, weight:-2, movePoints: 2, attackPoints: 3, attack: "SpellMeleeWillBindLockAll", attackWidth: 2.5, attackRange: 1, tilesMinRange: 1, power: 2, dmgType: "glue", fullBoundBonus: 3,
		terrainTags: {"secondhalf":2, "thirdhalf":1, "latexAnger": 4, "latexRage": 4, "latexPleased": 2, "latexFriendly": 3, "temple": 8, "doortrap":5, revenge: 5, "alchemist": 5, "latex": 5, "slime": 5}, allFloors: true, shrines: ["Latex", "Elements"],
		events: [
			{trigger: "afterEnemyTick", type: "createEffectTile", kind: "LatexThinBlue", time: 4, power: 1, chance: 0.5, aoe: 0.5},
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "LatexThinBlue", aoe: 1.5, power: 1, chance: 1.0},
		],
		dropTable: [{name: "HardSlimeRaw", amount: 4, weight: 10}, {name: "RopeRune", weight: 2, noSummon: true}],
	},
	{name: "ElementalLeather", outfit: "ElementalLeather", style: "EarthElemental", faction: "Elemental", playLine: "Elemental", clusterWith: "elemental", bound: "ElementalLeather", squeeze: true, color: "#9999a0",
		tags: KDMapInit(["opendoors", "elemental", "leather", "melee", "chainresist", "crushresist", "jail", "antiMagic", "jailer", "leatherRestraints", "leatherRestraintsHeavy", "ballGagRestraints", "leashing", "search", "doortrap"]),
		armor: 1, followRange: 1, AI: "hunt", guardChance: 0.6, kite: 1.5,
		RestraintFilter: {
			unlimitedRestraints: true,
		},
		stamina: 3,
		maxblock: 1,
		maxdodge: 1,
		projectileAttack: true,
		visionRadius: 6, maxhp: 10, minLevel:2, weight:-2, movePoints: 1.5, attackPoints: 3, attack: "MeleeBindLock", attackWidth: 1, attackRange: 2.5, tilesMinRange: 1, power: 2.5, dmgType: "pain", fullBoundBonus: 2.5, projectileTargeting: true,
		terrainTags: {"secondhalf":2, "thirdhalf":1, "leatherAnger": 4, "leatherRage": 4, "temple": 8, "doortrap": 5, revenge: 5, "elemental": 3, "witch": 5, "leather": 4}, allFloors: true, shrines: ["Leather", "Elements"],
		dropTable: [{name: "Gold", amountMin: 10, amountMax: 20, weight: 10, noSummon: true}, {name: "RopeRune", weight: 2, noSummon: true}],
		events: [
			{trigger: "afterEnemyTick", type: "createEffectTile", kind: "Belts", time: 14, power: 1, chance: 0.5, aoe: 0.5},
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Belts", aoe: 1.5, power: 1, chance: 1.0},
		],
	},


	{name: "RopeKraken", faction: "KinkyConstruct", clusterWith: "construct", tags: KDMapInit(["construct", "nosignal", "melee", "boss", "elite", "unflinching", "hunter"]),
		Awareness: {
			chaseradius: 15,
		},
		Resistance: {
			profile: ["rope", "construct"],
		},
		maxblock: 3,
		maxdodge: 0,
		evasion: -1.4, armor: 1.5,
		ignorechance: 0.75, followRange: 1, AI: "hunt",  summon: [{enemy: "RopeMinion", range: 2.5, count: 4, strict: true}],
		spells: ["RopeEngulf", "EnemyEnchantRope3", "SummonRopeTentacle"], spellCooldownMult: 0.5, spellCooldownMod: 0, ignoreflag: ["kraken"], disarm: 0.25,
		visionRadius: 9, maxhp: 40, minLevel: 3, weight:-31, movePoints: 4, attackPoints: 2, attack: "Spell", attackWidth: 1, attackRange: 1, power: 6, dmgType: "chain",
		terrainTags: {"secondhalf":12, "lastthird":5, "boss": -80, "open": 20, "passage": -60, "ropeAnger": 20, "ropeRage": 40, "increasingWeight":0.5}, allFloors: true, shrines: ["Rope"],
		events: [
			{trigger: "passout", type: "delete", chance: 1.0}, // All rope krakens vanish after you pass outevents: [
			{trigger: "spellCast", type: "ropeKrakenSummonTentacle"}, // Drain HP when casting
		],
		dropTable: [{name: "StrongMagicRopeRaw", amount: 50, weight: 10}, {name: "Scissors", ignoreInInventory: true, weight: 2}, {name: "Knife", ignoreInInventory: true, weight: 5}, {name: "EnchKnife", ignoreInInventory: true, weight: 2}, {name: "ElfCrystal", weight: 3}]},
	{name: "RopeMinion", faction: "KinkyConstruct", tags: KDMapInit(["construct", "nosignal", "melee", "fireweakness", "minor","krakententacle"]), ignorechance: 0.75, followRange: 1, AI: "hunt",  master: {type: "RopeKraken", range: 4}, ignoreflag: ["kraken"], dependent: true,
		visionRadius: 10,
		Awareness: {
			chaseradius: 15,
		},
		nopickpocket: true,
		maxblock: 0,
		maxdodge: 1,
		Resistance: {
			profile: ["rope", "construct"],
		},
		dropTable: [{name: "WeakMagicRopeRaw", amount: 1, weight: 10},],
		maxhp: 8, minLevel: 0, weight:-1000, movePoints: 1.5, attackPoints: 2, attack: "MeleePullWill", attackWidth: 1, attackRange: 1, power: 3, dmgType: "crush", noAlert: true,
		terrainTags: {}, allFloors: true, shrines: ["Rope"]},


	{name: "SlimeKraken", faction: "Slime", clusterWith: "slime", color: "#aa0088", tags: KDMapInit(["slime", "boss", "unflinching", "melee", "slimeRestraints", "meleeresist", "chainimmune", "electricweakness", "acidresist", "iceweakness", "hunter"]),
		Animations: ["squishy"],
		Awareness: {
			chaseradius: 15,
		},
		effect: {
			effect: {name: "SlimeEngulf", power: 4},
		},
		Sound: {
			idleSoundName: "SlimeLarge2",
		},
		Resistance: {
			profile: ["slime"],
		},
		maxblock: 0,
		maxdodge: 0,
		nonDirectional: true,
		regen: 0.1,
		evasion: -1.5,
		nopickpocket: true,
		ignorechance: 0.75, followRange: 1, AI: "hunt",
		spells: ["SummonSlimeMinion"], spellCooldownMult: 1, spellCooldownMod: 0, ignoreflag: ["kraken"], disarm: 0.25,
		visionRadius: 7.5, maxhp: 30, minLevel: 3, weight:-31, movePoints: 4, attackPoints: 3, attack: "MeleeWillBindEffectSpell", attackWidth: 3, attackRange: 1.5, power: 6, dmgType: "glue",
		terrainTags: {"secondhalf":12, "lastthird":5, "boss": -40, "open": 20, "passage": -60, "alchemist": 20, "latexAnger": 20, "latexRage": 40, "increasingWeight":0.5}, allFloors: true, shrines: ["Rope"],
		events: [
			{trigger: "spellCast", type: "slimeKrakenSummonMinion"}, // Drain HP when casting
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "Slime", aoe: 1.5, power: 3, chance: 1.0, duration: 20},
			{trigger: "afterEnemyTick", type: "createEffectTile", kind: "Slime", time: 25, power: 3, chance: 1.0, aoe: 1.5}
		],
		ondeath: [{type: "spellOnSelf", spell: "WitchSlime"}],
		dropTable: [{name: "SlimeRaw", amountMin: 40, amountMax: 50, weight: 1}, {name: "Slimethrower", weight: 30, ignoreInInventory: true}, {name: "StaffDoll", weight: 40, ignoreInInventory: true}, {name: "StaffGlue", weight: 130, ignoreInInventory: true}]},

	{name: "SarcoKraken", faction: "KinkyConstruct", clusterWith: "construct", color: "#3b7d4f", tags: KDMapInit(["construct", "nosignal", "poisonresist", "soulimmune", "melee", "boss", "elite", "unflinching", "fireresist", "crushweakness", "chainweakness", "glueweakness", "hunter"]),
		armor: 3.0, spellResist: 1.5,
		evasion: -2.0,
		maxblock: 2,
		blockAmount: 2.5,
		maxdodge: 0,
		nopickpocket: true,
		ignorechance: 0.75, followRange: 1, AI: "hunt",  summon: [{enemy: "SarcoMinion", range: 2.5, count: 3, strict: true}],
		spells: ["SarcoHex", "SummonSarcoTentacle"], spellCooldownMult: 1, spellCooldownMod: 0, ignoreflag: ["kraken"],
		events: [
			{trigger: "spellCast", type: "sarcoKrakenSummonTentacle"}, // Drain HP when casting
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "FabricGreen", aoe: 1.5, power: 1, chance: 1.0, duration: 20},
		],
		visionRadius: 10, maxhp: 34, minLevel: 0, weight:-11, movePoints: 4, attackPoints: 3, attack: "SpellMeleePull", attackWidth: 1.5, attackMinRange: 1.5, attackRange: 6, power: 4, pullDist: 4, pullTowardSelf: true, dmgType: "charm",
		terrainTags: {"secondhalf":16, "lastthird":5, "boss": -10, "open": 20, "passage": -60, "increasingWeight":1}, floors: KDMapInit(["tmb"]), shrines: [],
		dropTable: [{name: "MysticDuctTapeRaw", amountMin: 25, amountMax: 50, weight: 12}],
	},
	{name: "SarcoMinion", faction: "KinkyConstruct", color: "#99ff99", tags: KDMapInit(["construct", "nosignal", "poisonresist", "soulimmune", "melee", "fireweakness", "minor", "slashweakness", "chainresist", "sarcotentacle", "mummyRestraints"]),
		ignorechance: 0.75, followRange: 1, AI: "hunt",  master: {type: "SarcoKraken", range: 7}, ignoreflag: ["kraken"], dependent: true, suicideOnAdd: true,
		visionRadius: 10, maxhp: 5, minLevel: 0, weight:-1000, movePoints: 1, attackPoints: 2, attack: "MeleeBindSuicide", attackWidth: 1, attackRange: 1, power: 2, fullBoundBonus: 2, dmgType: "chain", noAlert: true,
		events: [
			{trigger: "afterDamageEnemy", type: "bleedEffectTile", kind: "FabricGreen", aoe: 1.5, power: 1, chance: 1.0, duration: 20},
		],
		nopickpocket: true,
		maxblock: 0,
		maxdodge: 0,
		dropTable: [{name: "MysticDuctTapeRaw", amount: 1, weight: 12}],
		terrainTags: {}, allFloors: true, shrines: ["Rope"]},


	{name: "Dollsmith", nameList: "cyborg", outfit: "DollsmithDoll", style: "Fire", faction: "Enemy", clusterWith: "smithdoll", bound: "FactoryDoll", playLine: "Robot", color: "#ff3388",
		applyFaction: "Dollsmith",
		tags: KDMapInit(["leashing", "dollsmith", "doll", "opendoors", "closedoors", "jail", "jailer", "melee", "elite", "antiMagic", "glueresist", "crushresist", "electricresist", "handcuffer", "iceweakness", "blacksteelRestraints", "blacksteelCuffs", "teasetoys"]),
		spellResist: 1.0, armor: 1.0,
		followLeashedOnly: true, followRange: 1,
		spells: ["RubberBolt"], spellCooldownMult: 2, spellCooldownMod: 0,
		Security: {
			level_key: 3,
			level_tech: 1,
		},
		preferBlock: true,
		Behavior: {
			thorough: 0.6,
			ensurePlayerTagArousal: ["ChastityUpper", "ChastityLower"],
		},
		stamina: 6,
		RestraintFilter: {
			bonusRestraints: 2,
			requiredItems: ["BlacksteelBelt", "BlacksteelBra"],
		},
		summon: [{enemy: "DollsmithDoll", range: 2.5, count: 1, strict: true}, {enemy: "DollsmithDoll", range: 2.5, count: 1, chance: 0.5, strict: true}],
		specialCD: 6, specialAttack: "WillBind", specialRemove: "Lock", specialExtraTags: ["redLatexBasic"], specialRemoveTags: ["blacksteelRestraints", "blacksteelCuffs", "leashing", "teasetoys"],
		specialAttackPoints: 2, specialWidth: 3, specialMsg: true, specialCondition: "canRestrainWithExtra", specialCDonAttack: true, specialIgnoreStam: true,
		attackLock: "Red",
		AI: "hunt", guardChance: 0.6, visionRadius: 7, maxhp: 14, minLevel:3, weight:15, movePoints: 2,
		attackPoints: 2, attack: "SpellMeleeBindLock", attackWidth: 1, attackRange: 1, power: 1, dmgType: "grope", fullBoundBonus: 1.5,
		terrainTags: {"increasingWeight":1, "dollsmith": 5}, floors:KDMapInit(["bel"]), shrines: ["Metal", "Latex"],

		dropTable: [{name: "Gold", amountMin: 15, amountMax: 20, weight: 10}, {name: "KeyCard", weight: 1}]},

	{name: "Dollmaker", nameList: "cyborg", outfit: "DollmakerApprentice", style: "Water", faction: "Enemy", clusterWith: "smithdoll", bound: "FactoryDoll", playLine: "Robot", color: "#ff88ff",
		applyFaction: "Dollsmith",
		tags: KDMapInit(["leashing", "dollsmith", "doll", "opendoors", "closedoors", "jail", "antiMagic", "jailer", "ranged", "miniboss", "antiMagic",
			"imprisonable",
			"glueresist", "electricresist", "crushresist", "iceweakness", "blacksteelchastity", "redlatexEncase", "teasetoys"]),
		spellResist: 1.5, armor: 0.5,
		followLeashedOnly: true, followRange: 1.5, dontKiteWhenDisabled: true, kite: 4.5, noKiteWhenHarmless: true,
		spells: ["RubberBolt", "EncaseBolt", "DollConvert", "DollBoost", "EnemyCM1"],
		unlockCommandLevel: 2, unlockCommandCD: 30, spellCooldownMult: 1, spellCooldownMod: -1, buffallies: true, projectileTargeting: true, bypass: true,
		Security: {
			level_key: 3,
			level_tech: 1,
		},
		stamina: 2,
		Behavior: {
			thorough: 0.6,
			ensurePlayerTagArousal: ["ChastityUpper", "ChastityLower"],
		},
		RestraintFilter: {
			bonusRestraints: 2,
			requiredItems: ["BlacksteelBelt", "BlacksteelBra"],
		},
		useLock: "Purple",
		specialAttack: "WillBind", specialCD: 5, specialExtraTags: ["redLatexBasic"], specialRemoveTags: ["blacksteelchastity", "redlatexEncase", "leashing", "teasetoys"],
		specialAttackPoints: 2, specialWidth: 3, specialMsg: true, specialCondition: "canRestrainWithExtra", specialCDonAttack: true, specialIgnoreStam: true,
		AI: "hunt", guardChance: 0.6, visionRadius: 7, maxhp: 14, minLevel:5, weight:10, movePoints: 2.4,
		attackPoints: 3, attack: "SpellMeleeBindWill", attackWidth: 1, attackRange: 1, power: 4, dmgType: "glue",
		terrainTags: {"increasingWeight":1, "dollsmith": 5, "latexOptout": -9}, floors:KDMapInit(["bel"]), shrines: ["Metal", "Latex"],
		dropTable: [{name: "Gold", amountMin: 15, amountMax: 20, weight: 10}, {name: "StaffDoll", ignoreInInventory: true, weight: 100}, {name: "KeyCard", weight: 4}]},

	{name: "DollsmithDoll", nameList: "cyborg", outfit: "DollsmithDoll", style: "Water", faction: "Enemy", clusterWith: "dollsmith", bound: "EncasedFactoryDoll", playLine: "Gagged", color: "#ff3388",
		applyFaction: "Dollsmith",
		tags: KDMapInit(["opendoors", "doll", "smithdoll", "submissive", "noshop", "gagged", "alwaysAlert", "imprisonable", "minor", "ignorenoSP", "melee", "noarms",
			"glueresist", "electricresist", "ticklesevereweakness", "chainresist", "charmweakness", "crushresist"]),
		ignorechance: 0, armor: 1, spellResist: 1.0, followRange: 1, AI: "hunt",  cohesion: 0.9, events: [
			{trigger: "tick", type: "secretToy"},
		],
		nopickpocket: true,
		stamina: 4,
		master: {type: "Dollsmith", range: 2.5, loose: true, aggressive: true},
		sneakThreshold: 2.5, difficulty: 0.05,
		ignoreflag: ["dollSmithDoll"], failAttackflag: ["dollSmithDoll"],
		visionRadius: 7.5, maxhp: 8, minLevel:0, weight:4, movePoints: 1.5,
		attackPoints: 3, attack: "MeleeWillSlow", attackWidth: 3, attackRange: 1, power: 2, dmgType: "charm",
		terrainTags: {"latexAnger": 3, "latexRage": 3, "metalAnger": 3, "metalRage": 3, "smithdoll": 40},
		shrines: ["Metal"], floors:KDMapInit(["bel"])},


	{name: "Rat", faction: "Beast", tags: KDMapInit(["ignorenoSP", "beast", "darkvision", "melee", "minor"]), followRange: 1, AI: "guard", squeeze: true,
		visionRadius: 4, maxhp: 1, evasion: 0.5, minLevel:0, weight:8, movePoints: 1.5, attackPoints: 2, attack: "MeleeWill", attackWidth: 1, attackRange: 1, power: 1, dmgType: "pain",
		terrainTags: {"rubble":20, "increasingWeight":-5}, floors:KDMapInit(["grv"])},
	{name: "Bat", faction: "Beast", tags: KDMapInit(["ignorenoSP", "beast", "darkvision", "melee", "minor", "chainresist", "flying"]), followRange: 1, AI: "guard", squeeze: true, ethereal: true,
		visionRadius: 4, maxhp: 1, evasion: 0.5, minLevel:0, weight:4, movePoints: 1, attackPoints: 1, attack: "MeleeWill", attackWidth: 1, attackRange: 1, power: 1, dmgType: "pain",
		terrainTags: {"rubble":20, "increasingWeight":-5}, floors:KDMapInit(["jngWild", "cav"])},

	{name: "Apprentice", nameList: "witch", outfit: "ApprenticeBlue", style: "Air", faction: "Apprentice", color: "#9563ff", spellWhileParole: true, bound: "Apprentice", playLine: "Apprentice",
		tags: KDMapInit(["leashing", "mage", "opendoors", "rope", "binding",
			"jail", "human", "imprisonable", "shadowclan", "closedoors", "apprentice", "ropeRestraints", "antiMagic", "ranged", "glueweakness", "chainweakness", "tickleweakness", "search", "jailer", "jail"]), followRange: 2,
		castWhileMoving: true, spells: ["RopeEngulfWeak", "EnemyEnchantRope", "EnemyCM1"], unlockCommandLevel: 1, unlockCommandCD: 90, stopToCast: true, spellRdy: true, kite: 1.5, kiteChance: 0.9, cohesion: 1.0, followLeashedOnly: true,
		spellCooldownMult: 1, spellCooldownMod: 0, AI: "hunt", guardChance: 0.6, visionRadius: 5, maxhp: 8, minLevel:2, weight:10, movePoints: 2, attackPoints: 3, attack: "SpellMeleeBindLock", attackWidth: 1, attackRange: 1, power: 1, dmgType: "grope", fullBoundBonus: 1,
		terrainTags: {"secondhalf":3, "lastthird":3, "increasingWeight": -1, "apprentice": 4, "rope": 4, "magical": 4}, allFloors: true, shrines: ["Elements"],
		attackLock: "White",
		stamina: 2,
		maxblock: 0,
		maxdodge: 0,
		dropTable: [{name: "RedKey", weight: 1}, {name: "Nothing", weight: 29}]},
	{name: "Apprentice2", nameList: "witch", outfit: "ApprenticeRed", style: "Earth", faction: "Apprentice", color: "#ff1616", bound: "Apprentice2", playLine: "Apprentice",
		tags: KDMapInit(["leashing", "mage", "opendoors", "leather", "binding", "human",
			"jail", "imprisonable", "conjurer", "latexRestraints", "ropeRestraints", "closedoors", "apprentice", "ranged", "glueweakness", "chainweakness", "tickleweakness", "search"]), followRange: 2,
		castWhileMoving: true, spells: ["SummonSingleTickleHand", "SummonEnemyGag", "SummonLock", "SummonCuff", "EnemyCM1"], unlockCommandLevel: 1, unlockCommandCD: 90, stopToCast: true, spellRdy: true, kite: 1.5, kiteChance: 0.9, cohesion: 1.0, followLeashedOnly: true,
		spellCooldownMult: 1, spellCooldownMod: 0, AI: "hunt", guardChance: 0.6, visionRadius: 5.5, maxhp: 8,
		minLevel:1, weight:6, movePoints: 2, attackPoints: 3, attack: "SpellMeleeBindLock", attackWidth: 1, attackRange: 1, power: 1, dmgType: "grope", fullBoundBonus: 1,
		terrainTags: {"secondhalf":3, "lastthird":3, "increasingWeight": -1, "apprentice": 4, "conjure": 4, "magical": 4}, allFloors: true, shrines: ["Conjure"],
		attackLock: "White",
		stamina: 2,
		maxblock: 0,
		maxdodge: 0,
		dropTable: [{name: "RedKey", weight: 1}, {name: "Nothing", weight: 29}]},
	{name: "WitchApprentice", nameList: "witch", outfit: "ApprenticeBlue", style: "Earth",
		faction: "Witch", color: "#812fcc", bound: "WitchApprentice", playLine: "Apprentice",
		buffallies: true,
		tags: KDMapInit(["leashing", "witchapprentice", "mage", "opendoors", "leather",
			"jailer",
			"binding", "human", "imprisonable", "conjurer", "leatherRestraintsMagic", "beltRestraintsMagic",
			"closedoors", "apprentice", "ranged", "arcaneweakness", "tickleweakness", "search"]), followRange: 2,
		castWhileMoving: true, spells: ["MagicBelt", "ShieldTheWitch", "EnemyEnchantRope", "EnemyCM1"],
		unlockCommandLevel: 1, unlockCommandCD: 90, stopToCast: true, spellRdy: true, kite: 1.5, kiteChance: 0.9, cohesion: 1.0, followLeashedOnly: true,
		spellCooldownMult: 1, spellCooldownMod: 0, AI: "hunt", guardChance: 0.6, visionRadius: 5.5, maxhp: 10,
		minLevel:2, weight:8, movePoints: 2, attackPoints: 3,
		attack: "SpellMeleeBindLock", attackWidth: 1, attackRange: 1, power: 1, dmgType: "grope", fullBoundBonus: 1,
		terrainTags: {"secondhalf":3, "lastthird":3, "increasingWeight": -1,
			"apprentice": 4, "witch": 15, "magical": 4}, allFloors: true, shrines: ["Elements"],
		attackLock: "White",
		stamina: 2,
		maxblock: 0,
		maxdodge: 0,
		Magic: {
			castCooldownUnique: {
				ShieldTheWitch: 9,
			},
			priority: {
				EnemyCM1: 4,
				ShieldTheWitch: 5,
				EnemyEnchantRope: 3,
			},
		},

		dropTable: [{name: "RedKey", weight: 1}, {name: "Nothing", weight: 29}]},
	{name: "ApprenticeSlime", nameList: "witch", outfit: "ApprenticeSlime", style: "Necromancer", faction: "Apprentice", color: "#FF00FF", bound: "ApprenticeSlime", playLine: "Apprentice",
		tags: KDMapInit(["leashing", "mage", "opendoors", "binding", "human", "imprisonable",
			"jail",
			"conjurer", "latexRestraints", "closedoors", "apprentice", "ranged", "glueresist",
			"chainweakness", "tickleweakness", "search"]), followRange: 2,
		castWhileMoving: true, spells: ["SlimePuddle", "ManySlimes", "EnemyCM1"], unlockCommandLevel: 1, unlockCommandCD: 90, stopToCast: true, spellRdy: true, kite: 1.5, kiteChance: 0.9, cohesion: 1.0, followLeashedOnly: true,
		spellCooldownMult: 1, spellCooldownMod: 0, AI: "hunt", guardChance: 0.6, visionRadius: 5, maxhp: 8, minLevel:2, weight:8, movePoints: 2, attackPoints: 3, attack: "SpellMeleeBindLock", attackWidth: 1, attackRange: 1, power: 1, dmgType: "grope", fullBoundBonus: 1,
		terrainTags: {"secondhalf":3, "lastthird":3, "increasingWeight": -1, "apprentice": 4, "slime": 4, "slimeOptOut": -2, "slimePref": 2, "magical": 4}, allFloors: true, shrines: ["Latex"],
		attackLock: "White",
		stamina: 2,
		maxblock: 0,
		maxdodge: 0,
		dropTable: [{name: "RedKey", weight: 1}, {name: "Nothing", weight: 29}]},

	{name: "WitchRope", nameList: "witch", outfit: "WitchRope", style: "Earth", color: "#ffae70", faction: "Witch", clusterWith: "apprentice", bound: "WitchRope", playLine: "Witch",
		tags: KDMapInit(["leashing", "mage", "guardCall", "jail", "rope", "jailer", "imprisonable", "opendoors", "ropeRestraints", "closedoors", "human", "witch", "ranged", "elite", "hunter"]), followRange: 2,
		castWhileMoving: true, spells: ["WitchRope", "EnemyEnchantRope", "RopeEngulfWeak", "EnemyCM1"], unlockCommandLevel: 1, unlockCommandCD: 30, stopToCast: true, spellRdy: true, kite: 1.5, kiteChance: 0.9,
		spellCooldownMult: 1, spellCooldownMod: 0, AI: "hunt", guardChance: 0.6, visionRadius: 7, maxhp: 10, minLevel:0, weight:4, movePoints: 3, attackPoints: 2, attack: "SpellMeleeBind", attackWidth: 1, attackRange: 1, power: 2, dmgType: "grope", fullBoundBonus: 3,
		terrainTags: {"secondhalf":1, "lastthird":2, "increasingWeight": -1, "ropeAnger": 6, "tech": -6, "rope": 6}, allFloors: true, shrines: ["Rope"], followLeashedOnly: true,
		stamina: 2,
		maxblock: 1,
		maxdodge: 1,
		Magic: {
			castCooldownUnique: {
				EnemyEnchantRope: 6,
			},
			priority: {
				EnemyEnchantRope: 8,
			},
		},
		dropTable: [{name: "Gold", amountMin: 5, amountMax: 15, weight: 14, noSummon: true}, {name: "RopeRune", weight: 1, noSummon: true}]},

	{name: "WitchShibari", nameList: "witch", outfit: "Bikini", style: "Earth", color: "#ffae70", faction: "Witch", clusterWith: "apprentice", bound: "WitchRope",
		playLine: "Witch", tags: KDMapInit(["leashing", "mage", "guardCall", "jail", "rope", "jailer", "imprisonable", "opendoors", "ropeRestraints", "closedoors", "human", "witch", "ranged", "miniboss", "hunter"]), followRange: 2,
		castWhileMoving: true, spells: ["WitchRopeBoltLaunchMany", "EnemyEnchantRope2", "RopeEngulfWeak", "EnemyCM1"], unlockCommandLevel: 2, unlockCommandCD: 20, stopToCast: true, spellRdy: true, kite: 2.5, kiteChance: 0.9,
		spellCooldownMult: 0.7, spellCooldownMod: 0, AI: "hunt", guardChance: 0.2, visionRadius: 7, maxhp: 12, minLevel:2, weight:1, movePoints: 2.2, attackPoints: 2, attack: "EffectSpellMeleeBind", attackWidth: 2.5, attackRange: 1, power: 3, dmgType: "charm", fullBoundBonus: 3,
		terrainTags: {"secondhalf":0, "lastthird":1.5, "increasingWeight": -1, "ropeAnger": 8, "tech": -1, "rope": 4}, allFloors: true, shrines: ["Rope"], followLeashedOnly: true,
		stamina: 5,
		maxblock: 1,
		effect: {
			effect: {name: "Disrobe"},
		},
		Magic: {
			castCooldownUnique: {
				WitchRopeBoltLaunchMany: 20,
				EnemyEnchantRope2: 4,
			},
			priority: {
				WitchRopeBoltLaunchMany: 10,
				EnemyEnchantRope2: 8,
			},
		},
		maxdodge: 2,
		evasion: 0.3,
		dropTable: [{name: "Gold", amountMin: 15, amountMax: 25, weight: 3, noSummon: true}, {name: "RopeRune", weight: 7, noSummon: true}]},

	{name: "WitchFlame", nameList: "witch", outfit: "WitchFlame", style: "Fire", faction: "Witch", clusterWith: "elemental", bound: "WitchFlame", playLine: "Witch", color: "#d30000", tags: KDMapInit(["leashing", "mage", "guardCall", "jail", "jailer", "imprisonable", "opendoors", "handcuffer", "fire", "closedoors", "human", "witch", "ranged", "elite", "unflinching", "fireresist", "soapweakness", "iceweakness", "hunter"]), followRange: 2,
		castWhileMoving: true, spells: ["HeatBolt", "EnemyCM1"], unlockCommandLevel: 1, unlockCommandCD: 30, stopToCast: true, spellRdy: true, kite: 1.5, kiteChance: 0.9,
		spellCooldownMult: 1, spellCooldownMod: 0, AI: "hunt", guardChance: 0.6, visionRadius: 7, maxhp: 11, minLevel:0, weight:2, movePoints: 2, attackPoints: 3, attack: "SpellMeleeBindLock", attackWidth: 1, attackRange: 1, power: 2, dmgType: "grope", fullBoundBonus: 3,
		terrainTags: {"secondhalf":1, "lastthird":2, "elementsAnger": 6, "tech": -6, "fire": 4}, allFloors: true, shrines: [], followLeashedOnly: true,
		attackLock: "White",
		stamina: 2,
		maxblock: 0,
		maxdodge: 1,
		events: [{trigger: "getLights", type: "enemyTorch", power: 3.5, color: "#ff8933"}],
		dropTable: [{name: "Gold", amountMin: 10, amountMax: 20, weight: 14, noSummon: true}],
	},
	{name: "WitchIce", nameList: "witch", outfit: "WitchIce", style: "Ice", faction: "Witch", clusterWith: "elemental", bound: "WitchIce", playLine: "Witch", color: "#73efe8", tags: KDMapInit(["leashing", "mage", "guardCall", "jail", "jailer", "imprisonable", "opendoors", "handcuffer", "ice", "closedoors", "human", "witch", "ranged", "elite", "unflinching", "crushweakness", "fireweakness", "soapresist", "iceresist", "slashresist", "hunter"]), followRange: 2,
		castWhileMoving: true, spells: ["WitchIcebolt", "EnemyCM1"], unlockCommandLevel: 1, unlockCommandCD: 30, stopToCast: true, spellRdy: true, kite: 1.5, kiteChance: 0.9,
		spellCooldownMult: 1, spellCooldownMod: 0, AI: "hunt", guardChance: 0.6, visionRadius: 7, maxhp: 11, minLevel:2, weight:2, movePoints: 2, attackPoints: 3, attack: "SpellMeleeBindLock", attackWidth: 1, attackRange: 1, power: 2, dmgType: "grope", fullBoundBonus: 3,
		terrainTags: {"secondhalf":1, "lastthird":2, "elementsAnger": 6, "tech": -6, "ice": 6, "water": 2}, allFloors: true, shrines: [], followLeashedOnly: true,
		attackLock: "White",
		stamina: 2,
		maxblock: 2,
		maxdodge: 0,
		dropTable: [{name: "Gold", amountMin: 10, amountMax: 20, weight: 14, noSummon: true}],
	},
	{name: "WitchEarth", nameList: "witch", outfit: "WitchEarth", style: "Earth", faction: "Witch", clusterWith: "elemental", bound: "WitchEarth", playLine: "Witch", color: "#f8c53a", tags: KDMapInit(["leashing", "mage", "guardCall", "jail", "jailer", "imprisonable", "opendoors", "handcuffer", "earth", "closedoors", "human", "witch", "ranged", "elite", "unflinching", "crushresist", "stunweakness", "iceweakness", "fireresist", "hunter", "slashresist", "pierceresist",
		"shackleRestraints", "steelCuffs"]), followRange: 1,
		castWhileMoving: true, spells: ["WitchBoulder", "EnemyCM1"], unlockCommandLevel: 1, unlockCommandCD: 30, stopToCast: true, spellRdy: true,
		spellCooldownMult: 1, spellCooldownMod: 0, AI: "hunt", guardChance: 0.7, visionRadius: 7, maxhp: 14, minLevel:2, weight:2, movePoints: 2, attackPoints: 3, attack: "SpellMeleeBindLock", attackWidth: 1, attackRange: 1, power: 2, dmgType: "grope", fullBoundBonus: 3,
		terrainTags: {"secondhalf":1, "lastthird":2, "elementsAnger": 6, "tech": -6, "earth": 4}, allFloors: true, shrines: [], followLeashedOnly: true,
		attackLock: "White",
		stamina: 2,
		maxblock: 2,
		maxdodge: 0,
		dropTable: [{name: "Gold", amountMin: 10, amountMax: 20, weight: 14, noSummon: true}],
	},
	{name: "WitchWater", nameList: "witch", outfit: "WitchWater", style: "Water", faction: "Witch", clusterWith: "elemental", bound: "WitchWater", playLine: "Witch", color: "#4572e3", tags: KDMapInit(["leashing", "mage", "guardCall", "jailer", "opendoors", "imprisonable", "handcuffer", "water", "closedoors", "human", "witch", "ranged", "elite", "unflinching", "fireresist", "acidresist", "soapresist", "electricsevereweakness", "pierceresist", "hunter", "latexRestraints"]), followRange: 1,
		castWhileMoving: true, spells: ["WitchWaterBall", "EnemyCM1"], unlockCommandLevel: 1, unlockCommandCD: 30, stopToCast: true, spellRdy: true, evasion: 0.25,
		spellCooldownMult: 1, spellCooldownMod: 0, AI: "hunt", guardChance: 0.6, visionRadius: 7, maxhp: 11, minLevel:0, weight:2, movePoints: 3, attackPoints: 4, attack: "SpellMeleeBindLock", attackWidth: 1, attackRange: 1, power: 2, dmgType: "grope", fullBoundBonus: 3,
		terrainTags: {"secondhalf":1, "lastthird":2, "elementsAnger": 6, "tech": -6, "water": 6, "ice": 2}, allFloors: true, shrines: [], followLeashedOnly: true,
		attackLock: "White",
		stamina: 2,
		maxblock: 0,
		maxdodge: 2,
		dropTable: [{name: "Gold", amountMin: 10, amountMax: 20, weight: 14, noSummon: true}],
	},
	{name: "WitchAqua", nameList: "witch", outfit: "WitchWater", style: "Water", faction: "Witch", clusterWith: "elemental", bound: "WitchWater", playLine: "Witch", color: "#4572e3",
		tags: KDMapInit(["leashing", "mage", "guardCall", "jailer", "opendoors", "imprisonable", "handcuffer", "water", "closedoors", "human", "witch", "ranged", "miniboss", "unflinching", "fireresist", "acidresist", "soapresist", "electricsevereweakness", "pierceresist", "hunter", "latexRestraints"]),
		followRange: 1, dontKiteWhenDisabled: true, kite: 2.5,
		castWhileMoving: true, spells: ["WitchWaterBall", "EnemyCM1", "BubbleBurst"], unlockCommandLevel: 1, unlockCommandCD: 12, stopToCast: true, spellRdy: true,
		spellCooldownMult: 1, spellCooldownMod: 0, AI: "hunt", guardChance: 0.6, visionRadius: 7, maxhp: 20,
		Magic: {
			castCooldownUnique: {
				WitchWaterBall: 2,
			},
		},
		minLevel:3, weight:2, movePoints: 3, attackPoints: 4, attack: "SpellMeleeBindLock", attackWidth: 1, attackRange: 1, power: 2, dmgType: "grope", fullBoundBonus: 3,
		terrainTags: {"secondhalf":2, "lastthird":1, "bubbleOptout": -5, "bubblePref": 5, "elementsAnger": 6, "tech": -4, "water": 4, "ice": 2}, allFloors: true, shrines: [], followLeashedOnly: true,
		attackLock: "White",
		stamina: 5,
		maxblock: 0,
		maxdodge: 0,
		dropTable: [{name: "Gold", amountMin: 10, amountMax: 20, weight: 14, noSummon: true}],
	},



	{name: "WitchShock", nameList: "witch", outfit: "WitchShock", style: "Air", faction: "Witch", clusterWith: "apprentice", bound: "Witch", playLine: "Witch",
		tags: KDMapInit(["leashing", "mage", "opendoors", "antiMagic", "handcuffer", "electric", "jail", "jailer", "closedoors", "human", "witch", "ranged", "miniboss", "unflinching", "electricresist", "glueweakness", "iceweakness", "hunter"]), followRange: 2,
		castWhileMoving: true, spells: ["WitchElectrify", "WitchElectricOrb", "EnemyCM1"], unlockCommandLevel: 1, unlockCommandCD: 12, stopToCast: true, spellRdy: true, kite: 1.5, kiteChance: 0.9,
		spellCooldownMult: 1, spellCooldownMod: 0, AI: "hunt", guardChance: 0.6, visionRadius: 7, maxhp: 15, minLevel:3, weight:2, movePoints: 2, attackPoints: 3, attack: "SpellMeleeBindLock", attackWidth: 1, attackRange: 1, power: 2, dmgType: "grope", fullBoundBonus: 3,
		terrainTags: {"secondhalf":2, "lastthird":1, "tech": -10, "electric": 6}, allFloors: true, shrines: [], followLeashedOnly: true,
		dropTable: [{name: "Gold", amountMin: 10, amountMax: 20, weight: 14, noSummon: true}], attackLock: "White",
		maxblock: 0,
		maxdodge: 1,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 2, color: KDBaseLightBlue},
			{trigger: "afterEnemyTick", type: "electrifyLocal", power: 1, chance: 0.5, aoe: 1.5}
		],
	},
	{name: "WitchMagnet", nameList: "science", outfit: "WitchMagnet", style: "Air", faction: "Witch", color: "#92e8c0", clusterWith: "apprentice", bound: "Witch", playLine: "Witch", tags: KDMapInit(["leashing", "mage", "opendoors", "antiMagic", "magnetCuffs", "electric", "metal", "jailer", "closedoors", "human", "witch", "ranged", "miniboss", "unflinching", "electricresist", "glueweakness", "iceweakness", "hunter"]),
		castWhileMoving: true, spells: ["AreaElectrify", "WitchElectricOrb", "EnemyCM1"], unlockCommandLevel: 2, unlockCommandCD: 10, stopToCast: true, spellRdy: true, followRange: 1,
		armor: 1,
		maxblock: 0,
		maxdodge: 1,
		spellCooldownMult: 1, spellCooldownMod: -1, AI: "hunt", guardChance: 0.6, visionRadius: 8, maxhp: 24, minLevel:12, weight:1, movePoints: 2, attackPoints: 2, attack: "SpellMeleeBindLock",
		attackWidth: 1, attackRange: 1, power: 1, dmgType: "electric", fullBoundBonus: 1, noLeashUnlessExhausted: true, attackLock: "Purple",
		terrainTags: {"lastthird":1, "miniboss": -10, "tech": -10, "metalAnger": 4, "elementsAnger": 6, "increasingWeight": 0.5, "electric": 6}, allFloors: true, shrines: [], followLeashedOnly: true,
		dropTable: [{name: "BlueKey", weight: 3}, {name: "ScrollArms", weight: 1}, {name: "ScrollVerbal", weight: 1}, {name: "ScrollLegs", weight: 1}],
		RestraintFilter: {
			requiredItems: ["MagneticArmCuffs", "MagneticAnkleCuffs"],
		},
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 2, color: KDBaseLightBlue},
			{trigger: "afterEnemyTick", type: "electrifyLocal", power: 1, aoe: 1.5},
		],
	},
	{name: "WitchChain", nameList: "witch", outfit: "WitchChain", style: "Earth", faction: "Witch", clusterWith: "bandit", bound: "WitchChain", playLine: "Witch", color: "#AAAAAA", tags: KDMapInit(["leashing", "mage", "opendoors", "fiddle", "antiMagic", "closedoors", "metal", "imprisonable", "jail", "jailer", "chainRestraints", "human", "witch", "melee", "miniboss", "unflinching", "electricweakness", "chainresist", "crushweakness", "meleeresist", "fireweakness", "hunter"]),
		followRange: 1, spells: ["WitchChainBolt", "EnemyCM1"], unlockCommandLevel: 1, unlockCommandCD: 12, spellRdy: true,
		armor: 1,
		maxblock: 2,
		maxdodge: 0,
		spellCooldownMult: 2, spellCooldownMod: 2, AI: "hunt", guardChance: 0.6, visionRadius: 6, maxhp: 18, minLevel:3, weight:2, movePoints: 3, disarm: 0.33,
		attackPoints: 3, attack: "MeleeLockAllBindSpell", attackWidth: 2.5, attackRange: 1, tilesMinRange: 1, power: 3, dmgType: "grope", fullBoundBonus: 3, multiBind: 2, attackLock: "Red",
		terrainTags: {"secondhalf":3, "lastthird":3, "tech": -10, "metal": 6}, allFloors: true, shrines: [],
		dropTable: [{name: "Gold", amountMin: 10, amountMax: 20, weight: 14, noSummon: true}]},
	{name: "WitchMetal", nameList: "dragonheart", outfit: "WitchMetal", style: "Earth", faction: "Witch", clusterWith: "bandit", bound: "WitchChain", playLine: "Witch", color: "#AAAAAA",
		tags: KDMapInit(["leashing", "opendoors", "closedoors", "jailer", "chainRestraints",
			"shackleRestraints", "steelRestraints", "fiddle", "mage", "handcuffer", "human", "antiMagic", "witch", "metal", "melee", "elite", "miniboss", "unflinching", "chainresist", "electricweakness", "crushweakness", "meleeresist", "fireweakness", "hunter"]),
		armor: 2,
		maxblock: 4,
		maxdodge: 0,
		followRange: 1, spells: ["ManyChains", "SummonChainWalls", "EnemyCM1"], unlockCommandLevel: 2, unlockCommandCD: 10, spellRdy: true,
		spellCooldownMult: 1, spellCooldownMod: 2, AI: "hunt", guardChance: 0.6, visionRadius: 6, maxhp: 24, shield: 5, minLevel:9, weight:1, movePoints: 3, disarm: 0.33,
		attackPoints: 3, attack: "MeleeLockAllBindSpell", attackWidth: 3, attackRange: 1, tilesMinRange: 1, power: 4, dmgType: "grope", fullBoundBonus: 4, multiBind: 3, attackLock: "Purple",
		terrainTags: {"lastthird":1, "miniboss": -10, "tech": -10, "metalAnger": 4, "metalFriendly": 6, "conjureAnger": 6, "increasingWeight": 0.5, "metal": 6}, allFloors: true, shrines: [],
		dropTable: [{name: "BlueKey", weight: 3}, {name: "ScrollArms", weight: 1}, {name: "ScrollVerbal", weight: 1}, {name: "ScrollLegs", weight: 1}],
	},
	{name: "WitchSlime", nameList: "witch", outfit: "WitchSlime", style: "Necromancer", faction: "Witch", clusterWith: "slime", bound: "WitchSlime", playLine: "Witch",
		tags: KDMapInit(["leashing", "mage", "slimewalk", "slime", "opendoors", "closedoors", "witch", "jail", "jailer", "ranged", "miniboss", "antiMagic",
			"unflinching", "slimeRestraints", "glueimmune", "acidweakness", "soapweakness", "electricweakness", "iceweakness", "hunter"]), squeeze: true,
		followLeashedOnly: true, kite: 1.5, kiteChance: 0.9, followRange: 4, castWhileMoving: true,
		spells: ["ManySlimes", "ManySlimes", "WitchSlimeBall", "WitchSlime", "BubbleBurstSlime", "EnemyCM1"], unlockCommandLevel: 1, unlockCommandCD: 12, stopToCast: true, spellRdy: true,
		spellCooldownMult: 2, spellCooldownMod: -7, AI: "hunt", guardChance: 0.6, visionRadius: 8, maxhp: 13, minLevel:3, weight:2, movePoints: 3, attackPoints: 3, attack: "Spell", attackWidth: 1, attackRange: 1, power: 1, dmgType: "grope", fullBoundBonus: 1,
		attackLock: "Purple",
		maxblock: 0,
		maxdodge: 2,
		terrainTags: {"secondhalf":2, "lastthird":1, "bubbleOptout": -3.5, "bubblePref": 2, "open": 4, "tech": -8, "slime": 4, "slimeOptOut": -2, "slimePref": 2}, allFloors: true, shrines: [],
		events: [
			{trigger: "afterEnemyTick", type: "createEffectTile", kind: "Slime", time: 14, power: 1, chance: 0.5, aoe: 0.5},
			{trigger: "getLights", type: "enemyTorch", power: 2, color: "#ff00ff"},
		],
		dropTable: [{name: "Gold", amountMin: 10, amountMax: 20, weight: 14, noSummon: true}]},
	{name: "Necromancer", nameList: "chinese", outfit: "Necromancer", style: "Necromancer", faction: "Enemy", clusterWith: "skeleton", bound: "Necromancer", playLine: "Necromancer",
		stamina: 2,
		maxblock: 1,
		maxdodge: 0,
		tags: KDMapInit(["leashing", "guardCall", "opendoors", "jailer", "closedoors", "human", "witch", "antiMagic", "shadowclan", "velvetpact",
			"ranged", "mage", "miniboss", "unflinching", "meleeweakness", "hunter"]), followRange: 1, cohesion: 0.9,
		spells: ["SummonSkeleton", "SummonSkeletons", "EnemyCM1"], unlockCommandLevel: 1, unlockCommandCD: 16, spellCooldownMult: 1, spellCooldownMod: 2, spellRdy: true,
		AI: "hunt", guardChance: 0.6, visionRadius: 6, maxhp: 20, minLevel: 2, weight:3, movePoints: 3, attackPoints: 3, attack: "MeleeLockAllWillSpellBind", attackWidth: 1, attackRange: 1, power: 5, dmgType: "grope",
		terrainTags: {"secondhalf":3, "lastthird":3, "miniboss": -7, "tech": -20, "velvet": 4, "skeleton": 3}, shrines: [], floors:KDMapInit(["cat", "jng", "tmb", "tmp"]), attackLock: "White",
		dropTable: [{name: "Gold", amountMin: 10, amountMax: 20, weight: 14, noSummon: true}]},

	{name: "HighWizard", nameList: "witch", outfit: "WitchShock", style: "Water", clusterWith: "mushroom",
		bound: "HighWizard", faction: "Mushy", playLine: "Witch", color: "#a583ff",
		tags: KDMapInit(["leashing", "mage", "mushy", "imprisonable", "opendoors", "closedoors", "human", "ranged", "unflinching", "hunter"]), squeeze: true,
		stamina: 2,
		maxblock: 0,
		maxdodge: 0,
		Magic: {
			castCooldownUnique: {
				PocketSpores: 0.1,
			},
			priority: {
				PocketSpores: 1,
			},
		},
		followLeashedOnly: true, kite: 1.5, kiteChance: 0.9, followRange: 4, castWhileMoving: true, spells: ["HighBolt", "Spores", "EnemyCM1", "PocketSpores"],
		unlockCommandLevel: 1, unlockCommandCD: 12, stopToCast: true, spellRdy: true,
		spellCooldownMult: 2, spellCooldownMod: 1, AI: "hunt", guardChance: 0.6, visionRadius: 6, maxhp: 13, minLevel:4, weight:12, movePoints: 2,
		attackPoints: 2, attack: "Spell", attackWidth: 1, attackRange: 1, power: 1, dmgType: "tickle", fullBoundBonus: 1,
		terrainTags: {"secondhalf":2, "lastthird":1, "open": 4, "mushy": 5}, floors:KDMapInit(["cry"]), shrines: [],
		dropTable: [{name: "Gold", amountMin: 10, amountMax: 20, weight: 9}]},
	{name: "Fungal", nameList: "space", outfit: "FunGal", style: "Water", clusterWith: "mushroom", bound: "HighWizard", faction: "Mushy", playLine: "Fungal", color: "#a583ff", tags: KDMapInit(["leashing", "guardCall", "mushy", "jail", "jailer", "opendoors", "closedoors", "mushroom", "ranged", "unflinching", "hunter", "glueresist"]), squeeze: true,
		followLeashedOnly: true, kite: 1.5, kiteChance: 0.9, followRange: 4, castWhileMoving: true, spells: ["HighBolt", "CrystalPuff", "EnemyCM1"], unlockCommandLevel: 1, unlockCommandCD: 30, stopToCast: true, spellRdy: true,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 4.5, color: "#892fcc"},
		],
		maxblock: 2,
		maxdodge: 0,
		stamina: 2,
		spellCooldownMult: 1, spellCooldownMod: 1, AI: "hunt", guardChance: 0.6, visionRadius: 7, maxhp: 8, regen: 0.1, minLevel:3, weight:12, movePoints: 3, attackPoints: 3, attack: "SpellMeleeWillLockAll", attackWidth: 1, attackRange: 1, power: 2, dmgType: "grope", fullBoundBonus: 2,
		attackLock: "Purple",
		terrainTags: {"secondhalf":2, "lastthird":1, "open": 4, "mushroom": 4, "mushy": 5}, floors:KDMapInit(["cry"]), shrines: [],
		dropTable: [{name: "Gold", amountMin: 5, amountMax: 0, weight: 8}]},


	{name: "Dressmaker", nameList: "french", outfit: "Dressmaker", style: "Fire", clusterWith: "construct", bound: "Dressmaker", playLine: "Dressmaker", faction: "Dressmaker", color: "#f135a4", tags: KDMapInit(["leashing", "antiMagic", "ribbon", "dressmaker", "imprisonable", "kiguRestraints", "guardCall", "jail", "jailer", "conjurer", "acidweakness", "soapresist", "opendoors", "closedoors", "human", "ranged", "unflinching", "hunter", "dressRestraints"]),
		RestraintFilter: {
			requiredItems: ["BindingDress"],
		},
		stamina: 3,
		maxblock: 1,
		maxdodge: 1,
		followLeashedOnly: true, kite: 1.5, kiteChance: 0.3, followRange: 4, castWhileMoving: true, spells: ["Ribbons", "Ribbons", "Ribbons", "RibbonBurst", "EnemyCM1"], unlockCommandLevel: 1, unlockCommandCD: 90, stopToCast: true, spellRdy: true, noKiteWhenHarmless: true, noSpellsWhenHarmless: true,
		spellCooldownMult: 1, spellCooldownMod: 0, AI: "hunt", guardChance: 0.6, visionRadius: 7, maxhp: 13, minLevel:0, weight:-6, movePoints: 2, attackPoints: 3, attack: "SpellMeleeBindLock", projectileTargeting: true,
		attackWidth: 1, attackRange: 1, power: 3, dmgType: "grope", fullBoundBonus: 3, focusPlayer: true, attackLock: "Purple",
		terrainTags: {"secondhalf":2, "lastthird":1, "open": 4, "dressmaker": 20, "conjureAnger": 5, "conjureRage": 4, "ropeAnger": 3, "ropeRage": 2}, allFloors: true, shrines: ["Conjure", "Rope"],
		dropTable: [{name: "RibbonRaw", amount: 7, weight: 14}]},
	{name: "Nurse", outfit: "Nurse", style: "Earth", clusterWith: "construct", bound: "Nurse", playLine: "Nurse", faction: "Dressmaker", color: "#f135a4",
		RestraintFilter: {
			requiredItems: ["AsylumJacket"],
		},
		stamina: 4,
		maxblock: 2,
		maxdodge: 0,
		tags: KDMapInit(["leashing", "guardCall", "genericJailer", "dressmaker", "imprisonable", "leather", "jail", "jailer", "conjurer", "soapresist", "opendoors", "closedoors", "human", "ranged", "unflinching", "hunter", "nurseRestraints"]),
		followLeashedOnly: true, kite: 1.5, kiteChance: 0.3, followRange: 4, castWhileMoving: true, spells: ["NurseBola", "NurseSyringe"], miscastmsg: "KDBanditMiscast", miscastsfx: "Miss", stopToCast: true, spellRdy: true, noKiteWhenHarmless: true, noSpellsWhenHarmless: true, dontKiteWhenDisabled: true,
		spellCooldownMult: 1, spellCooldownMod: 0, AI: "hunt", guardChance: 0.6, visionRadius: 7, maxhp: 11, minLevel:0, weight:-40, movePoints: 2, attackPoints: 3, attack: "SpellMeleeBindWillLock", projectileTargeting: true,
		attackWidth: 1, attackRange: 1, power: 3, dmgType: "charm", fullBoundBonus: 3, focusPlayer: true, attackLock: "White",
		terrainTags: {"secondhalf":2, "lastthird":1, "jailGuard": 50, "Guard": 50, "willAnger": 49, "willRage": 4, "ropeAnger": 3, "ropeRage": 2, "dressmaker": 50, "NoNurse": -10000}, allFloors: true, shrines: ["Will", "Rope"],
		events: [
			{trigger: "afterEnemyTick", type: "nurseAura", power: 0.1, dist: 2.59},

		],
		dropTable: [{name: "Gold", amountMin: 5, amountMax: 15, weight: 14, noSummon: true}]},



	{name: "Librarian", nameList: "cyborg", outfit: "Librarian", style: "Water", clusterWith: "construct", bound: "Librarian", playLine: "Librarian", faction: "Dressmaker", color: "#f135a4",
		tags: KDMapInit(["leashing", "mage", "ice", "metal", "rubber", "vine", "electric", "dressmaker", "miniboss", "jailer", "acidweakness", "soapweakness", "antiMagic", "conjurer", "opendoors", "closedoors", "human", "ranged", "unflinching", "hunter", "lowWeightRibbons", "magicRibbonsHarsh", "gagSpell", "mittensSpell"]),
		followLeashedOnly: true, kite: 1.5, kiteChance: 0.3, followRange: 4, castWhileMoving: true, spells: [
			"SummonBookSlime",
			"SummonBookIce",
			"SummonBookNature",
			"SummonBookForbidden",
			"SummonBookArcane",
			"SummonBookCelestial",
			"SummonBookElectric",
			"EnemyCM1"], unlockCommandLevel: 2, unlockCommandCD: 12, stopToCast: true, spellRdy: true, noKiteWhenHarmless: true, noSpellsWhenHarmless: true,
		evasion: -0.4,
		maxblock: 3,
		maxdodge: 0,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 3, color: KDBaseWhite},
		],
		spellCooldownMult: 0.7, spellCooldownMod: 0, AI: "hunt", guardChance: 0.6, visionRadius: 10, maxhp: 12, spellResist: 2.0, minLevel:0, weight: -12, movePoints: 2, attackPoints: 2, attack: "SpellMeleeBindLockAll", projectileAttack: true,
		attackWidth: 1, attackRange: 1, power: 3, dmgType: "grope", fullBoundBonus: 3, focusPlayer: true, attackLock: "Purple",
		terrainTags: {"secondhalf":2, "lastthird":1, "open": 10, "miniboss": -5, "dressmaker": 12, "elementsAnger": 7, "elementsRage": 5}, allFloors: true, shrines: ["Conjure", "Elements"],
		dropTable: [{name: "ScrollArms", weight: 2}, {name: "ScrollVerbal", weight: 2}, {name: "ScrollLegs", weight: 2}, {name: "ScrollPurity", weight: 1}]},

	{name: "MummyCursed", nameList: "bast", outfit: "Mummy", style: "Mummy", bound: "MummyCursed", nopickpocket: true, color: KDBaseNeon, playLine: "GaggedMummy", faction: "Bast", tags: KDMapInit(["mimicBlock", "mummyTrap", "gagged", "removeDoorSpawn", "ignoreharmless", "darkvision", "mummy", "melee", "elite", "mummyRestraints", "soapweakness", "fireweakness", "meleeweakness", "charmweakness"]),
		evasion: -0.25, ignorechance: 1.0, armor: 0, followRange: 1, AI: "ambush", difficulty: 0.05, guardChance: 0, events: [
			{trigger: "tick", type: "secretToy"},
		],
		stamina: 2,
		Resistance: {
			profile: ["catgirl"],
		},
		maxblock: 0,
		maxdodge: 0,
		GFX: {
			lighting: true,
		},
		visionRadius: 10, ambushRadius: 2.01, blindSight: 10, maxhp: 12, minLevel:0, weight:5, movePoints: 1, attackPoints: 2, attack: "MeleeBind", attackWidth: 1, attackRange: 1, power: 2, dmgType: "charm", fullBoundBonus: 1,
		terrainTags: {"secondhalf":5, "mummyTrap": 50, "lastthird":5, "door": 50}, floors:KDMapInit(["tmb"]), shrines: ["Will"],
		dropTable: [{name: "MysticDuctTapeRaw", amount: 4, weight: 25}]},


	{name: "Mummy", nameList: "bast", outfit: "Mummy", style: "Mummy", clusterWith: "mummy", bound: "Mummy", faction: "Bast", color: KDBaseNeon, tags: KDMapInit(["leashing", "religious", "antiMagic", "darkvision", "opendoors", "closedoors", "jail", "jailer", "mummy", "melee", "elite", "mummyRestraints", "fireweakness", "soapweakness", "hunter"]), followLeashedOnly: true, followRange: 1,
		spells: ["MummyBolt", "EnemyCM1"], unlockCommandLevel: 1, unlockCommandCD: 90, specialCD: 3,
		specialAttack: "BindLock", playLine: "Mummy", spellCooldownMult: 1, spellCooldownMod: 5,
		specialAttackPoints: 2, specialWidth: 3, spellRdy: true,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 3, color: "#4fd658"},
		],
		maxblock: 1,
		maxdodge: 1,
		stamina: 4,
		Resistance: {
			profile: ["catgirl"],
		},
		attackLock: "Purple",
		AI: "hunt", guardChance: 0.6, visionRadius: 7, maxhp: 8,
		minLevel:3, weight:18, movePoints: 2, attackPoints: 2, attack: "SpellMeleeWill",
		attackWidth: 1, attackRange: 1, power: 4, fullBoundBonus: 2, dmgType: "crush",
		terrainTags: {"secondhalf":2, "lastthird":4, "open": 2, "increasingWeight":1, "mummy": 4},
		floors:KDMapInit(["tmb"]), shrines: ["Will"],
		dropTable: [{name: "Gold", amountMin: 15, amountMax: 20, weight: 10}, {name: "MysticDuctTapeRaw", amount: 15, weight: 4}]},
	{name: "Cleric", nameList: "bast", outfit: "Cleric", style: "Mummy", clusterWith: "mummy", bound: "Cleric", faction: "Bast", playLine: "Mummy", color: "#4fd658", tags: KDMapInit(["leashing", "religious", "opendoors", "closedoors", "mummy", "ranged", "search", "fireweakness", "soapweakness"]),
		followLeashedOnly: true, followRange: 4, attackThruBars: true,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 2, color: "#4fd658"},
		],
		maxblock: 0,
		maxdodge: 1,
		stamina: 2,
		Resistance: {
			profile: ["catgirl"],
		},
		spells: ["ClericBeam", "EnemyCM1"], unlockCommandLevel: 1, unlockCommandCD: 90, spellCooldownMult: 1, spellCooldownMod: 0, stopToCast: true, kite: 1.5, kiteChance: 0.9,
		attackPoints: 3, attack: "Spell", attackWidth: 1, attackRange: 1, power: 3, dmgType: "fire",
		AI: "guard", visionRadius: 7, maxhp: 8, minLevel:0, weight:13, movePoints: 1.5, fullBoundBonus: 1,
		terrainTags: {"secondhalf":0, "lastthird":1, "passage": -99, "open": 4, "mummy": 5}, floors:KDMapInit(["tmb"]),
		shrines: ["Will"], dropTable: [{name: "MysticDuctTapeRaw", amount: 5, weight: 25}]},
	{name: "ClericHigh", nameList: "bast", outfit: "Cleric", style: "Mummy", clusterWith: "mummy", bound: "Cleric",
		faction: "Bast", playLine: "Mummy", color: "#4fd658",
		tags: KDMapInit(["leashing", "religious", "opendoors", "closedoors", "mummy", "ranged", "search",
			"miniboss",
			"fireweakness", "soapweakness"]),
		followLeashedOnly: true, followRange: 2, attackThruBars: true,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 4, color: "#4fd658"},
		],
		ondeath: [{type: "spellOnSelf", spell: "HexLatexExplosion"}],
		maxblock: 0,
		maxdodge: 1,
		stamina: 2,
		Resistance: {
			profile: ["catgirl"],
		},
		Magic: {
			priority: {
				HexOrb: 10,
			},
		},
		spells: ["ClericBeamMulti", "HexOrb", "EnemyCM1"], unlockCommandLevel: 2, unlockCommandCD: 30,
		spellCooldownMult: 1, spellCooldownMod: 0, stopToCast: true, kite: 1.5, kiteChance: 0.9,
		spellResist: 1.0,
		attackPoints: 3, attack: "MeleeBindLockSpell", attackWidth: 2.5, attackRange: 1, power: 3, dmgType: "chain",
		AI: "hunt", visionRadius: 8, maxhp: 16, minLevel:3, weight:10, movePoints: 1.8, fullBoundBonus: 1,
		blindSight: 2,
		terrainTags: {"secondhalf":0, "lastthird":1, "passage": -99, "open": 14, "mummy": 5}, floors:KDMapInit(["tmb"]),
		shrines: ["Will"], dropTable: [{name: "MysticDuctTapeRaw", amount: 25, weight: 50}]},
	{name: "MeleeCleric", nameList: "bast", outfit: "Cleric", style: "Mummy", clusterWith: "mummy", bound: "MeleeCleric", playLine: "Mummy", faction: "Bast", tags: KDMapInit(["leashing", "darkvision", "opendoors", "closedoors", "mummy", "imprisonable", "melee", "kittyRestraints", "jail", "jailer", "search", "fireweakness", "soapweakness"]),
		followRange: 1, blindSight: 2.5, specialCD: 5, specialAttack: "BindLock",
		armor: 1,
		stamina: 6,
		Resistance: {
			profile: ["catgirl"],
		},
		maxblock: 2,
		maxdodge: 1,
		attackLock: "White",
		AI: "hunt", guardChance: 0.6, visionRadius: 6, maxhp: 8, minLevel:0, weight:15, movePoints: 1.5, attackPoints: 2, attack: "MeleeWill", attackWidth: 1, attackRange: 1, power: 2, fullBoundBonus: 2, dmgType: "grope",
		terrainTags: {"secondhalf":0, "lastthird":-2, "mummy": 6}, floors:KDMapInit(["tmb"]),
		shrines: ["Will"], dropTable: [{name: "MysticDuctTapeRaw", amount: 5, weight: 25}]},

	{name: "Jailer", outfit: "Jailer", style: "Earth", bound: "Jailer", tags: KDMapInit(["leashing", "opendoors", "closedoors", "antiMagic", "jail", "jailer", "genericJailer", "melee",
		"shackleRestraints", "steelCuffs", "guardCall", "jailRestraints"]), keys: true, followRange: 1, AI: "patrol",
		visionRadius: 6, maxhp: 12, minLevel: -1, weight:0, movePoints: 1, attackPoints: 3, attack: "MeleeBindLockWill", attackWidth: 1, attackRange: 1, power: 2, dmgType: "grope", fullBoundBonus: 2,
		stamina: 3,
		maxblock: 1,
		maxdodge: 0,
		terrainTags: {"jailGuard": 15, "Guard": 1}, allFloors: true, disarm: 0.5, evasion: -0.5, focusPlayer: true, attackLock: "White",
		dropTable: [{name: "Pick", weight: 15}, {name: "RedKey", weight: 5}]},
	{name: "Chef", nameList: "italian", outfit: "Chef", style: "Fire", bound: "Jailer", tags: KDMapInit(["leashing", "ignoregagged", "opendoors", "closedoors", "melee", "ballGagRestraintsMagic"]), followRange: 1, AI: "hunt",
		visionRadius: 6, maxhp: 24, minLevel: -1, weight:-1000, movePoints: 1.4, armor: 1.5,
		stamina: 6,
		maxblock: 5,
		maxdodge: 0,
		RestraintFilter: {
			unlimitedRestraints: true,
		},
		attackPoints: 2, attack: "MeleeBind", attackWidth: 2.5, attackRange: 1, power: 3, dmgType: "grope", fullBoundBonus: 2,
		terrainTags: {}, allFloors: true, disarm: 0.33, evasion: -0.5, focusPlayer: true,
		useLock: "Blue",
		dropTable: [{name: "Brownies", weight: 15}]},
	{name: "Guard", outfit: "Jailer", style: "Ice", bound: "Guard", tags: KDMapInit(["leashing", "opendoors", "closedoors", "antiMagic", "miniboss", "jail", "jailer", "melee",
		"shackleRestraints", "steelRestraints", "jailRestraints", "guardCall"]), noDisplace: false, keys: true, followRange: 1, AI: "guard", visionRadius: 6, disarm: 0.5,
		maxhp: 12, minLevel: -1, weight:-1000, movePoints: 1, attackPoints: 3, attack: "MeleeBindLockWill", attackWidth: 1, attackRange: 1, power: 2, dmgType: "grope",
		fullBoundBonus: 2, evasion: -0.5, focusPlayer: true, attackLock: "White",
		stamina: 2,
		maxblock: 1,
		maxdodge: 0,
		RemoteControl: {
			punishRemote: 3,
			punishRemoteChance: 0.15,
		},
		events: [
			{trigger: "defeat", type: "delete", chance: 1.0},
		],
		terrainTags: {"Guard": 1010}, allFloors: true, dropTable: [{name: "RedKey", weight: 1}]},
	{name: "GuardHeavy", nameList: "russian", outfit: "Jailer", style: "Air", bound: "GuardHeavy", tags: KDMapInit(["leashing", "opendoors", "closedoors", "antiMagic", "jail", "jailer", "melee", "unflinching", "hunter", "guardCall", "miniboss",
		"shackleRestraints", "steelRestraints", "handcuffer", "jailRestraints"]), noDisplace: false, disarm: 0.5,
		keys: true, followRange: 1, AI: "guard", visionRadius: 7, armor: 1.5, maxhp: 12, minLevel: 4, weight:-20, movePoints: 1, attackPoints: 2, evasion: -0.5, focusPlayer: true,
		attack: "MeleeBindLockWillStun", attackWidth: 3, attackRange: 1, power: 5, dmgType: "electric", stunTime: 1, attackLock: "Red",
		RemoteControl: {
			punishRemote: 4,
			punishRemoteChance: 0.2,
		},
		maxblock: 2,
		maxdodge: 1,
		stamina: 3,
		events: [
			{trigger: "defeat", type: "delete", chance: 1.0},
		],
		terrainTags: {"jailGuard": 22, "increasingWeight": 1, "jailbreak": 28}, allFloors: true, dropTable: [{name: "RedKey", weight: 1}]},


	// Minibosses
	{name: "BanditMerchant", nameList: "french", outfit: "BanditChief", style: "Bandit", faction: "Bandit", clusterWith: "bandit", playLine: "Bandit", bound: "BanditChief",
		tags: KDMapInit([
			"opendoors", "cacheguard", "closedoors", "leashing", "bandit", "banditleader",
			"boss", "melee", "ranged", "caster", "antiMagic",
			"ballGagRestraints", "banditMagicRestraints","leatherRestraints", "leatherRestraintsHeavy", "chainweakness", "glueweakness", "jailer", "hunter"
		]), cohesion: 0.9, armor: -1, followRange: 1, AI: "hunt",
		spells: ["PoisonDagger", "BearTrap", "LustBomb"], spellCooldownMult: 1, spellCooldownMod: 0, noSpellLeashing: true,
		stamina: 2,
		maxblock: 0,
		maxdodge: 3,
		summon: [
			{enemy: "BanditPet", range: 3, count: 2, chance: 1.0, strict: true},],
		visionRadius: 8, maxhp: 30, minLevel:3, weight:-20, movePoints: 2, attackPoints: 3, attack: "SpellMeleeBindLock", attackWidth: 3.6, attackRange: 1, power: 4, dmgType: "grope", fullBoundBonus: 2,
		terrainTags: {"boss": -5, "open": 10, "increasingWeight":1, "BanditEnemy": 11, "BanditWanted": 3, "BanditHated": 4}, shrines: ["Leather"], allFloors: true,
		factionrep: {"Bountyhunter": 0.02},
		dropTable: [{name: "Gold", amountMin: 80, amountMax: 100, weight: 10}]},



	// Bosses
	{name: "Fuuka1", recruitType: "FuukaRecruit", outfit: "Fuuka", style: "Fuuka", nameList: "Fuuka", playLine: "Fuuka", bound: "Fuuka", faction: "Boss", clusterWith: "zombie", tags: KDMapInit(["nosub", "nocapture", "leashing", "noshop", "fuuka", "zombie", "ranged", "mikoRestraints", "stageBoss", "boss", "nocapture", "unflinching"]),
		armor: 0, followRange: 3, AI: "guard",
		
		
		onSpawnScript: "Boss",
		wanderAISetting: "Boss",

		events: [
			{trigger: "getLights", type: "enemyTorch", power: 2, color: KDBaseWhite},
			{trigger: "tick", type: "BossAssignFaction", kind: "Fuuka"},
			{trigger: "tick", type: "FuukaManagement", count: 30},
		],
		RestraintFilter: {
			unlimitedRestraints: true,
			requiredItems: ["MikoGag", "MikoDress"],
		},
		Behavior: {
			leashCondition: "fuukaLeash",
		},
		preferDodge: true,
		stamina: 4,
		maxblock: 1,
		maxdodge: 3,
		unlockCommandLevel: 3, unlockCommandCD: 7,
		Magic: {
			castCooldownUnique: {
				FuukaOrb: 12,
			},
			priority: {
				FuukaOrb: 10,
			},
		},
		spells: ["ZombieOrb", "ManyOrbs", "EnemyCM_self"], spellCooldownMult: 0.25, spellCooldownMod: 0, castWhileMoving: true, buffallies: true, kite: 1.5, projectileAttack: true, accuracy: 0.7, noChannel: true,
		visionRadius: 8, maxhp: 80, minLevel:0, weight:-1000, movePoints: 2, attackPoints: 3, attack: "SpellMeleeBindLock", attackWidth: 3, attackRange: 1, power: 4, dmgType: "grope", fullBoundBonus: 4,
		attackLock: "White",
		terrainTags: {}, floors:KDMapInit([]), dropTable: [{name: "Scrolls", weight: 10}], ondeath: [{type: "bossstage", dialogue:"FuukaStage2", click: true}]},
	{name: "Fuuka2", recruitType: "FuukaRecruit", outfit: "Fuuka", style: "Fuuka", nameList: "Fuuka", playLine: "Fuuka", bound: "Fuuka", faction: "Boss", clusterWith: "zombie",
		tags: KDMapInit(["nosub", "leashing", "fuuka",
			"bulwark", "zombie", "ranged", "mikoRestraints", "stageBoss", "boss", "unstoppable"]),
		armor: 0, followRange: 1, AI: "hunt",
		onSpawnScript: "Boss",
		wanderAISetting: "Boss",
		RestraintFilter: {
			unlimitedRestraints: true,
			requiredItems: ["MikoGag", "MikoDress"],
		},
		Behavior: {
			leashCondition: "fuukaLeash",
		},
		special: true,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 3.5, color: "#ff7777"},
			{trigger: "tick", type: "BossAssignFaction", kind: "Fuuka"},
			{trigger: "tick", type: "FuukaManagement", count: 15},
		],
		maxblock: 3,
		maxdodge: 3,
		preferBlock: true,
		Magic: {
			castCooldownUnique: {
				FuukaOrbMulti: 12,
				SummonZombies: 30,
				SummonMikoGhosts: 24,
			},
			priority: {
				FuukaOrbMulti: 10,
				SummonZombies: 9,
				SummonMikoGhosts: 8,
			},
		},
		stamina: 6,
		unlockCommandLevel: 3, unlockCommandCD: 7,
		spells: ["ZombieOrb", "ManyOrbs", "SummonMikoGhosts", "SummonZombies", "EnemyCM_self", "FuukaOrbMulti"], spellCooldownMult: 0.25, spellCooldownMod: 0, castWhileMoving: true, buffallies: true, projectileAttack: true, accuracy: 0.85, noChannel: true,
		visionRadius: 12, maxhp: 45, minLevel:0, weight:-1000, movePoints: 1, attackPoints: 3, attack: "SpellMeleeBindLock", attackWidth: 3, attackRange: 1, power: 4, dmgType: "grope", fullBoundBonus: 4,
		attackLock: "Purple",
		terrainTags: {}, floors:KDMapInit([]), dropTable: [{name: "BlueKey", weight: 10}], ondeath: [{type: "dialogue_and_die", dialogue:"FuukaWin", click: true}]},

	{name: "FuukaRecruit", outfit: "Fuuka", style: "Fuuka", nameList: "Fuuka", playLine: "Fuuka", bound: "Fuuka", clusterWith: "zombie",
		tags: KDMapInit(["nosub", "leashing", "fuuka",
			"bulwark", "zombie", "ranged", "mikoRestraints", "unstoppable", "stageBossRecruit"]),
		armor: 0, followRange: 1, AI: "hunt",
		RestraintFilter: {
			unlimitedRestraints: true,
			requiredItems: ["MikoGag", "MikoDress"],
		},
		special: true,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 3.5, color: "#ff7777"},
		],
		maxblock: 3,
		maxdodge: 3,
		preferBlock: true,
		Magic: {
			castCooldownUnique: {
				SummonMikoGhosts: 45,
			},
			priority: {
				SummonMikoGhosts: 15,
			},
		},
		stamina: 6,
		unlockCommandLevel: 3, unlockCommandCD: 7,
		spells: ["ZombieOrb", "ManyOrbs", "SummonMikoGhosts", "EnemyCM_self"], spellCooldownMult: 0.75, spellCooldownMod: 0, castWhileMoving: true, buffallies: true, projectileAttack: true, accuracy: 0.85, noChannel: true,
		visionRadius: 12, maxhp: 40, minLevel:0, weight:-1000, movePoints: 1, attackPoints: 3, attack: "SpellMeleeBindLock", attackWidth: 3, attackRange: 1, power: 4, dmgType: "grope", fullBoundBonus: 4,
		attackLock: "Purple",
		terrainTags: {}, floors:KDMapInit([]), dropTable: [{name: "BlueKey", weight: 10}]},

	{name: "FuukaPillar", faction: "Natural", color: KDBaseRed,
		lowpriority: true,
		nonDirectional: true, noFlip: true,
		Sound: {
			baseAmount: 1,
			moveAmount: 0,
		},
		Resistance: {
			profile: ["construct"],
		},
		tags: KDMapInit(["scenery", "minor", "inactive", "nonvulnerable", "unstoppable", "immobile", "nobrain", "nosignal", "fire", "temporary", "coldimmune",
			"poisonimmune", "soulimmune", "fireimmune", "pierceresist", "coldweakness", "holyweakness", "tickleresist", "groperesist", "painresist", "charmimmune",
		]),
		spellResist: 1, armor: 2,
		sneakthreshold: 0.6,
		evasion: -9, ignorechance: 1.0, followRange: 3.5, AI: "ambush", ambushRadius: 0, difficulty: -0.05, regen: 0.05,
		visionRadius: 3.5, maxhp: 7, minLevel:0, weight:-10, movePoints: 99999, attackPoints: 4, attack: "", attackWidth: 1.25, attackRange: 1, power: 1, dmgType: "fire",
		terrainTags: {}, allFloors: false, shrines: ["Will"],
		ondeath: [{type: "summon", enemy: "SummonedZombie", range: 2.5, count: 4, strict: true, lifetime: 50}],
		events: [
			{trigger: "afterPlayerAttack", type: "spellReflect", spell: "SealingBolt", time: 1},
			{trigger: "NPCHitNPC", type: "spellReflect", spell: "SealingBolt", time: 1},
			{trigger: "afterDamageEnemy", type: "spellReflect", spell: "SealingBolt", time: 1},
		],
	},

	{name: "MikoGhost", faction: "Ghost", color: KDBaseWhite, clusterWith: "ghost",
		tags: KDMapInit(["flying", "fuuka", "ghost", "melee", "glueimmune", "chainimmune", "temporary"]), ethereal: true, ignorechance: 0, armor: 0, followRange: 1, AI: "hunt",
		specialCD: 7, specialAttack: "Slow",
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 2, color: KDBaseWhite},
		],
		stamina: 2,
		maxblock: 0,
		maxdodge: 0,
		visionRadius: 30, blindSight: 30, evasion: 9.0, alwaysEvade: true, maxhp: 1, regen: -0.051, minLevel:0, weight:-1000, movePoints: 2, attackPoints: 1, attack: "MeleeWill", attackWidth: 3, attackRange: 1, power: 1, dmgType: "grope", fullBoundBonus: 0,
		terrainTags: {}, shrines: ["Illusion"], floors:KDMapInit([]), dropTable: [{name: "Ectoplasm", chance: 0.6, weight: 10}],},

	{name: "WardenArcher", nameList: "dragonheart", outfit: "Bandit", style: "GreenHair", bound: "WardenArcher", color: KDBaseMint,
		playLine: "Adventurer_Sub_Fighter",
		armor: -0.5,
		tags: KDMapInit(["opendoors", "warden", "wardenprisoner", "miniboss", "leashing", "human", "melee", "leatherRestraints",
			"leatherRestraintsHeavy", "gropeweakness", "iceweakness", "jail", "jailer", "submissive"]), cohesion: 0.9,
		evasion: 0.2, kite: 4.5,
		faction: "Boss",
		dontKiteWhenDisabled: true,
		Behavior: {
			leashCondition: "wardenLeash",
		},

		spells: ["RestrainingBolt"], spellCooldownMult: 1, spellCooldownMod: 0, castWhileMoving: true, projectileTargeting: true, accuracy: 1.5,

		followLeashedOnly: true, ignorechance: 0, followRange: 2.5, AI: "hunt", guardChance: 0.0,
		visionRadius: 14.5, blindSight: 8, maxhp: 40, minLevel:12, weight:1, movePoints: 2, attackPoints: 3, attack: "SpellMeleeWillBindLock",
		attackWidth: 2.5, attackRange: 1, power: 3, dmgType: "grope", fullBoundBonus: 1,
		stamina: 10,
		preferDodge: true, maxblock: 0, maxdodge: 2,
		events: [
			{trigger: "tick", type: "BossAssignFaction", kind: "Warden"},
			{trigger: "afterDamageEnemy", type: "FreeWardenPrisoners"},
		],
		attackLock: "Red_Hi",
		terrainTags: {}, shrines: [], floors:KDMapInit([]),
		dropTable: [{name: "PotionStamina", weight: 100, amount: 3}]},

	{name: "WardenFighter", nameList: "dragonheart", outfit: "AdventurerDom", style: "BlackCatGirl", bound: "WardenFighter", color: KDBaseRed,
		playLine: "Adventurer_Switch_Fighter",
		armor: 1,
		Resistance: {
			block_phys: 1.0,
		},
		tags: KDMapInit(["opendoors", "warden", "wardenprisoner", "miniboss", "leashing", "human", "melee", "leatherRestraints",
			"bulwark",
			"leatherRestraintsHeavy", "painweakness", "iceweakness", "jail", "jailer", "submissive"]), cohesion: 0.9,
		faction: "Boss",
		dontKiteWhenDisabled: true,
		Behavior: {
			leashCondition: "wardenLeash",
		},

		spells: ["Taunt"], spellCooldownMult: 1, spellCooldownMod: 0, castWhileMoving: true, projectileTargeting: true, accuracy: 1.5,

		followLeashedOnly: true, ignorechance: 0, followRange: 2.5, AI: "hunt", guardChance: 0.0,
		visionRadius: 13.5, blindSight: 8, maxhp: 50, minLevel:12, weight:1, movePoints: 1.5, attackPoints: 2, attack: "SpellMeleeWillBindLock",
		attackWidth: 3, attackRange: 1, power: 3, dmgType: "pain", fullBoundBonus: 1,
		stamina: 7,
		preferDodge: true, maxblock: 0, maxdodge: 1,
		events: [
			{trigger: "tick", type: "BossAssignFaction", kind: "Warden"},
			{trigger: "afterDamageEnemy", type: "FreeWardenPrisoners"},
		],
		attackLock: "Red_Hi",
		terrainTags: {}, shrines: [], floors:KDMapInit([]),
		dropTable: [{name: "PotionWill", weight: 100, amount: 3}]},


	{name: "WardenMage", nameList: "dragonheart", outfit: "AdventurerSub", style: "BlueHair", bound: "WardenMage", color: KDBaseLightBlue,
		playLine: "Adventurer_Brat_Fighter",
		armor: -1,
		Resistance: {
			block_magic: 2.0,
		},
		tags: KDMapInit(["opendoors", "warden", "wardenprisoner", "miniboss", "leashing", "human", "melee", "leatherRestraints",
			"leatherRestraintsHeavy", "tickleweakness", "iceweakness", "jail", "jailer", "submissive"]), cohesion: 0.9,
		evasion: -0.2, kite: 4.5,
		faction: "Boss",
		dontKiteWhenDisabled: true,

		spells: ["MagicMissile", "MagicMissileChannel", "MagicMissileChannel"], spellCooldownMult: 1, spellCooldownMod: 0, castWhileMoving: true, projectileTargeting: true, accuracy: 1.5,

		followLeashedOnly: true, ignorechance: 0, followRange: 2.5, AI: "hunt", guardChance: 0.0,
		visionRadius: 14.5, blindSight: 8, maxhp: 30, minLevel:12, weight:1, movePoints: 1.4, attackPoints: 3, attack: "SpellMeleeWillBindLockAll",
		attackWidth: 2.5, attackRange: 1, power: 3, dmgType: "tickle", fullBoundBonus: 1,
		stamina: 4,
		preferDodge: true, maxblock: 0, maxdodge: 1,
		events: [
			{trigger: "tick", type: "BossAssignFaction", kind: "Warden"},
			{trigger: "afterDamageEnemy", type: "FreeWardenPrisoners"},
		],
		Behavior: {
			leashCondition: "wardenLeash",
		},
		attackLock: "Purple",
		terrainTags: {}, shrines: [], floors:KDMapInit([]),
		dropTable: [{name: "PotionMana", weight: 100, amount: 3}]},

	{name: "TheWarden1", recruitType: "TheWardenRecruit", outfit: "Jailer", style: "Jailer", nameList: "TheWarden", playLine: "TheWarden", bound: "TheWarden", faction: "Boss", clusterWith: "human",
		color: "#ffaa44",
		tags: KDMapInit(["nosub", "nocapture", "leashing", "noshop", "warden", "human", "magicresist", "soulweakness", "ranged", "highsecRestraints", "leatherRestraints", "leatherRestraintsHeavy", "stageBoss", "boss"]),
		armor: 1, followRange: 3, AI: "guard",
		events: [
			{trigger: "tick", type: "BossAssignFaction", kind: "Warden"},
			{trigger: "tick", type: "WardenManagement", count: 1},
		],
		onSpawnScript: "Boss",
		wanderAISetting: "Boss",
		RestraintFilter: {
			unlimitedRestraints: true,
		},
		Behavior: {
			leashCondition: "wardenLeash",
		},
		preferDodge: true,
		stamina: 4,
		maxblock: 1,
		maxdodge: 0,
		unlockCommandLevel: 3, unlockCommandCD: 7,
		spells: ["OneBarMissile", "EnemyCM_self"], spellCooldownMult: 0.4, spellCooldownMod: 0, castWhileMoving: true, buffallies: true, kite: 2.5, projectileAttack: true, accuracy: 0.75, noChannel: true,
		visionRadius: 8, maxhp: 30, minLevel:0, weight:-1000, movePoints: 2, attackPoints: 3, attack: "SpellMeleeBindLockAllWill", attackWidth: 2.5, attackRange: 1, power: 4, dmgType: "grope", fullBoundBonus: 4,
		attackLock: "Purple",
		terrainTags: {}, floors:KDMapInit([]), dropTable: [{name: "Scrolls", weight: 10}], ondeath: [{type: "bossstage", dialogue:"TheWardenStage2", click: true}]},

	{name: "TheWarden2", recruitType: "TheWardenRecruit", outfit: "Jailer", style: "Jailer", nameList: "TheWarden", playLine: "TheWarden", bound: "TheWarden", faction: "Boss", clusterWith: "human",
		color: "#ffaa44",
		tags: KDMapInit(["nosub", "leashing", "noshop", "warden", "human", "soulweakness", "magicresist", "ranged", "highsecRestraints", "leatherRestraints", "leatherRestraintsHeavy", "stageBoss", "boss", "unflinching"]),
		armor: 1, followRange: 3, AI: "guard",
		events: [
			{trigger: "tick", type: "BossAssignFaction", kind: "Warden"},
			{trigger: "tick", type: "WardenManagement", count: 3},
		],
		onSpawnScript: "Boss",
		wanderAISetting: "Boss",
		RestraintFilter: {
			unlimitedRestraints: true,
		},
		Behavior: {
			leashCondition: "wardenLeash",
		},
		special: true,
		preferDodge: true,
		stamina: 4,
		maxblock: 1,
		maxdodge: 1,
		unlockCommandLevel: 3, unlockCommandCD: 7,
		spells: ["OneBarMissile", "EnemySteelRainBurst", "EnemyCM_self"], spellCooldownMult: 0.4, spellCooldownMod: 0, castWhileMoving: true, buffallies: true, kite: 2.5, projectileAttack: true, accuracy: 0.75, noChannel: true,
		visionRadius: 9, maxhp: 80, minLevel:0, weight:-1000, movePoints: 2, attackPoints: 3, attack: "SpellMeleeBindLockAllWill", attackWidth: 2.5, attackRange: 1, power: 4, dmgType: "grope", fullBoundBonus: 4,
		attackLock: "HiSec",
		terrainTags: {}, floors:KDMapInit([]), dropTable: [{name: "Scrolls", weight: 10}], ondeath: [{type: "dialogue_and_die", dialogue:"TheWardenWin", click: true}]},

	{name: "TheWardenRecruit", outfit: "Jailer", style: "Jailer", nameList: "TheWarden", playLine: "TheWarden", bound: "TheWarden", clusterWith: "human",
			color: "#ffaa44",
			tags: KDMapInit(["nosub", "leashing", "noshop", "warden", "human", "soulweakness", "magicresist", "ranged", "highsecRestraints", "leatherRestraints", "leatherRestraintsHeavy", "unflinching", "stageBossRecruit"]),
			armor: 1, followRange: 3, AI: "guard",
			
			RestraintFilter: {
				unlimitedRestraints: true,
			},
			special: true,
			preferDodge: true,
			stamina: 4,
			maxblock: 1,
			maxdodge: 1,
			unlockCommandLevel: 3, unlockCommandCD: 7,
			spells: ["EnemySteelRainBurst", "EnemyCM_self"], spellCooldownMult: 0.5, spellCooldownMod: 0, castWhileMoving: true, buffallies: true, kite: 2.5, projectileAttack: true, accuracy: 0.75, noChannel: true,
			visionRadius: 9, maxhp: 40, minLevel:0, weight:-1000, movePoints: 2, attackPoints: 3, attack: "SpellMeleeBindLockAllWill", attackWidth: 2.5, attackRange: 1, power: 4, dmgType: "grope", fullBoundBonus: 4,
			attackLock: "HiSec",
			terrainTags: {}, floors:KDMapInit([]), dropTable: [{name: "Scrolls", weight: 10}]},

	{name: "DollmakerBoss1", recruitType: "DollmakerRecruit", outfit: "DollSuit", playLine: "Dollmaker", bound: "DollmakerBoss", faction: "Boss", clusterWith: "dollsmith",
		applyFaction: "Dollsmith",
		tags: KDMapInit(["nosub", "leashing", "noshop", "dollsmith", "ranged", "nocapture", "slimewalk",
			"bulwark",
			"glueresist", "electricresist", "crushresist", "iceweakness", "dollmakerrestraints", "controlharness", "cyberdollchastity", "teasetoys", "stageBoss", "boss", "nocapture", "unstoppable"]),
		spellResist: 2.0, armor: 0.5, followRange: 1.5, AI: "guard", kite: 4.5, noKiteWhenHarmless: true, dontKiteWhenDisabled: true,
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 3.5, color: "#ff88ff"},
			{trigger: "afterEnemyTick", type: "dollmakerMissiles", count: 2, time: 8, dist: 10, kind: "RubberMissile"},
			{trigger: "tick", type: "BossAssignFaction", kind: "Dollsmith"},
		],
		onSpawnScript: "Boss",
		wanderAISetting: "Boss",
		RestraintFilter: {
			unlimitedRestraints: true,
		},
		Behavior: {
			leashCondition: "dollmakerLeash",
		},
		maxblock: 3,
		maxdodge: 1,
		preferDodge: true,
		stamina: 2,
		unlockCommandLevel: 3, unlockCommandCD: 14,
		spells: ["SummonDrones", "DollConvertMany", "DollBoost", "EnemyCM_self"],
		spellCooldownMult: 0.25, spellCooldownMod: 0, castWhileMoving: true, buffallies: true, projectileAttack: true, accuracy: 0.7, noChannel: true,
		visionRadius: 9, maxhp: 70, minLevel:0, weight:-1000, movePoints: 2, attackPoints: 3, attack: "SpellMeleeBindLockAll", attackWidth: 3, attackRange: 1, power: 4, dmgType: "soul", fullBoundBonus: 4,
		terrainTags: {}, floors:KDMapInit([]),
		ondeath: [{type: "bossstage", dialogue:"DollmakerStage2", click: true}],
	},

	{name: "DollmakerBoss2", recruitType: "DollmakerRecruit", outfit: "DollSuit", playLine: "Dollmaker", bound: "DollmakerBoss", faction: "Boss", clusterWith: "dollsmith",
		applyFaction: "Dollsmith",
		tags: KDMapInit(["nosub", "leashing", "noshop", "dollsmith", "ranged", "nocapture", "slimewalk",
			"bulwark",
			"glueresist", "electricresist", "crushresist", "iceweakness", "dollmakerrestraints", "cyberdollchastity", "cyberdollrestraints", "controlharness", "teasetoys", "stageBoss", "boss", "nocapture", "unstoppable"]),
		spellResist: 2.0, armor: 0.5, followRange: 5.5, AI: "guard",
		events: [
			{trigger: "tick", type: "suicideWhenBound"},
			{trigger: "getLights", type: "enemyTorch", power: 3.5, color: "#ff88ff"},
			{trigger: "afterEnemyTick", type: "dollmakerMissiles", count: 2, time: 15, dist: 10, kind: "RubberNuke"},
			{trigger: "tick", type: "BossAssignFaction", kind: "Dollsmith"},
		],
		onSpawnScript: "Boss",
		wanderAISetting: "Boss",
		stamina: 3,
		maxblock: 1,
		maxdodge: 3,
		RestraintFilter: {
			unlimitedRestraints: true,
		},
		Behavior: {
			leashCondition: "dollmakerLeash",
		},
		preferDodge: true,
		unlockCommandLevel: 3, unlockCommandCD: 14,
		spells: ["SummonCaptureDrones", "DollConvertMany", "DollBoost", "EnemyCM_self"],
		spellCooldownMult: 0.15, spellCooldownMod: 0, castWhileMoving: true, buffallies: true, kite: 2.5, accuracy: 0.85, noChannel: true,
		visionRadius: 20, blindSight: 7, maxhp: 60, minLevel:0, weight:-1000, movePoints: 2, attackPoints: 3, attack: "SpellMeleeBindLockAll", attackWidth: 3, attackRange: 1, power: 4, dmgType: "soul", fullBoundBonus: 4,
		terrainTags: {}, floors:KDMapInit([]),
		ondeath: [{type: "bossstage", dialogue:"DollmakerStage3", click: true}]},

	{name: "DollmakerBoss3", recruitType: "DollmakerRecruit", nameList: "Dollmaker", outfit: "Dollmaker", style: "Dollmaker", playLine: "Dollmaker", bound: "DollmakerBoss", faction: "Boss", clusterWith: "dollsmith",
		applyFaction: "Dollsmith",
		tags: KDMapInit(["nosub", "leashing", "noshop", "dollsmith", "ranged", "slimewalk",
			"bulwark",
			"glueresist", "electricresist", "crushresist", "iceweakness", "dollmakerrestraints", "cyberdollchastity", "cyberdollrestraints", "cyberdollheavy", "controlharness", "teasetoys", "stageBoss", "boss", "unstoppable"]),
		spellResist: 2.0, armor: 0.5, followRange: 1.5, AI: "guard",
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 3.5, color: "#ff88ff"},
			{trigger: "afterEnemyTick", type: "dollmakerMissiles", count: 2, time: 9, dist: 10, kind: "RubberNuke"},
			{trigger: "tick", type: "BossAssignFaction", kind: "Dollsmith"},
		],
		onSpawnScript: "Boss",
		wanderAISetting: "Boss",
		preferBlock: true,
		maxblock: 5,
		maxdodge: 0,
		stamina: 5,
		RestraintFilter: {
			unlimitedRestraints: true,
		},
		Behavior: {
			leashCondition: "dollmakerLeash",
		},
		special: true,
		unlockCommandLevel: 3, unlockCommandCD: 14,
		spells: ["DollConvertMany", "DollBoost", "EnemyCM_self", "ManyCables"],
		spellCooldownMult: 0.2, spellCooldownMod: 0, castWhileMoving: true, buffallies: true, projectileAttack: true, accuracy: 1.15, noChannel: true,
		visionRadius: 30, blindSight: 30, maxhp: 140, minLevel:0, weight:-1000, movePoints: 1.7, attackPoints: 3, attack: "SpellMeleeBindLockAll", attackWidth: 3, attackRange: 1, power: 4, dmgType: "soul", fullBoundBonus: 4,
		terrainTags: {}, floors:KDMapInit([]),
		ondeath: [{type: "dialogue_and_die", dialogue:"DollmakerWin", click: true}]},

	{name: "DollmakerRecruit", nameList: "Dollmaker", outfit: "Dollmaker", style: "Dollmaker", playLine: "Dollmaker", bound: "DollmakerBoss", clusterWith: "dollsmith",
		applyFaction: "Dollsmith",
		tags: KDMapInit(["nosub", "leashing", "noshop", "dollsmith", "ranged", "slimewalk",
			"bulwark",
			"glueresist", "electricresist", "crushresist", "iceweakness", "dollmakerrestraints", "cyberdollchastity", "cyberdollrestraints", "cyberdollheavy", "controlharness", "teasetoys", "unstoppable", "stageBossRecruit"]),
		spellResist: 2.0, armor: 0.5, followRange: 1.5, AI: "guard",
		events: [
			{trigger: "getLights", type: "enemyTorch", power: 3.5, color: "#ff88ff"},
		],
		preferBlock: true,
		maxblock: 5,
		maxdodge: 0,
		stamina: 5,
		RestraintFilter: {
			unlimitedRestraints: true,
		},
		Magic: {
			castCooldownUnique: {
				SummonDrones: 20,
			}
		},
		special: true,
		unlockCommandLevel: 3, unlockCommandCD: 14,
		spells: ["SummonDrones", "EnemyCM_self", "ManyCables"],
		spellCooldownMult: 0.2, spellCooldownMod: 0, castWhileMoving: true, buffallies: true, projectileAttack: true, accuracy: 1.15, noChannel: true,
		visionRadius: 30, blindSight: 30, maxhp: 40, minLevel:0, weight:-1000, movePoints: 1.7, attackPoints: 3, attack: "SpellMeleeBindLockAll", attackWidth: 3, attackRange: 1, power: 4, dmgType: "soul", fullBoundBonus: 4,
		terrainTags: {}, floors:KDMapInit([])},


	//region curse

	{name: "EpicenterCursed", faction: "Curse", color: "#880044",
		tags: KDMapInit(["opendoors", "epicenterCursed", "epicenter", "curseTrap", "ghost", "cursed", "soulimmune", "melee", "fireweakness", "shadowimmune", "glueimmune", "chainimmune", "shadowHands", "poisonimmune", "meleeresist", "flying"]),
		ignorechance: 0, armor: 0, followRange: 1, AI: "huntshadow", noAlert: true, hitsfx: "Evil",
		ethereal: true,
		spells: ["ManyShadowHands", "ManyObsidianBolts", "CursingCircle", "CursingCircle"], spellCooldownMult: 1.1, spellCooldownMod: 0, castWhileMoving: true,
		visionRadius: 15, blindSight: 8, evasion: -2, maxhp: 61.7, minLevel: 0, weight:0,
		movePoints: 4, attackPoints: 2, attack: "Spell",
		attackWidth: 1, attackRange: 1, power: 1.0, dmgType: "cold", fullBoundBonus: 4,
		regen: 0.02,
		maxblock: 0,
		maxdodge: 0,
		stamina: 2,
		events: [
			{trigger: "tick", type: "DeleteCurse", tags: ["cursedCollar"]},
			{trigger: "addEntity", type: "EpicenterAssignHP"},
		],
		terrainTags: {"curseTrap": 10}, shrines: [], allFloors: true,
		dropTable: [{name: "ManaOrb", weight: 1}],
	},
	{name: "EpicenterCursed2", faction: "Curse", color: "#a4affa",
		tags: KDMapInit(["opendoors", "epicenterCursed", "epicenter", "curseTrap", "ghost", "cursed", "soulimmune", "melee", "fireweakness", "shadowimmune", "glueimmune", "chainimmune", "shadowHands", "poisonimmune", "meleeresist", "flying"]),
		ignorechance: 0, armor: 0, followRange: 1, AI: "huntshadow", noAlert: true, hitsfx: "Evil",
		ethereal: true,
		spells: ["ManyShadowHands", "ManyMithrilBolts", "CursingCircle2", "CursingCircle2"], spellCooldownMult: 1.1, spellCooldownMod: 0, castWhileMoving: true,
		visionRadius: 15, blindSight: 8, evasion: -2, maxhp: 61.7, minLevel: 0, weight:0,
		movePoints: 4, attackPoints: 2, attack: "Spell",
		attackWidth: 1, attackRange: 1, power: 1.0, dmgType: "cold", fullBoundBonus: 4,
		regen: 0.02,
		maxblock: 0,
		maxdodge: 0,
		stamina: 2,
		events: [
			{trigger: "tick", type: "DeleteCurse", tags: ["cursedCollar2"]},
			{trigger: "addEntity", type: "EpicenterAssignHP"},
		],
		terrainTags: {"curseTrap": 10}, shrines: [], allFloors: true,
		dropTable: [{name: "ManaOrb", weight: 1}],
	},
	//endregion
];


let KDOndeath: Record<string, (enemy: entity, o: any, mapData: KDMapDataType) => void> = {
	"DirtPile": (enemy, _o, mapData) => {
		if (!KDGameData.QuestData.DirtPiles) KDGameData.QuestData.DirtPiles = {
			pilesTotal: 0,
			pilesSinceLastSpawn: 0,
			lastSpawn: "Frog",
			quota: -10,
		};
		if (KDRandom() < -0.2 + 0.1 * KDGameData.QuestData.DirtPiles.pilesSinceLastSpawn) {
			let type = CommonRandomItemFromList(KDGameData.QuestData.DirtPiles.lastSpawn, [
				"Frog",
				"SlimeMold",
				"SlimeMoldLeaper",
				"SmallSlime",
				"Bat",
				"Rat",
				"Ghost",
				"Mimic",
				"Gag",
				"AnimArmbinder",
				"AnimHarness",
				"AnimStraitjacket",
				"AnimYoke",
			]);
			if (mapData == KDMapData)
				KinkyDungeonSummonEnemy(enemy.x, enemy.y, type, 1, 0.5, false, undefined, false, undefined, "Ambush", true, 0, true, undefined, false);
			KDGameData.QuestData.DirtPiles.lastSpawn = type;
			if (mapData == KDMapData)
				KinkyDungeonSendTextMessage(9, TextGet("KDDirtPileSurprise").replace("ENMY", TextGet("Name" + type)), KDBaseOrange, 6);
			KDGameData.QuestData.DirtPiles.pilesSinceLastSpawn = 0;
		} else {
			KDGameData.QuestData.DirtPiles.pilesSinceLastSpawn += 1;
		}
		KDGameData.QuestData.DirtPiles.pilesTotal += 1;
	},
	"WolfServer": (enemy, _o, mapData) => {
		// TODO
	},
	"DragonSeal": (enemy, _o, mapData) => {
		if (enemy.id == KDGameData.DragonTarget) {
			KDGameData.DragonCaptured = true;
		}
	},

	

	"transform": (enemy, o, mapData) => {
		if (mapData == KDMapData) {
			let f: entity = null;
			let e = KinkyDungeonSummonEnemy(enemy.x, enemy.y, o.enemy, 1, 0.5, 
				o.strict, o.lifetime, o.hidden, undefined, 
				o.faction || KDGetFaction(enemy), 
				!!enemy.hostile, o.minradius, o.startAware, undefined, o.hideTimer);
			for (let en of e) {
				if (!f) {
					f = en;
					f.id = enemy.id;
					f.CustomName = enemy.CustomNameColor;
					f.CustomNameColor = enemy.CustomNameColor;
					f.created = enemy.created;
					f.homeCoord = enemy.homeCoord;
					if (o.storeTrueForm) {
						let NPC = KDGetPersistentNPC(f.id);
						if (NPC) {
							NPC.trueEntity = enemy;
						}
					}
					if (o.inheritDamage && enemy.hp < 0) {
						en.hp -= -enemy.hp;
					}

				} else
					KDProcessCustomPatron(en.Enemy, en, 0, false);

			}
		}

	},
	"summon": (enemy, o, mapData) => {
		if (mapData == KDMapData) {
			let f: entity = null;
			let e = KinkyDungeonSummonEnemy(enemy.x, enemy.y, o.enemy, o.count, o.range, o.strict, o.lifetime, o.hidden, undefined, o.faction || KDGetFaction(enemy), o.hostile, o.minradius, o.startAware, undefined, o.hideTimer);
			for (let en of e) {
				if (o.sameid && !f) {
					f = en;
					f.id = enemy.id;
					f.CustomName = enemy.CustomNameColor;
					f.CustomNameColor = enemy.CustomNameColor;
					f.created = enemy.created;
					f.homeCoord = enemy.homeCoord;
					if (o.storeTrueForm) {
						let NPC = KDGetPersistentNPC(f.id);
						if (NPC) {
							NPC.trueEntity = enemy;
						}
					}

				} else
					KDProcessCustomPatron(en.Enemy, en, 0, false);

			}
		}

	},
	"dialogue": (enemy, o, mapData) => {
		if (mapData == KDMapData)
			KDStartDialog(o.dialogue, enemy.Enemy.name, o.click, enemy.personality, enemy);
	},
	"die": (enemy, o, mapData) => {
		if (KDIsNPCPersistent(enemy.id)) {
			let npc = KDGetPersistentNPC(enemy.id);
			// if not captured, we just delete
			if (!npc.collect) {
				DisposeEntity(enemy.id);
			}
		}
	},
	"dialogue_and_die": (enemy, o, mapData) => {
		// make them not spawn
		
		if (mapData == KDMapData)
			KDStartDialog(o.dialogue, enemy.Enemy.name, o.click, enemy.personality, enemy);
		if (KDIsNPCPersistent(enemy.id)) {
			let npc = KDGetPersistentNPC(enemy.id);
			// if not captured, we prevent them from spawning ever again
			if (!npc.collect) {
				npc.deactivated = true;
			}
		}
	},

	"bossstage": (enemy, o, mapData) => {
		if (mapData == KDMapData)
			KDStartDialog(o.dialogue, enemy.Enemy.name, o.click, enemy.personality, enemy);
		enemy.hp = 0;
	},
	"murder": (_enemy, _o, mapData) => {
		if (mapData == KDMapData)
			KDMurderShopkeeper(1);
	},
	"spellOnSelf": (enemy, o, mapData) => {
		if (mapData == KDMapData) {
			let spell = KinkyDungeonFindSpell(o.spell, true);
			if (spell) KinkyDungeonCastSpell(enemy.x, enemy.y, spell, undefined, undefined, undefined, KDGetFaction(enemy));
		}
	},
	"MasterGear": (enemy, o, mapData) => {
		if (mapData == KDMapData) {
			let masterWorkItems = KDGetRestraintsEligible(
				{tags: ['masterworkRestraints']}, KDGetEffLevel(), KDCurrIndex(),
				true, undefined, undefined, undefined,
				undefined, undefined, true
			);
			masterWorkItems = masterWorkItems.filter((m) => {
				return !KinkyDungeonPlayerTags.get(m.restraint.name + "Worn");
			})
			if (masterWorkItems.length > 0) {
				let chosen = CommonRandomItemFromList(undefined, masterWorkItems);
				if (chosen) {
					mapData.GroundItems.push({x:enemy.x, y:enemy.y, name: chosen.restraint.name});
				}
			}
		}
	},
	"removeQuest": (_enemy, o) => {
		KDRemoveQuest(o.quest, false, false, true);
	},
	"dollID": (enemy, _o, mapData) => {
		if (mapData == KDMapData && KDistChebyshev(enemy.x - KinkyDungeonPlayerEntity.x, enemy.y - KinkyDungeonPlayerEntity.y) < 9) {
			if (!KinkyDungeonFlags.get("gotDollID")) {
				let dropped = {x:enemy.x, y:enemy.y, name: "DollID"};
				KDMapData.GroundItems.push(dropped);
				KinkyDungeonSetFlag("gotDollID", -1, 1);
			}
		}
	},
	"addQuest": (_enemy, o) => {
		KDAddQuest(o.quest);
	},
};

let KDSpecialConditions: Record<string, SpecialCondition> = {
	"canRestrainWithExtra": {
		resetCD: false,
		criteria: (enemy, AIData) => {
			let rThresh = enemy.Enemy.RestraintFilter?.powerThresh || KDDefaultRestraintThresh;
			return !AIData.player?.player
				|| (KDEnemyHasFlag(enemy, "targ_player")
				&& KDistChebyshev(enemy.x - AIData.player.x, enemy.y - AIData.player.y) < 3
				&& KDGetRestraintsEligible(
				{tags: KDGetTags(enemy, true)}, MiniGameKinkyDungeonLevel,
				KDCurrIndex(),
				enemy.Enemy.bypass,
					enemy.Enemy.useLock ? enemy.Enemy.useLock : "",
					!(enemy.Enemy.ignoreStaminaForBinds || (true && enemy.Enemy.specialIgnoreStam)) && !AIData.attack.includes("Suicide"),
					false,
					!(KinkyDungeonStatsChoice.has("TightRestraints") || enemy.Enemy.tags.miniboss || enemy.Enemy.tags.boss),
					KDGetExtraTags(enemy, true, true),
					false,
					{
						maxPower: rThresh + 0.01,
						looseLimit: true,
						onlyUnlimited: true,
						ignore: enemy.items,
					}, enemy, undefined, undefined, undefined,  undefined, undefined, {
						QuitOnFirst: true,
					}
			).length > 0);
		}
	}
};

let KDSpecialBuffs: Record<string, KDSpecialEnemyBuff> = {
	"Armored": {
		filter: (_enemy, types) => {
			return types.some((type) => {return ["HighValue", "NGP_Reg", "Hardmode_Reg"].includes(type);});
		},
		weight: (_enemy, _types) => {
			return 40;
		},
		apply: (enemy, _types) => {
			KinkyDungeonApplyBuffToEntity(enemy, {
				id: "Armored",
				aura: KDBaseWhite, auraSprite: "Armored",
				noAuraColor: true,
				duration: 9999, infinite: true,
				power: 3,
				type: "Armor",
			});
		},
	},
	"Fast": {
		filter: (enemy, types) => {
			if (KDIsImmobile(enemy)) return false;
			return types.some((type) => {return ["HighValue", "NGP_Reg", "Hardmode_Reg"].includes(type);});
		},
		weight: (_enemy, _types) => {
			return 40;
		},
		apply: (enemy, _types) => {
			KinkyDungeonApplyBuffToEntity(enemy, {
				id: "Fast",
				aura: KDBaseWhite, auraSprite: "Fast",
				noAuraColor: true,
				duration: 9999, infinite: true,
				power: 0.5,
				type: "MoveSpeed",
			});
		},
	},
	"Muscle": {
		filter: (enemy, types) => {
			if (!enemy.Enemy.attack?.includes("Melee") && !enemy.Enemy.specialAttack?.includes("Melee")) return false;
			return types.some((type) => {return ["HighValue", "NGP_Reg", "Hardmode_Reg"].includes(type);});
		},
		weight: (_enemy, _types) => {
			return 40;
		},
		apply: (enemy, _types) => {
			KinkyDungeonApplyBuffToEntity(enemy, {
				id: "Muscle",
				aura: KDBaseWhite, auraSprite: "Muscle",
				noAuraColor: true,
				duration: 9999, infinite: true,
				power: Math.min(5, enemy.Enemy.power*2),
				type: "AttackPower",
			});
			KinkyDungeonApplyBuffToEntity(enemy, {
				id: "Muscle2",
				duration: 9999, infinite: true,
				power: 1,
				type: "AttackWidth",
			});
		},
	},
	"EnergyShield": {
		filter: (_enemy, types) => {
			return types.some((type) => {return ["HighValue", "NGP_Reg", "Hardmode_Reg"].includes(type);});
		},
		weight: (_enemy, _types) => {
			return 40;
		},
		apply: (enemy, _types) => {
			KinkyDungeonApplyBuffToEntity(enemy, {
				id: "EnergyShield",
				aura: KDBaseWhite, auraSprite: "EnergyShield",
				duration: 9999, infinite: true,
				noAuraColor: true,
				power: enemy.Enemy.maxhp * 0.25,
				type: "MaxShield",
			});
			KinkyDungeonApplyBuffToEntity(enemy, {
				id: "EnergyShield2",
				duration: 9999, infinite: true,
				power: 0.1,
				type: "ShieldRegenBG",
			});
		},
	},
	"HealingAura": {
		filter: (enemy, types) => {
			if (enemy.Enemy.tags?.robot || enemy.Enemy.tags?.construct || enemy.Enemy.tags?.nobrain) return false;
			return types.some((type) => {return ["HighValue", "NGP_Boss", "Hardmode_Boss", "Extreme"].includes(type);});
		},
		weight: (enemy, _types) => {
			return 10 + (enemy.Enemy.shrines?.includes("Will") ? 20 : 0);
		},
		apply: (enemy, _types) => {
			KinkyDungeonApplyBuffToEntity(enemy, {
				id: "HealingAuraSBuff",
				aura: KDBaseWhite, auraSprite: "HealingAura",
				duration: 9999, infinite: true,
				noAuraColor: true,
				power: 1,
				events: [
					{trigger: "afterEnemyTick", type: "nurseAura", power: 0.3, dist: 1.5},
				],
			});
		},
	},
	"Missiles": {
		filter: (_enemy, types) => {
			return types.some((type) => {return ["HighValue", "NGP_Boss", "Hardmode_Boss", "Extreme"].includes(type);});
		},
		weight: (enemy, _types) => {
			return 4 + (enemy.Enemy.shrines?.includes("Latex") || enemy.Enemy.tags?.robot ? 40 : 0);
		},
		apply: (enemy, _types) => {
			let count = Math.min(4, Math.max(1, Math.ceil(KDGetEffLevel()/3)));
			if ((enemy.Enemy.tags?.boss)) count = 4;
			else if (enemy.Enemy.tags?.miniboss) count = Math.max(count, 3);
			else if (enemy.Enemy.tags?.elite) count = Math.max(count, 2);
			KinkyDungeonApplyBuffToEntity(enemy, {
				id: "Missiles",
				duration: 9999, infinite: true,
				power: count,
				aura: KDBaseWhite, auraSprite: "Missiles4",
				noAuraColor: true,
				events: [
					{trigger: "afterEnemyTick", count: count, type: "Missiles", power: 1.5,
						time: 12 + ((enemy.Enemy.tags?.minor) ? 10 : (enemy.Enemy.tags?.elite || enemy.Enemy.tags?.miniboss || enemy.Enemy.tags?.boss) ? 0 : 5), spell: "RubberMissile"},
				],
			});
		},
	},
	"Airbender": {
		filter: (_enemy, types) => {
			return types.some((type) => {return ["HighValue", "NGP_Boss", "Hardmode_Boss", "Extreme"].includes(type);});
		},
		weight: (enemy, _types) => {
			return 4 + ((enemy.Enemy.kite || enemy.Enemy.tags?.ranged) ? 20 : 0);
		},
		apply: (enemy, _types) => {
			let count = 2;
			KinkyDungeonApplyBuffToEntity(enemy, {
				id: "Airbender",
				duration: 9999, infinite: true,
				power: count,
				aura: KDBaseWhite, auraSprite: "Airbender1",
				noAuraColor: true,
				events: [
					{trigger: "afterEnemyTick", count: count, type: "Airbender", time: 4 + ((enemy.Enemy.tags?.minor) ? 4 : (enemy.Enemy.tags?.elite || enemy.Enemy.tags?.miniboss || enemy.Enemy.tags?.boss) ? 0 : 2), spell: "EnemyWindBlast"},
				],
			});
		},
	},
	"ElectrifyX": {
		filter: (_enemy, types) => {
			return types.some((type) => {return ["HighValue", "NGP_Boss", "Hardmode_Boss"].includes(type);});
		},
		weight: (enemy, _types) => {
			return 10 + (enemy.Enemy.shrines?.includes("Metal") ? 20 : 0) + ((enemy.Enemy.tags?.water) ? 20 : 0);
		},
		apply: (enemy, _types) => {
			KinkyDungeonApplyBuffToEntity(enemy, {
				id: "ElectrifyX",
				duration: 9999, infinite: true,
				power: 1,
				events: [
					{trigger: "afterEnemyTick", type: "spellX", time: 4, spell: "WitchElectrify"},
				],
			});
		},
	},
	"FireexpX": {
		filter: (enemy, types) => {
			if (enemy.Enemy.tags?.water || enemy.Enemy.tags?.ice) return false;
			return types.some((type) => {return ["HighValue", "NGP_Boss", "Hardmode_Boss"].includes(type);});
		},
		weight: (enemy, _types) => {
			return 10 + (enemy.Enemy.tags?.fire ? 20 : 0);
		},
		apply: (enemy, _types) => {
			KinkyDungeonApplyBuffToEntity(enemy, {
				id: "FireexpX",
				duration: 9999, infinite: true,
				power: 1,
				events: [
					{trigger: "afterEnemyTick", type: "spellX", time: 3, spell: "Fireexp"},
				],
			});
		},
	},
	"VineexpX": {
		filter: (_enemy, types) => {
			return types.some((type) => {return ["HighValue", "NGP_Boss", "Hardmode_Boss"].includes(type);});
		},
		weight: (enemy, _types) => {
			return 10 + (enemy.Enemy.tags?.plant || enemy.Enemy.tags?.nature || enemy.Enemy.tags?.elf ? 20 : 0);
		},
		apply: (enemy, _types) => {
			KinkyDungeonApplyBuffToEntity(enemy, {
				id: "VineexpX",
				duration: 9999, infinite: true,
				power: 1,
				events: [
					{trigger: "afterEnemyTick", type: "spellX", time: 3, spell: "Vineexp"},
				],
			});
		},
	},
	"BubbleexpX": {
		filter: (enemy, types) => {
			if (enemy.Enemy.tags?.fire) return false;
			return types.some((type) => {return ["HighValue", "NGP_Boss", "Hardmode_Boss"].includes(type);});
		},
		weight: (enemy, _types) => {
			return 10 + ((enemy.Enemy.tags?.water) ? 20 : 0);
		},
		apply: (enemy, _types) => {
			KinkyDungeonApplyBuffToEntity(enemy, {
				id: "BubbleexpX",
				duration: 9999, infinite: true,
				power: 1,
				events: [
					{trigger: "afterEnemyTick", type: "spellX", time: 6, spell: "Bubbleexp"},
				],
			});
		},
	},
	"IceexpX": {
		filter: (_enemy, types) => {
			return types.some((type) => {return ["HighValue", "NGP_Boss", "Hardmode_Boss"].includes(type);});
		},
		weight: (enemy, _types) => {
			return 10 + ((enemy.Enemy.tags?.ice) ? 20 : 0);
		},
		apply: (enemy, _types) => {
			KinkyDungeonApplyBuffToEntity(enemy, {
				id: "IceexpX",
				duration: 9999, infinite: true,
				power: 1,
				events: [
					{trigger: "afterEnemyTick", type: "spellX", time: 6, spell: "Iceexp"},
				],
			});
		},
	},
	"BearTrapper": {
		filter: (enemy, types) => {
			if (KDIsImmobile(enemy)) return false;
			return types.some((type) => {return ["HighValue", "NGP_Boss", "Hardmode_Boss"].includes(type);});
		},
		weight: (enemy, _types) => {
			return 10 + (enemy.Enemy.attack?.includes("Bind") ? 20 : 0);
		},
		apply: (enemy, _types) => {
			KinkyDungeonApplyBuffToEntity(enemy, {
				id: "BearTrapper",
				duration: 9999, infinite: true,
				power: 1,
				events: [
					{trigger: "afterEnemyTick", type: "spellX", time: 8, spell: "BearTrap", always: true, count: 1},
				],
			});
		},
	},
};

/**
 * @param enemy
 */
function KDEndEnemyAction(enemy: entity) {
	if (KDEnemyAction[enemy.action]?.end) {
		KDEnemyAction[enemy.action].end(enemy);
	}
	enemy.action = "";
}

/**
 * @param enemy
 */
function KDMaintainEnemyAction(enemy: entity, delta: number) {
	let forceEnd = false;
	if (enemy.FacilityAction) {
		KDTickCollectionWanderEntity(enemy, delta);
	}
	if (KDEnemyHasFlag(enemy, "overrideMove") || KDEnemyHasFlag(enemy, "endAction") || enemy.playWithPlayer > 0)
		forceEnd = true;
	if (!KDEnemyAction[enemy.action]?.maintain || !KDEnemyAction[enemy.action].maintain(enemy, delta) || forceEnd) {
		KDEndEnemyAction(enemy);
	}
}

let KDEnemyAction: Record<string, KDEnemyActionType> = {
	"observerchase": {
		holdleash: true,
		end: (enemy) => {
			// Reset position
			enemy.gx = enemy.x;
			enemy.gy = enemy.y;
		},
		filter: (enemy) => {
			return !(enemy.aware);
		},
		maintain: (enemy, _delta) => {
			// Stops investigating if alerted or idle
			return ((enemy.idle && KDRandom() < 0.1)
				|| !(enemy.aware)
				|| enemy.attackPoints
				|| KDistChebyshev(enemy.x - enemy.gx, enemy.y - enemy.gy) <= 1.5);
		},
		sprint: false,
	},
	"investigatesound": {
		holdleash: true,
		end: (enemy) => {
			// Reset position
			enemy.gx = enemy.x;
			enemy.gy = enemy.y;
		},
		filter: (enemy) => {
			return !(enemy.aware);
		},
		maintain: (enemy, _delta) => {
			// Stops investigating if alerted or idle
			return !(enemy.idle
				|| (KinkyDungeonAggressive(enemy) && enemy.aware)
				|| enemy.attackPoints
				|| KDistChebyshev(enemy.x - enemy.gx, enemy.y - enemy.gy) <= 1.5);
		},
		sprint: false,
	},
	"investigatesignal": {
		holdleash: true,
		end: (enemy) => {
			// Reset position
			enemy.gx = enemy.x;
			enemy.gy = enemy.y;
		},
		filter: (enemy) => {
			return !(enemy.aware);
		},
		maintain: (enemy, _delta) => {
			// Stops investigating if alerted or idle
			return ((enemy.idle && KDRandom() < 0.5)
				|| !(enemy.aware)
				|| enemy.attackPoints
				|| KDistChebyshev(enemy.x - enemy.gx, enemy.y - enemy.gy) <= 1.5);
		},
		sprint: true,
	},
};




let SpecialPersistentScriptSettingList: Record<string, (npc: KDPersistentNPC, enemy: enemy) => string> = {
	Default: (npc: KDPersistentNPC, enemy: enemy) => {
		return undefined;
	},
	Dragon: (npc: KDPersistentNPC, enemy: enemy) => {
		return "Dragon";
	},
	MaidKnightAndSquire: (npc: KDPersistentNPC, enemy: enemy) => {
		return "MaidKnightAndSquire";
	},
}
let SpawnAISettingList: Record<string, (npc: KDPersistentNPC, enemy: enemy) => string> = {
	Default: (npc: KDPersistentNPC, enemy: enemy) => {
		return "Default";
	},
	None: (npc: KDPersistentNPC, enemy: enemy) => {
		return "None";
	},
	Dragon: (npc: KDPersistentNPC, enemy: enemy) => {
		return "Dragon";
	},
}

let WanderAISettingList: Record<string, (npc: KDPersistentNPC, enemy: enemy) => string> = {
	Default: (npc: KDPersistentNPC, enemy: enemy) => {
		if (npc?.entity?.summoned) {
			return "GoToMain";
		}
		return "Default";
	},
	None: (npc: KDPersistentNPC, enemy: enemy) => {
		return "None";
	},
	Dragon: (npc: KDPersistentNPC, enemy: enemy) => {
		return "Dragon";
	},
	Boss: (npc: KDPersistentNPC, enemy: enemy) => {
		return "Boss";
	},
	Targeted: (npc: KDPersistentNPC, enemy: enemy) => {
		return "Targeted";
	},
}
